import { baseSignOutButton, useAccountProfile, InternalLink, useSearchAgentAlerts, mapArrayToString, baseFavoriteBtn, isValidEmail, isPhoneValid, useClientSettings, formatNumber, formatPrice, baseVehicleCard, baseFavoriteVehicles, useAccountUser, useDeleteAccount, baseChangePassword, FilterTypes, baseSearchAgentEdit, baseAccountPage, hasWindow, baseForgotPassword, baseAuthenticationForm, navigateInternalPage, useSession, hasDocument, getUrlParamValueFromWindow, baseRegistration, baseResetPassword, baseDealerContactForm, DealerContactTypes, hasValue, DefaultImage, useDealerships, ExternalLink, baseMarkerMapWithDealerships, DefaultMapViewPort, DefaultText, MarkupText, ActionLink, DefaultAction, DefaultTitle, DefaultTitleTextIconItem, DefaultImageTextActionItem, DefaultImageTextTitleItem, DefaultTitleWithDraftJsTextAndJsonImageItem, useVehiclesFilterData, useAnalytics, baseSearchBox, navigateInternalUrl, useContentBlockImpressionWhenInViewport, DefaultActionList, DefaultImageAction, baseAdvertisementBlock, DefaultAdvertiseGroupRef, DefaultSocialIconActionList, DefaultActionWithSubActionsList, useOuterClick, baseLanguagePicker, DefaultActionWithSubContentActionsAndCtas, baseCookieBanner, baseFinancingBanner, useWindowDimensions, baseFinancingContent, DefaultSeoBlock, useFavorites, getStickiesOffset, baseCompare, useScrollPosition, baseCompareBanner, baseImageViewerAndThumbnails, ImageViewer, ImageLightBox, b64DecodeUnicode, withFilters, basePreviousNextButtons, useDeviceType, baseVehicleDetail, basePagination, baseVehiclesPaged, baseTypedFilter, baseMakeFilterForMakeModel, baseModelFilterForMakeModel, baseFilter, withSort, useQuery, baseVehiclesAndFilters, baseReservationWizardUserForm, baseReservationWizard, baseMakeSearchAgentCriteriaForMakeModel, baseModelSearchAgentCriteriaForModel, baseTypedSearchAgentCriteria, SearchAgentCriteriaTypes, baseSearchAgentCriteria, baseSearchAgentField, baseSearchAgentTopBar, baseSearchAgentForm, baseSearchAgent, baseSliderWithCustomImageCard } from '@digitalexperience/dealer-website-core';
export { CaptchaProvider, DataContext, DataContextProvider, defaults as coreDefaults, types as coreTypes, utils as coreUtils, useAnalytics, useSession } from '@digitalexperience/dealer-website-core';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { uniq, map, filter, times, head, orderBy, includes, isArray, some, range, find, last, trimEnd, forEach, isObject, isEqual, uniqBy, sortBy, mapValues, keyBy, min, max, every, isBoolean, nth, toLower, parseInt as parseInt$1, each, omit, merge, pick, isEmpty, keys as keys$2 } from 'lodash';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import Slider, { Range } from 'rc-slider';
import Select, { components } from 'react-select';
import Fade from 'react-reveal/Fade';
import { Fade as Fade$1, Slide } from 'react-reveal';
import { useSwipeable } from 'react-swipeable';
import Switch from 'react-switch';
import Sticky from 'react-stickynode';
import { createPortal } from 'react-dom';
import Scrollbars from 'react-custom-scrollbars';

var fonts = [];
var icons = [];
var css = [];
var config = {
  defaultCulture: 'nl',
  fonts: fonts,
  icons: icons,
  css: css
};

var SignOutButton = function SignOutButton(_ref) {
  var signOut = _ref.signOut,
    loading = _ref.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "py-2 border-l-2 border-white hover:text-secondary-three transition cursor-pointer",
    onClick: function onClick() {
      signOut();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-sign-out px-4"
  }), loading ? t('Logging out...') : t('Log out'));
};
var SignOutButton$1 = baseSignOutButton(SignOutButton);

var ProfileSummary = function ProfileSummary(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    userFetched = _useState[0],
    setUserFetched = _useState[1];
  var _useAccountProfile = useAccountProfile(context),
    profile = _useAccountProfile.profile,
    loading = _useAccountProfile.loading,
    fetchUserProfile = _useAccountProfile.fetchUserProfile;
  useEffect(function () {
    fetchUserProfile();
    setUserFetched(true);
  }, []);
  if (!userFetched || loading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-secondary-five animate-pulse rounded p-8 mb-5 relative"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "invisible"
    }, t('This is you')), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading..."), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading..."), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading..."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading..."), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading..."), /*#__PURE__*/React.createElement("p", {
      className: "invisible truncate"
    }, "Loading...")), /*#__PURE__*/React.createElement("div", {
      className: "invisible"
    }, "Loading..."));
  }
  if (!loading && userFetched && !profile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-secondary-five rounded p-8"
    }, t('Something went wrong') + '...');
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five rounded p-8 mb-5 relative",
    style: {
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-cog absolute top-8 right-8 text-secondary-four text-5xl",
    style: {
      zIndex: -1
    }
  }), /*#__PURE__*/React.createElement("h4", null, t('About you')), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.firstName, " ", profile.lastName), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.street, " ", profile.number, " ", profile.bus), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.postalCode, " ", profile.city), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.telephone), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.mobile), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, profile.email)), /*#__PURE__*/React.createElement(InternalLink, {
    className: "underline text-secondary font-semibold cursor-pointer hover:text-secondary-six transition",
    page: context.defaultPageNames.accountProfile,
    context: context
  }, t('Manage your preferences')), /*#__PURE__*/React.createElement(InternalLink, {
    className: "underline text-secondary font-semibold cursor-pointer hover:text-secondary-six transition mt-2",
    page: context.defaultPageNames.accountChangePassword,
    context: context
  }, t('Change password')));
};

var CarAgentSummary = function CarAgentSummary(_ref) {
  var _alert$criteria, _alert$criteria2, _alert$criteria3, _alert$criteria4, _alert$criteria5, _alert$criteria6, _alert$criteria7, _alert$criteria8, _alert$criteria9;
  var context = _ref.context;
  var _useSearchAgentAlerts = useSearchAgentAlerts(context),
    alerts = _useSearchAgentAlerts.alerts,
    loading = _useSearchAgentAlerts.loading,
    fetchSearchAgentAlerts = _useSearchAgentAlerts.fetchSearchAgentAlerts;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    alertFetched = _useState[0],
    setAlertFetched = _useState[1];
  useEffect(function () {
    fetchSearchAgentAlerts();
    setAlertFetched(true);
  }, []);
  if (!alertFetched || loading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-five animate-pulse rounded p-8 mb-5"
    }, /*#__PURE__*/React.createElement("p", {
      className: "invisible"
    }, "Loading..."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", {
      className: "invisible"
    }, "Loading...")), /*#__PURE__*/React.createElement("div", {
      className: "invisible"
    }, "Loading..."));
  }
  if (!alerts && alertFetched && !loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-secondary-five rounded p-8"
    }, t('Something went wrong') + '...');
  }
  var alert = alerts.length > 0 ? alerts[0] : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five rounded p-8 mb-5 relative",
    style: {
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-lightbulb-on absolute top-8 right-8 text-secondary-four text-5xl",
    style: {
      zIndex: -1
    }
  }), /*#__PURE__*/React.createElement("p", null, t('Our Car Agent will look for your ideal car'), "."), alert && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, t('He will take the following properties into account'), ":"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "font-semibold"
  }, ((_alert$criteria = alert.criteria) === null || _alert$criteria === void 0 ? void 0 : _alert$criteria.makeModel) && ((_alert$criteria2 = alert.criteria) === null || _alert$criteria2 === void 0 ? void 0 : _alert$criteria2.makeModel.length) > 0 && /*#__PURE__*/React.createElement("div", null, t('Make/model'), ": ", mapArrayToString(uniq((_alert$criteria3 = alert.criteria) === null || _alert$criteria3 === void 0 ? void 0 : _alert$criteria3.makeModel))), ((_alert$criteria4 = alert.criteria) === null || _alert$criteria4 === void 0 ? void 0 : _alert$criteria4.body) && ((_alert$criteria5 = alert.criteria) === null || _alert$criteria5 === void 0 ? void 0 : _alert$criteria5.body.length) > 0 && /*#__PURE__*/React.createElement("div", null, t('Body'), ": ", mapArrayToString(uniq((_alert$criteria6 = alert.criteria) === null || _alert$criteria6 === void 0 ? void 0 : _alert$criteria6.body))), ((_alert$criteria7 = alert.criteria) === null || _alert$criteria7 === void 0 ? void 0 : _alert$criteria7.fuel) && ((_alert$criteria8 = alert.criteria) === null || _alert$criteria8 === void 0 ? void 0 : _alert$criteria8.fuel.length) > 0 && /*#__PURE__*/React.createElement("div", null, t('Brandstof'), ": ", mapArrayToString(uniq((_alert$criteria9 = alert.criteria) === null || _alert$criteria9 === void 0 ? void 0 : _alert$criteria9.fuel)))))), /*#__PURE__*/React.createElement(InternalLink, {
    className: "underline text-secondary font-semibold cursor-pointer hover:text-secondary-six transition",
    page: context.defaultPageNames.accountCarAgent,
    context: context
  }, t('Manage your car preferences')));
};

var FavoriteButton = function FavoriteButton(_ref) {
  var isFavorite = _ref.isFavorite,
    updateFavorite = _ref.updateFavorite;
  var _useState = useState(false),
    isHovering = _useState[0],
    setIsHovering = _useState[1];
  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    updateFavorite();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center opacity-100 bg-none rounded-full cursor-pointer transition",
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    },
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("i", {
    className: (isHovering || isFavorite ? 'fas text-primary' : 'far text-primary') + " fa-heart transition text-20"
  }));
};
var FavoriteButton$1 = baseFavoriteBtn(FavoriteButton);

var imageDefault = "vehicle-card-default-photo~JKItFXZF.jpg";

var useAsset = function useAsset(resource) {
  return require("/" + resource)["default"];
};
var resolveAsset = function resolveAsset(resource) {
  return require("/" + resource)["default"];
};
var isJsonString = function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
var priceTypes = {
  PRICE: 'price',
  MONTHLY_PRICE: 'monthly'
};
var isOnlyNumbers = function isOnlyNumbers(value) {
  return /^[0-9]*$/i.test(value);
};
var isOnlyChars = function isOnlyChars(value) {
  return /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value);
};
var isOnlyCharsAndSlash = function isOnlyCharsAndSlash(value) {
  return /^([A-Za-z/]*)$/.test(value);
};
var formatNumberToMin2Digits = function formatNumberToMin2Digits(number) {
  return parseFloat(number).toLocaleString('nl-NL', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
};
var validateForm = function validateForm(validationFields, data) {
  if (validationFields === void 0) {
    validationFields = null;
  }
  if (data === void 0) {
    data = null;
  }
  var isValid = true;
  var errors = {};
  if (validationFields && data) {
    map(validationFields, function (field) {
      if (field.rules.includes('notEmpty')) {
        if (!data[field.field]) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
      if (field.rules.includes('email')) {
        if (!isValidEmail(data[field.field])) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
      if (field.rules.includes('onlyNumbers')) {
        if (!isOnlyNumbers(data[field.field])) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
      if (field.rules.includes('onlyChars')) {
        if (!isOnlyChars(data[field.field])) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
      if (field.rules.includes('date')) {
        if (!isOnlyCharsAndSlash(data[field.field])) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
      if (field.rules.includes('telephone')) {
        if (!isPhoneValid(data[field.field])) {
          errors[field.field] = field.msg;
          isValid = false;
        }
      }
    });
  }
  return {
    isValid: isValid,
    errors: errors
  };
};
var actionVisible = function actionVisible(action) {
  return !(action.title === '' && action.type === '' && action.url === '');
};

var PriceBlockProfessional = function PriceBlockProfessional(_ref) {
  var price = _ref.price,
    priceLabel = _ref.priceLabel,
    monthlyPrice = _ref.monthlyPrice,
    vehicleAvailable = _ref.vehicleAvailable,
    dark = _ref.dark;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-2 justify-between items-center truncate text-xs font-semibold",
    style: {
      minHeight: 58
    }
  }, monthlyPrice && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center h-full rounded bg-secondary-five",
    style: {
      minHeight: 58
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-15 font-semibold leading-5 flex items-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-12 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", null, vehicleAvailable ? monthlyPrice : 'XXX')), /*#__PURE__*/React.createElement("div", {
    className: "text-10 " + (dark ? 'text-white' : 'text-secondary-three') + " mt-1"
  }, t('p/m'), " ", priceLabel)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center h-full border rounded border-secondary-five",
    style: {
      minHeight: 58
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-15 flex items-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-12 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", null, vehicleAvailable ? price : 'XXX')), /*#__PURE__*/React.createElement("div", {
    className: "text-10 " + (dark ? 'text-white' : 'text-secondary-three') + " mt-1"
  }, priceLabel, " "))));
};

var PriceBlockPrivate = function PriceBlockPrivate(_ref) {
  var price = _ref.price,
    monthlyPrice = _ref.monthlyPrice,
    brutoPrice = _ref.brutoPrice,
    vehicleAvailable = _ref.vehicleAvailable,
    dark = _ref.dark;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-2 justify-between items-center truncate text-xs font-semibold",
    style: {
      minHeight: 58
    }
  }, monthlyPrice && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center h-full rounded bg-secondary-five",
    style: {
      minHeight: 58
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-15 font-semibold leading-5 flex items-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-12 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", null, vehicleAvailable ? monthlyPrice : 'XXX')), /*#__PURE__*/React.createElement("div", {
    className: "text-10 " + (dark ? 'text-white' : 'text-secondary-three') + " mt-1"
  }, t('p/m incl. VAT'))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center h-full border rounded border-secondary-five",
    style: {
      minHeight: 58
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-15 font-semibold flex items-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-12 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", null, vehicleAvailable ? price : 'XXX'), brutoPrice && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start font-semibold line-through ml-4"
  }, vehicleAvailable ? brutoPrice : 'XXX')), /*#__PURE__*/React.createElement("div", {
    className: "text-10 " + (dark ? 'text-white' : 'text-secondary-three') + " mt-1"
  }, t('incl. VAT'), " "))));
};

var useVehiclePrices = function useVehiclePrices(_ref) {
  var vehicle = _ref.vehicle,
    _ref$activeRate = _ref.activeRate,
    activeRate = _ref$activeRate === void 0 ? undefined : _ref$activeRate,
    context = _ref.context;
  var _useState = useState(null),
    price = _useState[0],
    setPrice = _useState[1];
  var _useState2 = useState(null),
    brutoPrice = _useState2[0],
    setBrutoPrice = _useState2[1];
  var _useState3 = useState(null),
    monthlyLastPayment = _useState3[0],
    setMonthlyLastPayment = _useState3[1];
  var _useState4 = useState(null),
    monthlyPrice = _useState4[0],
    setMonthlyPrice = _useState4[1];
  var _useState5 = useState(null),
    priceLabel = _useState5[0],
    setPriceLabel = _useState5[1];
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterInclVatActive = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var isProfessional = clientSettings.isProfessional;
  var financingEnabled = context.financing;
  useEffect(function () {
    resolvePrices();
  }, [clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat, clientSettings.isProfessional, activeRate]);
  var resolvePrices = function resolvePrices() {
    var newPrice,
      newBrutoPrice,
      newMonthlyLastPayment,
      newMonthlyPrice,
      newPriceLabel = null;
    if (isProfessional) {
      if (!vehicle.vatRegime) {
        newPrice = vehicle !== null && vehicle !== void 0 && vehicle.price && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) > 0 ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) : null;
        if (activeRate) {
          newMonthlyPrice = activeRate !== null && activeRate !== void 0 && activeRate.priceIncl ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.priceIncl) : null;
        } else {
          newMonthlyPrice = vehicle !== null && vehicle !== void 0 && vehicle.monthlyPriceProfIncl && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPriceProfIncl) > 0 ? formatNumberToMin2Digits(vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPriceProfIncl) : null;
        }
        newPriceLabel = t('incl. VAT');
      } else {
        var priceOrNull = vehicle !== null && vehicle !== void 0 && vehicle.price && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) > 0 ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) : null;
        var priceExclOrNull = vehicle !== null && vehicle !== void 0 && vehicle.priceExcl && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceExcl) > 0 ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceExcl) : null;
        newPrice = filterInclVatActive ? priceOrNull : priceExclOrNull;
        newPriceLabel = filterInclVatActive ? t('incl. VAT') : t('excl. VAT');
        if (activeRate) {
          var monthlyPriceProfExclVatFromActiveRateOrNull = activeRate !== null && activeRate !== void 0 && activeRate.price ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.price) : null;
          var monthlyPriceProfInclVatFromActiveRateOrNull = activeRate !== null && activeRate !== void 0 && activeRate.priceIncl ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.priceIncl) : null;
          newMonthlyPrice = filterInclVatActive ? monthlyPriceProfInclVatFromActiveRateOrNull : monthlyPriceProfExclVatFromActiveRateOrNull;
        } else {
          var monthlyPriceProfOrNull = vehicle !== null && vehicle !== void 0 && vehicle.monthlyPriceProf && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPriceProf) > 0 ? formatNumberToMin2Digits(vehicle.monthlyPriceProf) : null;
          var monthlyPriceProfInclOrNull = vehicle !== null && vehicle !== void 0 && vehicle.monthlyPriceProfIncl && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPriceProfIncl) > 0 ? formatNumberToMin2Digits(vehicle.monthlyPriceProfIncl) : null;
          newMonthlyPrice = filterInclVatActive ? monthlyPriceProfInclOrNull : monthlyPriceProfOrNull;
        }
      }
      newBrutoPrice = null;
      newMonthlyLastPayment = vehicle.monthlyPriceType === 'balloon' && vehicle !== null && vehicle !== void 0 && vehicle.monthlyLastPayment ? formatNumberToMin2Digits(vehicle.monthlyLastPayment) : null;
    } else {
      newPrice = vehicle !== null && vehicle !== void 0 && vehicle.price && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) > 0 ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) : null;
      newBrutoPrice = vehicle !== null && vehicle !== void 0 && vehicle.brutoPrice && (vehicle.categoryKey === 'new' || vehicle.categoryKey === 'demo') ? formatPrice(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brutoPrice) : null;
      if (activeRate) {
        newMonthlyPrice = activeRate !== null && activeRate !== void 0 && activeRate.monthlyPrice ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.monthlyPrice) : null;
        newMonthlyLastPayment = activeRate !== null && activeRate !== void 0 && activeRate.balloon_rate && (activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) !== undefined ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) : null;
      } else {
        newMonthlyPrice = vehicle !== null && vehicle !== void 0 && vehicle.monthlyPrice ? formatNumberToMin2Digits(vehicle.monthlyPrice) : null;
        newMonthlyLastPayment = vehicle.monthlyPriceType === 'balloon' && vehicle !== null && vehicle !== void 0 && vehicle.monthlyLastPayment ? formatNumberToMin2Digits(vehicle.monthlyLastPayment) : null;
      }
      newPriceLabel = t('incl. VAT');
    }
    setPrice(newPrice);
    setBrutoPrice(newBrutoPrice);
    setMonthlyLastPayment(newMonthlyLastPayment);
    setMonthlyPrice(newMonthlyPrice);
    setPriceLabel(newPriceLabel);
  };
  return {
    price: price,
    monthlyPrice: financingEnabled ? monthlyPrice : null,
    priceLabel: priceLabel,
    brutoPrice: brutoPrice,
    monthlyLastPayment: financingEnabled ? monthlyLastPayment : null
  };
};

var PriceBlock = function PriceBlock(_ref) {
  var vehicle = _ref.vehicle,
    dark = _ref.dark,
    context = _ref.context;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = clientSettings.isProfessional;
  var _useVehiclePrices = useVehiclePrices({
      vehicle: vehicle,
      context: context
    }),
    price = _useVehiclePrices.price,
    monthlyPrice = _useVehiclePrices.monthlyPrice,
    priceLabel = _useVehiclePrices.priceLabel,
    brutoPrice = _useVehiclePrices.brutoPrice,
    monthlyLastPayment = _useVehiclePrices.monthlyLastPayment;
  if (isProfessional) {
    return /*#__PURE__*/React.createElement(PriceBlockProfessional, {
      price: price,
      priceLabel: priceLabel,
      brutoPrice: brutoPrice,
      monthlyPrice: monthlyPrice,
      monthlyLastPayment: monthlyLastPayment,
      vehicleAvailable: !vehicle.sold && !vehicle.reserved,
      context: context,
      dark: dark
    });
  }
  return /*#__PURE__*/React.createElement(PriceBlockPrivate, {
    price: price,
    brutoPrice: brutoPrice,
    monthlyPrice: monthlyPrice,
    monthlyLastPayment: monthlyLastPayment,
    vehicleAvailable: !vehicle.sold && !vehicle.reserved,
    context: context,
    dark: dark
  });
};

var Badges = function Badges(_ref) {
  var vehicle = _ref.vehicle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var priceAdvantage = vehicle !== null && vehicle !== void 0 && vehicle.brutoPrice && vehicle !== null && vehicle !== void 0 && vehicle.price ? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brutoPrice) - (vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) : 0;
  var tradeInDiscountBadgeVisible = !!(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && !vehicle.reserved;
  var recyclingDiscountBadgeVisible = !(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && !vehicle.reserved && !!(vehicle !== null && vehicle !== void 0 && vehicle.recyclingDiscount);
  var newBadgeVisible = !(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && !vehicle.reserved && !(vehicle !== null && vehicle !== void 0 && vehicle.recyclingDiscount) && !!vehicle.categoryKey === 'new';
  var isReservedBadgeVisible = vehicle.reserved;
  var priceAdvantageBadgeVisible = priceAdvantage > 0 && !vehicle.reserved && (vehicle.categoryKey === 'new' || vehicle.categoryKey === 'demo');
  var badges = [{
    visible: tradeInDiscountBadgeVisible,
    className: 'bg-black text-white',
    label: t('Trade in discount') + ": " + formatPrice(vehicle.tradeInDiscount)
  }, {
    visible: recyclingDiscountBadgeVisible,
    className: 'bg-black text-white',
    label: t('Recycling discount') + ": " + formatPrice(vehicle.recyclingDiscount)
  }, {
    visible: newBadgeVisible,
    className: 'bg-black text-white',
    label: t('New')
  }, {
    visible: isReservedBadgeVisible,
    className: 'bg-success text-white',
    label: t('Reserved')
  }, {
    visible: priceAdvantageBadgeVisible,
    className: 'bg-success text-white',
    label: t('Your advantage') + ": " + formatPrice(priceAdvantage)
  }];
  var visibleBadges = filter(badges, function (badge) {
    return badge.visible;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap"
  }, visibleBadges.map(function (badge, index) {
    var className = badge.className;
    return /*#__PURE__*/React.createElement("div", {
      key: badge.label + "-" + index,
      className: "rounded text-10 font-semibold leading-4 py-1 px-1 mr-1 mb-1 " + className
    }, badge.label);
  }));
};

var VehicleCard = function VehicleCard(_ref) {
  var dark = _ref.dark,
    vehicle = _ref.vehicle,
    context = _ref.context,
    _onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getFirstImageUri = function getFirstImageUri(images) {
    var _images$;
    return images instanceof Array ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.uri : images === null || images === void 0 ? void 0 : images.uri;
  };
  var isReserved = vehicle.reserved;
  var renderOverlay = function renderOverlay(type) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center absolute right-0 left-0 top-0 bottom-0 text-white cursor-default",
      style: {
        zIndex: 100,
        background: 'rgba(0,0,0,0.5)'
      },
      onClick: function onClick(e) {
        return e.preventDefault();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-lock-alt mb-3 text-24"
    }), type === 'sold' && /*#__PURE__*/React.createElement("h3", null, t('Sold')), type === 'reserved' && /*#__PURE__*/React.createElement("h3", null, t('Reserved')));
  };
  var getLocation = function getLocation() {
    var _vehicle$dealer, _vehicle$dealer2, _vehicle$dealer3;
    var location = '';
    if (vehicle !== null && vehicle !== void 0 && (_vehicle$dealer = vehicle.dealer) !== null && _vehicle$dealer !== void 0 && _vehicle$dealer.postal || vehicle !== null && vehicle !== void 0 && (_vehicle$dealer2 = vehicle.dealer) !== null && _vehicle$dealer2 !== void 0 && _vehicle$dealer2.city || vehicle !== null && vehicle !== void 0 && (_vehicle$dealer3 = vehicle.dealer) !== null && _vehicle$dealer3 !== void 0 && _vehicle$dealer3.name) {
      var _vehicle$dealer4, _vehicle$dealer5, _vehicle$dealer6;
      location = (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer4 = vehicle.dealer) === null || _vehicle$dealer4 === void 0 ? void 0 : _vehicle$dealer4.postal) + ' ' + (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer5 = vehicle.dealer) === null || _vehicle$dealer5 === void 0 ? void 0 : _vehicle$dealer5.city) + ' - ' + (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer6 = vehicle.dealer) === null || _vehicle$dealer6 === void 0 ? void 0 : _vehicle$dealer6.name);
    }
    return location;
  };
  var coverImageSrc = getFirstImageUri(vehicle === null || vehicle === void 0 ? void 0 : vehicle.images) ? getFirstImageUri(vehicle === null || vehicle === void 0 ? void 0 : vehicle.images) : resolveAsset(imageDefault);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative border border-gray-200 rounded shadow"
  }, (vehicle === null || vehicle === void 0 ? void 0 : vehicle.sold) && renderOverlay('sold'), /*#__PURE__*/React.createElement("div", {
    className: "w-full overflow-hidden " + (isReserved ? 'pointer-events-none cursor-default' : ''),
    onClick: function onClick(e) {
      return _onClick ? _onClick(e) : undefined;
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("img", {
    src: coverImageSrc,
    className: "w-full " + (isReserved ? 'pointer-events-none cursor-default' : ''),
    alt: "Cover image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute top-4 left-4 right-10"
  }, /*#__PURE__*/React.createElement(Badges, {
    vehicle: vehicle,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute top-0 right-0 w-7 h-7 rounded-bl bg-white"
  }, /*#__PURE__*/React.createElement(FavoriteButton$1, {
    reference: vehicle === null || vehicle === void 0 ? void 0 : vehicle.reference,
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full " + (dark ? 'text-white bg-secondary-two' : 'text-primary bg-white')
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full px-4 pt-3 mb-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate text-base font-semibold mb-px"
  }, vehicle.make + ' ' + vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "truncate text-sm text-secondary-three"
  }, vehicle.version)), /*#__PURE__*/React.createElement("div", {
    className: "w-full px-4 mb-2"
  }, /*#__PURE__*/React.createElement(PriceBlock, {
    vehicle: vehicle,
    context: context,
    dark: dark
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap font-medium " + (dark ? 'text-secondary-five' : 'text-primary') + " truncate text-12 px-4",
    style: {
      minHeight: 55
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.fuel), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.firstRegistrationYear), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.gearbox), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, formatNumber(vehicle.mileage), " km"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.euroNorm), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full h-6"
  }, vehicle.co2, " g/km CO ", /*#__PURE__*/React.createElement("sup", null, "2"))), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.dealer) && /*#__PURE__*/React.createElement("div", {
    className: "mt-4 py-4 border-t border-gray-200 flex items-center " + (dark ? 'text-secondary-five' : 'text-primary') + " truncate text-12 font-medium"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 w-full truncate"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-map-marker-alt mr-2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "truncate"
  }, getLocation())))))));
};
VehicleCard.defaultProps = {
  dark: false,
  mode: 'default'
};
var VehicleCardDesktop = baseVehicleCard(VehicleCard);

var VehicleCardSkeleton = function VehicleCardSkeleton(_ref) {
  var dark = _ref.dark;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-gradient-to-tr " + (dark ? 'from-secondary-two to-secondary-three' : 'from-secondary-four to-secondary-five') + " bg-secondary-five animate-pulse",
    style: {
      paddingTop: '75%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden invisible p-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate text-lg font-bold mb-1"
  }, "Skeleton"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-top truncate text-sm font-semibold flex mb-1"
  }, "\u20AC", /*#__PURE__*/React.createElement("div", {
    className: "text-2xl font-bold -mt-1 px-1 flex items-top"
  }, "XXX")), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 40
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block invisible w-full px-4 pt-4 pb-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate text-lg font-bold mb-1"
  }, "Skeleton"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-top truncate text-xs font-semibold flex mb-1"
  }, "\u20AC ", /*#__PURE__*/React.createElement("div", {
    className: "text-22 font-bold px-1 flex items-top"
  }, "XXX"))));
};

var FavoritesSummary = function FavoritesSummary(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-3 gap-4"
    }, times(3, function (index) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: 'skeleton-' + index
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "invisible"
    }, "Loading..."));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, vehicles.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-4"
  }, map(vehicles.slice(0, 3), function (vehicle) {
    return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
      gridSize: 4,
      key: vehicle.ide,
      vehicle: vehicle,
      context: context
    });
  })), /*#__PURE__*/React.createElement(InternalLink, {
    className: "mt-5 font-semibold underline text-secondary hover:text-secondary-six transtion cursor-pointer",
    page: context.defaultPageNames.accountFavorites,
    context: context
  }, t('Show all favorites'))), vehicles.length <= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t("You didn't select any favorites...")), /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('Add cars by clicking on the heart icon.')), /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicles,
    className: "font-semibold underline text-secondary hover:text-secondary-six transtion cursor-pointer",
    context: context
  }, t('View all cars'))));
};
var FavoritesSummary$1 = baseFavoriteVehicles(FavoritesSummary, 3);

var AccountOverview = function AccountOverview(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Account overview')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full mb-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 pr-0 md:pr-4 mb-11 md:mb-0 flex-none"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-5"
  }, t('Preferences')), /*#__PURE__*/React.createElement(ProfileSummary, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 pl-0 md:pl-4 flex-none"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-5"
  }, t('Keep me notified')), /*#__PURE__*/React.createElement(CarAgentSummary, {
    context: context
  }))), /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Favorites')), /*#__PURE__*/React.createElement(FavoritesSummary$1, {
    context: context
  }));
};

var Favorites = function Favorites(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-3 gap-4"
    }, times(12, function (index) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: 'skeleton-' + index,
        dark: false
      });
    }));
  }
  if ((vehicles === null || vehicles === void 0 ? void 0 : vehicles.length) < 1) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
      className: "mb-5"
    }, t('Favorites')), /*#__PURE__*/React.createElement("p", null, t("You didn't select any favorites.")));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden mb-5 "
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: "text-14 text-secondary-two hover:text-secondary-three",
    page: context.defaultPageNames.accountOverview,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-left mr-2"
  }), t('Account overview')))), /*#__PURE__*/React.createElement("h2", {
    className: "mb-5"
  }, t('Favorites')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-4"
  }, map(vehicles, function (vehicle) {
    return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
      gridSize: 3,
      key: vehicle === null || vehicle === void 0 ? void 0 : vehicle.id,
      vehicle: vehicle,
      context: context
    });
  })));
};
var Favorites$1 = baseFavoriteVehicles(Favorites);

var ProfileOverview = function ProfileOverview(_ref) {
  var profile = _ref.profile,
    address = _ref.address;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pb-8 border-b border-secondary-four"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold mb-2"
  }, t('Personal info')), /*#__PURE__*/React.createElement("p", null, profile.firstName, " ", profile.lastName)), /*#__PURE__*/React.createElement("div", {
    className: "py-8 border-b border-secondary-four"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold mb-2"
  }, t('Address')), /*#__PURE__*/React.createElement("p", null, address.street, " ", address.number, " ", address.bus), /*#__PURE__*/React.createElement("p", null, address.postalCode, " ", address.city)), /*#__PURE__*/React.createElement("div", {
    className: "py-8 border-b border-secondary-four"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold mb-2"
  }, t('Contact')), /*#__PURE__*/React.createElement("p", null, profile.telephone), /*#__PURE__*/React.createElement("p", null, profile.email)));
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var ProfileEditForm = function ProfileEditForm(_ref) {
  var profile = _ref.profile,
    address = _ref.address,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState({
      firstName: profile === null || profile === void 0 ? void 0 : profile.firstName,
      lastName: profile === null || profile === void 0 ? void 0 : profile.lastName,
      telephone: profile === null || profile === void 0 ? void 0 : profile.telephone,
      email: profile === null || profile === void 0 ? void 0 : profile.email,
      street: address === null || address === void 0 ? void 0 : address.street,
      number: address === null || address === void 0 ? void 0 : address.number,
      bus: address === null || address === void 0 ? void 0 : address.bus,
      postalCode: address === null || address === void 0 ? void 0 : address.postalCode,
      city: address === null || address === void 0 ? void 0 : address.city
    }),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = useState({}),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  useEffect(function () {
    setData({
      firstName: profile === null || profile === void 0 ? void 0 : profile.firstName,
      lastName: profile === null || profile === void 0 ? void 0 : profile.lastName,
      telephone: profile === null || profile === void 0 ? void 0 : profile.telephone,
      email: profile === null || profile === void 0 ? void 0 : profile.email,
      street: address === null || address === void 0 ? void 0 : address.street,
      number: address === null || address === void 0 ? void 0 : address.number,
      bus: address === null || address === void 0 ? void 0 : address.bus,
      postalCode: address === null || address === void 0 ? void 0 : address.postalCode,
      city: address === null || address === void 0 ? void 0 : address.city
    });
  }, [profile, address]);
  var setValue = function setValue(key, value) {
    var _extends2;
    setData(_extends({}, data, (_extends2 = {}, _extends2[key] = value, _extends2)));
  };
  var validationFields = [{
    field: 'firstName',
    rules: ['notEmpty'],
    msg: t('The first name cannot be empty.')
  }, {
    field: 'lastName',
    rules: ['notEmpty'],
    msg: t('The last name cannot be empty.')
  }, {
    field: 'street',
    rules: ['notEmpty', 'onlyChars'],
    msg: t('The street cannot be empty and it should have only characters.')
  }, {
    field: 'number',
    rules: ['notEmpty'],
    msg: t('The number cannot be empty.')
  }, {
    field: 'postalCode',
    rules: ['notEmpty', 'onlyNumbers'],
    msg: t('The postal code should have at least one number.')
  }, {
    field: 'city',
    rules: ['notEmpty'],
    msg: t('The city cannot be empty.')
  }, {
    field: 'telephone',
    rules: ['notEmpty', 'telephone'],
    msg: t('The telephone needs to be valid.')
  }, {
    field: 'email',
    rules: ['notEmpty', 'email'],
    msg: t('The email needs to be valid.')
  }];
  var isValid = function isValid() {
    setFormErrors({});
    var _validateForm = validateForm(validationFields, data),
      isValid = _validateForm.isValid,
      errors = _validateForm.errors;
    setFormErrors(errors);
    return isValid;
  };
  var onSave = function onSave(data) {
    if (isValid()) {
      onSubmit(data);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-5 font-semibold"
  }, t('Personal info')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4 mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.firstName ? 'text-red-500' : 'text-secondary-three')
  }, t('First name')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.firstName ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('First name'),
    value: data.firstName,
    onChange: function onChange(e) {
      return setValue('firstName', e.target.value);
    }
  }), formErrors.firstName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.firstName)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.lastName ? 'text-red-500' : 'text-secondary-three')
  }, t('Last name')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.lastName ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Last name'),
    value: data.lastName,
    onChange: function onChange(e) {
      return setValue('lastName', e.target.value);
    }
  }), formErrors.lastName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.lastName))), /*#__PURE__*/React.createElement("p", {
    className: "mb-5 font-semibold"
  }, t('Address')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4 mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.street ? 'text-red-500' : 'text-secondary-three')
  }, t('Street')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.street ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Street'),
    value: data.street,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^a-zA-Z -]/g, '');
      setValue('street', value);
    }
  }), formErrors.street && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.street)), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.number ? 'text-red-500' : 'text-secondary-three')
  }, t('House number')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.number ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('House number'),
    value: data.number,
    onChange: function onChange(e) {
      return setValue('number', e.target.value);
    }
  }), formErrors.number && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.number)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2"
  }, t('Box number')), /*#__PURE__*/React.createElement("input", {
    className: "border border-secondary-three rounded px-5 py-3",
    type: "text",
    placeholder: t('Box number'),
    value: data.bus,
    onChange: function onChange(e) {
      return setValue('bus', e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.postalCode ? 'text-red-500' : 'text-secondary-three')
  }, t('Postal code')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.postalCode ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Postal code'),
    value: data.postalCode,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9]/g, '');
      setValue('postalCode', value);
    }
  }), formErrors.postalCode && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.postalCode)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.city ? 'text-red-500' : 'text-secondary-three')
  }, t('City')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.city ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('City'),
    value: data.city,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^a-zA-Z -]/g, '');
      setValue('city', value);
    }
  }), formErrors.city && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.city))), /*#__PURE__*/React.createElement("p", {
    className: "mb-5 font-semibold"
  }, t('Contact')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4 mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.telephone ? 'text-red-500' : 'text-secondary-three')
  }, t('Phone')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.telephone ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: "+32 486 43 43 43",
    value: data.telephone,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9+ ]/g, '');
      setValue('telephone', value);
    }
  }), formErrors.telephone && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.telephone)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.email ? 'text-red-500' : 'text-secondary-three')
  }, t('Email')), /*#__PURE__*/React.createElement("input", {
    className: "border rounded px-5 py-3 " + (formErrors.email ? 'border-red-500' : 'border-secondary-three'),
    disabled: true,
    type: "text",
    placeholder: "john.doe@autralis.com",
    value: data.email,
    onChange: function onChange(e) {
      return setValue('email', e.target.value);
    }
  }), formErrors.email && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.email))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "button button-alternate py-5"
  }, t('Cancel')), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSave(data);
    },
    className: "button button-secondary py-5"
  }, t('Save changes'))));
};

var views = {
  overview: 'overview',
  edit: 'edit'
};
var ProfileOverviewAndEdit = function ProfileOverviewAndEdit(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(views.overview),
    view = _useState[0],
    setView = _useState[1];
  var _useState2 = useState(false),
    isUpdating = _useState2[0],
    setIsUpdating = _useState2[1];
  var _useAccountUser = useAccountUser(context),
    accountUser = _useAccountUser.accountUser,
    accountUserLoading = _useAccountUser.loading,
    accountUserError = _useAccountUser.error,
    accountUserFetch = _useAccountUser.accountUserFetch,
    accountUserUpdateIndividual = _useAccountUser.accountUserUpdateIndividual,
    accountUserUpdateAddress = _useAccountUser.accountUserUpdateAddress;
  useEffect(function () {
    accountUserFetch();
  }, []);
  if (accountUserLoading || isUpdating) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-60 mb-10 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-20 w-full mb-8 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-20 w-full mb-8 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-20 w-full mb-8 bg-gray-200 animate-pulse"
    }));
  }
  if (!accountUserLoading && (accountUserError || !accountUser)) {
    return /*#__PURE__*/React.createElement("div", null, t('Something went wrong.'));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-10"
  }, /*#__PURE__*/React.createElement("h2", null, t('Profile')), view === views.overview && /*#__PURE__*/React.createElement("div", {
    className: "font-semibold underline hover:text-secondary-three transition cursor-pointer",
    onClick: function onClick() {
      return setView(views.edit);
    }
  }, t('Edit')), view === views.edit && /*#__PURE__*/React.createElement("div", {
    className: "font-semibold underline hover:text-secondary-three transition cursor-pointer",
    onClick: function onClick() {
      return setView(views.overview);
    }
  }, t('Close'))), view === views.overview && /*#__PURE__*/React.createElement(ProfileOverview, {
    profile: accountUser === null || accountUser === void 0 ? void 0 : accountUser.individual,
    address: head(accountUser === null || accountUser === void 0 ? void 0 : accountUser.addresses),
    context: context
  })), view === views.edit && /*#__PURE__*/React.createElement(ProfileEditForm, {
    profile: accountUser === null || accountUser === void 0 ? void 0 : accountUser.individual,
    address: head(accountUser === null || accountUser === void 0 ? void 0 : accountUser.addresses),
    context: context,
    onSubmit: function onSubmit(data) {
      var _accountUser$addresse, _accountUser$individu, _address, _address2, _address3, _address4;
      setIsUpdating(true);
      var address = undefined;
      if (accountUser !== null && accountUser !== void 0 && accountUser.addresses && (accountUser === null || accountUser === void 0 ? void 0 : (_accountUser$addresse = accountUser.addresses) === null || _accountUser$addresse === void 0 ? void 0 : _accountUser$addresse.length) > 0) {
        address = head(accountUser === null || accountUser === void 0 ? void 0 : accountUser.addresses);
      }
      var individualData = {
        firstName: data.firstName,
        lastName: data.lastName,
        telephone: data.telephone,
        title: '',
        mobile: '',
        email: data === null || data === void 0 ? void 0 : data.email,
        language: context !== null && context !== void 0 && context.culture ? context === null || context === void 0 ? void 0 : context.culture : 'nl',
        uniqueId: accountUser === null || accountUser === void 0 ? void 0 : (_accountUser$individu = accountUser.individual) === null || _accountUser$individu === void 0 ? void 0 : _accountUser$individu.uniqueId
      };
      var addressData = {
        country: address ? (_address = address) === null || _address === void 0 ? void 0 : _address.country : '',
        postalCode: data.postalCode,
        city: data.city,
        street: data.street,
        number: data.number,
        bus: data.bus,
        defaultDelivery: address ? (_address2 = address) === null || _address2 === void 0 ? void 0 : _address2.defaultDelivery : true,
        defaultInvoice: address ? (_address3 = address) === null || _address3 === void 0 ? void 0 : _address3.defaultInvoice : false,
        uniqueId: address ? (_address4 = address) === null || _address4 === void 0 ? void 0 : _address4.uniqueId : v4(),
        recipient: ''
      };
      accountUserUpdateIndividual(individualData, function () {
        accountUserUpdateAddress(addressData, function () {
          accountUserFetch(function () {
            setIsUpdating(false);
            setView(views.overview);
          });
        });
      });
    },
    onClose: function onClose() {
      return setView(views.overview);
    }
  }));
};

var ProfileAndPreferences = function ProfileAndPreferences(_ref) {
  var context = _ref.context;
  var _useDeleteAccount = useDeleteAccount(context),
    deleteAccount = _useDeleteAccount.deleteAccount;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden mb-5 "
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: "text-14 text-secondary-two hover:text-secondary-three",
    page: context.defaultPageNames.accountOverview,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-left mr-2"
  }), t('Account overview')))), /*#__PURE__*/React.createElement(ProfileOverviewAndEdit, {
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "py-8 border-t border-secondary-four"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold"
  }, t('Delete account')), /*#__PURE__*/React.createElement("div", {
    className: "font-semibold underline hover:text-secondary-three transition cursor-pointer",
    onClick: function onClick() {
      return deleteAccount();
    }
  }, t('Delete'))), /*#__PURE__*/React.createElement("p", null, t('You can delete your Delorge account at any time'), ". ", t('Your profile and all associated information will be removed'), ".")));
};

var ChangePasswordForm = function ChangePasswordForm(_ref) {
  var passwordChange = _ref.passwordChange,
    error = _ref.error,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    oldPassword = _useState[0],
    setOldPassword = _useState[1];
  var _useState2 = useState(''),
    password = _useState2[0],
    setPassword = _useState2[1];
  var _useState3 = useState(''),
    confirmPassword = _useState3[0],
    setConfirmPassword = _useState3[1];
  var _useState4 = useState(false),
    showSamePasswordError = _useState4[0],
    setShowSamePasswordError = _useState4[1];
  var handleSubmit = function handleSubmit() {
    if (password !== confirmPassword) {
      setShowSamePasswordError(true);
    } else {
      setShowSamePasswordError(false);
      passwordChange(oldPassword, password);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden mb-5 "
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: "text-14 text-secondary-two hover:text-secondary-three",
    page: context.defaultPageNames.accountOverview,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-left mr-2"
  }), t('Account overview')))), /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Change password')), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mb-8"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2",
    htmlFor: "current-password"
  }, t('Current password')), /*#__PURE__*/React.createElement("input", {
    className: "border " + (error && !showSamePasswordError ? 'border-red-500 bg-red-50' : 'border-secondary-three') + " rounded px-5 py-3",
    id: "current-password",
    type: "password",
    placeholder: t('Current password'),
    value: oldPassword,
    onChange: function onChange(e) {
      return setOldPassword(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mb-8"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2",
    htmlFor: "new-password"
  }, t('New password')), /*#__PURE__*/React.createElement("input", {
    className: "border " + (showSamePasswordError || error ? 'border-red-500 bg-red-50' : 'border-secondary-three') + " rounded px-5 py-3",
    id: "new-password",
    type: "password",
    placeholder: t('New password'),
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mb-8"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2",
    htmlFor: "confirm-password"
  }, t('Confirm new password')), /*#__PURE__*/React.createElement("input", {
    className: "border " + (showSamePasswordError || error ? 'border-red-500 bg-red-50' : 'border-secondary-three') + " rounded px-5 py-3",
    id: "confirm-password",
    type: "password",
    placeholder: t('Confirm new password'),
    value: confirmPassword,
    onChange: function onChange(e) {
      return setConfirmPassword(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mb-8"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-alternate mb-4"
  }, t('Cancel')), /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    onClick: function onClick() {
      return handleSubmit();
    }
  }, t('Save changes'))), showSamePasswordError && /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, t('Please make sure your passwords match'), "."), error && !showSamePasswordError && /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, error)));
};
var ChangePasswordForm$1 = baseChangePassword(ChangePasswordForm);

var Checkbox = function Checkbox(_ref) {
  var dark = _ref.dark,
    _onClick = _ref.onClick,
    checked = _ref.checked,
    label = _ref.label,
    classNames = _ref.classNames;
  var _useState = useState(checked),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer " + classNames,
    onClick: function onClick(e) {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(!isChecked, e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border border-secondary-three rounded w-5 h-5 \n          " + (isChecked ? 'bg-black text-white' : dark ? 'bg-black text-white' : 'bg-white text-primary')
  }, isChecked && /*#__PURE__*/React.createElement("i", {
    className: "fas fa-check text-xs"
  })), label && /*#__PURE__*/React.createElement("span", {
    className: "text-sm ml-2"
  }, label));
};
Checkbox.defaultProps = {
  checked: false,
  label: '',
  onClick: undefined,
  classNames: 'mr-10'
};

var InputField = function InputField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    errorText = _ref.errorText,
    required = _ref.required,
    type = _ref.type,
    withIcon = _ref.withIcon,
    icon = _ref.icon,
    errorClass = _ref.errorClass,
    inputClass = _ref.inputClass,
    onlyNumbers = _ref.onlyNumbers,
    lightForm = _ref.lightForm,
    onKeyDown = _ref.onKeyDown;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative " + containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "absolute text-xs px-1 bg-white " + (hasError ? 'text-red-400' : lightForm ? 'text-white' : 'text-primary'),
    style: {
      left: 10,
      top: -8,
      zIndex: 1
    }
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, withIcon && /*#__PURE__*/React.createElement("div", {
    className: "flex -mr-px"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center leading-normal rounded rounded-r-none " + (lightForm ? 'text-white' : 'text-gray-700  border') + " border-r-0 " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-white border-gray-400') + " px-3 whitespace-nowrap text-sm"
  }, /*#__PURE__*/React.createElement("i", {
    className: "" + icon
  }))), /*#__PURE__*/React.createElement("input", {
    className: "appearance-none block w-full " + (lightForm ? 'text-white rounded-none px-0' : 'text-gray-700') + " " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-white border-gray-400') + "  " + (withIcon ? 'border-r border-t border-b rounded-l-none pr-4 rounded-r' : 'border px-4 rounded') + " py-3 focus:outline-none " + inputClass,
    type: type,
    placeholder: placeholder,
    value: value,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onChange: function onChange(e) {
      if (onlyNumbers) {
        var re = /^[0-9\b]+$/;
        if (re.test(e.target.value)) {
          _onChange(e.target.value);
        }
      } else {
        _onChange(e.target.value);
      }
    }
  })), hasError && errorText !== '' && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1 " + errorClass
  }, errorText));
};
InputField.defaultProps = {
  containerClass: 'text-sm',
  type: 'text',
  required: false,
  withIcon: false,
  icon: '',
  errorClass: '',
  inputClass: 'rounded',
  onlyNumbers: false,
  lightForm: false
};

var GenericList = function GenericList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    _ref$orderByField = _ref.orderByField,
    orderByField = _ref$orderByField === void 0 ? 'label' : _ref$orderByField,
    handleFilterChanged = _ref.handleFilterChanged,
    _ref$withSearch = _ref.withSearch,
    withSearch = _ref$withSearch === void 0 ? false : _ref$withSearch,
    _ref$maxOptions = _ref.maxOptions,
    maxOptions = _ref$maxOptions === void 0 ? 6 : _ref$maxOptions,
    renderSubFilters = _ref.renderSubFilters;
  var _useState = useState(''),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var _useState2 = useState(false),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mappedOptions = map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  });
  var options = orderByField !== undefined && orderByField !== null && orderByField !== '' ? orderBy(mappedOptions, [orderByField]) : mappedOptions;
  var matchedOptions = searchTerm ? filter(options, function (option) {
    var _option$label;
    return includes((_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toLowerCase(), searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
  }) : options;
  var visibleOptions = showAll ? matchedOptions : matchedOptions.slice(0, maxOptions);
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, withSearch && /*#__PURE__*/React.createElement(InputField, {
    value: searchTerm,
    withIcon: true,
    icon: "far fa-search",
    placeholder: t('Enter the search term'),
    onChange: function onChange(value) {
      return setSearchTerm(value);
    }
  }), (matchedOptions === null || matchedOptions === void 0 ? void 0 : matchedOptions.length) === 0 && /*#__PURE__*/React.createElement("div", null, t('No options to show')), visibleOptions.map(function (option, i) {
    var isSelected = isArray(option.value) ? some(option.value, function (value) {
      return values.includes(value);
    }) : values.includes(option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: option.value + "-" + i
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onClick: function onClick() {
        return handleFilterChanged(option);
      },
      checked: isSelected,
      label: option.label
    }), renderSubFilters && typeof renderSubFilters === 'function' && isSelected && renderSubFilters(option));
  }), matchedOptions.length > maxOptions && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setShowAll(function (prev) {
        return !prev;
      });
    },
    className: "mt-4 text-primary underline text-sm hover:no-underline cursor-pointer",
    style: {
      width: 'fit-content'
    }
  }, showAll ? t('Show less') : t('Show more')));
};
GenericList.defaultProps = {
  containerClass: 'space-y-2'
};

var MakesAgent = function MakesAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var ModelsList = function ModelsList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged;
  var isModelSelected = function isModelSelected(values, option, make) {
    return some(values, function (val) {
      return (val === null || val === void 0 ? void 0 : val.model) === option && val.make === make;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(items, function (item, i) {
    var _item$make, _item$make2;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + ((_item$make = item.make) === null || _item$make === void 0 ? void 0 : _item$make.key)
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-secondary-three font-bold mt-2"
    }, item === null || item === void 0 ? void 0 : (_item$make2 = item.make) === null || _item$make2 === void 0 ? void 0 : _item$make2.text), map(item.options, function (option) {
      var isSelected = isModelSelected(values, option.key, item.make.key);
      return /*#__PURE__*/React.createElement("div", {
        key: "filter-" + option.key + "-" + i,
        className: "flex items-center justify-between py-5 cursor-pointer text-base text-primary hover:text-secondary-three transition",
        onClick: function onClick() {
          return handleFilterChanged(option);
        }
      }, /*#__PURE__*/React.createElement("div", null, option.label), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center border border-secondary-three rounded w-6 h-6 " + (isSelected ? 'bg-black text-white' : 'bg-white text-primary')
      }, isSelected && /*#__PURE__*/React.createElement("i", {
        className: "fas fa-check text-xs"
      })));
    }));
  }));
};

var ModelsAgent = function ModelsAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(ModelsList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var PriceAgent = function PriceAgent(_ref) {
  var prices = _ref.prices,
    monthly = _ref.monthly,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(0),
    currentPrice = _useState[0],
    setCurrentPrice = _useState[1];
  var _useState2 = useState(0),
    currentMonthly = _useState2[0],
    setCurrentMonthly = _useState2[1];
  var _useState3 = useState(false),
    showMonthly = _useState3[0],
    setShowMonthly = _useState3[1];
  var renderMonthlySlider = function renderMonthlySlider() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Slider, {
      min: monthly === null || monthly === void 0 ? void 0 : monthly.min,
      max: monthly === null || monthly === void 0 ? void 0 : monthly.max,
      step: monthly === null || monthly === void 0 ? void 0 : monthly.step,
      value: currentMonthly,
      onChange: function onChange(value) {
        return setCurrentMonthly(value);
      },
      onAfterChange: function onAfterChange(value) {
        return onChange([0, value], FilterTypes.monthlyPrice);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold mt-2"
    }, t('Max. amount'), /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, formatPrice(currentMonthly))));
  };
  var renderTotalPriceSlider = function renderTotalPriceSlider() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Slider, {
      min: prices === null || prices === void 0 ? void 0 : prices.min,
      max: prices === null || prices === void 0 ? void 0 : prices.max,
      step: prices === null || prices === void 0 ? void 0 : prices.step,
      value: currentPrice,
      onChange: function onChange(value) {
        return setCurrentPrice(value);
      },
      onAfterChange: function onAfterChange(value) {
        return onChange([0, value], FilterTypes.price);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold mt-2"
    }, t('Max. amount'), /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, formatPrice(currentPrice))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "inline-block mb-5 bg-secondary-five rounded-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer inline-block rounded-full py-3 px-5 " + (!showMonthly ? 'bg-secondary-three text-white' : 'bg-secondary-five text-primary'),
    onClick: function onClick() {
      return setShowMonthly(false);
    }
  }, t('Total price')), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer inline-block py-3 px-5 rounded-full " + (showMonthly ? 'bg-secondary-three  text-white' : 'bg-secondary-five text-primary'),
    onClick: function onClick() {
      return setShowMonthly(true);
    }
  }, t('Monthly price'))), showMonthly ? renderMonthlySlider() : renderTotalPriceSlider());
};

var CategoryAgent = function CategoryAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var BodyTypeAgent = function BodyTypeAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var SelectBox = function SelectBox(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    placeholder = _ref.placeholder,
    isLoading = _ref.isLoading,
    isMulti = _ref.isMulti,
    isSearchable = _ref.isSearchable,
    customComponents = _ref.customComponents,
    closeMenuOnSelect = _ref.closeMenuOnSelect,
    menuPlacement = _ref.menuPlacement,
    hideSelectedOptions = _ref.hideSelectedOptions,
    customStyles = _ref.customStyles,
    label = _ref.label;
  var DropdownIndicator = function DropdownIndicator(props) {
    return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("i", {
      className: (props.selectProps.menuIsOpen ? 'far fa-chevron-up' : 'far fa-chevron-down') + " text-secondary-three"
    }));
  };
  var formatGroupLabel = function formatGroupLabel(data) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "font-semibold text-primary text-12"
    }, "- ", data.label));
  };
  var Components = customComponents ? _extends({
    DropdownIndicator: DropdownIndicator
  }, customComponents) : {
    DropdownIndicator: DropdownIndicator
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, label && /*#__PURE__*/React.createElement("span", {
    className: "absolute text-xs px-1 bg-white",
    style: {
      left: 10,
      top: -8,
      zIndex: 1
    }
  }, label), /*#__PURE__*/React.createElement(Select, {
    value: value,
    onChange: onChange,
    options: options,
    classNamePrefix: "delorge-select",
    className: className,
    components: Components,
    formatGroupLabel: formatGroupLabel,
    isDisabled: isDisabled,
    placeholder: placeholder,
    isLoading: isLoading,
    closeMenuOnSelect: closeMenuOnSelect,
    menuPlacement: menuPlacement,
    isMulti: isMulti,
    isSearchable: isSearchable,
    hideSelectedOptions: hideSelectedOptions,
    styles: _extends({
      indicatorSeparator: function indicatorSeparator() {
        return {
          display: 'none'
        };
      }
    }, customStyles)
  }));
};
SelectBox.defaultProps = {
  value: null,
  options: [],
  isDisabled: false,
  className: '',
  placeholder: 'Select...',
  label: null,
  isLoading: false,
  customComponents: null,
  isMulti: false,
  isSearchable: false,
  closeMenuOnSelect: true,
  menuPlacement: 'bottom',
  hideSelectedOptions: false,
  customStyles: {}
};

var GenericRangeSelect = function GenericRangeSelect(_ref) {
  var placeHolderFrom = _ref.placeHolderFrom,
    placeHolderTo = _ref.placeHolderTo,
    optionsFrom = _ref.optionsFrom,
    optionsTo = _ref.optionsTo,
    value = _ref.value,
    handleFilterChanged = _ref.handleFilterChanged;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var valueFrom = value ? {
    label: value[0] ? value[0] : ''
  } : '';
  var valueTo = value ? {
    label: value[1] ? value[1] : ''
  } : '';
  if (value && value[0]) {
    optionsTo = filter(optionsTo, function (y) {
      return y.value >= value[0];
    });
  }
  if (value && value[1]) {
    optionsFrom = filter(optionsFrom, function (y) {
      return y.value <= value[1];
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 w-full "
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueFrom,
    options: optionsFrom,
    className: "border border-secondary-three border-r-0 rounded rounded-r-none",
    placeholder: placeHolderFrom,
    label: t('From'),
    isLoading: false,
    onChange: function onChange(item) {
      var start = item.value;
      var stop = value && value[1] && value[1] > item.value ? value[1] : undefined;
      handleFilterChanged([start, stop]);
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: valueTo,
    options: optionsTo,
    className: "border border-secondary-three rounded rounded-l-none",
    placeholder: placeHolderTo,
    label: t('To'),
    isLoading: false,
    onChange: function onChange(item) {
      var start = value && value[0] && value[0] < item.value ? value[0] : undefined;
      var stop = item.value;
      handleFilterChanged([start, stop]);
    }
  }));
};

var YearAgent = function YearAgent(_ref) {
  var min = _ref.min,
    max = _ref.max,
    values = _ref.values,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(min, max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(min, max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: values,
    handleFilterChanged: onChange
  }));
};

var FuelAgent = function FuelAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var MileageAgent = function MileageAgent(_ref) {
  var min = _ref.min,
    max = _ref.max,
    values = _ref.values,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mileagesFrom = range(min, max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  var mileagesTo = range(min, max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: mileagesFrom,
    optionsTo: mileagesTo,
    value: values,
    handleFilterChanged: onChange
  }));
};

var GearboxAgent = function GearboxAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var GenericColorList = function GenericColorList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    gridClass = _ref.gridClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text,
      color: item.custom
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement("div", {
    className: gridClass
  }, map(options, function (option) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "exterior-filter-" + option.value,
      className: "flex flex-col items-center cursor-pointer",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-14 h-14 rounded-full flex items-center justify-center text-xl " + (option.value === 'white' ? 'border border-primary text-primary' : 'text-white'),
      style: {
        backgroundColor: option.color
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check"
    })), /*#__PURE__*/React.createElement("div", {
      className: "py-4 capitalize truncate"
    }, option.label));
  }));
};
GenericColorList.defaultProps = {
  gridClass: 'grid grid-cols-4 gap-4'
};

var ExteriorAgent = function ExteriorAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericColorList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var InteriorColorAgent = function InteriorColorAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericColorList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var UpholsteryAgent = function UpholsteryAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var EuronormAgent = function EuronormAgent(_ref) {
  var items = _ref.items,
    values = _ref.values,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    handleFilterChanged: onChange
  });
};

var labels = {
  PK: 'PK',
  KW: 'KW'
};
var initPK = {
  min: '',
  max: ''
};
var initKW = {
  min: '',
  max: ''
};
var PowerAgent = function PowerAgent(_ref) {
  var values = _ref.values,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  var _useState = useState('PK'),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pk = values.pk,
      kw = values.kw;
    if (pk) {
      setPk({
        min: pk[0],
        max: pk[1]
      });
    }
    if (kw) {
      setKw({
        min: kw[0],
        max: kw[1]
      });
    }
  }, []);
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      onChange(value, FilterTypes.pk);
    } else {
      onRemove({
        type: FilterTypes.pk
      });
    }
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      onChange(value, FilterTypes.kw);
    } else {
      onRemove({
        type: FilterTypes.kw
      });
    }
  };
  var powerOptions = [{
    value: labels.PK,
    label: t('hp')
  }, {
    value: labels.KW,
    label: t('kW')
  }];
  var renderPk = function renderPk() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-primary text-primary rounded-l focus:outline-none",
      value: pk.min,
      style: {
        minHeight: 42,
        maxHeight: 42
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-primary rounded-r focus:outline-none",
      value: pk.max,
      style: {
        minHeight: 42,
        maxHeight: 42
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKw = function renderKw() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-primary text-primary rounded-l focus:outline-none",
      value: kw.min,
      style: {
        minHeight: 42,
        maxHeight: 42
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-primary rounded-r focus:outline-none",
      value: kw.max,
      style: {
        minHeight: 42,
        maxHeight: 42
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-2/5 mr-2"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: find(powerOptions, function (i) {
      return i.value === activeOption;
    }),
    options: powerOptions,
    className: "focus:outline-none",
    isLoading: false,
    onChange: function onChange(option) {
      return setActiveOption(option.value);
    }
  })), /*#__PURE__*/React.createElement(Fade, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-3/5 w-full flex"
  }, activeOption === labels.PK && renderPk(), activeOption === labels.KW && renderKw())));
};

var SEATS_RANGE = [{
  label: 'S',
  icon: 'icon-family-small',
  value: 2
}, {
  label: 'M',
  icon: 'icon-family-medium',
  value: 3
}, {
  label: 'L',
  icon: 'icon-family-large',
  value: 4
}, {
  label: 'XL',
  icon: 'icon-family-xlarge',
  value: 5
}];
var SeatsAgent = function SeatsAgent(_ref) {
  var values = _ref.values,
    onChange = _ref.onChange;
  var isSelected = function isSelected(value) {
    return values && head(values) && head(values) === value;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap text-14"
  }, map(SEATS_RANGE, function (seat) {
    var value = seat.value,
      label = seat.label,
      icon = seat.icon;
    return /*#__PURE__*/React.createElement("div", {
      className: "w-24 h-24 border " + (isSelected(value) ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 shadow-md hover:border-secondary-three transition",
      onClick: function onClick() {
        return onChange([value]);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center outline-none text-primary"
    }, /*#__PURE__*/React.createElement("i", {
      className: icon,
      style: {
        fontSize: 29
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "mt-3 text-14 truncate leading-24 w-full text-center"
    }, label)));
  }));
};

var DOORS_RANGE = [{
  label: 'All',
  value: undefined
}, {
  label: '2/3',
  value: [2, 3]
}, {
  label: '4/5',
  value: [4, 5]
}, {
  label: '6/7',
  value: [6, 7]
}];
var DoorsAgent = function DoorsAgent(_ref) {
  var values = _ref.values,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  var isSelected = function isSelected(value) {
    return JSON.stringify(values) === JSON.stringify(value);
  };
  var handleClick = function handleClick(value) {
    if (value) {
      onChange(value);
    } else {
      onRemove({
        type: FilterTypes.doorsRange
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 text-14",
    style: {
      height: 42
    }
  }, map(DOORS_RANGE, function (d, index) {
    var isLast = DOORS_RANGE.length - 1 === index;
    var isFirst = index === 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center items-center cursor-pointer text-center border-t border-b border-l border-primary \n                                " + (isSelected(d.value) ? 'bg-secondary-two text-white' : 'text-secondary-three') + "\n                                " + (isFirst ? 'rounded-l' : '') + " \n                                " + (isLast ? 'rounded-r border-r' : ''),
      onClick: function onClick() {
        return handleClick(d.value);
      }
    }, d.label);
  }));
};

var INIT = {
  min: '',
  max: ''
};
var Co2Agent = function Co2Agent(_ref) {
  var values = _ref.values,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  var _useState = useState(INIT),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (values) {
      setValue({
        min: values[0],
        max: values[1]
      });
    }
  }, []);
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      onChange([value.min, value.max], FilterTypes.co2Range);
    } else {
      onRemove({
        type: FilterTypes.co2Range
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex",
    style: {
      height: 44
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border border-primary text-primary rounded-l focus:outline-none",
    value: value.min,
    style: {
      maxHeight: 46
    },
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-primary rounded-r focus:outline-none",
    value: value.max,
    style: {
      maxHeight: 46
    },
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }));
};

var VatAgent = function VatAgent(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange(val) {
    if (val) {
      onChange(val, FilterTypes.vat);
    } else {
      onRemove({
        type: FilterTypes.vat
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-gray-900 mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row py-2 px-1 rounded cursor-pointer hover:text-primary",
    onClick: function onClick() {
      return handleChange(!value);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded border border-primary mr-2",
    style: {
      height: 16,
      width: 16
    }
  }, value && /*#__PURE__*/React.createElement("i", {
    className: "far fa-check text-secondary-two",
    style: {
      fontSize: 12
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between flex-1 relative text-primary " + (value ? 'font-semibold' : 'font-normal')
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('VAT deductible')))));
};

var CarAgentFilters = function CarAgentFilters(_ref) {
  var keys = _ref.keys,
    category = _ref.category,
    context = _ref.context,
    _onChange = _ref.onChange,
    _onRemove = _ref.onRemove;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderCategoryContent = function renderCategoryContent(category) {
    var _category$data, _category$data2, _category$selected, _category$selected2, _category$data3, _category$data4, _category$data5, _category$data6;
    switch (category.key) {
      case keys.make:
        return /*#__PURE__*/React.createElement(MakesAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.makeModel,
              value: data.value
            });
          },
          context: context
        });
      case keys.model:
        return /*#__PURE__*/React.createElement(ModelsAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.makeModel,
              value: data.value
            });
          }
        });
      case keys.price:
        return /*#__PURE__*/React.createElement(PriceAgent, {
          prices: category === null || category === void 0 ? void 0 : (_category$data = category.data) === null || _category$data === void 0 ? void 0 : _category$data.prices,
          monthly: category === null || category === void 0 ? void 0 : (_category$data2 = category.data) === null || _category$data2 === void 0 ? void 0 : _category$data2.monthly,
          selectedPrice: category === null || category === void 0 ? void 0 : (_category$selected = category.selected) === null || _category$selected === void 0 ? void 0 : _category$selected.prices,
          selectedMonthly: (_category$selected2 = category.selected) === null || _category$selected2 === void 0 ? void 0 : _category$selected2.monthlyPrices,
          onChange: function onChange(data, type) {
            return _onChange({
              type: type,
              value: data
            });
          },
          context: context
        });
      case keys.category:
        return /*#__PURE__*/React.createElement(CategoryAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.category,
              value: data.value
            });
          }
        });
      case keys.body:
        return /*#__PURE__*/React.createElement(BodyTypeAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.body,
              value: data.value
            });
          }
        });
      case keys.year:
        return /*#__PURE__*/React.createElement(YearAgent, {
          min: category === null || category === void 0 ? void 0 : (_category$data3 = category.data) === null || _category$data3 === void 0 ? void 0 : _category$data3.min,
          max: category === null || category === void 0 ? void 0 : (_category$data4 = category.data) === null || _category$data4 === void 0 ? void 0 : _category$data4.max,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.year,
              value: data
            });
          }
        });
      case keys.fuel:
        return /*#__PURE__*/React.createElement(FuelAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.fuel,
              value: data.value
            });
          }
        });
      case keys.mileage:
        return /*#__PURE__*/React.createElement(MileageAgent, {
          min: category === null || category === void 0 ? void 0 : (_category$data5 = category.data) === null || _category$data5 === void 0 ? void 0 : _category$data5.min,
          max: category === null || category === void 0 ? void 0 : (_category$data6 = category.data) === null || _category$data6 === void 0 ? void 0 : _category$data6.max,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.mileage,
              value: data
            });
          }
        });
      case keys.power:
        return /*#__PURE__*/React.createElement(PowerAgent, {
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data, type) {
            return _onChange({
              type: type,
              value: data
            });
          },
          onRemove: function onRemove(data) {
            return _onRemove(data);
          }
        });
      case keys.gearbox:
        return /*#__PURE__*/React.createElement(GearboxAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.transmission,
              value: data.value
            });
          }
        });
      case keys.seating:
        return /*#__PURE__*/React.createElement(SeatsAgent, {
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.seatsRange,
              value: data
            });
          }
        });
      case keys.doors:
        return /*#__PURE__*/React.createElement(DoorsAgent, {
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.doorsRange,
              value: data
            });
          },
          onRemove: function onRemove(data) {
            return _onRemove(data);
          }
        });
      case keys.vat:
        return /*#__PURE__*/React.createElement(VatAgent, {
          value: category === null || category === void 0 ? void 0 : category.value,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.vat,
              value: data
            });
          },
          onRemove: function onRemove(data) {
            return _onRemove(data);
          }
        });
      case keys.exteriorColor:
        return /*#__PURE__*/React.createElement(ExteriorAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.exteriorColor,
              value: data.value
            });
          }
        });
      case keys.interiorColor:
        return /*#__PURE__*/React.createElement(InteriorColorAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.interiorColor,
              value: data.value
            });
          }
        });
      case keys.upholstery:
        return /*#__PURE__*/React.createElement(UpholsteryAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.interiorUpholstery,
              value: data.value
            });
          }
        });
      case keys.co2:
        return /*#__PURE__*/React.createElement(Co2Agent, {
          values: category === null || category === void 0 ? void 0 : category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.co2Range,
              value: data
            });
          },
          onRemove: function onRemove(data) {
            return _onRemove(data);
          }
        });
      case keys.euronorm:
        return /*#__PURE__*/React.createElement(EuronormAgent, {
          items: category === null || category === void 0 ? void 0 : category.data,
          values: category.values,
          onChange: function onChange(data) {
            return _onChange({
              type: FilterTypes.euroNorm,
              value: data.value
            });
          }
        });
      default:
        return /*#__PURE__*/React.createElement("p", null, t('Something went wrong'), "...");
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, renderCategoryContent(category));
};

var CarAgentUser = function CarAgentUser(_ref) {
  var state = _ref.state,
    isEdit = _ref.isEdit,
    onUpdate = _ref.onUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState({}),
    user = _useState[0],
    setUser = _useState[1];
  var _useState2 = useState({}),
    formErrors = _useState2[0];
  useEffect(function () {
    setUser(state.user);
  }, [state]);
  var handleUpdateUser = function handleUpdateUser(field, value) {
    var _extends2;
    var updated = _extends({}, user, (_extends2 = {}, _extends2[field] = value, _extends2));
    setUser(updated);
  };
  var onEdit = function onEdit(e) {
    e.preventDefault();
    onUpdate(user);
  };
  if (!isEdit) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, ' ', state.user.firstName, " ", state.user.lastName), /*#__PURE__*/React.createElement("p", null, state.user.telephone), /*#__PURE__*/React.createElement("p", null, state.user.email));
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return onEdit(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4 md:mb-0 w-full md:w-1/2 mr-0 md:mr-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-user absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: user.firstName,
    placeholder: t('First name'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.firstName ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return handleUpdateUser('firstName', e.target.value);
    }
  }), formErrors.firstName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.firstName)), /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4 md:mb-0 w-full md:w-1/2 ml-0 md:ml-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-user absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: user.lastName,
    placeholder: t('Last name'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.lastName ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return handleUpdateUser('lastName', e.target.value);
    }
  }), formErrors.lastName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.lastName))), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4 md:mb-0 w-full md:w-1/2 mr-0 md:mr-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-phone absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: user.telephone,
    placeholder: t('Telephone'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.telephone ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return handleUpdateUser('telephone', e.target.value);
    }
  }), formErrors.telephone && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.telephone)), /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4 md:mb-0 w-full md:w-1/2 ml-0 md:ml-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-envelope absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "email",
    value: user.email,
    placeholder: t('Email'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.email ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return handleUpdateUser('email', e.target.value);
    }
  }), formErrors.email && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.email))), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button button-secondary"
  }, t('Update'))));
};

var keys = {
  make: 'make',
  model: 'model',
  price: 'price',
  category: 'category',
  body: 'body',
  year: 'year',
  fuel: 'fuel',
  mileage: 'mileage',
  power: 'power',
  gearbox: 'gearbox',
  seating: 'seating',
  doors: 'doors',
  vat: 'vat',
  exteriorColor: 'exteriorColor',
  interiorColor: 'interiorColor',
  material: 'material',
  co2: 'co2',
  euronorm: 'euronorm'
};
var CarAgentOverview = function CarAgentOverview(_ref) {
  var _head;
  var alert = _ref.alert,
    updateSearchAgentAlertUser = _ref.updateSearchAgentAlertUser,
    updateSearchAgentAlertFilters = _ref.updateSearchAgentAlertFilters,
    loading = _ref.loading,
    data = _ref.data,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('make'),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useState2 = useState(alert),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(false),
    isEditUser = _useState3[0],
    setIsEditUser = _useState3[1];
  useEffect(function () {
    setState(alert);
  }, [alert]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "loading");
  }
  if (!state) {
    return /*#__PURE__*/React.createElement("div", null, "Ohnoo");
  }
  var modelsPerMake = function modelsPerMake() {
    return map(data === null || data === void 0 ? void 0 : data.makes, function (make) {
      if (make !== null && make !== void 0 && make.models) {
        return {
          make: make,
          options: map(filter(make.models, function (model) {
            return model.custom === make.key;
          }), function (model) {
            return {
              key: model.key,
              value: make.key + '|' + model.key,
              label: model.text
            };
          })
        };
      }
    });
  };
  var carAgentCategories = [{
    key: keys.make,
    translation: function translation(t) {
      return t('Make');
    },
    data: data === null || data === void 0 ? void 0 : data.makes,
    values: uniq(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.makeModel;
    }), function (f) {
      if (includes(f.value, '|')) {
        return f.value.split('|')[0];
      } else {
        return f.value;
      }
    }))
  }, {
    key: keys.model,
    translation: function translation(t) {
      return t('Model');
    },
    data: modelsPerMake(),
    values: uniq(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.makeModel;
    }), function (f) {
      if (includes(f.value, '|')) {
        var make = head(f.value.split('|'));
        var model = last(f.value.split('|'));
        if (make && model) return {
          make: make,
          model: model
        };
      }
    }))
  }, {
    key: keys.price,
    translation: function translation(t) {
      return t('Price');
    },
    data: {
      prices: data === null || data === void 0 ? void 0 : data.prices,
      monthly: data === null || data === void 0 ? void 0 : data.monthlyPrices
    },
    selected: {
      prices: last(map(filter(state.filters, function (f) {
        return f.type === FilterTypes.price;
      }), function (f) {
        return f.value;
      })),
      monthlyPrices: last(map(filter(state.filters, function (f) {
        return f.type === FilterTypes.price;
      }), function (f) {
        return f.value;
      }))
    }
  }, {
    key: keys.body,
    translation: function translation(t) {
      return t('Type');
    },
    data: data === null || data === void 0 ? void 0 : data.bodyTypes,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.body;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.year,
    translation: function translation(t) {
      return t('Year');
    },
    data: data === null || data === void 0 ? void 0 : data.years,
    values: head(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.year;
    }), function (f) {
      return f.value;
    }))
  }, {
    key: keys.fuel,
    translation: function translation(t) {
      return t('Fuel');
    },
    data: data === null || data === void 0 ? void 0 : data.fuels,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.fuel;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.mileage,
    translation: function translation(t) {
      return t('Mileage');
    },
    data: data === null || data === void 0 ? void 0 : data.mileages,
    values: head(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.mileage;
    }), function (f) {
      return f.value;
    }))
  }, {
    key: keys.power,
    translation: function translation(t) {
      return t('Power');
    },
    values: {
      pk: last(map(filter(state.filters, function (f) {
        return f.type === FilterTypes.pk;
      }), function (f) {
        return f.value;
      })),
      kw: last(map(filter(state.filters, function (f) {
        return f.type === FilterTypes.kw;
      }), function (f) {
        return f.value;
      }))
    }
  }, {
    key: keys.gearbox,
    translation: function translation(t) {
      return t('Transmission');
    },
    data: data === null || data === void 0 ? void 0 : data.gearboxes,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.transmission;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.seating,
    translation: function translation(t) {
      return t('Seating');
    },
    values: head(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.seatsRange;
    }), function (f) {
      return f.value;
    }))
  }, {
    key: keys.doors,
    translation: function translation(t) {
      return t('Doors');
    },
    values: head(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.doorsRange;
    }), function (f) {
      return f.value;
    }))
  }, {
    key: keys.vat,
    translation: function translation(t) {
      return t('VAT');
    },
    value: (_head = head(filter(state.filters, function (f) {
      return f.type === FilterTypes.vat;
    }))) === null || _head === void 0 ? void 0 : _head.value
  }, {
    key: keys.exteriorColor,
    translation: function translation(t) {
      return t('Exterior color');
    },
    data: data === null || data === void 0 ? void 0 : data.exteriorColors,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.exteriorColor;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.interiorColor,
    translation: function translation(t) {
      return t('Interior color');
    },
    data: data === null || data === void 0 ? void 0 : data.interiorColors,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.interiorColor;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.upholstery,
    translation: function translation(t) {
      return t('Material');
    },
    data: data === null || data === void 0 ? void 0 : data.interiorUpholsteries,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.interiorUpholstery;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.co2,
    translation: function translation(t) {
      return t('CO2 emission (g/km)');
    },
    values: last(map(filter(state.filters, function (f) {
      return f.type === FilterTypes.co2Range;
    }), function (f) {
      return f.value;
    }))
  }, {
    key: keys.euronorm,
    translation: function translation(t) {
      return t('Euronorm');
    },
    data: data === null || data === void 0 ? void 0 : data.euroNorms,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.euroNorm;
    }), function (f) {
      return f.value;
    })
  }, {
    key: keys.category,
    translation: function translation(t) {
      return t('Vehicle category');
    },
    data: data === null || data === void 0 ? void 0 : data.categories,
    values: map(filter(state.filters, function (f) {
      return f.type === FilterTypes.category;
    }), function (f) {
      return f.value;
    })
  }];
  var addFilter = function addFilter(data) {
    return [].concat(state.filters, [data]);
  };
  var removeFilter = function removeFilter(data) {
    return filter(state.filters, function (f) {
      return JSON.stringify(f) !== JSON.stringify(data);
    });
  };
  var removeFilterByType = function removeFilterByType(data) {
    return filter(state.filters, function (f) {
      return f.type !== data.type;
    });
  };
  var handleUpdateFilters = function handleUpdateFilters(data) {
    var UNIQUE = [FilterTypes.mileage, FilterTypes.pk, FilterTypes.kw, FilterTypes.co2Range, FilterTypes.seatsRange, FilterTypes.doorsRange, FilterTypes.price, FilterTypes.monthlyPrice, FilterTypes.year];
    var updated;
    if (includes(UNIQUE, data.type)) {
      updated = _extends({}, state, {
        filters: [].concat(removeFilterByType(data), [data])
      });
    } else {
      var existingFilter = find(state.filters, function (fil) {
        return JSON.stringify(fil) === JSON.stringify(data);
      });
      if (existingFilter) {
        updated = _extends({}, state, {
          filters: removeFilter(data)
        });
      } else {
        updated = _extends({}, state, {
          filters: addFilter(data)
        });
      }
    }
    setState(updated);
  };
  var handleRemoveFilter = function handleRemoveFilter(data) {
    var updated = _extends({}, state, {
      filters: removeFilterByType(data)
    });
    setState(updated);
  };
  var handleUpdateCriteria = function handleUpdateCriteria(e) {
    e.preventDefault();
    updateSearchAgentAlertFilters(state.filters);
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return handleUpdateCriteria(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden mb-5 "
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: "text-14 text-secondary-two hover:text-secondary-three",
    page: context.defaultPageNames.accountOverview,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-left mr-2"
  }), t('Account overview')))), /*#__PURE__*/React.createElement("h2", {
    className: "mb-5"
  }, t('Did you not find what you were looking for? We will look for you!')), /*#__PURE__*/React.createElement("p", null, t('Let our Car Agent know what you think is important and we will search in our extensive network for your dreamcar'), "."), /*#__PURE__*/React.createElement("div", {
    className: "pb-5 border-b border-secondary-four mb-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('We will contact you using this contact information'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between font-semibold mb-2"
  }, /*#__PURE__*/React.createElement("p", null, t('Contact')), !isEditUser && /*#__PURE__*/React.createElement("p", {
    className: "underline cursor-pointer",
    onClick: function onClick() {
      return setIsEditUser(true);
    }
  }, t('Edit')), isEditUser && /*#__PURE__*/React.createElement("p", {
    className: "underline cursor-pointer",
    onClick: function onClick() {
      return setIsEditUser(false);
    }
  }, t('Back'))), /*#__PURE__*/React.createElement(Fade$1, {
    spy: isEditUser
  }, /*#__PURE__*/React.createElement(CarAgentUser, {
    state: state,
    isEdit: isEditUser,
    onUpdate: function onUpdate(user) {
      setState(_extends({}, state, {
        user: user
      }));
      updateSearchAgentAlertUser(user);
      setIsEditUser(false);
    },
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2"
  }, map(carAgentCategories, function (category) {
    return /*#__PURE__*/React.createElement("div", {
      key: category.key
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        category.key === activeCategory ? setActiveCategory('') : setActiveCategory(category.key);
      },
      className: "flex justify-between items-center bg-secondary-two text-white p-4 border-b border-secondary-three cursor-pointer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, category.translation(t)), /*#__PURE__*/React.createElement("i", {
      className: "text-20 fal " + (activeCategory === category.key ? 'fa-angle-down' : 'fa-angle-up')
    })), activeCategory === category.key && /*#__PURE__*/React.createElement(CarAgentFilters, {
      keys: keys,
      state: state,
      category: category,
      context: context,
      onChange: function onChange(data) {
        return handleUpdateFilters(data);
      },
      onRemove: function onRemove(data) {
        return handleRemoveFilter(data);
      }
    }));
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "w-full mt-5 button button-primary"
  }, loading ? t('Loading...') : t('Send criteria'))));
};
var CarAgentOverview$1 = baseSearchAgentEdit(CarAgentOverview);

var resolveViewByUrl = function resolveViewByUrl(context) {
  if (hasWindow()) {
    var page = find(context.allPagesData, function (data) {
      return data.url === window.location.pathname && data.language === context.culture;
    });
    return page ? page.key : 'account-overview';
  }
  return 'account-overview';
};
var resolvePageTypeByKey = function resolvePageTypeByKey(key, context) {
  var page = find(context.allPagesData, function (data) {
    return data.key === key && data.language === context.culture;
  });
  return page ? page.type : 'accountOverview';
};
var AccountPage = function AccountPage(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(resolveViewByUrl(context)),
    activeView = _useState[0];
  var views = {
    overview: {
      key: 'account-overview',
      title: t('Account overview'),
      icon: 'far fa-user',
      menu: true
    },
    profile: {
      key: 'account-profile',
      title: t('Profile and preferences'),
      icon: 'far fa-cog',
      menu: true
    },
    password: {
      key: 'account-change-password',
      title: t('Change password'),
      icon: 'far fa-unlock',
      menu: true
    },
    carAgent: {
      key: 'account-car-agent',
      title: t('Keep me notified'),
      icon: 'far fa-lightbulb-on',
      menu: true
    },
    favorites: {
      key: 'account-favorites',
      title: t('My favorites'),
      icon: 'far fa-heart',
      menu: true
    }
  };
  var renderView = function renderView(view) {
    switch (view) {
      case views.overview.key:
        return /*#__PURE__*/React.createElement(AccountOverview, {
          context: context
        });
      case views.profile.key:
        return /*#__PURE__*/React.createElement(ProfileAndPreferences, {
          context: context
        });
      case views.password.key:
        return /*#__PURE__*/React.createElement(ChangePasswordForm$1, {
          context: context
        });
      case views.carAgent.key:
        return /*#__PURE__*/React.createElement(CarAgentOverview$1, {
          context: context
        });
      case views.favorites.key:
        return /*#__PURE__*/React.createElement(Favorites$1, {
          context: context
        });
      default:
        return /*#__PURE__*/React.createElement(AccountOverview, {
          context: context
        });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto py-12 px-5 md:px-10",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-56 mr-8 flex-none"
  }, /*#__PURE__*/React.createElement("ul", null, map(filter(views, function (view) {
    return view.menu;
  }), function (view) {
    return /*#__PURE__*/React.createElement("li", {
      key: view.key,
      className: "cursor-pointer truncate border-l-4 " + (view.key === activeView ? 'border-secondary' : 'border-white') + " py-2 hover:text-secondary-three transition"
    }, /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames[resolvePageTypeByKey(view.key, context)],
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex pl-4"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 30,
        minWidth: 30
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "" + (view === null || view === void 0 ? void 0 : view.icon)
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-full truncate"
    }, view === null || view === void 0 ? void 0 : view.title))));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SignOutButton$1, {
    context: context
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, renderView(activeView))));
};
var AccountPage$1 = baseAccountPage(AccountPage);

var Account = function Account(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement(AccountPage$1, {
    context: context
  });
};
Account.human = {
  nl: 'Account',
  fr: 'Account',
  en: 'Account'
};
Account.defaultProps = {};

var ForgotPasswordMessage = function ForgotPasswordMessage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t('Follow the instructions in the email we have sent you.')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, t('Attention'), "!"), " ", t('Look in your spam folder if you did not receive an email for resetting your password'), "."));
};

var ForgotPasswordForm = function ForgotPasswordForm(_ref) {
  var onSubmit = _ref.onSubmit;
  var _useState = useState(''),
    email = _useState[0],
    setEmail = _useState[1];
  var _useState2 = useState({}),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validationFields = [{
    field: 'email',
    rules: ['notEmpty', 'email'],
    msg: t('Please add a valid email address.')
  }];
  var isValid = function isValid() {
    setFormErrors({});
    var data = {
      email: email
    };
    var _validateForm = validateForm(validationFields, data),
      isValid = _validateForm.isValid,
      errors = _validateForm.errors;
    setFormErrors(errors);
    return isValid;
  };
  var handleClick = function handleClick() {
    if (isValid()) {
      onSubmit(email);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-4"
  }, t('If you want to reset your password, please fill in the email address you use when logging in'), "."), /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4 "
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-envelope text-secondary-four absolute left-5",
    style: {
      top: 18
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "w-full md:w-1/2 border rounded pl-12 pr-5 py-3 " + (formErrors.email ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Email'),
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    }
  }), formErrors.email && /*#__PURE__*/React.createElement("div", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.email)), /*#__PURE__*/React.createElement("button", {
    className: "block bg-primary text-white font-bold py-2 px-4 rounded",
    type: "button",
    onClick: function onClick() {
      return handleClick();
    }
  }, t('Send')));
};

var ForgotPassword = function ForgotPassword(_ref) {
  var passwordResetRequest = _ref.passwordResetRequest,
    view = _ref.view,
    views = _ref.views,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Forgot your password?')), view === views.form && /*#__PURE__*/React.createElement(ForgotPasswordForm, {
    onSubmit: function onSubmit(email) {
      return passwordResetRequest(email);
    },
    context: context
  }), view === views.message && /*#__PURE__*/React.createElement(ForgotPasswordMessage, {
    context: context
  }));
};
var ForgotPasswordComponent = baseForgotPassword(ForgotPassword);

var ForgotPassword$1 = function ForgotPassword(props) {
  return /*#__PURE__*/React.createElement(ForgotPasswordComponent, props);
};
ForgotPassword$1.human = {
  nl: 'Forgot password',
  fr: 'Forgot password',
  en: 'Forgot password'
};
ForgotPassword$1.defaultProps = {};

var AuthForm = function AuthForm(_ref) {
  var authenticate = _ref.authenticate,
    loading = _ref.loading,
    error = _ref.error,
    context = _ref.context,
    onAfterLogin = _ref.onAfterLogin;
  var _useState = useState(''),
    userName = _useState[0],
    setUserName = _useState[1];
  var _useState2 = useState(''),
    password = _useState2[0],
    setPassword = _useState2[1];
  var _useState3 = useState({}),
    formErrors = _useState3[0],
    setFormErrors = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validationFields = [{
    field: 'userName',
    rules: ['notEmpty', 'email'],
    msg: t('Please add a valid email address.')
  }, {
    field: 'password',
    rules: ['notEmpty'],
    msg: t('The password cannot be empty.')
  }];
  var isValid = function isValid() {
    setFormErrors({});
    var data = {
      userName: userName,
      password: password
    };
    var _validateForm = validateForm(validationFields, data),
      isValid = _validateForm.isValid,
      errors = _validateForm.errors;
    setFormErrors(errors);
    return isValid;
  };
  var handleAuth = function handleAuth() {
    if (isValid()) {
      authenticate(userName, password);
      if (onAfterLogin && typeof onAfterLogin === 'function') {
        onAfterLogin(loading, error);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-envelope absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: t('Email address'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.userName ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return setUserName(e.target.value);
    }
  }), formErrors.userName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.userName)), /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-lock absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "password",
    placeholder: t('Password'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.password ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    }
  }), formErrors.password && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.password)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary mr-4",
    onClick: handleAuth
  }, loading ? t('Logging in...') : t('Log in')), /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.forgotPassword,
    context: context
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-semibold underline"
  }, t('Forgot password?')))), error && /*#__PURE__*/React.createElement("span", {
    className: "text-sm mt-2 text-red-500"
  }, error));
};
var AuthForm$1 = baseAuthenticationForm(AuthForm);

var RegistrationFormBasic = function RegistrationFormBasic(_ref) {
  var context = _ref.context;
  var _useState = useState(''),
    email = _useState[0],
    setEmail = _useState[1];
  var _useState2 = useState({}),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validationFields = [{
    field: 'email',
    rules: ['notEmpty', 'email'],
    msg: t('Please add a valid email address.')
  }];
  var isValid = function isValid() {
    setFormErrors({});
    var data = {
      email: email
    };
    var _validateForm = validateForm(validationFields, data),
      isValid = _validateForm.isValid,
      errors = _validateForm.errors;
    setFormErrors(errors);
    return isValid;
  };
  var onCreateAccount = function onCreateAccount() {
    if (isValid()) {
      navigateInternalPage(context, context.defaultPageNames.registration, "email=" + email);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-envelope absolute text-secondary-four",
    style: {
      top: 14,
      left: 22
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: t('Email address'),
    className: "w-full border rounded py-2 pl-14 " + (formErrors.email ? 'border-red-500' : 'border-secondary-three'),
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    }
  }), formErrors.email && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.email)), /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    onClick: onCreateAccount
  }, t('Create an account')));
};

var Login = function Login(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex justify-center items-center",
    style: {
      maxWidth: 1000,
      minHeight: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-8"
  }, t('Log in')), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 pr-0 md:pr-8 border-none md:border-solid border-r border-secondary-four"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-14 mb-4"
  }, t('Existing cursomers')), /*#__PURE__*/React.createElement(AuthForm$1, {
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden mt-4"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-alternate",
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.registration);
    }
  }, t('Create an account')))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-1/2 pl-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-14"
  }, t('New here?')), /*#__PURE__*/React.createElement("p", {
    className: "text-14 mb-4"
  }, t('Create an account within 2 minutes')), /*#__PURE__*/React.createElement(RegistrationFormBasic, {
    context: context
  })))));
};
Login.human = {
  nl: 'Authenticate',
  fr: 'Authenticate',
  en: 'Authenticate'
};
Login.defaultProps = {};

var LoginPopup = function LoginPopup(_ref) {
  var context = _ref.context;
  var _useState = useState(false),
    showPopup = _useState[0],
    setShowPopup = _useState[1];
  var _useSession = useSession(context),
    session = _useSession.session;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (!hasDocument) return;
    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];
    if (showPopup) {
      if (html) html.classList.add('overflow-hidden');
      if (body) body.classList.add('overflow-hidden');
    }
    if (!showPopup) {
      if (html && html.classList.contains('overflow-hidden')) {
        html.classList.remove('overflow-hidden');
      }
      if (body && body.classList.contains('overflow-hidden')) {
        body.classList.remove('overflow-hidden');
      }
    }
  }, [showPopup]);
  useEffect(function () {
    var isAuthenticated = session === null || session === void 0 ? void 0 : session.authenticated;
    var isClosed = false;
    if (hasWindow()) {
      isClosed = window.sessionStorage.getItem('LOGIN-CLOSED');
    }
    setShowPopup(!isAuthenticated && !isClosed);
  }, []);
  var onLogin = function onLogin(loading, error) {
    if (!loading && !error) {
      onClose();
    }
  };
  var onClose = function onClose() {
    setShowPopup(false);
    if (hasWindow()) {
      window.sessionStorage.setItem('LOGIN-CLOSED', 'true');
    }
  };
  return /*#__PURE__*/React.createElement(Fade$1, {
    when: showPopup,
    collapse: true,
    duration: 300
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center fixed inset-0 bg-black bg-opacity-20 px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mx-auto px-5 md:px-14 pt-7 pb-7 flex justify-center items-center bg-white w-full lg2:w-2/3 xl2:w-1/2",
    style: {
      maxWidth: 950,
      minHeight: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-18 text-primary"
  }))), /*#__PURE__*/React.createElement("h3", {
    className: "mb-1"
  }, t('Save your favorites')), /*#__PURE__*/React.createElement("div", {
    className: "text-16 text-primary mb-8"
  }, t('Create an account or login to be sure to have your favorites when you come back.')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 pr-0 md:pr-8 border-none md:border-solid border-r border-secondary-four mb-12 md:mb-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-14 mb-4"
  }, t('Existing cursomers')), /*#__PURE__*/React.createElement(AuthForm$1, {
    context: context,
    onAfterLogin: function onAfterLogin(loading, error) {
      return onLogin(loading, error);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 pl-0 md:pl-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-14"
  }, t('New here?')), /*#__PURE__*/React.createElement("p", {
    className: "text-14 mb-4"
  }, t('Create an account within 2 minutes')), /*#__PURE__*/React.createElement(RegistrationFormBasic, {
    context: context
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-end mt-4 text-14 text-secondary-three"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer hover:text-secondary-two",
    onClick: function onClick() {
      return onClose();
    }
  }, t('It does not interest me.'))))));
};

var RegistrationConfirmationMessage = function RegistrationConfirmationMessage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Confirm email address')), /*#__PURE__*/React.createElement("h4", {
    className: "mb-5"
  }, t('Check your email and active your account')), /*#__PURE__*/React.createElement("p", {
    className: "mb-10"
  }, t('We have sent you an email with the link to active your Delorge account'), "."), /*#__PURE__*/React.createElement("h4", {
    className: "mb-5"
  }, t('I did not get an email'), "?"), /*#__PURE__*/React.createElement("p", null, t('Check your spam folder'), "."));
};

var RegistrationConfirmationPending = function RegistrationConfirmationPending(_ref) {
  var error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start",
      style: {
        maxWidth: 1000
      }
    }, /*#__PURE__*/React.createElement("h2", {
      className: "mb-10"
    }, t('Create an account')), /*#__PURE__*/React.createElement("p", {
      className: "text-secondary"
    }, error));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Create an account')), /*#__PURE__*/React.createElement("p", null, t('We are creating your Delorge account'), "..."));
};

var RegistrationForm = function RegistrationForm(_ref) {
  var onSubmit = _ref.onSubmit,
    error = _ref.error,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState({
      firstName: '',
      lastName: '',
      email: context && !context.builder ? getUrlParamValueFromWindow('email') : '',
      mobile: '',
      password: '',
      telephone: '',
      street: '',
      number: '',
      bus: '',
      postalCode: '',
      city: ''
    }),
    userData = _useState[0],
    setUserData = _useState[1];
  var _useState2 = useState({}),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var _useState3 = useState(''),
    confirmPassword = _useState3[0],
    setConfirmPassword = _useState3[1];
  var _useState4 = useState(true),
    passwordsMatch = _useState4[0],
    setPasswordsMatch = _useState4[1];
  var validationFields = [{
    field: 'firstName',
    rules: ['notEmpty'],
    msg: t('The first name cannot be empty.')
  }, {
    field: 'lastName',
    rules: ['notEmpty'],
    msg: t('The last name cannot be empty.')
  }, {
    field: 'email',
    rules: ['notEmpty', 'email'],
    msg: t('The email needs to be valid.')
  }, {
    field: 'password',
    rules: ['notEmpty'],
    msg: t('The password cannot be empty.')
  }];
  var isValid = function isValid() {
    setFormErrors({});
    var _validateForm = validateForm(validationFields, userData),
      isValid = _validateForm.isValid,
      errors = _validateForm.errors;
    setFormErrors(errors);
    return isValid;
  };
  var updateUserData = function updateUserData(key, value) {
    var _extends2;
    setUserData(_extends({}, userData, (_extends2 = {}, _extends2[key] = value, _extends2)));
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    if (userData.password !== confirmPassword) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
      if (isValid()) {
        var submitData = {
          individual: {
            uniqueId: v4(),
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            mobile: userData.mobile,
            telephone: userData.telephone,
            language: context.culture ? context.culture : undefined,
            subscriptions: [{
              key: 'mailing_newsletter',
              active: false
            }]
          },
          addresses: [{
            uniqueId: v4(),
            country: '',
            city: userData.city,
            postalCode: userData.postalCode,
            street: userData.street,
            number: userData.number,
            bus: userData.bus,
            recipient: '',
            defaultDelivery: true,
            defaultInvoice: false
          }],
          password: userData.password
        };
        onSubmit(submitData);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Create an account')), /*#__PURE__*/React.createElement("form", {
    className: "w-full",
    onSubmit: function onSubmit(e) {
      return handleSubmit(e);
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('Personal info')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 mr-0 md:mr-3 mb-5 md:mb-0"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.firstName ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "firstname"
  }, t('First name'), "*"), /*#__PURE__*/React.createElement("input", {
    id: "firstname",
    autoComplete: "given-name",
    className: "border rounded px-5 py-3 " + (formErrors.firstName ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('First name'),
    value: userData.firstName,
    onChange: function onChange(e) {
      return updateUserData('firstName', e.target.value);
    }
  }), formErrors.firstName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.firstName)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 ml-0 md:ml-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.lastName ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "lastname"
  }, t('Last name'), "*"), /*#__PURE__*/React.createElement("input", {
    id: "lastname",
    autoComplete: "family-name",
    className: "border rounded px-5 py-3 " + (formErrors.lastName ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Last name'),
    value: userData.lastName,
    onChange: function onChange(e) {
      return updateUserData('lastName', e.target.value);
    }
  }), formErrors.lastName && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.lastName))), /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('Address')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 mr-0 md:mr-3 mb-5 md:mb-0"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.street ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "street"
  }, t('Street')), /*#__PURE__*/React.createElement("input", {
    id: "street",
    className: "border rounded px-5 py-3 " + (formErrors.street ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Street'),
    value: userData.street,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^a-zA-Z -]/g, '');
      updateUserData('street', value);
    }
  }), formErrors.street && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.street)), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full md:w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-1/2 pl-0 md:pl-3 pr-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.number ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "number"
  }, t('Housenumber')), /*#__PURE__*/React.createElement("input", {
    id: "number",
    className: "border rounded px-5 py-3 " + (formErrors.number ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Housenumber'),
    value: userData.number,
    onChange: function onChange(e) {
      return updateUserData('number', e.target.value);
    }
  }), formErrors.number && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.number)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-1/2 pl-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2",
    htmlFor: "bus"
  }, t('Box number')), /*#__PURE__*/React.createElement("input", {
    id: "bus",
    className: "border border-secondary-three rounded px-5 py-3",
    type: "text",
    placeholder: t('Box number'),
    value: userData.bus,
    onChange: function onChange(e) {
      return updateUserData('bus', e.target.value);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/4 mr-0 md:mr-3 mb-5 md:mb-0"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.postalCode ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "zip"
  }, t('Postal code')), /*#__PURE__*/React.createElement("input", {
    id: "zip",
    autoComplete: "postal-code",
    className: "border rounded px-5 py-3 " + (formErrors.postalCode ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Postal code'),
    value: userData.postalCode,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9]/g, '');
      updateUserData('postalCode', value);
    }
  }), formErrors.postalCode && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.postalCode)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 ml-0 md:ml-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.city ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "city"
  }, t('City')), /*#__PURE__*/React.createElement("input", {
    id: "city",
    className: "border rounded px-5 py-3 " + (formErrors.city ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('City'),
    value: userData.city,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^a-zA-Z -]/g, '');
      updateUserData('city', value);
    }
  }), formErrors.city && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.city))), /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('Contact info')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 mr-0 md:mr-3 mb-5 md:mb-0"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.telephone ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "telephone"
  }, t('Telephone')), /*#__PURE__*/React.createElement("input", {
    id: "telephone",
    className: "border rounded px-5 py-3 " + (formErrors.telephone ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Telephone'),
    value: userData.telephone,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9+ ]/g, '');
      updateUserData('telephone', value);
    }
  }), formErrors.telephone && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.telephone)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 ml-0 md:ml-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.mobile ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "mobile"
  }, t('Mobile')), /*#__PURE__*/React.createElement("input", {
    id: "mobile",
    className: "border rounded px-5 py-3 " + (formErrors.mobile ? 'border-red-500' : 'border-secondary-three'),
    type: "text",
    placeholder: t('Mobile'),
    value: userData.mobile,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9+ ]/g, '');
      updateUserData('mobile', value);
    }
  }), formErrors.mobile && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.mobile))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.email ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "email"
  }, t('Email address'), "*"), /*#__PURE__*/React.createElement("input", {
    id: "email",
    autoComplete: "email",
    className: "border rounded px-5 py-3 " + (formErrors.email ? 'border-red-500' : 'border-secondary-three'),
    type: "email",
    placeholder: t('Email address'),
    value: userData.email,
    onChange: function onChange(e) {
      return updateUserData('email', e.target.value);
    }
  }), formErrors.email && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.email))), /*#__PURE__*/React.createElement("p", {
    className: "mb-5"
  }, t('Password')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full mb-5"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-14 mb-2 " + (formErrors.password ? 'text-red-500' : 'text-secondary-three'),
    htmlFor: "password"
  }, t('Password'), "*"), /*#__PURE__*/React.createElement("input", {
    id: "password",
    autoComplete: "new-password",
    className: "border " + (passwordsMatch && !formErrors.password ? 'border-secondary-three bg-white' : 'border-red-400') + " rounded px-5 py-3",
    type: "password",
    placeholder: t('Password'),
    value: userData.password,
    onChange: function onChange(e) {
      return updateUserData('password', e.target.value);
    }
  }), formErrors.password && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.password)), /*#__PURE__*/React.createElement("label", {
    className: "text-14 text-secondary-three mb-2",
    htmlFor: "confirm"
  }, t('Confirm password'), "*"), /*#__PURE__*/React.createElement("input", {
    id: "confirm",
    autoComplete: "new-password",
    className: "border " + (passwordsMatch ? 'border-secondary-three bg-white' : 'border-red-400') + " rounded px-5 py-3",
    type: "password",
    placeholder: t('Confirm password'),
    value: confirmPassword,
    onChange: function onChange(e) {
      return setConfirmPassword(e.target.value);
    }
  })), !passwordsMatch && /*#__PURE__*/React.createElement("p", {
    className: "text-xs mt-1 text-red-500"
  }, t('Please make sure your passwords match'), "."), passwordsMatch && error && /*#__PURE__*/React.createElement("p", {
    className: "text-xs mt-1 text-red-500"
  }, error), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 mt-10"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button button-secondary mb-2"
  }, t('Save')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button-alternate"
  }, t('Cancel')))));
};

var Registration = function Registration(_ref) {
  var register = _ref.register,
    view = _ref.view,
    views = _ref.views,
    loading = _ref.loading,
    error = _ref.error,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, view === views.form && /*#__PURE__*/React.createElement(RegistrationForm, {
    onSubmit: function onSubmit(data) {
      register(data);
    },
    error: error,
    context: context
  }), view === views.confirmationMessage && /*#__PURE__*/React.createElement(RegistrationConfirmationMessage, {
    context: context
  }), view === views.confirmationPending && /*#__PURE__*/React.createElement(RegistrationConfirmationPending, {
    error: error,
    loading: loading,
    context: context
  }));
};
var RegistrationComponent = baseRegistration(Registration);

var Registration$1 = function Registration(props) {
  return /*#__PURE__*/React.createElement(RegistrationComponent, props);
};
Registration$1.human = {
  nl: 'Registration',
  fr: 'Registration',
  en: 'Registration'
};
Registration$1.defaultProps = {};

var ResetPasswordForm = function ResetPasswordForm(_ref) {
  var passwordReset = _ref.passwordReset,
    loading = _ref.loading,
    error = _ref.error;
  var _useState = useState(undefined),
    password = _useState[0],
    setPassword = _useState[1];
  var _useState2 = useState(undefined),
    password2 = _useState2[0],
    setPassword2 = _useState2[1];
  var _useState3 = useState({}),
    formErrors = _useState3[0],
    setFormErrors = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    if (password !== undefined && password2 !== undefined && password === password2) {
      passwordReset(password);
    } else {
      setFormErrors({
        password: 'The password cannot be empty.',
        password2: 'The password cannot be empty.'
      });
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    },
    className: "mx-auto px-5 md:px-10 min-h-content-desktop pt-12 pb-24 flex flex-col justify-center items-start",
    style: {
      maxWidth: 400
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-10"
  }, t('Reset your password.')), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 w-full"
  }, /*#__PURE__*/React.createElement("label", {
    className: "block text-sm font-bold mb-2 " + (formErrors.password ? 'text-red-500' : 'text-grey-darker'),
    htmlFor: "password"
  }, t('Password')), /*#__PURE__*/React.createElement("input", {
    className: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker " + (formErrors.password ? 'border-red-500' : 'border-secondary-three'),
    id: "password",
    type: "password",
    placeholder: t('Password'),
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    }
  }), formErrors.password && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.password)), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 w-full"
  }, /*#__PURE__*/React.createElement("label", {
    className: "block text-sm font-bold mb-2 " + (formErrors.password2 ? 'text-red-500' : 'text-grey-darker'),
    htmlFor: "password2"
  }, t('Confirm password')), /*#__PURE__*/React.createElement("input", {
    className: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker " + (formErrors.password2 ? 'border-red-500' : 'border-secondary-three'),
    id: "password2",
    type: "password",
    placeholder: t('Confirmed password'),
    onChange: function onChange(e) {
      return setPassword2(e.target.value);
    }
  }), formErrors.password2 && /*#__PURE__*/React.createElement("span", {
    className: "text-xs mt-1 text-red-500"
  }, formErrors.password2)), /*#__PURE__*/React.createElement("button", {
    className: "bg-primary text-white font-bold py-2 px-4 rounded",
    type: "submit"
  }, loading ? t('Resetting...') : t('Reset password')), error);
};
var ResetPasswordForm$1 = baseResetPassword(ResetPasswordForm);

var ResetPassword = function ResetPassword(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ResetPasswordForm$1, {
    context: context
  }));
};
ResetPassword.human = {
  nl: 'Reset password',
  fr: 'Reset password',
  en: 'Reset password'
};
ResetPassword.defaultProps = {};

var ErrorIndicator = function ErrorIndicator(_ref) {
  var error = _ref.error,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-red-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-red-300 flex items-center justify-center rounded-l"
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-red-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4  flex items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-tight"
  }, error))));
};
ErrorIndicator.defaultProps = {
  error: 'Er ging iets mis. Probeer later opnieuw.',
  icon: 'fad fa-exclamation-circle'
};

var SuccessIndicator = function SuccessIndicator(_ref) {
  var success = _ref.success,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-green-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-green-300 flex items-center justify-center rounded-l",
    style: {
      minWidth: '4rem'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-green-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4 flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leading-tight list-none"
  }, success))));
};
SuccessIndicator.defaultProps = {
  success: 'Success!',
  icon: 'fad fa-check'
};

var TextAreaField = function TextAreaField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    heightClass = _ref.heightClass,
    inputClass = _ref.inputClass;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative " + containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "absolute text-xs px-1 bg-white " + (hasError ? 'text-red-400' : 'text-primary'),
    style: {
      left: 10,
      top: -8,
      zIndex: 1
    }
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("textarea", {
    className: "appearance-none block w-full " + (hasError ? 'bg-red-100 border-red-400' : 'bg-white border-gray-400') + " text-gray-700 border rounded py-3 px-4 mb-1 " + heightClass + " focus:outline-none focus:border-primary " + inputClass,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value,
    placeholder: placeholder
  }), hasError && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs"
  }, errorText));
};
TextAreaField.defaultProps = {
  containerClass: 'text-xs font-bold',
  required: false,
  heightClass: 'h-48',
  inputClass: ''
};

var _initialFormData;
var FormFields = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData = (_initialFormData = {}, _initialFormData[FormFields.firstName] = '', _initialFormData[FormFields.lastName] = '', _initialFormData[FormFields.email] = '', _initialFormData[FormFields.phone] = '', _initialFormData[FormFields.message] = '', _initialFormData[FormFields.privacy] = false, _initialFormData);
var validator = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields.phone] = t('Phone is required.');
  }
  if (!hasValue(data.message)) {
    errors[FormFields.message] = t('Message is required.');
  }
  if (data.privacy === false) {
    errors[FormFields.privacy] = '';
  }
  return errors;
};
var submitDataMapper = function submitDataMapper(formData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy
  };
};
var ContactForm = function ContactForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "flex flex-col flex-1 relative"
  }, validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Thanks. We are going to answer as soon as possible.')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mb-5 md:mb-0 mr-0 md:mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: t('First name'),
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.firstName, value);
    },
    errorText: validationErrors[FormFields.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-0 md:ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.lastName, value);
    },
    errorText: validationErrors[FormFields.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-0 md:mr-1",
    inputClass: "rounded",
    label: t('Phone'),
    placeholder: t('Phone'),
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields.phone, value);
    },
    errorText: validationErrors[FormFields.phone],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mb-5 md:mb-0 mr-0 md:ml-1",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: t('Email address'),
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields.email, value);
    },
    errorText: validationErrors[FormFields.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Any comments'),
    placeholder: t('Comments'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields.message, value);
    },
    errorText: validationErrors[FormFields.message],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-primary",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var ContactForm$1 = baseDealerContactForm(DealerContactTypes.general, initialFormData, validator, submitDataMapper, ContactForm);

var BuilderImage = function BuilderImage(_ref) {
  var image = _ref.image,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement("img", {
    srcSet: ((image === null || image === void 0 ? void 0 : image.mobile) || (image === null || image === void 0 ? void 0 : image.desktop)) + " 300w, " + ((image === null || image === void 0 ? void 0 : image.tablet) || (image === null || image === void 0 ? void 0 : image.desktop)) + " 768w, " + (image === null || image === void 0 ? void 0 : image.desktop) + " 1280w",
    src: image === null || image === void 0 ? void 0 : image.desktop,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    className: className,
    style: style
  });
};

var ContactFormTextAndImage = function ContactFormTextAndImage(_ref) {
  var image = _ref.image,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col md:flex-row mt-8"
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: image,
    className: "w-full md:w-1/2 object-cover",
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 p-5 md:p-12 bg-secondary-five"
  }, /*#__PURE__*/React.createElement(ContactForm$1, {
    context: context
  })));
};
ContactFormTextAndImage.defaultProps = {
  image: DefaultImage
};
ContactFormTextAndImage.human = {
  nl: '',
  fr: '',
  en: ''
};

var _initialFormData$1;
var FormFields$1 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  company: 'company',
  message: 'message',
  messageTitle: 'messageTitle',
  privacy: 'privacy'
};
var initialFormData$1 = (_initialFormData$1 = {}, _initialFormData$1[FormFields$1.firstName] = '', _initialFormData$1[FormFields$1.lastName] = '', _initialFormData$1[FormFields$1.email] = '', _initialFormData$1[FormFields$1.company] = '', _initialFormData$1[FormFields$1.messageTitle] = '', _initialFormData$1[FormFields$1.message] = '', _initialFormData$1[FormFields$1.privacy] = false, _initialFormData$1);
var validator$1 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$1.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$1.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$1.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$1.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.company)) {
    errors[FormFields$1.company] = t('Company is required.');
  }
  if (!hasValue(data.messageTitle)) {
    errors[FormFields$1.messageTitle] = t('Message title is required.');
  }
  if (!hasValue(data.message)) {
    errors[FormFields$1.message] = t('Message is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$1.privacy] = '';
  }
  return errors;
};
var submitDataMapper$1 = function submitDataMapper(formData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    company: formData.company,
    message_title: formData.messageTitle,
    message: formData.message,
    privacy: formData.privacy
  };
};
var ContactForm$2 = function ContactForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "flex flex-col flex-1 relative"
  }, validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Thanks. We are going to answer as soon as possible.')
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-28 font-semibold text-primary mb-8"
  }, t('Contact us')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mb-5 md:mb-0 mr-0 md:mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: t('First name'),
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.firstName, value);
    },
    errorText: validationErrors[FormFields$1.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-0 md:ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.lastName, value);
    },
    errorText: validationErrors[FormFields$1.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mb-5 md:mb-0 ml-0 md:mr-1",
    inputClass: "rounded",
    label: t('Company'),
    placeholder: t('Company'),
    value: data.company,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.company, value);
    },
    errorText: validationErrors[FormFields$1.company],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mr-0 md:ml-1",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: t('Email address'),
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.email, value);
    },
    errorText: validationErrors[FormFields$1.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:mb-0 ml-0 md:mr-1",
    inputClass: "rounded",
    label: t('Message title'),
    placeholder: t('Question about...'),
    value: data.messageTitle,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.messageTitle, value);
    },
    errorText: validationErrors[FormFields$1.messageTitle],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Message'),
    placeholder: t('I would like to ask...'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.message, value);
    },
    errorText: validationErrors[FormFields$1.message],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields$1.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-primary",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var ContactFormV2 = baseDealerContactForm(DealerContactTypes.general, initialFormData$1, validator$1, submitDataMapper$1, ContactForm$2);

var ContactFormTextAndImageV2 = function ContactFormTextAndImageV2(_ref) {
  var image = _ref.image,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container grid grid-cols-1 md:grid-cols-2 pt-7 md:pt-15 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative",
    style: {
      minHeight: 400
    }
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: image,
    className: "absolute w-full h-full object-cover",
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full p-5 md:p-12 bg-secondary-five"
  }, /*#__PURE__*/React.createElement(ContactFormV2, {
    context: context
  })));
};
ContactFormTextAndImageV2.defaultProps = {
  image: DefaultImage
};
ContactFormTextAndImageV2.human = {
  nl: '',
  fr: '',
  en: ''
};

var Dealerships = function Dealerships(_ref) {
  var context = _ref.context;
  var _useDealerships = useDealerships(context),
    fetchDealerships = _useDealerships.fetchDealerships,
    dealerships = _useDealerships.dealerships,
    loading = _useDealerships.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    fetchDealerships();
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container px-5 md:px-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid gap-y-4 gap-x-8 sm:grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    }, times(12, function (index) {
      return /*#__PURE__*/React.createElement("div", {
        key: 'dealership-skeleton-' + index,
        className: "bg-secondary-five animate-pulse",
        style: {
          height: 250
        }
      });
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid sm:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-4 gap-x-8"
  }, map(orderBy(dealerships, ['name'], ['asc']), function (dealer) {
    return /*#__PURE__*/React.createElement("div", {
      key: dealer.id,
      className: "relative p-8 mb-2 bg-secondary-five"
    }, dealer.tel && /*#__PURE__*/React.createElement(ExternalLink, {
      url: "tel:" + dealer.tel.replace(/ /g, ''),
      className: "absolute top-3 right-8 cursor-pointer",
      context: context
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-phone-alt"
    })), /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-22"
    }, dealer.name), /*#__PURE__*/React.createElement("p", {
      className: "mb-5"
    }, dealer.address, " ", dealer.postal, " ", dealer.city), /*#__PURE__*/React.createElement("p", {
      className: "mb-5 w-full flex-wrap overflow-hidden font-semibold",
      style: {
        maxHeight: 48,
        height: 48
      }
    }, dealer.subtitle), dealer.appointmentUrl && /*#__PURE__*/React.createElement(ExternalLink, {
      url: dealer.appointmentUrl,
      className: "button button-secondary w-full mb-2 text-center",
      context: context
    }, t('Make an appointment')), dealer.videoCallUrl && /*#__PURE__*/React.createElement(ExternalLink, {
      url: dealer.videoCallUrl,
      className: "button button-secondary w-full mb-2 text-center",
      context: context
    }, t('Book a live video call')), /*#__PURE__*/React.createElement(InternalLink, {
      url: dealer.vehiclesUrl,
      context: context,
      className: "border border-primary text-center rounded w-full p-1"
    }, dealer.vehiclesCount, " ", t('cars for sale')));
  })));
};
Dealerships.defaultProps = {};
Dealerships.human = {
  nl: '',
  fr: '',
  en: ''
};

var TitleWithLines = function TitleWithLines(_ref) {
  var text = _ref.text,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center " + className
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-full bg-black",
    style: {
      height: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-28 font-semibold text-primary md:whitespace-nowrap mx-0 md:mx-4"
  }, text), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-full bg-black",
    style: {
      height: 1
    }
  }));
};

var Map = function Map(_ref) {
  var loading = _ref.loading,
    height = _ref.height;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-secondary-five animate-pulse",
      style: {
        height: height
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", null);
};
Map.defaultProps = {
  height: 400
};
var Map$1 = baseMarkerMapWithDealerships(Map);

var INITIAL_STATE = {
  location: null,
  make: null,
  service: null
};
var DUMMY_DATA = {
  LOCATIONS: [{
    value: 1,
    label: 'Location 1'
  }, {
    value: 2,
    label: 'Location 2'
  }, {
    value: 3,
    label: 'Location 3'
  }],
  MAKES: [{
    value: 1,
    label: 'VW'
  }, {
    value: 2,
    label: 'AUDI'
  }, {
    value: 3,
    label: 'PASSAT'
  }],
  SERVICES: [{
    value: 1,
    label: 'Repair'
  }, {
    value: 2,
    label: 'LOREM ipsum'
  }]
};
var MapSearch = function MapSearch() {
  var _useState = useState(INITIAL_STATE),
    formData = _useState[0],
    setFormData = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange(field, value) {
    var _extends2;
    setFormData(_extends({}, formData, (_extends2 = {}, _extends2[field] = value, _extends2)));
  };
  var onSearch = function onSearch() {};
  var renderCustomOption = function renderCustomOption(options, field, innerProps, data) {
    var isSelected = formData[field] === data.value;
    return /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row py-1 px-3 hover:bg-secondary-five cursor-pointer hover:text-primary",
      onClick: function onClick() {
        return handleChange(field, data.value);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded border border-primary mr-2 w-4 h-4"
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check text-primary text-12"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative text-primary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, data.label))));
  };
  var valueLabel = function valueLabel(options, value) {
    var record = find(options, function (o) {
      return o.value === value;
    });
    return record ? {
      label: record.label
    } : '';
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-center justify-center space-y-5 md:space-y-0 md:space-x-5 lg2:space-x-12 bg-primary py-5 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "min-w-200px lg:min-w-250px lg2:min-w-300px"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel(DUMMY_DATA.LOCATIONS, formData.location),
    options: DUMMY_DATA.LOCATIONS,
    placeholder: t('Location'),
    closeMenuOnSelect: false,
    className: "transparent",
    customComponents: {
      Option: function Option(_ref) {
        var innerProps = _ref.innerProps,
          isDisabled = _ref.isDisabled,
          data = _ref.data;
        if (isDisabled) {
          return null;
        }
        return renderCustomOption(DUMMY_DATA.LOCATIONS, 'location', innerProps, data);
      }
    },
    isLoading: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "min-w-200px lg:min-w-250px lg2:min-w-300px"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel(DUMMY_DATA.MAKES, formData.make),
    options: DUMMY_DATA.MAKES,
    placeholder: t('Make'),
    closeMenuOnSelect: false,
    className: "transparent",
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        if (isDisabled) {
          return null;
        }
        return renderCustomOption(DUMMY_DATA.MAKES, 'make', innerProps, data);
      }
    },
    isLoading: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "min-w-200px lg:min-w-250px lg2:min-w-300px"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel(DUMMY_DATA.SERVICES, formData.make),
    options: DUMMY_DATA.SERVICES,
    placeholder: t('Service'),
    closeMenuOnSelect: false,
    className: "transparent",
    customComponents: {
      Option: function Option(_ref3) {
        var innerProps = _ref3.innerProps,
          isDisabled = _ref3.isDisabled,
          data = _ref3.data;
        if (isDisabled) {
          return null;
        }
        return renderCustomOption(DUMMY_DATA.SERVICES, 'service', innerProps, data);
      }
    },
    isLoading: false
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "button button-alternate",
    onClick: function onClick() {
      return onSearch();
    },
    style: {
      height: 44
    }
  }, t('Search'))));
};

var dealershipsQuery = "query Dealerships {\n  dealerships {\n    id\n    name\n    address\n    postal\n    city\n    reference\n    email\n    fax\n    tel \n    url\n    image\n    latitude\n    longitude\n    dealershipType\n    contactUrl\n    appointmentUrl\n    priority\n    \n    openingHoursShowroom {    \n      day\n      start\n      stop\n    }\n    \n  }    \n}";
var mapMarkers = function mapMarkers(dealerships) {
  return map(filter(dealerships, function (d) {
    return d.latitude && d.longitude;
  }), function (d) {
    return {
      lat: d.latitude,
      lng: d.longitude
    };
  });
};
var Skeleton = function Skeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full py-7 md:py-15"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-7 md:px-15"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse hidden md:block w-full bg-gray-200",
    style: {
      height: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse mx-0 md:mx-4 h-6 w-96 bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse hidden md:block w-full bg-gray-200",
    style: {
      height: 1
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hidden mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-center justify-center space-y-5 md:space-y-0 md:space-x-5 lg2:space-x-12 bg-primary py-5 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse min-w-200px lg:min-w-250px lg2:min-w-300px h-10 bg-gray-200 rounded"
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse min-w-200px lg:min-w-250px lg2:min-w-300px h-10 bg-gray-200 rounded"
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse min-w-200px lg:min-w-250px lg2:min-w-300px h-10 bg-gray-200 rounded"
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse min-w-200px h-10 bg-gray-200 rounded"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 lg2:grid-cols-4 gap-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 pl-5 pr-5 md:pr-0 overflow-hidden h-300px md:h-500px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-col-1 sm:grid-cols-2 md:grid-cols-1 gap-5"
  }, times(4, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: "relative p-8 bg-secondary-five h-200px w-full bg-gray-200 animate-pulse"
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute top-3 right-8 cursor-pointer w-4 h-4 bg-gray-200"
    }), /*#__PURE__*/React.createElement("p", {
      className: "bg-gray-200 w-3/4 h-8 mb-3"
    }), /*#__PURE__*/React.createElement("p", {
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-200 w-2/3 h-4 mb-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-200 w-1/3 h-4"
    })), /*#__PURE__*/React.createElement("div", {
      className: "animate-pulse w-full h-10 bg-gray-200 rounded"
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse col-span-1 md:col-span-2 lg2:col-span-3 h-500px bg-gray-200 w-full"
  })));
};
var MarkerMapAndCharTitle = function MarkerMapAndCharTitle(_ref) {
  var title = _ref.title,
    marker_image = _ref.marker_image,
    viewport = _ref.viewport,
    context = _ref.context;
  var _useDealerships = useDealerships(context, dealershipsQuery),
    dealerships = _useDealerships.dealerships,
    loading = _useDealerships.loading,
    error = _useDealerships.error,
    fetchDealerships = _useDealerships.fetchDealerships;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    fetchDealerships();
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
  if (!loading && error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "relative flex flex-1",
      style: {
        minHeight: 250
      }
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('The dealerships could not be fetched.')
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full py-7 md:py-15"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-7 md:px-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden mb-5"
  }, /*#__PURE__*/React.createElement(MapSearch, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 lg2:grid-cols-4 gap-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 pl-5 pr-5 md:pr-0 overflow-y-scroll h-300px md:h-500px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-col-1 sm:grid-cols-2 md:grid-cols-1 gap-5"
  }, (dealerships === null || dealerships === void 0 ? void 0 : dealerships.length) < 1 && /*#__PURE__*/React.createElement("div", {
    className: "p-4 bg-yellow-100 text-yellow-800"
  }, t('No dealerships to show.')), (dealerships === null || dealerships === void 0 ? void 0 : dealerships.length) > 0 && map(orderBy(dealerships, ['name'], ['asc']), function (dealer) {
    return /*#__PURE__*/React.createElement("div", {
      key: dealer.id,
      className: "relative p-8 bg-secondary-five"
    }, dealer.tel && /*#__PURE__*/React.createElement(ExternalLink, {
      url: "tel:" + dealer.tel.replace(/ /g, ''),
      className: "absolute top-3 right-8 cursor-pointer",
      context: context
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-phone-alt"
    })), /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-22"
    }, dealer.name), /*#__PURE__*/React.createElement("p", {
      className: "mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-1"
    }, dealer.address), /*#__PURE__*/React.createElement("div", null, dealer.postal, " ", dealer.city)), dealer.appointmentUrl && /*#__PURE__*/React.createElement(ExternalLink, {
      url: dealer.appointmentUrl,
      context: context,
      className: "button button-secondary text-center"
    }, t('Go to details')));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 md:col-span-2 lg2:col-span-3 h-500px"
  }, /*#__PURE__*/React.createElement(Map$1, {
    marker_image: marker_image,
    viewPort: viewport,
    markers: mapMarkers(dealerships),
    dealerships: dealerships,
    loading: loading,
    height: "100%",
    context: context
  }))));
};
MarkerMapAndCharTitle.defaultProps = {
  marker_image: DefaultImage,
  marker_image_inverse: DefaultImage,
  viewport: DefaultMapViewPort,
  title: DefaultText
};
MarkerMapAndCharTitle.human = {
  nl: '',
  fr: '',
  en: ''
};

var MarkerMapAndText = function MarkerMapAndText(_ref) {
  var text = _ref.text,
    marker_image = _ref.marker_image,
    viewport = _ref.viewport,
    markers = _ref.markers,
    dealerships = _ref.dealerships,
    context = _ref.context;
  var getPageName = function getPageName(key, context) {
    var pageData = find(context.allPagesData, function (p) {
      return p.key === key && p.language === context.culture;
    });
    return pageData === null || pageData === void 0 ? void 0 : pageData.description;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-primary mb-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 flex flex-col lg:flex-row mb-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-1/2 flex flex-col justify-center relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-white pt-4 static lg:absolute top-0 mb-10"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.home,
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-home-alt cursor-pointer"
  })), /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right mx-3",
    style: {
      fontSize: 10
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, getPageName('contact', context))), /*#__PURE__*/React.createElement("div", {
    className: "text-white mr-0 lg:mr-8 pt-0 md:pt-16 pb-0 md:pb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full lg:w-1/2 bg-secondary-five relative self-end",
    style: {
      height: 400
    }
  }, /*#__PURE__*/React.createElement(Map$1, {
    marker_image: marker_image,
    viewport: viewport,
    markers: markers,
    dealerships: dealerships,
    context: context
  }))));
};
MarkerMapAndText.defaultProps = {
  marker_image: DefaultImage,
  viewport: DefaultMapViewPort,
  text: DefaultText
};
MarkerMapAndText.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerBlogPosts = function BannerBlogPosts(_ref) {
  var title = _ref.title,
    blog_posts = _ref.blog_posts,
    all_action = _ref.all_action,
    context = _ref.context;
  var blog_posts_filter_data = isJsonString(blog_posts) ? JSON.parse(blog_posts) : blog_posts;
  var items = blog_posts_filter_data['result'];
  if (items && items.length === 0 && !context.builder) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 50
    },
    className: "container px-5 md:px-10 my-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: title
  })), items && items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 lg2:grid-cols-4 gap-4"
  }, map(orderBy(items.slice(0, 4), ['creation_date'], ['desc']), function (blogPost) {
    var image = isJsonString(blogPost.image) ? JSON.parse(blogPost.image) : blogPost.image;
    return /*#__PURE__*/React.createElement(InternalLink, {
      url: blogPost.url,
      context: context,
      key: "blog-post-" + (blogPost === null || blogPost === void 0 ? void 0 : blogPost.id),
      className: "block relative bg-secondary-two",
      style: {
        minHeight: 300
      }
    }, blogPost.image && /*#__PURE__*/React.createElement(BuilderImage, {
      style: {
        minHeight: 300,
        maxHeight: 500
      },
      image: image,
      className: "object-cover w-full h-full",
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "bg-gradient-to-t from-black absolute bottom-0 w-full flex flex-col items-start p-6"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-white w-full pr-4 overflow-hidden",
      style: {
        maxHeight: 132
      }
    }, blogPost.title)), /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 right-0 flex items-center justify-center w-8 h-8 border border-secondary-four bg-white"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-8 flex justify-center"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    className: "flex-none button button-alternate",
    action: all_action,
    context: context
  })));
};
BannerBlogPosts.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerBlogPosts.defaultProps = {
  title: DefaultText,
  blog_posts: [],
  all_action: DefaultAction
};

var BannerBlogPostsWithCharTitleAndAction = function BannerBlogPostsWithCharTitleAndAction(_ref) {
  var title = _ref.title,
    blog_posts = _ref.blog_posts,
    all_action = _ref.all_action,
    context = _ref.context;
  var blog_posts_filter_data = isJsonString(blog_posts) ? JSON.parse(blog_posts) : blog_posts;
  var items = blog_posts_filter_data['result'];
  var gridClass = 'grid grid-cols-1 sm:grid-cols-2 lg2:grid-cols-4 gap-4';
  var renderBuilderBlocks = function renderBuilderBlocks() {
    return /*#__PURE__*/React.createElement("div", {
      className: gridClass
    }, times(4, function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item,
        className: "block relative bg-gray-400 h-300px"
      });
    }));
  };
  if (items && items.length === 0 && !context.builder) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 50
    },
    className: "container p-7 md:p-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    context: context,
    text: title,
    className: "mb-10"
  }), items && items.length === 0 && context.builder && renderBuilderBlocks(), items && items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: gridClass
  }, map(orderBy(items.slice(0, 4), ['creation_date'], ['desc']), function (blogPost) {
    var image = isJsonString(blogPost.image) ? JSON.parse(blogPost.image) : blogPost.image;
    return /*#__PURE__*/React.createElement(InternalLink, {
      url: blogPost.url,
      context: context,
      key: "blog-post-" + (blogPost === null || blogPost === void 0 ? void 0 : blogPost.id),
      className: "block relative bg-secondary-two",
      style: {
        minHeight: 300
      }
    }, blogPost.image && /*#__PURE__*/React.createElement(BuilderImage, {
      style: {
        minHeight: 300,
        maxHeight: 500
      },
      image: image,
      className: "object-cover w-full h-full",
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "bg-gradient-to-t from-black absolute bottom-0 w-full flex flex-col items-start p-6"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-white w-full pr-4 overflow-hidden",
      style: {
        maxHeight: 132
      }
    }, blogPost.title)), /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 right-0 flex items-center justify-center w-8 h-8 border border-secondary-four bg-white"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 flex justify-center"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    className: "flex-none button button-secondary",
    action: all_action,
    context: context
  })));
};
BannerBlogPostsWithCharTitleAndAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerBlogPostsWithCharTitleAndAction.defaultProps = {
  title: DefaultText,
  blog_posts: [],
  all_action: DefaultAction
};

var BannerDraftJsMarkupFieldAndTitle = function BannerDraftJsMarkupFieldAndTitle(_ref) {
  var title = _ref.title,
    text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container p-7 md:p-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mx-auto text-center",
    style: {
      maxWidth: 900
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })));
};
BannerDraftJsMarkupFieldAndTitle.defaultProps = {
  title: DefaultText,
  text: DefaultText
};
BannerDraftJsMarkupFieldAndTitle.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerDraftJsWithImageListWithCharTitle = function BannerDraftJsWithImageListWithCharTitle(_ref) {
  var context = _ref.context,
    title = _ref.title,
    items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-7 md:px-15 pt-7 md:pt-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-5"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "bannerDraftJsWithImageListWithCharTitle-" + i,
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "block relative h-300px md:h-400px lg:h-500px"
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item.image,
      className: "object-cover w-full h-full rounded",
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "mt-5"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: item.text,
      context: context
    })));
  })));
};
BannerDraftJsWithImageListWithCharTitle.defaultProps = {
  title: DefaultText,
  items: [{
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }]
};
BannerDraftJsWithImageListWithCharTitle.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerDraftJsWithImageListWithCharTitleFourCol = function BannerDraftJsWithImageListWithCharTitleFourCol(_ref) {
  var context = _ref.context,
    title = _ref.title,
    items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-7 md:px-15 mt-7 md:mt-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "bannerDraftJsWithImageListWithCharTitleFourCol-" + i,
      className: "flex justify-center md:justify-start flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item.image,
      className: "object-cover w-full h-full rounded max-w-300px md:max-w-none max-h-300px",
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "mt-5 w-full truncate text-center md:text-left"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: item.text,
      context: context
    })));
  })));
};
BannerDraftJsWithImageListWithCharTitleFourCol.defaultProps = {
  title: DefaultText,
  items: [{
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }, {
    text: DefaultText,
    image: DefaultImage
  }]
};
BannerDraftJsWithImageListWithCharTitleFourCol.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerGenericIconTextAndTitle = function BannerGenericIconTextAndTitle(_ref) {
  var title = _ref.title,
    data = _ref.data,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 my-16 md:my-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row space-x-0 lg:space-x-5 space-y-5 lg:space-y-0"
  }, map(data, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "banner-item-" + index,
      className: "flex bg-secondary-five rounded px-10 py-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-none text-secondary"
    }, (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/React.createElement("i", {
      className: item.icon + " text-4xl md:text-5xl mr-5 md:mr-10"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
      className: "mb-2"
    }, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/React.createElement(MarkupText, {
      text: item === null || item === void 0 ? void 0 : item.text,
      context: context
    })));
  })));
};
BannerGenericIconTextAndTitle.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericIconTextAndTitle.defaultProps = {
  title: DefaultTitle,
  data: DefaultTitleTextIconItem
};

var BannerGenericImageTextActionWithCharTitleAndAction = function BannerGenericImageTextActionWithCharTitleAndAction(_ref) {
  var title = _ref.title,
    items = _ref.items,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container p-7 md:p-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 lg2:grid-cols-4 gap-4"
  }, map(items, function (item, i) {
    var image = item.image;
    return /*#__PURE__*/React.createElement("div", {
      key: "generic-image-text-action-with-title-and-action-" + i,
      className: "block relative",
      style: {
        minHeight: 300,
        maxHeight: 400
      }
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: image,
      className: "object-cover w-full h-full rounded",
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "bg-gradient-to-t from-black absolute bottom-0 w-full flex flex-col items-start p-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-white"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: item.text,
      context: context
    })), /*#__PURE__*/React.createElement(ActionLink, {
      action: item.action,
      context: context,
      className: "flex self-start button button-alternate mt-5"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-8 flex justify-center"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    className: "flex-none button button-secondary",
    action: action,
    context: context
  })));
};
BannerGenericImageTextActionWithCharTitleAndAction.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem)],
  action: DefaultAction
};
BannerGenericImageTextActionWithCharTitleAndAction.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerGenericImageTextActionWithCharTitleAndCustomCard = function BannerGenericImageTextActionWithCharTitleAndCustomCard(_ref) {
  var title = _ref.title,
    items = _ref.items,
    custom_card_text = _ref.custom_card_text,
    custom_card_action = _ref.custom_card_action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container p-7 md:p-15"
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "bannerDraftJsWithImageListWithCharTitleFourCol-" + i,
      className: "flex justify-center md:justify-start flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item.image,
      className: "object-cover w-full h-full rounded max-w-300px md:max-w-none max-h-250px",
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "mt-5 w-full truncate text-center md:text-left mb-2"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: item.text,
      context: context
    })), actionVisible(item.action) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionLink, {
      action: item.action,
      context: context,
      className: "inline-block button button-secondary"
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center bg-primary text-white p-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: custom_card_text,
    context: context
  })), actionVisible(custom_card_action) && /*#__PURE__*/React.createElement(ActionLink, {
    action: custom_card_action,
    context: context,
    className: "inline-block button button-alternate mt-8"
  }))));
};
BannerGenericImageTextActionWithCharTitleAndCustomCard.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem)],
  custom_card_action: DefaultAction,
  custom_card_text: DefaultText
};
BannerGenericImageTextActionWithCharTitleAndCustomCard.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerGenericImageTextActionWithTitle = function BannerGenericImageTextActionWithTitle(_ref) {
  var title = _ref.title,
    items = _ref.items,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col py-10 md:py-16 px-5 md:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row"
  }, map(items, function (item, index) {
    var _item$image, _item$image2;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex-1 " + (index === 0 ? 'ml-0' : 'md:ml-4')
    }, /*#__PURE__*/React.createElement("img", {
      className: "w-full h-auto md:h-2/5 lg:h-1/2 xl:h-3/5 object-cover",
      src: (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.desktop,
      alt: (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.alt
    }), /*#__PURE__*/React.createElement("div", {
      className: "py-8 px-0 md:px-8"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      context: context,
      text: item.text
    }), /*#__PURE__*/React.createElement(ActionLink, {
      className: "mt-4 underline font-semibold cursor-pointer",
      action: item.action,
      context: context
    })));
  })));
};
BannerGenericImageTextActionWithTitle.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericImageTextActionWithTitle.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem)]
};

var BannerGenericImageTextActionWithTitle_Dark = function BannerGenericImageTextActionWithTitle_Dark(_ref) {
  var title = _ref.title,
    items = _ref.items,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two text-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col py-10 md:py-16 px-5 md:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row"
  }, map(items, function (item, index) {
    var _item$image, _item$image2;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex-1 " + (index === 0 ? 'ml-0' : 'md:ml-4')
    }, /*#__PURE__*/React.createElement("img", {
      className: "w-full h-auto md:h-2/5 lg:h-1/2 xl:h-3/5 object-cover",
      src: (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.desktop,
      alt: (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.alt
    }), /*#__PURE__*/React.createElement("div", {
      className: "py-8 px-0 md:px-8"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      context: context,
      text: item.text
    }), /*#__PURE__*/React.createElement(ActionLink, {
      className: "mt-4 underline font-semibold cursor-pointer",
      action: item.action,
      context: context
    })));
  }))));
};
BannerGenericImageTextActionWithTitle_Dark.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericImageTextActionWithTitle_Dark.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem), _extends({}, DefaultImageTextActionItem)]
};

var BannerGenericImageTextTitle = function BannerGenericImageTextTitle(_ref) {
  var _activeItem$image, _activeItem$image2;
  var items = _ref.items,
    context = _ref.context;
  var _useState = useState(items ? items[0] : null),
    activeItem = _useState[0],
    setActiveItem = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full"
  }, /*#__PURE__*/React.createElement("img", {
    className: "object-cover w-full md:w-2/3",
    src: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem$image = activeItem.image) === null || _activeItem$image === void 0 ? void 0 : _activeItem$image.desktop,
    alt: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem$image2 = activeItem.image) === null || _activeItem$image2 === void 0 ? void 0 : _activeItem$image2.alt
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/3 px-5 md:px-10"
  }, map(items, function (item, index) {
    if (item.title === activeItem.title) {
      return /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer pt-4 " + (index === 0 ? '' : 'border-t border-secondary-four')
      }, /*#__PURE__*/React.createElement("h3", {
        className: "truncate"
      }, item.title), /*#__PURE__*/React.createElement(MarkupText, {
        context: context,
        text: item.text
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer flex justify-between items-center " + (index === 0 ? '' : 'border-t border-secondary-four') + " py-4",
      onClick: function onClick() {
        setActiveItem(item);
      }
    }, /*#__PURE__*/React.createElement("h3", {
      className: "truncate"
    }, item.title), /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-down pl-8"
    }));
  }))));
};
BannerGenericImageTextTitle.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericImageTextTitle.defaultProps = {
  items: [_extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem)]
};

var BannerGenericImageTextTitle_InfoOverlay = function BannerGenericImageTextTitle_InfoOverlay(_ref) {
  var _items$activeItem, _items$activeItem$ima, _items$activeItem2, _items$activeItem2$im;
  var items = _ref.items,
    context = _ref.context;
  var _useState = useState(0),
    activeItem = _useState[0],
    setActiveItem = _useState[1];
  var renderIcon = function renderIcon(index, left, top) {
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute",
      style: {
        left: left,
        top: top
      }
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setActiveItem(index);
      },
      className: "rounded-full bg-secondary " + (activeItem === index ? 'bg-opacity-25' : 'bg-opacity-0') + " w-11 h-11 flex items-center justify-center cursor-pointer transition"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-full bg-white w-7 h-7 flex items-center justify-center shadow-xl border-2 " + (activeItem === index ? 'border-secondary' : 'border-white')
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info absolute text-secondary text"
    }))));
  };
  var renderIcons = function renderIcons() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderIcon(0, '18%', '35%'), renderIcon(1, '6%', '50%'), renderIcon(2, '17%', '70%'), renderIcon(3, '50%', '40%'), renderIcon(4, '87%', '43%'), renderIcon(5, '90%', '55%'));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-primary text-white my-16 md:my-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row w-full items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-2/3 h-full relative"
  }, /*#__PURE__*/React.createElement("img", {
    className: "object-contain w-full",
    src: (_items$activeItem = items[activeItem]) === null || _items$activeItem === void 0 ? void 0 : (_items$activeItem$ima = _items$activeItem.image) === null || _items$activeItem$ima === void 0 ? void 0 : _items$activeItem$ima.desktop,
    alt: (_items$activeItem2 = items[activeItem]) === null || _items$activeItem2 === void 0 ? void 0 : (_items$activeItem2$im = _items$activeItem2.image) === null || _items$activeItem2$im === void 0 ? void 0 : _items$activeItem2$im.alt
  }), renderIcons()), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-1/3 px-5 lg:px-10 py-10"
  }, map(items, function (item, index) {
    if (index === activeItem) {
      return /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer pt-4 " + (index === 0 ? '' : 'border-t border-secondary-four')
      }, /*#__PURE__*/React.createElement("h3", {
        className: "truncate"
      }, item.title), /*#__PURE__*/React.createElement("div", {
        className: "py-5"
      }, /*#__PURE__*/React.createElement(MarkupText, {
        context: context,
        text: item.text
      })));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer flex justify-between items-center " + (index === 0 ? '' : 'border-t border-secondary-four') + " py-4",
      onClick: function onClick() {
        setActiveItem(index);
      }
    }, /*#__PURE__*/React.createElement("h3", {
      className: "truncate"
    }, item.title), /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-down pl-8"
    }));
  })))));
};
BannerGenericImageTextTitle_InfoOverlay.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericImageTextTitle_InfoOverlay.defaultProps = {
  items: [_extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem), _extends({}, DefaultImageTextTitleItem)]
};

var BannerGenericJsonItemsWithCharTitleAndDraftJsText = function BannerGenericJsonItemsWithCharTitleAndDraftJsText(_ref) {
  var title = _ref.title,
    text = _ref.text,
    items = _ref.items,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-7 md:px-15",
    style: {
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement(TitleWithLines, {
    text: title,
    context: context,
    className: "mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mx-auto text-center",
    style: {
      maxWidth: 900
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mt-18 space-y-15"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "BannerGenericJsonItemsWithCharTitleAndDraftJsTextItem-" + i,
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center mx-auto bg-primary px-5 text-white text-24 rounded absolute",
      style: {
        height: 49,
        top: -24.5
      }
    }, item.title)), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
    }, map(item.items, function (subItem, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: "BannerGenericJsonItemsWithCharTitleAndDraftJsTextSubItem-" + i
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-center"
      }, /*#__PURE__*/React.createElement(BuilderImage, {
        image: subItem.image,
        className: "object-cover w-full h-full rounded max-w-300px md:max-w-none max-h-300px",
        context: context
      })), /*#__PURE__*/React.createElement("div", {
        className: "mt-5 w-full truncate text-center md:text-left"
      }, /*#__PURE__*/React.createElement(MarkupText, {
        text: subItem.text,
        context: context
      })));
    })));
  })));
};
BannerGenericJsonItemsWithCharTitleAndDraftJsText.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericJsonItemsWithCharTitleAndDraftJsText.defaultProps = {
  title: DefaultText,
  text: DefaultText,
  items: [DefaultTitleWithDraftJsTextAndJsonImageItem, DefaultTitleWithDraftJsTextAndJsonImageItem, DefaultTitleWithDraftJsTextAndJsonImageItem]
};

var BannerHtml = function BannerHtml(_ref) {
  var html = _ref.html,
    context = _ref.context;
  if (context.builder && html === '') {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: 50
      }
    }, "Html block");
  }
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
BannerHtml.defaultProps = {
  html: ''
};
BannerHtml.human = {
  nl: 'Html block',
  fr: 'Html block',
  en: 'Html block'
};

var BannerImageAndTextWithAction = function BannerImageAndTextWithAction(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-primary my-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col md:flex-row items-center px-5 md:px-10 py-16 text-white"
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: 'Two people getting an online estimate on their car',
    className: "w-full md:w-1/2 px-5 md:px-0 max-h-80 object-cover flex-none"
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-5 md:px-10 py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    className: 'inline-block',
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "button bg-white hover:bg-gray-50 transition-colors text-primary cursor-pointer"
  }, action === null || action === void 0 ? void 0 : action.title)))));
};
BannerImageAndTextWithAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerImageAndTextWithAction.defaultProps = {
  image: DefaultImage,
  text: DefaultText
};

var Carousel = function Carousel(_ref) {
  var items = _ref.items,
    animationDurationInSeconden = _ref.animationDurationInSeconden,
    showDots = _ref.showDots,
    _ref$showShade = _ref.showShade,
    showShade = _ref$showShade === void 0 ? false : _ref$showShade,
    context = _ref.context;
  var _useState = useState(true),
    startReached = _useState[0],
    setStartReached = _useState[1];
  var _useState2 = useState(false),
    endReached = _useState2[0],
    setEndReached = _useState2[1];
  var _useState3 = useState(0),
    currentIndex = _useState3[0],
    setCurrentIndex = _useState3[1];
  var _useState4 = useState(null),
    containerWidth = _useState4[0],
    setContainerWidth = _useState4[1];
  var containerRef = useRef(null);
  var maxIndex = items ? (items === null || items === void 0 ? void 0 : items.length) - 1 : 0;
  var onNext = function onNext() {
    var newIndex = currentIndex + 1;
    if (newIndex >= maxIndex) {
      setStartReached(false);
      setEndReached(true);
      newIndex = maxIndex;
    }
    setCurrentIndex(newIndex);
  };
  var onPrev = function onPrev() {
    var newIndex = currentIndex - 1;
    if (newIndex <= 0) {
      newIndex = 0;
      setEndReached(false);
      setStartReached(true);
    }
    setCurrentIndex(newIndex);
  };
  useEffect(function () {
    if (containerWidth) {
      var duration = animationDurationInSeconden * 1000;
      var interval = setTimeout(function () {
        if (endReached) onPrev();
        if (startReached) onNext();
      }, duration);
      return function () {
        return clearTimeout(interval);
      };
    }
  }, [containerWidth, currentIndex]);
  useEffect(function () {
    if (containerRef !== null && containerRef !== void 0 && containerRef.current) {
      var _containerRef$current;
      setContainerWidth(containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth);
    }
  }, [containerRef]);
  var renderDots = function renderDots() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center inset-x-0 space-x-2 absolute bottom-4 " + (showShade ? 'text-gray-400' : 'text-secondary-two')
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-circle text-10  cursor-pointer " + (currentIndex === 0 ? 'opacity-50' : 'opacity-80'),
      onClick: onPrev
    }), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-circle text-12 opacity-80 "
    }), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-circle text-10  cursor-pointer " + (currentIndex === totalSlides - 1 ? 'opacity-50' : 'opacity-80'),
      onClick: onNext
    }));
  };
  var marginLeft = context.builder ? 0 : -1 * (currentIndex * containerWidth);
  var containerStyle = context.builder ? {
    marginLeft: marginLeft,
    maxWidth: 1240
  } : {
    marginLeft: marginLeft
  };
  var itemStyle = context.builder ? {
    width: 1240
  } : {
    width: containerWidth
  };
  var totalSlides = items ? items === null || items === void 0 ? void 0 : items.length : 0;
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "flex overflow-x-scroll no-scrollbar w-full h-full relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap relative h-full transition-all duration-300 ",
    style: containerStyle
  }, map(items, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "relative h-full",
      key: "carousel-image-" + index,
      style: itemStyle
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item === null || item === void 0 ? void 0 : item.image,
      className: "w-full h-full rounded transition-transform transform duration-500 absolute inset-x-0 object-cover",
      context: context
    }));
  })), showShade && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0",
    style: {
      background: 'linear-gradient(90deg,#000000 0%,rgba(255,255,255,0.001) 100%)',
      opacity: 0.8
    }
  }), showDots && totalSlides > 1 && renderDots());
};
Carousel.defaultProps = {
  item: [],
  animationDurationInSeconden: 5,
  showDots: true
};

var SelectBoxSecondary = function SelectBoxSecondary(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    placeholder = _ref.placeholder,
    isLoading = _ref.isLoading,
    isMulti = _ref.isMulti,
    isSearchable = _ref.isSearchable,
    customComponents = _ref.customComponents,
    closeMenuOnSelect = _ref.closeMenuOnSelect,
    menuPlacement = _ref.menuPlacement,
    hideSelectedOptions = _ref.hideSelectedOptions,
    dark = _ref.dark;
  var lightStyles = {
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    }
  };
  var darkStyles = {
    control: function control(provided) {
      return _extends({}, provided, {
        color: 'white',
        display: 'flex',
        backgroundColor: '#212121'
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    input: function input() {
      return {
        color: 'white'
      };
    },
    menu: function menu(styles) {
      return _extends({}, styles, {
        backgroundColor: '#212121',
        color: 'white',
        border: '1px solid #696969'
      });
    },
    singleValue: function singleValue(styles) {
      return _extends({}, styles, {
        color: 'white'
      });
    }
  };
  var DropdownIndicator = function DropdownIndicator(props) {
    return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, menuPlacement === 'top' && /*#__PURE__*/React.createElement("i", {
      className: (props.selectProps.menuIsOpen ? 'far fa-chevron-down' : 'far fa-chevron-up') + " " + (dark ? 'text-white' : 'text-primary')
    }), menuPlacement !== 'top' && /*#__PURE__*/React.createElement("i", {
      className: (props.selectProps.menuIsOpen ? 'far fa-chevron-up' : 'far fa-chevron-down') + " " + (dark ? 'text-white' : 'text-primary')
    }));
  };
  var formatGroupLabel = function formatGroupLabel(data) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "font-secondary font-semibold text-primary text-12"
    }, "- ", data.label));
  };
  var Components = customComponents ? _extends({
    DropdownIndicator: DropdownIndicator
  }, customComponents) : {
    DropdownIndicator: DropdownIndicator
  };
  return /*#__PURE__*/React.createElement(Select, {
    value: value,
    onChange: onChange,
    options: options,
    classNamePrefix: "delorge-select",
    className: className,
    components: Components,
    formatGroupLabel: formatGroupLabel,
    isDisabled: isDisabled,
    placeholder: placeholder,
    isLoading: isLoading,
    closeMenuOnSelect: closeMenuOnSelect,
    menuPlacement: menuPlacement,
    isMulti: isMulti,
    isSearchable: isSearchable,
    hideSelectedOptions: hideSelectedOptions,
    styles: dark ? darkStyles : lightStyles
  });
};
SelectBoxSecondary.defaultProps = {
  value: null,
  options: [],
  isDisabled: false,
  className: '',
  placeholder: 'Select...',
  isLoading: false,
  customComponents: null,
  isMulti: false,
  isSearchable: false,
  closeMenuOnSelect: true,
  menuPlacement: 'bottom',
  hideSelectedOptions: false
};

var SingleSelect = function SingleSelect(_ref) {
  var placeHolder = _ref.placeHolder,
    items = _ref.items,
    values = _ref.values,
    menuPlacement = _ref.menuPlacement,
    isLoading = _ref.isLoading,
    dark = _ref.dark,
    handleSelectChange = _ref.handleSelectChange;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  var valuesLabels = map(filter(options, function (option) {
    return includes(values, option.value);
  }), function (item) {
    return item.label;
  });
  var valueLabel = valuesLabels.length > 0 ? {
    label: valuesLabels.join(', ')
  } : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectBoxSecondary, {
    value: valueLabel,
    options: options,
    isMulti: false,
    isSearchable: false,
    isLoading: isLoading,
    placeholder: placeHolder,
    closeMenuOnSelect: true,
    menuPlacement: menuPlacement,
    hideSelectedOptions: true,
    dark: dark,
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = includes(values, data.value);
        return !isDisabled && !isSelected ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row px-3 py-2 " + (dark ? 'hover:bg-secondary-three' : 'hover:bg-gray-100') + " cursor-pointer",
          onClick: function onClick() {
            return handleSelectChange(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize " + (dark ? 'text-white' : 'text-primary') + " text-base"
        }, data.label))) : null;
      }
    }
  }));
};
SingleSelect.defaultProps = {
  menuPlacement: 'bottom',
  dark: false
};

var VEHICLES_FILTERS = "query Vehicles($filtersFilter: VehiclesFilterParamType) {\n  vehiclesFilter(params: $filtersFilter) {\n   makes {\n      key\n      description    \n      count\n      priority\n    }\n   } \n  }";
var MakesSearch = function MakesSearch(_ref) {
  var context = _ref.context,
    onMakeClick = _ref.onMakeClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useVehiclesFilterDat = useVehiclesFilterData(VEHICLES_FILTERS, context),
    data = _useVehiclesFilterDat.data,
    loading = _useVehiclesFilterDat.loading,
    fetchVehiclesFilterData = _useVehiclesFilterDat.fetchVehiclesFilterData;
  useEffect(function () {
    fetchVehiclesFilterData();
  }, []);
  var makeItems = data ? map(orderBy(data === null || data === void 0 ? void 0 : data.makes, 'priority'), function (make) {
    return {
      key: make.key,
      text: make.text
    };
  }) : [];
  return /*#__PURE__*/React.createElement(SingleSelect, {
    placeHolder: t('Select Brand'),
    items: makeItems,
    values: {},
    isLoading: loading,
    dark: true,
    handleSelectChange: onMakeClick
  });
};

var SearchSuggestions = function SearchSuggestions(_ref) {
  var hits = _ref.hits,
    nbHits = _ref.nbHits,
    allUrl = _ref.allUrl,
    onAllResultClick = _ref.onAllResultClick,
    inputValue = _ref.inputValue,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    searchResultClickEventAnalytics = _useAnalytics.searchResultClickEventAnalytics;
  var handleClickResult = function handleClickResult(e, index, searchResult) {
    searchResultClickEventAnalytics({
      searchResultCount: nbHits,
      filter: inputValue || '',
      searchResultPosition: index + 1,
      searchResult: searchResult.make + " " + searchResult.model
    });
    onAllResultClick(e);
  };
  var renderNoResults = function renderNoResults() {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-8"
    }, t('No results found'), ".");
  };
  var renderResults = function renderResults() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "underline px-8 pb-4 pt-8 cursor-pointer",
      onClick: onAllResultClick
    }, /*#__PURE__*/React.createElement(InternalLink, {
      url: allUrl,
      context: context
    }, nbHits, " ", t('results'))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-4 px-8 py-4"
    }, map(hits.slice(0, 9), function (searchResult, index) {
      var _JSON$parse$;
      var imageUrl = (_JSON$parse$ = JSON.parse(searchResult.images)[0]) === null || _JSON$parse$ === void 0 ? void 0 : _JSON$parse$.uri;
      return /*#__PURE__*/React.createElement("div", {
        key: "algolia-result-" + index,
        onClick: function onClick(e) {
          return handleClickResult(e, index, searchResult);
        }
      }, /*#__PURE__*/React.createElement(InternalLink, {
        key: searchResult.reference,
        url: searchResult.url,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer"
      }, imageUrl && /*#__PURE__*/React.createElement("img", {
        src: imageUrl,
        className: "rounded",
        alt: "Search result"
      }), !imageUrl && /*#__PURE__*/React.createElement("img", {
        src: resolveAsset(imageDefault),
        className: "rounded",
        alt: "No image"
      }), /*#__PURE__*/React.createElement("p", {
        className: "text-14 mt-2 text-center font-semibold truncate"
      }, searchResult.make, " ", searchResult.model))));
    })), /*#__PURE__*/React.createElement(InternalLink, {
      url: allUrl,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-b flex items-center justify-center bg-secondary-two hover:bg-secondary-three cursor-pointer transition",
      onClick: onAllResultClick
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-white font-semibold py-4"
    }, t('View all') + (" " + nbHits + " ") + t('results')))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute rounded bg-black border border-white text-white mt-1 z-50 shadow-2xl inset-x-0"
  }, nbHits <= 0 && renderNoResults(), nbHits > 0 && renderResults());
};

var SearchBox = function SearchBox(_ref) {
  var getSuggestions = _ref.getSuggestions,
    queryResult = _ref.queryResult,
    showIcon = _ref.showIcon,
    inputClassName = _ref.inputClassName,
    placeholder = _ref.placeholder,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$searchQ = _useAnalytics.searchQueryEventAnalytics,
    searchQueryEventAnalytics = _useAnalytics$searchQ === void 0 ? function () {
      return null;
    } : _useAnalytics$searchQ;
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if ((queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits) !== undefined && inputValue) {
      setInputValue('');
      navigateInternalUrl(context, queryResult === null || queryResult === void 0 ? void 0 : queryResult.allUrl, false);
    }
  };
  var onIconClick = function onIconClick() {
    if ((queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits) !== undefined && inputValue) {
      setInputValue('');
      navigateInternalUrl(context, queryResult === null || queryResult === void 0 ? void 0 : queryResult.allUrl, false);
    } else {
      navigateInternalUrl(context, context.defaultPageNames.vehicles);
    }
  };
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded-l w-16 cursor-pointer",
      onClick: onIconClick
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-search text-secondary-five"
    }));
  };
  useEffect(function () {
    if (queryResult) {
      searchQueryEventAnalytics({
        searchKeyword: inputValue,
        searchResultCount: queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits
      });
    }
  }, [queryResult]);
  var placeholderText = placeholder ? placeholder : t('Type what you are looking for (e.g. black Audi A3)');
  return /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    className: "relative",
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex border border-white rounded"
  }, showIcon && renderIcon(), /*#__PURE__*/React.createElement("input", {
    autoComplete: "false",
    name: 'search-box-' + Math.random(),
    className: "w-full pl-3 " + inputClassName,
    onChange: function onChange(input) {
      getSuggestions(input);
      setInputValue(input.target.value);
    },
    type: "text",
    placeholder: placeholderText
  })), (queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits) !== undefined && inputValue && /*#__PURE__*/React.createElement(SearchSuggestions, {
    hits: queryResult.hits,
    nbHits: queryResult.nbHits,
    allUrl: queryResult.allUrl,
    inputValue: inputValue,
    context: context,
    onAllResultClick: function onAllResultClick() {
      return setInputValue('');
    }
  }));
};
SearchBox.defaultProps = {
  showIcon: true,
  inputClassName: 'bg-black text-white py-3 placeholder-white rounded outline-none'
};
var SearchBox$1 = baseSearchBox(SearchBox);

var findStockPage = function findStockPage(context) {
  return find(context === null || context === void 0 ? void 0 : context.allPagesData, function (page) {
    return (page.key === 'stock' || page.key === '/stock/') && page.language === context.culture;
  });
};
var Search = function Search(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function () {
      return null;
    } : _useAnalytics$buttonC;
  var searchRef = useRef();
  useContentBlockImpressionWhenInViewport(searchRef, 'search', context);
  var handleClick = function handleClick() {
    buttonClickEventAnalytics({
      analyticsButtonName: 'search',
      analyticsButtonType: 'button',
      analyticsButtonCategory: 'inbound-link',
      analyticsButtonPosition: 'Search',
      url: context.defaultPageNames.vehicles
    });
  };
  var handleMakeClick = function handleMakeClick(make) {
    var stockUrl = findStockPage(context) ? trimEnd(findStockPage(context).url, '/') : '';
    navigateInternalPage(context, stockUrl + "/?model[" + make.label.toLowerCase() + "]=");
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: searchRef,
    className: "flex flex-col h-full justify-center lg2:justify-start text-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row items-center w-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 w-full mb-4 lg:mb-0"
  }, /*#__PURE__*/React.createElement(MakesSearch, {
    context: context,
    onMakeClick: handleMakeClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block mx-4 lg2:mx-8 text-32"
  }, t('or')), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 w-full"
  }, /*#__PURE__*/React.createElement(SearchBox$1, {
    context: context,
    showIcon: false
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicles,
    context: context,
    className: "button button-alternate flex justify-center items-center h-12 text-center rounded cursor-pointer text-16 font-semibold",
    gatsbyClassName: "button-gatsby",
    onClick: handleClick
  }, t('Show all makes'))));
};

var BannerImagesCarouselWithTitleAndSearch = function BannerImagesCarouselWithTitleAndSearch(_ref) {
  var imagesWithTitleTextAndAction = _ref.imagesWithTitleTextAndAction,
    title = _ref.title,
    context = _ref.context;
  var _useState = useState(false),
    isHeaderDirectlyBefore = _useState[0],
    setIsHeaderDirectlyBefore = _useState[1];
  useEffect(function () {
    var headerTransparentDiv = document.querySelector('.header-transparent');
    var carouselWithSearchDiv = document.querySelector('.carousel-with-search');
    if (headerTransparentDiv && carouselWithSearchDiv && headerTransparentDiv !== null && headerTransparentDiv !== void 0 && headerTransparentDiv.parentNode && carouselWithSearchDiv !== null && carouselWithSearchDiv !== void 0 && carouselWithSearchDiv.parentNode) {
      setIsHeaderDirectlyBefore(headerTransparentDiv.parentNode === carouselWithSearchDiv.parentNode.previousElementSibling);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel-with-search " + (isHeaderDirectlyBefore ? '-mt-100px' : 'mt-0')
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-500px"
  }, /*#__PURE__*/React.createElement(Carousel, {
    items: imagesWithTitleTextAndAction,
    context: context,
    showDots: true,
    showShade: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-black py-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container grid grid-cols-1 lg:grid-cols-3 gap-5 lg2:gap-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 text-center lg:text-left text-32 lg2:text-40 font-medium text-white"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 lg:col-span-2"
  }, /*#__PURE__*/React.createElement(Search, {
    context: context
  })))));
};
BannerImagesCarouselWithTitleAndSearch.human = {
  nl: 'Held - afbeeldingencarrousel met titel en zoeken',
  fr: 'Hero - carrousel dimages avec titre et recherche',
  en: 'Hero - images carousel with title and search'
};

var BannerJsonImageAndTextWithAction = function BannerJsonImageAndTextWithAction(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: image.desktop,
    alt: image.alt
  }), /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }), /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    context: context
  }));
};
BannerJsonImageAndTextWithAction.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerJsonImageAndTextWithAction.human = {
  nl: 'Campaign block',
  fr: 'Campaign block',
  en: 'Campaign block'
};

var BannerJsonImageAndTextWithActionImageLeftDark = function BannerJsonImageAndTextWithActionImageLeftDark(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-primary border-t border-white border-opacity-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-15 lg2:gap-24"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: image.desktop,
    alt: image.alt,
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-style-check"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })), actionVisible(action) && /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    context: context,
    className: "flex self-start button button-alternate mt-9"
  }))));
};
BannerJsonImageAndTextWithActionImageLeftDark.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerJsonImageAndTextWithActionImageLeftDark.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerJsonImageAndTextWithActionImageLeftLight = function BannerJsonImageAndTextWithActionImageLeftLight(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container grid grid-cols-1 md:grid-cols-2 w-full bg-white gap-7 md:gap-15 lg2:gap-24"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: image.desktop,
    alt: image.alt,
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }), actionVisible(action) && /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    context: context,
    className: "flex self-start button button-secondary mt-9"
  })));
};
BannerJsonImageAndTextWithActionImageLeftLight.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerJsonImageAndTextWithActionImageLeftLight.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerJsonImageAndTextWithActionImageRightDark = function BannerJsonImageAndTextWithActionImageRightDark(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-primary border-t border-white border-opacity-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-15 lg2:gap-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-style-check"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })), actionVisible(action) && /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    context: context,
    className: "flex self-start button button-alternate mt-9"
  })), /*#__PURE__*/React.createElement("div", {
    className: "order-first md:order-last"
  }, /*#__PURE__*/React.createElement("img", {
    src: image.desktop,
    alt: image.alt,
    className: "w-full h-full object-cover"
  }))));
};
BannerJsonImageAndTextWithActionImageRightDark.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerJsonImageAndTextWithActionImageRightDark.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerJsonImageAndTextWithActionImageRightLight = function BannerJsonImageAndTextWithActionImageRightLight(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container grid grid-cols-1 md:grid-cols-2 w-full bg-white gap-7 md:gap-15 lg2:gap-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }), actionVisible(action) && /*#__PURE__*/React.createElement(ActionLink, {
    action: action,
    context: context,
    className: "flex self-start button button-secondary mt-9"
  })), /*#__PURE__*/React.createElement("div", {
    className: "order-first md:order-last"
  }, /*#__PURE__*/React.createElement("img", {
    src: image.desktop,
    alt: image.alt,
    className: "w-full h-full object-cover"
  })));
};
BannerJsonImageAndTextWithActionImageRightLight.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerJsonImageAndTextWithActionImageRightLight.human = {
  nl: '',
  fr: '',
  en: ''
};

var BannerMultiTextAction = function BannerMultiTextAction(_ref) {
  var data = _ref.data,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getTopBadge = function getTopBadge(action, index) {
    if (index === 0) return /*#__PURE__*/React.createElement("div", {
      className: "inline-block bg-primary text-white rounded font-semibold px-5 py-2"
    }, t('Minimum price'));
    if (index === 1) return /*#__PURE__*/React.createElement(ActionLink, {
      action: action,
      context: context,
      className: "inline-block button button-primary"
    }, t('Calculate trade in'));
    if (index === 2) return /*#__PURE__*/React.createElement("div", {
      className: "inline-block bg-primary text-white rounded font-semibold px-5 py-2"
    }, t('Maximum price'));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 my-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-stretch space-x-0 md:space-x-5"
  }, map(data, function (item, index) {
    if (index < 3) {
      return /*#__PURE__*/React.createElement("div", {
        key: "banner-multi-item-" + index,
        className: (index === 1 ? 'py-0' : 'py-5') + " w-full md:w-1/3"
      }, /*#__PURE__*/React.createElement("div", {
        className: (index === 1 ? 'bg-primary text-white' : 'bg-secondary-five') + " rounded p-10 lg:p-16 h-full"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pb-5"
      }, getTopBadge(item === null || item === void 0 ? void 0 : item.action, index)), /*#__PURE__*/React.createElement(MarkupText, {
        text: item === null || item === void 0 ? void 0 : item.text,
        context: context
      })));
    }
  })));
};
BannerMultiTextAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerMultiTextAction.defaultProps = {
  data: DefaultActionList
};

var BannerTitleDescriptionActionAndImages = function BannerTitleDescriptionActionAndImages(_ref) {
  var title = _ref.title,
    description = _ref.description,
    actionLink = _ref.actionLink,
    imagesWithTitleDescriptionAndAction = _ref.imagesWithTitleDescriptionAndAction,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    hoveredBox = _useState[0],
    setVisibleHoveredBox = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "container  grid grid-cols-1 md2:grid-cols-3 lg:grid-cols-4 gap-6 md2:gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary col-span-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 text-32 lg2:text-40 font-medium text-primary"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-8"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: description,
    context: context
  })), /*#__PURE__*/React.createElement(ActionLink, {
    className: "button button-secondary w-max",
    gatsbyClassName: "button-gatsby",
    action: actionLink,
    context: context
  }, t('View all services'))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 gap-4 col-span-2 lg:col-span-3 my-2"
  }, map(imagesWithTitleDescriptionAndAction, function (item, index) {
    var _item$action;
    var isHovered = hoveredBox === index;
    return /*#__PURE__*/React.createElement("div", {
      className: "relative ",
      onMouseEnter: function onMouseEnter() {
        return setVisibleHoveredBox(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setVisibleHoveredBox(null);
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      className: "flex items-end cursor-pointer overflow-hidden transform transition relative duration-500 flex-none " + (isHovered ? '-translate-y-2 shadow-2xl' : '') + " md:flex-1 generic-image-action-list-with-char-title h-64",
      gatsbyClassName: "flex items-end justify-start cursor-pointer flex-none md:flex-1 generic-image-action-list-with-char-title transition-all duration-500 h-64",
      key: 'image-action-' + index,
      action: item.action,
      context: context
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item === null || item === void 0 ? void 0 : item.image,
      className: "w-full h-full transition-transform transform duration-500 absolute inset-x-0 object-cover " + (isHovered ? 'scale-110' : ''),
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-white relative pl-10 w-full h-full flex justify-end flex-col ",
      style: {
        background: "linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.8) 75%)"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-32 font-bold"
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center text-base mb-10"
    }, t((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.title), /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right ml-2 text-8"
    })))));
  })));
};
BannerTitleDescriptionActionAndImages.human = {
  nl: 'Onze diensten - titel, beschrijving, knop en afbeeldingen',
  fr: 'Nos services - titre, description, bouton et images',
  en: 'Our services - title, description, button and images'
};

var BannerUspWithTextAndTwoBlocks = function BannerUspWithTextAndTwoBlocks(_ref) {
  var text = _ref.text,
    image1 = _ref.image1,
    text1 = _ref.text1,
    action1 = _ref.action1,
    image2 = _ref.image2,
    text2 = _ref.text2,
    action2 = _ref.action2,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container text-white my-8 flex flex-col lg2:flex-row px-5 md:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "check-marker w-full lg2:w-1/2 mb-4 lg2:mb-0 p-10 bg-secondary-two mr-0 md:mr-4"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg2:w-1/2 flex flex-col md:flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 relative mr-0 md:mr-4 mb-4 md:mb-0"
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: image1,
    className: "object-cover w-full",
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gradient-to-t from-black absolute bottom-0 w-full flex flex-col items-start p-8 lg2:p-4"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text1
  }), /*#__PURE__*/React.createElement(ActionLink, {
    className: "flex-none mt-4 button button-primary",
    action: action1,
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 relative"
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: image2,
    className: "object-cover w-full",
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gradient-to-t from-black absolute bottom-0 w-full flex flex-col items-start p-8 lg2:p-4"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text2
  }), /*#__PURE__*/React.createElement(ActionLink, {
    className: "flex-none mt-4 button button-primary",
    action: action2,
    context: context
  })))));
};
BannerUspWithTextAndTwoBlocks.human = {
  nl: 'USP Block',
  fr: 'USP Block',
  en: 'USP Block'
};
BannerUspWithTextAndTwoBlocks.defaultProps = {
  text: DefaultText,
  image1: DefaultImage,
  text1: DefaultText,
  action1: DefaultAction,
  image2: DefaultImage,
  text2: DefaultText,
  action2: DefaultAction
};

var BlogList = function BlogList(_ref) {
  var title = _ref.title,
    blog_posts = _ref.blog_posts,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10",
    style: {
      maxWidth: 1000,
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "py-12"
  }, title), /*#__PURE__*/React.createElement("div", null, map(blog_posts, function (post) {
    var image = isJsonString(post.image) ? JSON.parse(post.image) : post.image;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row mb-8"
    }, ((image === null || image === void 0 ? void 0 : image.mobile) || (image === null || image === void 0 ? void 0 : image.tablet) || (image === null || image === void 0 ? void 0 : image.desktop)) && /*#__PURE__*/React.createElement("img", {
      className: "flex-none w-full md:w-60 h-auto md:h-60 object-cover object-center",
      srcSet: "\n                    " + (image !== null && image !== void 0 && image.mobile ? image.mobile + ' 300w, ' : '') + "\n                    " + (image !== null && image !== void 0 && image.tablet ? image.tablet + ' 768w, ' : '') + "\n                    " + (image !== null && image !== void 0 && image.desktop ? image.desktop + ' 1280w, ' : '') + "\n                  ",
      src: image !== null && image !== void 0 && image.mobile ? image.mobile : image !== null && image !== void 0 && image.tablet ? image.tablet : image !== null && image !== void 0 && image.desktop ? image.desktop : '',
      alt: image !== null && image !== void 0 && image.alt ? image.alt : ''
    }), /*#__PURE__*/React.createElement("div", {
      className: "ml-0 md:ml-8 mt-8 md:mt-0",
      style: {
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("h2", {
      className: "mb-4 max-h-16 overflow-hidden truncate"
    }, post.title), /*#__PURE__*/React.createElement("div", {
      className: "mb-8 max-h-24 overflow-hidden"
    }, post.text), /*#__PURE__*/React.createElement(InternalLink, {
      url: post.url,
      context: context,
      className: "button button-secondary inline-block"
    }, t('Read more'))));
  })));
};
BlogList.human = {
  nl: '',
  fr: '',
  en: ''
};
BlogList.defaultProps = {
  blog_posts: 'will be generated on read'
};

var BrandSlider = function BrandSlider(_ref) {
  var cards = _ref.cards,
    inputWidth = _ref.width,
    autoSlideInterval = _ref.autoSlideInterval,
    withFadeEffect = _ref.withFadeEffect,
    renderLeftArrow = _ref.renderLeftArrow,
    renderRightArrow = _ref.renderRightArrow,
    renderScrollbar = _ref.renderScrollbar;
  var _useState = useState(0),
    currentIndex = _useState[0],
    setCurrentIndex = _useState[1];
  var _useState2 = useState(0),
    sliderTotalWidth = _useState2[0],
    setSliderTotalWidth = _useState2[1];
  var _useState3 = useState(0),
    contentWidth = _useState3[0],
    setContentWidth = _useState3[1];
  var _useState4 = useState(false),
    isMouseOver = _useState4[0],
    setIsMouseOver = _useState4[1];
  var _useState5 = useState(false),
    startAutoSwipe = _useState5[0],
    setStartAutoSwipe = _useState5[1];
  var _useState6 = useState(400),
    animationDuration = _useState6[0],
    setAnimationDuration = _useState6[1];
  var _useState7 = useState(0),
    maxIndex = _useState7[0],
    setMaxIndex = _useState7[1];
  var getCardWidth = function getCardWidth() {
    if (inputWidth && inputWidth > 0) return inputWidth;
    var width = 300;
    if (hasWindow()) {
      width = window.innerWidth < 768 ? 300 : 330;
    }
    return width;
  };
  var sliderContainerRef = useRef(null);
  var contentRef = useRef(null);
  var cardWidth = getCardWidth();
  var margin = 10;
  var autoSwipe = function autoSwipe() {
    var _getOptions = getOptions(),
      currentLeft = _getOptions.currentLeft,
      maxLeft = _getOptions.maxLeft;
    if (!isMouseOver) {
      if (currentIndex < getMaxIndex() && currentLeft < maxLeft) {
        setAnimationDuration(400);
        return onNext();
      } else {
        setAnimationDuration(autoSlideInterval * 1000 / 2);
        setCurrentIndex(0);
      }
    }
  };
  var calculateMaxWidth = function calculateMaxWidth() {
    if (sliderContainerRef && sliderContainerRef.current) {
      var sliderWrapper = sliderContainerRef.current;
      var sliderElements = sliderWrapper.children;
      forEach(sliderElements, function (el, i) {
        var isLast = (sliderElements === null || sliderElements === void 0 ? void 0 : sliderElements.length) - 1 === i;
        el.style.width = cardWidth + "px";
        if (!isLast) {
          el.style.marginRight = margin + "px";
        }
      });
      setMaxIndex(sliderElements === null || sliderElements === void 0 ? void 0 : sliderElements.length);
      setSliderTotalWidth(sliderContainerRef.current.clientWidth);
    }
    if (contentRef && contentRef.current) {
      setContentWidth(contentRef.current.clientWidth);
    }
  };
  useEffect(function () {
    calculateMaxWidth();
    if (hasWindow()) window.addEventListener('resize', calculateMaxWidth);
    setStartAutoSwipe(true);
    return function () {
      if (hasWindow()) window.removeEventListener('resize', calculateMaxWidth);
    };
  }, []);
  useEffect(function () {
    if (autoSlideInterval && startAutoSwipe) {
      var intervalCounter = autoSlideInterval * 1000;
      var interval = setTimeout(function () {
        return autoSwipe();
      }, intervalCounter);
      return function () {
        return clearTimeout(interval);
      };
    }
  }, [startAutoSwipe, currentIndex, isMouseOver]);
  var getMaxIndex = function getMaxIndex() {
    return maxIndex;
  };
  var onPrev = function onPrev() {
    if (currentIndex > 0) {
      var newIndex = currentIndex > 0 ? currentIndex - 1 : getMaxIndex();
      setCurrentIndex(newIndex);
    }
  };
  var getOptions = function getOptions() {
    var scrollValue = cardWidth + margin;
    var currentLeft = currentIndex * scrollValue;
    var maxLeft = sliderTotalWidth - contentWidth < 1 ? 0 : sliderTotalWidth - contentWidth;
    return {
      currentLeft: currentLeft,
      maxLeft: maxLeft
    };
  };
  var onNext = function onNext() {
    var _getOptions2 = getOptions(),
      currentLeft = _getOptions2.currentLeft,
      maxLeft = _getOptions2.maxLeft;
    if (currentIndex < getMaxIndex() && currentLeft < maxLeft) {
      var newIndex = currentIndex < getMaxIndex() ? currentIndex + 1 : 0;
      setCurrentIndex(newIndex);
    }
  };
  var handlers = useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      return onNext();
    },
    onSwipedRight: function onSwipedRight() {
      return onPrev();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });
  var showFadeEffect = function showFadeEffect() {
    var _getOptions3 = getOptions(),
      currentLeft = _getOptions3.currentLeft,
      maxLeft = _getOptions3.maxLeft;
    return currentIndex < getMaxIndex() && currentLeft < maxLeft;
  };
  var _getOptions4 = getOptions(),
    currentLeft = _getOptions4.currentLeft,
    maxLeft = _getOptions4.maxLeft;
  var left = currentLeft >= maxLeft ? maxLeft : currentLeft;
  var style = {
    left: -left
  };
  var prevEnabled = currentIndex > 0;
  var nextEnabled = currentIndex < getMaxIndex() && currentLeft < maxLeft;
  return /*#__PURE__*/React.createElement("div", {
    className: "core-relative core-w-full",
    onMouseOver: function onMouseOver() {
      return setIsMouseOver(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsMouseOver(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: "core-flex core-flex-col core-w-full core-relative"
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: "core-relative core-flex"
  }, handlers), renderLeftArrow && renderLeftArrow(prevEnabled, onPrev), /*#__PURE__*/React.createElement("div", {
    className: "core-overflow-x-hidden core-w-full"
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderContainerRef,
    className: "core-flex core-flex-nowrap core-relative",
    style: _extends({
      left: 0
    }, style, {
      width: 'fit-content',
      transition: "left " + animationDuration + "ms cubic-bezier(.25,.75,.5,1.25)"
    })
  }, cards.map(function (card, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "slider-card-" + i,
      className: ""
    }, card);
  }))), renderRightArrow && renderRightArrow(nextEnabled, onNext)), withFadeEffect && showFadeEffect() && /*#__PURE__*/React.createElement("div", {
    className: "core-bg-gradient-to-r core-from-transparent core-to-white core-absolute core-right-0 core-top-0 core-bottom-0",
    style: {
      width: 100
    }
  })), renderScrollbar && renderScrollbar(currentIndex, cards === null || cards === void 0 ? void 0 : cards.length));
};
BrandSlider.defaultProps = {
  withFadeEffect: true,
  width: undefined,
  renderRightArrow: undefined,
  renderLeftArrow: undefined,
  renderScrollbar: undefined
};

var GenericImageActionListWithCharTitle = function GenericImageActionListWithCharTitle(_ref) {
  var title = _ref.title,
    items = _ref.items,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uspRef = useRef();
  useContentBlockImpressionWhenInViewport(uspRef, 'usp', context);
  var _useState = useState(null),
    hoveredBox = _useState[0],
    setVisibleHoveredBox = _useState[1];
  var renderButton = function renderButton() {
    return /*#__PURE__*/React.createElement(InternalLink, {
      name: "vehicles-list",
      page: context.defaultPageNames.vehicles,
      className: "button button-secondary whitespace-nowrap w-max",
      gatsbyClassName: "button-gatsby",
      context: context
    }, t('Full offer'));
  };
  var renderCard = function renderCard(item, index) {
    var _item$action;
    var isHovered = hoveredBox === index;
    return /*#__PURE__*/React.createElement("div", {
      key: 'card-' + index,
      className: "relative",
      onMouseEnter: function onMouseEnter() {
        return setVisibleHoveredBox(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setVisibleHoveredBox(null);
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      className: "flex items-end cursor-pointer overflow-hidden transform transition relative duration-500 flex-none " + (isHovered ? '-translate-y-2' : '') + "  md:flex-1 generic-image-action-list-with-char-title h-369px  lg2:h-64",
      gatsbyClassName: "flex items-end justify-start cursor-pointer flex-none md:flex-1  generic-image-action-list-with-char-title transition-all duration-500 overflow-hidden h-64",
      key: 'image-action-' + index,
      action: item.action,
      context: context
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item === null || item === void 0 ? void 0 : item.image,
      className: "w-full h-full transition-transform transform duration-500 absolute inset-x-0 object-cover " + (isHovered ? 'scale-110' : ''),
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-white relative pl-5 w-full h-full flex justify-end flex-col",
      style: {
        background: "linear-gradient(180deg, rgba(0,0,0,0) 60%, rgba(0,0,0,0.8) 85%)"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-32 font-bold break-words"
    }, (_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.title), /*#__PURE__*/React.createElement("div", {
      className: "text-base mb-5"
    }, t('Discover our offer'), /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right ml-2 text-8"
    })))));
  };
  var renderGrid = function renderGrid() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex lg2:grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg2:grid-cols-5 gap-2.5"
    }, map(items, function (item, index) {
      return renderCard(item, index);
    }));
  };
  var renderScroller = function renderScroller() {
    return /*#__PURE__*/React.createElement(BrandSlider, {
      width: 280,
      withFadeEffect: false,
      cards: items.map(function (item, index) {
        return renderCard(item, index);
      }),
      renderLeftArrow: function renderLeftArrow(isEnabled, handleClick) {
        return /*#__PURE__*/React.createElement("div", {
          className: "absolute -left-8 bottom-1/2 z-20"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center bg-white w-16 h-16 transition cursor-pointer rounded-full " + (isEnabled ? '' : 'opacity-0 pointer-events-none'),
          onClick: function onClick() {
            return handleClick();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "far fa-chevron-left text-18 text-chevron-icon mr-1 mt-px"
        })));
      },
      renderRightArrow: function renderRightArrow(isEnabled, handleClick) {
        return /*#__PURE__*/React.createElement("div", {
          className: "absolute right-15 bottom-1/2 z-20"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center bg-white w-16 h-16  transition cursor-pointer rounded-full " + (isEnabled ? '' : 'opacity-0 pointer-events-none'),
          onClick: function onClick() {
            return handleClick();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "far fa-chevron-right text-18 text-chevron-icon ml-1 mt-px"
        })));
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: uspRef,
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center lg2:justify-between mb-6 md:mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-32 lg2:text-40 font-medium text-primary md:whitespace-nowrap"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "hidden ml-auto lg2:block"
  }, renderButton())), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:block"
  }, renderGrid()), /*#__PURE__*/React.createElement("div", {
    className: "block lg2:hidden"
  }, renderScroller()), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center my-10 lg2:hidden"
  }, renderButton()));
};
GenericImageActionListWithCharTitle.human = {
  nl: 'Generic Image Action List With Char Title',
  fr: 'Generic Image Action List With Char Title',
  en: 'Generic Image Action List With Char Title'
};
GenericImageActionListWithCharTitle.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageAction), _extends({}, DefaultImageAction), _extends({}, DefaultImageAction)]
};

var GenericImageActionListWithTitle = function GenericImageActionListWithTitle(_ref) {
  var title = _ref.title,
    items = _ref.items,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container py-8"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "no-scrollbar flex overflow-x-scroll scrollbar-snap-x px-10 py-10 mb-4"
  }, map(items, function (item, index) {
    var _item$action;
    return /*#__PURE__*/React.createElement(ActionLink, {
      className: "cursor-pointer flex-none md:flex-1",
      key: 'image-action-' + index,
      action: item.action,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-200px md:w-auto flex flex-col items-center relative ml-2 mr-2"
    }, /*#__PURE__*/React.createElement(BuilderImage, {
      image: item === null || item === void 0 ? void 0 : item.image,
      className: "rounded",
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "rounded absolute bottom-0 bg-secondary-two text-white font-semibold px-4 py-2 -mb-4"
    }, (_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.title)));
  })));
};
GenericImageActionListWithTitle.human = {
  nl: 'Lifestyle blocks',
  fr: 'Lifestyle blocks',
  en: 'Lifestyle blocks'
};
GenericImageActionListWithTitle.defaultProps = {
  title: DefaultText,
  items: [_extends({}, DefaultImageAction), _extends({}, DefaultImageAction), _extends({}, DefaultImageAction)]
};

var Paragraph = function Paragraph(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 my-10 md:my-24",
    style: {
      minHeight: 30
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  }));
};
Paragraph.human = {
  nl: '',
  fr: '',
  en: ''
};
Paragraph.defaultProps = {
  text: DefaultText
};

var Paragraph_Left = function Paragraph_Left(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-24 my-24",
    style: {
      minHeight: 30
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })));
};
Paragraph_Left.human = {
  nl: '',
  fr: '',
  en: ''
};
Paragraph_Left.defaultProps = {
  text: DefaultText
};

var AdvertiseComponent = function AdvertiseComponent(_ref) {
  var html = _ref.html;
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
var AdvertiseComponent$1 = baseAdvertisementBlock(AdvertiseComponent);

var AdvertisementBanner = function AdvertisementBanner(_ref) {
  var group = _ref.group,
    context = _ref.context;
  if (group.groupId === undefined && context.builder) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 50
      }
    }, " Advertisement block");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 pt-10",
    style: {
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupId: group.groupId,
    context: context
  }));
};
AdvertisementBanner.defaultProps = {
  group: DefaultAdvertiseGroupRef
};
AdvertisementBanner.human = {
  nl: 'Advertisement block',
  fr: 'Advertisement block',
  en: 'Advertisement block'
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var context = _ref.context,
    className = _ref.className;
  var languages = ['en', 'fr', 'nl'];
  var getPageFromPath = function getPageFromPath() {
    if (hasWindow()) {
      var _filter;
      return (_filter = filter(window.location.pathname.split('/'), function (path) {
        return path !== '' && !includes(languages, path);
      })) === null || _filter === void 0 ? void 0 : _filter.pop();
    }
  };
  var findCurrentPage = function findCurrentPage() {
    if (hasWindow()) {
      return find(context.allPagesData, function (data) {
        return data.url === window.location.pathname && data.language === context.culture;
      });
    }
  };
  var currentPage = findCurrentPage();
  var isCurrentHome = !getPageFromPath();
  if (isCurrentHome) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "" + className
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.home,
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-home-alt cursor-pointer"
  })), /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right mx-3",
    style: {
      fontSize: 10
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, currentPage !== null && currentPage !== void 0 && currentPage.description ? currentPage.description : getPageFromPath()));
};
Breadcrumbs.defaultProps = {
  className: 'container px-5 md:px-10 py-5 flex items-center'
};
Breadcrumbs.human = {
  nl: '',
  fr: '',
  en: ''
};

var Footer = function Footer(_ref) {
  var logo = _ref.logo,
    socials = _ref.socials,
    menu = _ref.menu,
    contactActions = _ref.contactActions,
    copyright = _ref.copyright,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-secondary-seven text-base text-black"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionLink, {
    action: logo === null || logo === void 0 ? void 0 : logo.action,
    context: context
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: logo === null || logo === void 0 ? void 0 : logo.image,
    className: "cursor-pointer mb-7 object-center object-contain",
    context: context,
    style: {
      height: 40,
      maxWidth: 160
    }
  })), (socials === null || socials === void 0 ? void 0 : socials.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 justify-start items-center"
  }, socials.map(function (social, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: social === null || social === void 0 ? void 0 : social.action,
      className: "hover:opacity-60 transition text-20",
      context: context
    }, /*#__PURE__*/React.createElement("i", {
      className: "" + social.icon
    }));
  }))), map(menu, function (item, index) {
    var isLastItem = index === (menu === null || menu === void 0 ? void 0 : menu.length) - 1;
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-24 mb-5"
    }, item.action.title), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, map(item.subActions, function (subAction, subIndex) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: index + " " + subIndex,
        className: "font-bold text-sm leading-7 hover:opacity-60 cursor-pointer transition mb-1",
        action: subAction,
        context: context
      }, subAction.title);
    }), isLastItem && (contactActions === null || contactActions === void 0 ? void 0 : contactActions.map(function (action, index) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: index,
        action: action,
        className: "button button-secondary w-max my-3",
        gatsbyClassName: "button-gatsby",
        context: context,
        style: {
          minWidth: 175
        }
      });
    }))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center px-10 py-11 max-w-screen-2xl mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-copyright-text"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: copyright
  }))));
};
Footer.defaultProps = {
  logo: DefaultImageAction,
  socials: DefaultSocialIconActionList,
  menu: DefaultActionWithSubActionsList,
  contactActions: DefaultActionList,
  copyright: DefaultText
};
Footer.human = {
  nl: 'Footer',
  fr: 'Footer',
  en: 'Footer'
};

var IconWithHover = function IconWithHover(_ref) {
  var iconClass = _ref.iconClass,
    hoverBackgroundClass = _ref.hoverBackgroundClass,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-none text-base hover:" + hoverBackgroundClass + " transition cursor-pointer rounded-full w-10 flex items-center justify-center " + className
  }, /*#__PURE__*/React.createElement("i", {
    className: "" + iconClass
  }));
};
IconWithHover.defaultProps = {
  className: 'h-10'
};

var AccountMenu = function AccountMenu(_ref) {
  var _session$user;
  var context = _ref.context,
    transparent = _ref.transparent;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSession = useSession(context),
    session = _useSession.session;
  var closeMenu = function closeMenu() {
    setOpen(false);
  };
  useEffect(function () {
    if (!hasDocument) return;
    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];
    if (open) {
      if (html) html.classList.add('overflow-hidden');
      if (body) {
        body.addEventListener('click', closeMenu);
        body.classList.add('overflow-y-scroll');
      }
    }
    if (!open) {
      if (html && html.classList.contains('overflow-hidden')) {
        html.classList.remove('overflow-hidden');
      }
      if (body && body.classList.contains('overflow-y-scroll')) {
        body.classList.remove('overflow-y-scroll');
      }
    }
    return function () {
      if (body) {
        body.removeEventListener('click', closeMenu);
      }
    };
  }, [open]);
  var userName = session === null || session === void 0 ? void 0 : (_session$user = session.user) === null || _session$user === void 0 ? void 0 : _session$user.firstName;
  var menuItems = [{
    icon: 'far fa-user',
    label: t('Account overview'),
    page: context.defaultPageNames.accountOverview
  }, {
    icon: 'far fa-cog',
    label: t('Profile and preferences'),
    page: context.defaultPageNames.accountProfile
  }, {
    icon: 'far fa-unlock',
    label: t('Change password'),
    page: context.defaultPageNames.accountChangePassword
  }, {
    icon: 'far fa-lightbulb-on',
    label: t('Keep me notified'),
    page: context.defaultPageNames.accountCarAgent
  }, {
    icon: 'far fa-heart',
    label: t('My favorites'),
    page: context.defaultPageNames.accountFavorites
  }];
  var renderButton = function renderButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center py-1 pl-1 pr-5"
    }, session !== null && session !== void 0 && session.authenticated ? /*#__PURE__*/React.createElement(SignOutButton$1, {
      context: context
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InternalLink, {
      className: "py-3 px-5 border-b-2 md:border-0 border-gray-50 text-secondary-two hover:text-secondary-three",
      page: context.defaultPageNames.login,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-sign-out mr-4"
    }), t('Login')))), /*#__PURE__*/React.createElement("i", {
      className: "fal fa-chevron-right text-xs"
    }));
  };
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement(Slide, {
      left: true,
      when: open,
      duration: 300,
      collapse: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixed inset-0 bg-white transition-all ease-linear",
      style: {
        zIndex: open ? 100 : -1
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center text-secondary-two py-5 px-5 w-full border-b-2 border-gray-50 " + (session !== null && session !== void 0 && session.authenticated ? 'justify-between' : 'justify-end')
    }, (session === null || session === void 0 ? void 0 : session.authenticated) && /*#__PURE__*/React.createElement("div", {
      className: "text-20 font-semibold"
    }, userName ? /*#__PURE__*/React.createElement("span", null, t('Welcome'), " ", userName) : ''), /*#__PURE__*/React.createElement("i", {
      className: "fal fa-times cursor-pointer",
      onClick: function onClick() {
        return setOpen(false);
      }
    })), map(menuItems, function (item, index) {
      var page = session !== null && session !== void 0 && session.authenticated ? item.page : context.defaultPageNames.login;
      return /*#__PURE__*/React.createElement(InternalLink, {
        key: index,
        className: "py-3 px-5 border-b-2 border-gray-50 text-secondary-two hover:text-secondary-three",
        page: page,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: 35
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: item.icon + " mr-2"
      })), item.label), /*#__PURE__*/React.createElement("i", {
        className: "fal fa-chevron-right text-xs"
      })));
    }), renderButton()));
  };
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute right-0 border border-gray-50 shadow-md bg-white transform transition-all duration-100 ease-linear " + (open ? 'translate-x-0 opacity-100 z-20' : 'translate-x-full opacity-0 -z-1'),
      style: {
        top: '120%',
        minWidth: 300
      }
    }, map(menuItems, function (item, index) {
      var page = session !== null && session !== void 0 && session.authenticated ? item.page : context.defaultPageNames.login;
      return /*#__PURE__*/React.createElement(InternalLink, {
        key: index,
        className: "py-3 px-5 border-b-2 border-gray-50 text-secondary-two hover:text-secondary-three",
        page: page,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: 35
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: item.icon + " mr-2"
      })), item.label), /*#__PURE__*/React.createElement("i", {
        className: "fal fa-chevron-right text-xs"
      })));
    }), renderButton());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "static md:relative"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      e.stopPropagation();
      setOpen(!open);
    },
    className: "z-10"
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "far fa-user " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex"
  }, renderDesktop()));
};

var Disclosure = function Disclosure(_ref) {
  var placeholder = _ref.placeholder,
    dropdownPosition = _ref.dropdownPosition,
    dropdownVerticalPosition = _ref.dropdownVerticalPosition,
    renderButton = _ref.renderButton,
    renderDropdown = _ref.renderDropdown,
    onToggleDropDown = _ref.onToggleDropDown,
    isLocked = _ref.isLocked;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var wrapperRef = useOuterClick(function () {
    setIsOpen(false);
  });
  useEffect(function () {
    if (onToggleDropDown && typeof onToggleDropDown === 'function') {
      onToggleDropDown(isOpen);
    }
  }, [isOpen]);
  var getDropdownHorizontalPositionClass = function getDropdownHorizontalPositionClass() {
    var position = 'right-0';
    if (dropdownPosition === 'left') position = 'left-0';
    return position;
  };
  var getDropdownVerticalPositionClass = function getDropdownVerticalPositionClass() {
    var position = 'top-full';
    if (dropdownVerticalPosition === 'top') position = 'bottom-full';
    return position;
  };
  var close = function close() {
    setIsOpen(false);
  };
  var button = function button() {
    if (renderButton) {
      return renderButton(isOpen, function () {
        return setIsOpen(!isOpen);
      }, function () {
        return setIsOpen(true);
      }, function () {
        return setIsOpen(false);
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "relative flex items-center justify-between rounded-4 text-gray-darkest hover:text-white bg-gray-lightest2 border border-gray-lightest2 hover:bg-green-dark2 hover:border-green-dark2 focus:border-green-dark2 px-4 h-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-12 whitespace-nowrap"
    }, placeholder), /*#__PURE__*/React.createElement("i", {
      className: "far fa-angle-down ml-2.5 text-14 pt-0.5 transform transition duration-150 ease-in-out " + (isOpen ? 'rotate-180' : '')
    }));
  };
  var dropdown = function dropdown() {
    if (renderDropdown) {
      return renderDropdown(close, isOpen);
    }
    return /*#__PURE__*/React.createElement("div", null, t('No content to show.'));
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "" + (isLocked ? 'pointer-events-none cursor-default' : ''),
    onClick: function onClick() {
      return isLocked ? undefined : setIsOpen(!isOpen);
    }
  }, button()), /*#__PURE__*/React.createElement(Fade$1, {
    when: isOpen && !isLocked,
    collapse: !isOpen || isLocked,
    duration: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: "select-field-dropdown absolute " + (isOpen && !isLocked ? 'opacity-100 z-50' : 'opacity-0 -z-1') + " " + getDropdownHorizontalPositionClass() + " " + getDropdownVerticalPositionClass()
  }, dropdown())));
};
Disclosure.defaultProps = {
  placeholder: 'Select',
  dropdownPosition: 'right',
  dropdownVerticalPosition: 'bottom',
  renderDropdown: undefined,
  renderButton: undefined,
  onToggleDropDown: undefined,
  loading: false
};

var LanguagePicker = function LanguagePicker(_ref) {
  var transparent = _ref.transparent,
    availableLanguages = _ref.availableLanguages,
    currentLanguage = _ref.currentLanguage,
    onLanguageChanged = _ref.onLanguageChanged,
    button = _ref.button,
    dropdownPosition = _ref.dropdownPosition,
    dropdownVerticalPosition = _ref.dropdownVerticalPosition;
  var _renderButton = function renderButton(isOpen) {
    if (button) {
      return button(isOpen, currentLanguage, availableLanguages);
    }
    if (!availableLanguages || availableLanguages.length <= 1) return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-none  text-16 font-bold cursor-pointer px-3\n        " + (transparent ? 'text-white hover:text-secondary-four' : 'text-secondary-two hover:text-secondary-three') + "\n        \n        "
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap uppercase mr-2"
    }, currentLanguage), /*#__PURE__*/React.createElement("i", {
      className: "fal fa-angle-down"
    }));
  };
  var renderDropdown = function renderDropdown() {
    return /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col space-y-2 py-2 px-4 rounded-4 border border-gray-lightest min-w-20 bg-white"
    }, availableLanguages.map(function (lng) {
      return /*#__PURE__*/React.createElement("div", {
        key: lng.code,
        className: "cursor-pointer uppercase text-copyright-text hover:text-black font-medium",
        onClick: function onClick() {
          return onLanguageChanged(lng.code);
        }
      }, lng.code);
    })));
  };
  return /*#__PURE__*/React.createElement(Disclosure, {
    renderButton: function renderButton(isOpen) {
      return _renderButton(isOpen);
    },
    renderDropdown: renderDropdown,
    dropdownPosition: dropdownPosition,
    dropdownVerticalPosition: dropdownVerticalPosition
  });
};
LanguagePicker.defaultProps = {
  dropdownPosition: 'right',
  dropdownVerticalPosition: 'bottom'
};
var LanguagePicker$1 = baseLanguagePicker(LanguagePicker, true);

var HeaderDesktop = function HeaderDesktop(_ref) {
  var logoDark = _ref.logoDark,
    _ref$logoLight = _ref.logoLight,
    logoLight = _ref$logoLight === void 0 ? null : _ref$logoLight,
    menuWithSubMenu = _ref.menuWithSubMenu,
    actions = _ref.actions,
    context = _ref.context,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'fixed' : _ref$position,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent,
    _ref$isSearchVisible = _ref.isSearchVisible,
    isSearchVisible = _ref$isSearchVisible === void 0 ? false : _ref$isSearchVisible,
    _ref$setIsSearchVisib = _ref.setIsSearchVisible,
    setIsSearchVisible = _ref$setIsSearchVisib === void 0 ? function () {
      return null;
    } : _ref$setIsSearchVisib;
  var logo = transparent && !!logoLight ? logoLight : logoDark;
  return /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:flex w-full flex-row items-center justify-center h-90px px-6 " + position + " top-0 z-40 transition-all duration-300 " + (transparent ? '' : 'bg-white')
  }, /*#__PURE__*/React.createElement(ActionLink, {
    className: "justify-self-start w-40 mr-auto h-full flex items-center",
    action: logo.action,
    context: context
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: logo === null || logo === void 0 ? void 0 : logo.image,
    className: "cursor-pointer transition-all duration-300",
    context: context,
    style: {
      height: transparent ? 60 : 54,
      maxWidth: 160,
      objectFit: 'contain',
      objectPosition: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center h-full justify-center"
  }, menuWithSubMenu === null || menuWithSubMenu === void 0 ? void 0 : menuWithSubMenu.map(function (menuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: menuItem.action,
      context: context,
      className: "px-3 h-full flex items-center justify-center font-semibold  " + (transparent ? 'text-white hover:text-secondary-four' : 'text-secondary-two hover:text-secondary-three') + " cursor-pointer transition"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center ml-auto h-full justify-center"
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: action,
      context: context,
      className: "button button-secondary text-14 h-9 mr-2",
      gatsbyClassName: "button-gatsby"
    });
  }), /*#__PURE__*/React.createElement(LanguagePicker$1, {
    transparent: transparent,
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setIsSearchVisible(!isSearchVisible);
    }
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "far fa-search text-20 " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), context.favorites && /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.favorites,
    className: "ml-2",
    context: context
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "far fa-heart text-20 " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), context.account && /*#__PURE__*/React.createElement("div", {
    className: "ml-2"
  }, /*#__PURE__*/React.createElement(AccountMenu, {
    context: context,
    transparent: transparent,
    iconClass: 'text-20'
  }))));
};

var HeaderMobile = function HeaderMobile(_ref) {
  var logoDark = _ref.logoDark,
    _ref$logoLight = _ref.logoLight,
    logoLight = _ref$logoLight === void 0 ? null : _ref$logoLight,
    menuWithSubMenu = _ref.menuWithSubMenu,
    actions = _ref.actions,
    context = _ref.context,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'fixed' : _ref$position,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent,
    _ref$isSideMenuOpen = _ref.isSideMenuOpen,
    isSideMenuOpen = _ref$isSideMenuOpen === void 0 ? false : _ref$isSideMenuOpen,
    _ref$isSearchVisible = _ref.isSearchVisible,
    isSearchVisible = _ref$isSearchVisible === void 0 ? false : _ref$isSearchVisible,
    _ref$handeChangeSideM = _ref.handeChangeSideMenu,
    handeChangeSideMenu = _ref$handeChangeSideM === void 0 ? function () {
      return null;
    } : _ref$handeChangeSideM,
    _ref$setIsSearchVisib = _ref.setIsSearchVisible,
    setIsSearchVisible = _ref$setIsSearchVisib === void 0 ? function () {
      return null;
    } : _ref$setIsSearchVisib;
  var handleClickBarsIcon = function handleClickBarsIcon() {
    handeChangeSideMenu(true);
  };
  var handleClickCloseIcon = function handleClickCloseIcon() {
    handeChangeSideMenu(false);
  };
  var logo = transparent && !!logoLight ? logoLight : logoDark;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex lg2:hidden flex-col w-full " + position + " top-0 z-40"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: action,
      context: context,
      className: "button button-secondary rounded-none text-14 h-9 w-full",
      gatsbyClassName: "button-gatsby"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center transition-all duration-300 " + (transparent ? 'h-32' : 'h-24 bg-white')
  }, /*#__PURE__*/React.createElement(ActionLink, {
    className: "ml-5 lg2:ml-11 mr-0 md:mr-auto header-logo",
    action: logo.action,
    context: context
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: logo === null || logo === void 0 ? void 0 : logo.image,
    className: "cursor-pointer object-contain object-center",
    context: context
  })), /*#__PURE__*/React.createElement(LanguagePicker$1, {
    transparent: transparent,
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setIsSearchVisible(!isSearchVisible);
    }
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    className: "w-8 h-8",
    iconClass: "far fa-search text-20 " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), context.favorites && /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.favorites,
    className: "ml-1",
    context: context
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "far fa-heart text-20 " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), context.account && /*#__PURE__*/React.createElement("div", {
    className: "ml-1"
  }, /*#__PURE__*/React.createElement(AccountMenu, {
    context: context,
    transparent: transparent,
    iconClass: 'text-20'
  })), !isSideMenuOpen && /*#__PURE__*/React.createElement("div", {
    className: "mr-1 ml-1",
    onClick: handleClickBarsIcon
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    className: "w-8 h-8",
    iconClass: "fa fa-bars text-20 font-thin " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })), isSideMenuOpen && /*#__PURE__*/React.createElement("div", {
    className: "mr-1 ml-1",
    onClick: handleClickCloseIcon
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    className: "w-8 h-8",
    iconClass: "fal fa-times text-20 font-thin " + (transparent && 'text-white'),
    hoverBackgroundClass: "" + (transparent ? 'bg-secondary-two' : 'bg-secondary-five')
  })))), /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-white z-30 pt-44 overflow-hidden transition-all duration-300 translate-x-full " + (isSideMenuOpen ? '' : '-left-full opacity-0 pointer-events-none')
  }, menuWithSubMenu === null || menuWithSubMenu === void 0 ? void 0 : menuWithSubMenu.map(function (menuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: menuItem.action,
      context: context,
      className: "px-5 flex items-start justify-start font-semibold text-24 leading-9 mb-3 " + (transparent ? 'text-white hover:text-secondary-four' : 'text-secondary-two hover:text-secondary-three') + " cursor-pointer transition"
    });
  })));
};

var SearchOverlay = function SearchOverlay(_ref) {
  var getSuggestions = _ref.getSuggestions,
    queryResult = _ref.queryResult,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    context = _ref.context;
  var _useState = useState(''),
    searchValue = _useState[0],
    setSearchValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleKeyPress = function handleKeyPress(event) {
    switch (event.keyCode) {
      case 27:
        handleClose();
        break;
    }
  };
  useEffect(function () {
    if (hasDocument()) {
      document.addEventListener('keyup', handleKeyPress);
      return function () {
        document.removeEventListener('keyup', handleKeyPress);
      };
    }
  }, []);
  var handleClose = function handleClose() {
    setSearchValue('');
    onClose();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center fixed inset-x-0 bg-white top-0 transition-all transform py-12 z-40 " + (isOpen ? 'translate-y-0' : '-translate-y-full')
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-center border-b-2 border-black w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-full flex-1"
  }, /*#__PURE__*/React.createElement("input", {
    className: "w-full bg-transparent outline-none border-0 font-semibold placeholder-black",
    type: "text",
    autoComplete: "false",
    name: 'search-overlay-input-' + Math.random(),
    onChange: function onChange(input) {
      getSuggestions(input);
      setSearchValue(input.target.value);
    },
    value: searchValue,
    placeholder: t('Type what you are looking for (e.g. black Audi A3)'),
    style: {
      height: 76,
      fontSize: 36
    }
  }), /*#__PURE__*/React.createElement("div", {
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "far fa-times text-30",
    hoverBackgroundClass: "bg-secondary-five"
  }))), (queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits) !== undefined && searchValue && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-x-0 top-full"
  }, /*#__PURE__*/React.createElement(SearchSuggestions, {
    hits: queryResult.hits,
    nbHits: queryResult.nbHits,
    allUrl: queryResult.allUrl,
    context: context,
    onAllResultClick: function onAllResultClick() {
      return setSearchValue('');
    }
  }))));
};
var SearchOverlay$1 = baseSearchBox(SearchOverlay);

var Header = function Header(_ref) {
  var logoDark = _ref.logoDark,
    logoLight = _ref.logoLight,
    menuWithSubMenu = _ref.menuWithSubMenu,
    actions = _ref.actions,
    context = _ref.context;
  var _useState = useState(true),
    transparent = _useState[0],
    setTransparent = _useState[1];
  var _useState2 = useState(false),
    isSearchVisible = _useState2[0],
    setIsSearchVisible = _useState2[1];
  var _useState3 = useState(false),
    isSideMenuOpen = _useState3[0],
    _setIsSideMenuOpen = _useState3[1];
  var refIsSideMenuOpen = useRef(false);
  var setIsSideMenuOpen = function setIsSideMenuOpen(value) {
    refIsSideMenuOpen.current = value;
    _setIsSideMenuOpen(value);
  };
  var settingTransparent = function settingTransparent() {
    if (hasWindow() && window.scrollY == 0 && !refIsSideMenuOpen.current) setTransparent(true);else setTransparent(false);
  };
  var handleScroll = function handleScroll() {
    settingTransparent();
  };
  var handeChangeSideMenu = function handeChangeSideMenu(value) {
    setIsSideMenuOpen(value);
    settingTransparent();
  };
  useEffect(function () {
    hasWindow() && window.addEventListener('scroll', handleScroll);
    return function () {
      hasWindow() && window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderDesktop, {
    logoDark: logoDark,
    logoLight: logoLight,
    menuWithSubMenu: menuWithSubMenu,
    actions: actions,
    context: context,
    transparent: transparent,
    isSearchVisible: isSearchVisible,
    setIsSearchVisible: setIsSearchVisible
  }), /*#__PURE__*/React.createElement(HeaderMobile, {
    logoDark: logoDark,
    logoLight: logoLight,
    menuWithSubMenu: menuWithSubMenu,
    actions: actions,
    context: context,
    transparent: transparent,
    isSideMenuOpen: isSideMenuOpen,
    isSearchVisible: isSearchVisible,
    handeChangeSideMenu: handeChangeSideMenu,
    setIsSearchVisible: setIsSearchVisible
  }), /*#__PURE__*/React.createElement(SearchOverlay$1, {
    isOpen: isSearchVisible,
    onClose: function onClose() {
      return setIsSearchVisible(false);
    },
    context: context
  }));
};
Header.defaultProps = {
  logoDark: DefaultImageAction,
  logoLight: DefaultImageAction,
  menuWithSubMenu: [DefaultActionWithSubContentActionsAndCtas],
  actions: DefaultActionList
};
Header.human = {
  nl: 'Header',
  fr: 'Header',
  en: 'Header'
};

var Header_Solid = function Header_Solid(_ref) {
  var logoDark = _ref.logoDark,
    menuWithSubMenu = _ref.menuWithSubMenu,
    actions = _ref.actions,
    context = _ref.context;
  var _useState = useState(false),
    isSearchVisible = _useState[0],
    setIsSearchVisible = _useState[1];
  var _useState2 = useState(false),
    isSideMenuOpen = _useState2[0],
    _setIsSideMenuOpen = _useState2[1];
  var refIsSideMenuOpen = useRef(false);
  var setIsSideMenuOpen = function setIsSideMenuOpen(value) {
    refIsSideMenuOpen.current = value;
    _setIsSideMenuOpen(value);
  };
  var handeChangeSideMenu = function handeChangeSideMenu(value) {
    setIsSideMenuOpen(value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "h-32 lg2:h-90px lg2:shadow"
  }), /*#__PURE__*/React.createElement(HeaderDesktop, {
    logoDark: logoDark,
    menuWithSubMenu: menuWithSubMenu,
    actions: actions,
    context: context,
    position: 'fixed',
    transparent: false,
    isSearchVisible: isSearchVisible,
    setIsSearchVisible: setIsSearchVisible
  }), /*#__PURE__*/React.createElement(HeaderMobile, {
    logoDark: logoDark,
    menuWithSubMenu: menuWithSubMenu,
    actions: actions,
    context: context,
    transparent: false,
    position: 'fixed',
    isSideMenuOpen: isSideMenuOpen,
    isSearchVisible: isSearchVisible,
    handeChangeSideMenu: handeChangeSideMenu,
    setIsSearchVisible: setIsSearchVisible
  }), /*#__PURE__*/React.createElement(SearchOverlay$1, {
    isOpen: isSearchVisible,
    onClose: function onClose() {
      return setIsSearchVisible(false);
    },
    context: context
  }));
};
Header_Solid.defaultProps = {
  logoDark: DefaultImageAction,
  menuWithSubMenu: [DefaultActionWithSubContentActionsAndCtas],
  actions: DefaultActionList
};
Header_Solid.human = {
  nl: 'Header Solid',
  fr: 'Header Solid',
  en: 'Header Solid'
};

var PageNotFound = function PageNotFound() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Page not found"));
};
PageNotFound.defaultProps = {};
PageNotFound.human = {
  nl: '404',
  fr: '404',
  en: '404'
};

var Separator = function Separator() {
  return /*#__PURE__*/React.createElement("div", {
    className: "h-8 md:h-12"
  });
};
Separator.human = {
  nl: 'Content separator',
  fr: 'Content separator',
  en: 'Content separator'
};

var CookieBanner = function CookieBanner(_ref) {
  var context = _ref.context,
    view = _ref.view,
    viewTypes = _ref.viewTypes,
    analyticsAccepted = _ref.analyticsAccepted,
    marketingAccepted = _ref.marketingAccepted,
    onAcceptAll = _ref.onAcceptAll,
    onShowSettings = _ref.onShowSettings,
    onAnalyticsChanged = _ref.onAnalyticsChanged,
    onMarketingChanged = _ref.onMarketingChanged,
    onRefuse = _ref.onRefuse,
    onSaveSettings = _ref.onSaveSettings,
    onPrivacyClick = _ref.onPrivacyClick,
    location = _ref.location,
    visible = _ref.visible;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$notific = _useAnalytics.notificationClickEventAnalytics,
    notificationClickEventAnalytics = _useAnalytics$notific === void 0 ? function () {
      return null;
    } : _useAnalytics$notific,
    _useAnalytics$notific2 = _useAnalytics.notificationImpressionEventAnalytics,
    notificationImpressionEventAnalytics = _useAnalytics$notific2 === void 0 ? function () {
      return null;
    } : _useAnalytics$notific2;
  var defaultNotificationData = {
    notificationType: 'banner',
    notificationCategory: 'cookie',
    notificationName: 'cookie-banner'
  };
  var handleClickAccept = function handleClickAccept(e) {
    notificationClickEventAnalytics(_extends({}, defaultNotificationData, {
      notificationOption: 'accept-all'
    }));
    onAcceptAll(e);
  };
  var handleSaveSettings = function handleSaveSettings(e) {
    notificationClickEventAnalytics(_extends({}, defaultNotificationData, {
      notificationOption: analyticsAccepted ? 'accept-all' : 'accept-necessary'
    }));
    onSaveSettings(e);
  };
  var handleClickRefuse = function handleClickRefuse(e) {
    notificationClickEventAnalytics(_extends({}, defaultNotificationData, {
      notificationOption: 'refuse-all'
    }));
    onRefuse(e);
  };
  useEffect(function () {
    if (view === viewTypes.banner && visible) {
      notificationImpressionEventAnalytics(_extends({}, defaultNotificationData, {
        notificationOption: ''
      }));
    }
  }, [view, visible]);
  var renderBanner = function renderBanner() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row justify-between items-center container mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "items-center justify-center mr-4 hidden md:block"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fad fa-cookie-bite text-4xl "
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", null, t('This website uses cookies to improve your experience.')), /*#__PURE__*/React.createElement("div", null, t('Click'), /*#__PURE__*/React.createElement("span", {
      className: "underline ml-1 mr-1 cursor-pointer outline-none",
      onClick: onPrivacyClick
    }, t('here')), /*#__PURE__*/React.createElement("span", null, t('to see how cookies work and why we use them.'))))), /*#__PURE__*/React.createElement("div", {
      className: "flex ml-0 md:ml-5 mt-5 md:mt-0 space-x-2 w-full md:w-auto"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button button-alternate whitespace-nowrap w-full md:w-max",
      onClick: onShowSettings
    }, t('Settings')), /*#__PURE__*/React.createElement("button", {
      className: "button button-secondary whitespace-nowrap w-full md:w-max",
      onClick: handleClickAccept
    }, t('Accept'))));
  };
  var renderSettings = function renderSettings() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 container mx-auto overflow-y-scroll",
      style: {
        maxHeight: 400
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-2xl mb-4 md:mb-2 font-semibold"
    }, t('Your cookie preferences')), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block"
    }, t('Please note that this website uses cookies (including third-party cookies). Some cookies are necessary for the website to function correctly and cannot be disabled. Other cookies are used for analytical and customisation purposes or for marketing. The different categories of cookies that we use are the following:')), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block w-full h-px bg-gray-100 my-4"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 w-full space-y-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 pt-1"
    }, /*#__PURE__*/React.createElement(Switch, {
      disabled: true,
      checked: true,
      onColor: "#00AFFF",
      width: 40,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, t('Necessary cookies')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('Some cookies are required for basic functionalities. The website will not work properly without it, so they are active by default and cannot be disabled.')))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 pt-1"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: function onChange(checked) {
        return onAnalyticsChanged(checked);
      },
      checked: analyticsAccepted,
      onColor: "#00AFFF",
      width: 40,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, t('Analytics cookies')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('We use tools to identify potential browsing errors, analyze how users interact with our content, and test or customize content versions to improve the overall browsing experience.')))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 pt-1"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: function onChange(checked) {
        return onMarketingChanged(checked);
      },
      checked: marketingAccepted,
      onColor: "#00AFFF",
      width: 40,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, t('Marketing cookies')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('We use web advertising tools to tailor content to your interests, avoid showing you the same ads repeatedly, and better understand which types of ads are most relevant to our users.'))))), /*#__PURE__*/React.createElement("div", {
      className: "w-full h-px bg-gray-100 my-4"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row space-y-2 md:space-y-0 space-x-0 md:space-x-2 justify-end w-full sticky bottom-0 md:relative bg-white"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button button-alternate whitespace-nowrap w-full md:w-max",
      onClick: handleClickRefuse
    }, t('Refuse cookies')), /*#__PURE__*/React.createElement("button", {
      className: "button button-alternate whitespace-nowrap w-full md:w-max",
      onClick: handleSaveSettings
    }, t('Apply selection')), /*#__PURE__*/React.createElement("button", {
      className: "button button-secondary whitespace-nowrap w-full md:w-max",
      onClick: handleClickAccept
    }, t('Accept all cookies'))));
  };
  var borderClassName = 'border-t';
  if (location === 'top') {
    borderClassName = 'border-b';
  }
  var positionClassName = location === 'top' ? 'top-0' : 'bottom-0';
  var hideClassName = location === 'top' ? '-translate-y-full' : 'translate-y-full';
  return /*#__PURE__*/React.createElement(Fade, {
    bottom: true,
    when: true,
    duration: 500,
    innerZ: 14,
    collapse: true,
    style: {
      marginTop: 120
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col py-5 px-5 fixed left-0 right-0 bg-white transform transition-all duration-300 " + positionClassName + " " + borderClassName + " " + (visible ? 'translate-y-0' : hideClassName)
  }, view === viewTypes.banner && renderBanner(), view === viewTypes.settings && renderSettings()));
};
var CookieBanner$1 = baseCookieBanner(CookieBanner);

var FinanceBanner = function FinanceBanner(_ref) {
  var Content = _ref.Content,
    onAcceptLegal = _ref.onAcceptLegal,
    visible = _ref.visible,
    location = _ref.location,
    context = _ref.context;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$notific = _useAnalytics.notificationClickEventAnalytics,
    notificationClickEventAnalytics = _useAnalytics$notific === void 0 ? function () {
      return null;
    } : _useAnalytics$notific,
    _useAnalytics$notific2 = _useAnalytics.notificationImpressionEventAnalytics,
    notificationImpressionEventAnalytics = _useAnalytics$notific2 === void 0 ? function () {
      return null;
    } : _useAnalytics$notific2;
  var handleClickAccept = function handleClickAccept() {
    onAcceptLegal();
    enableBodyScroll();
    notificationClickEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'financial',
      notificationName: 'financial-disclaimer',
      notificationOption: t('Accept')
    });
  };
  var enableBodyScroll = function enableBodyScroll() {
    toggleBodyScroll('scroll');
  };
  var toggleBodyScroll = function toggleBodyScroll(type) {
    if (document && width > 0 && width <= 768) {
      document.body.style.overflow = type;
    }
  };
  useEffect(function () {
    if (width > 0 && width <= 768) {
      toggleBodyScroll(visible ? 'hidden' : 'scroll');
    }
  }, [visible, width]);
  useEffect(function () {
    if (visible) {
      notificationImpressionEventAnalytics({
        notificationType: 'banner',
        notificationCategory: 'financial',
        notificationName: 'financial-disclaimer',
        notificationOption: ''
      });
    }
  }, [visible]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "bg-secondary-two fixed left-0 right-0 " + location + "-0 text-white py-8",
      style: {
        zIndex: 9999999
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "container flex flex-col md:flex-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-80 overflow-y-scroll md:h-auto mr-0 md:mr-5 finance-scrollbar scrollbar-snap-y"
    }, Content), /*#__PURE__*/React.createElement("div", {
      className: "flex items-start flex-none mt-5 md:mt-3"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button button-alternate text-primary text-14",
      onClick: handleClickAccept,
      style: {
        backgroundColor: '#ffcc41'
      }
    }, t('I understand')))))
  );
};
var FinanceBanner$1 = baseFinancingBanner(FinanceBanner);

var LoadingIndicator = function LoadingIndicator(_ref) {
  var color = _ref.color,
    small = _ref.small,
    extraSmall = _ref.extraSmall;
  var classes = small ? 'small-loader' : 'loader';
  classes = extraSmall ? 'extra-small' : classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner one " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner two " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner three " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }));
};
LoadingIndicator.defaultProps = {
  color: null,
  small: false,
  extraSmall: false
};

var FinancingTextBlock = function FinancingTextBlock(_ref) {
  var Content = _ref.Content,
    loading = _ref.loading;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-1"
  }, "*"), Content);
};
var FinancingTextBlock$1 = baseFinancingContent(FinancingTextBlock);

var SeoGenericMakeModelBlock = function SeoGenericMakeModelBlock(_ref) {
  var items = _ref.items,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 py-8"
  }, map(items, function (item, indexItem) {
    var title = item.title ? item.title.toLowerCase() : '';
    return /*#__PURE__*/React.createElement("div", {
      key: "make-" + indexItem,
      className: "mb-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 md2:grid-cols-3 lg:grid-cols-4 lg2:grid-cols-5 xl2:grid-cols-7  gap-x-4"
    }, map(item.items, function (subItem, indexSubItem) {
      return /*#__PURE__*/React.createElement("h6", {
        key: "model-" + indexSubItem,
        className: "cursor-pointer text-secondary-two hover:underline capitalize"
      }, /*#__PURE__*/React.createElement(ActionLink, {
        action: subItem.action,
        context: context
      }, /*#__PURE__*/React.createElement("span", {
        className: "capitalize"
      }, title), " ", subItem.action.title));
    })));
  }));
};
SeoGenericMakeModelBlock.defaultProps = {
  items: [_extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock)]
};
SeoGenericMakeModelBlock.human = {
  nl: '',
  fr: '',
  en: ''
};

var FavoriteHeader = function FavoriteHeader(_ref) {
  var context = _ref.context;
  var _useFavorites = useFavorites(context),
    totalFavoritesCount = _useFavorites.totalFavoritesCount;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mb-8"
  }, t('Your favorite vehicles')), totalFavoritesCount < 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-block md:flex items-center"
  }, t('Look for your favorite cars within our assortment'), /*#__PURE__*/React.createElement("span", {
    className: "bg-gray-50 mx-1 rounded-full px-2 py-1"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-heart"
  })), t('and keep them in this list.')), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex self-start bg-secondary-two hover:bg-secondary-three cursor-pointer text-white font-semibold rounded py-2 px-5 transition mt-5",
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.vehicles);
    }
  }, t('Assortment of new and second-hand cars.'))));
};
FavoriteHeader.defaultProps = {};
FavoriteHeader.human = {
  nl: 'Favorite header',
  fr: 'Favorite header',
  en: 'Favorite header'
};

var FavoriteVehiclesOverview = function FavoriteVehiclesOverview(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4"
  }, loading ? times(12, function (index) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: index,
      dark: false
    });
  }) : map(vehicles, function (vehicle) {
    return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
      gridSize: 4,
      key: vehicle === null || vehicle === void 0 ? void 0 : vehicle.id,
      vehicle: vehicle,
      context: context
    });
  })), !loading && context.account && vehicles && vehicles.length > 0 && /*#__PURE__*/React.createElement(LoginPopup, {
    context: context
  }));
};
var FavoriteVehiclesOverview$1 = baseFavoriteVehicles(FavoriteVehiclesOverview);

var FavoriteVehicles = function FavoriteVehicles(_ref) {
  var context = _ref.context;
  var _useFavorites = useFavorites(context),
    totalFavoritesCount = _useFavorites.totalFavoritesCount;
  if (totalFavoritesCount < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container lg:min-h-content-desktop"
  }, /*#__PURE__*/React.createElement(FavoriteVehiclesOverview$1, {
    context: context
  }));
};
FavoriteVehicles.defaultProps = {};
FavoriteVehicles.human = {
  nl: 'Favorite vehicles',
  fr: 'Favorite vehicles',
  en: 'Favorite vehicles'
};

var VehicleCardStatic = function VehicleCardStatic(_ref) {
  var dark = _ref.dark,
    vehicle = _ref.vehicle,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getFirstImageUri = function getFirstImageUri(images) {
    var _images$;
    return images instanceof Array ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.uri : images === null || images === void 0 ? void 0 : images.uri;
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bg-gradient-to-tr " + (dark ? 'from-secondary-two to-secondary-three' : 'from-secondary-four to-secondary-five') + " w-full h-full overflow-hidden relative",
    style: {
      paddingTop: '75%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-full top-0 left-0 h-full"
  }, getFirstImageUri(vehicle === null || vehicle === void 0 ? void 0 : vehicle.images) ? /*#__PURE__*/React.createElement("img", {
    className: "w-full cursor-pointer",
    src: getFirstImageUri(vehicle === null || vehicle === void 0 ? void 0 : vehicle.images)
  }) : /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full"
  }, /*#__PURE__*/React.createElement("img", {
    src: resolveAsset(imageDefault)
  })), !!(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 bg-secondary rounded text-white font-bold uppercase text-xs p-2 ml-4 mt-4"
  }, t('Trade in discount'), ": ", formatPrice(vehicle.tradeInDiscount)), !(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && !!(vehicle !== null && vehicle !== void 0 && vehicle.recyclingDiscount) && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 bg-secondary rounded text-white font-bold uppercase text-xs p-2 ml-4 mt-4"
  }, t('Recycling discount'), ": ", formatPrice(vehicle.recyclingDiscount)), !(vehicle !== null && vehicle !== void 0 && vehicle.tradeInDiscount) && !(vehicle !== null && vehicle !== void 0 && vehicle.recyclingDiscount) && !!vehicle.categoryKey === 'new' && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 bg-secondary rounded text-white font-bold uppercase text-xs p-2 ml-4 mt-4"
  }, t('New')))), /*#__PURE__*/React.createElement("div", {
    className: (dark ? 'bg-secondary-two text-white' : 'bg-white text-primary') + " p-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate text-lg font-bold mb-1"
  }, vehicle.make + ' ' + vehicle.model), /*#__PURE__*/React.createElement(PriceBlock, {
    vehicle: vehicle,
    context: context,
    dark: dark
  })));
};
var VehicleCardStatic$1 = baseVehicleCard(VehicleCardStatic);

var CompareArrows = function CompareArrows(_ref) {
  var gridColsClass = _ref.gridColsClass,
    hasPrev = _ref.hasPrev,
    hasNext = _ref.hasNext,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext;
  var renderButton = function renderButton(iconClass) {
    return /*#__PURE__*/React.createElement("div", {
      className: "button button-secondary flex justify-center items-center h-10 w-10"
    }, /*#__PURE__*/React.createElement("i", {
      className: iconClass
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full grid " + gridColsClass + " absolute top-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col h-10 items-start justify-center"
  }, hasPrev && /*#__PURE__*/React.createElement("div", {
    className: "z-10 -ml-2 md:-ml-4",
    onClick: onPrev
  }, renderButton('fal fa-chevron-left')), hasNext && /*#__PURE__*/React.createElement("div", {
    className: "absolute z-10 -right-2 md:-right-4",
    onClick: onNext
  }, renderButton('fal fa-chevron-right'))));
};

var CompareBar = function CompareBar(_ref) {
  var vehicles = _ref.vehicles,
    displayBar = _ref.displayBar,
    gridColsClass = _ref.gridColsClass;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getFirstImageUri = function getFirstImageUri(images) {
    var _images$;
    return images instanceof Array ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.uri : images === null || images === void 0 ? void 0 : images.uri;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed w-full left-0 bg-white border-b border-secondary-four z-10 transition transform " + (displayBar ? 'translate-y-0' : '-translate-y-full'),
    style: {
      top: getStickiesOffset()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 grid " + gridColsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), map(vehicles, function (vehicle, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "compare-bar-vehicle-" + index,
      className: "flex items-center py-2"
    }, /*#__PURE__*/React.createElement("img", {
      src: getFirstImageUri(vehicle.images),
      alt: vehicle.make + " " + vehicle.model,
      className: "hidden md:block h-10"
    }), /*#__PURE__*/React.createElement("div", {
      className: "truncate md:px-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "truncate text-lg font-bold"
    }, vehicle.make + ' ' + vehicle.model), /*#__PURE__*/React.createElement("div", {
      className: "flex items-top truncate text-sm font-semibold flex mb-1"
    }, "\u20AC", /*#__PURE__*/React.createElement("div", {
      className: "text-2xl font-bold -mt-1 px-1 flex items-top"
    }, " ", vehicle !== null && vehicle !== void 0 && vehicle.price ? formatNumber(vehicle.price) : vehicle !== null && vehicle !== void 0 && vehicle.monthlyPrice ? formatNumber(vehicle.monthlyPrice) : 'XXX', " "), vehicle !== null && vehicle !== void 0 && vehicle.price ? t('incl. VAT') : vehicle !== null && vehicle !== void 0 && vehicle.monthlyPrice ? t('/ month incl. VAT') : '')));
  })));
};

var CompareNoResults = function CompareNoResults() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("p", null, t('Unfortunately, your search returned no results') + '...');
};

var CompareSpecifications = function CompareSpecifications(_ref) {
  var gridColsClass = _ref.gridColsClass,
    vehicles = _ref.vehicles,
    compareGroups = _ref.compareGroups,
    compareFields = _ref.compareFields,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid " + gridColsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex flex-1 flex-col"
  }, map(orderBy(compareGroups, ['key'], ['desc']), function (item) {
    var options = filter(compareFields, function (cf) {
      return cf.group === item.key;
    });
    return /*#__PURE__*/React.createElement("div", {
      key: item.key,
      className: "flex flex-col border-t border-secondary-four mb-8"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "pt-6 pb-4"
    }, item.label(context.culture)), map(options, function (option, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: "option-" + index,
        className: "py-2 " + (index === 0 ? '' : 'border-t') + " border-r border-secondary-four"
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold"
      }, option.label(context.culture)));
    }));
  })), map(vehicles, function (vehicle, i) {
    var isFirstCol = i === 0;
    return /*#__PURE__*/React.createElement("div", {
      key: vehicle.reference,
      className: "flex flex-col"
    }, map(orderBy(compareGroups, ['key'], ['desc']), function (item, i) {
      var options = filter(compareFields, function (cf) {
        return cf.group === item.key;
      });
      return /*#__PURE__*/React.createElement("div", {
        key: "compare-title-" + i,
        className: "flex flex-col border-t border-secondary-four mb-8"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "pt-6 pb-4 " + (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
      }, item.label(context.culture)), map(options, function (option, index) {
        var _option$value, _option$value$props;
        return /*#__PURE__*/React.createElement("div", {
          key: "compare-option-" + index,
          className: "py-2 pr-0 pl-0 lg:pr-4 lg:pl-4 " + (index === 0 ? '' : 'border-t') + " lg:border-r border-secondary-four"
        }, /*#__PURE__*/React.createElement("div", {
          className: "block lg:hidden truncate paragraph-default font-semibold text-primary " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
        }, option.label(context.culture)), /*#__PURE__*/React.createElement("p", {
          className: "truncate",
          style: ((_option$value = option.value(vehicle)) === null || _option$value === void 0 ? void 0 : (_option$value$props = _option$value.props) === null || _option$value$props === void 0 ? void 0 : _option$value$props.className) === 'fal fa-check' ? {
            color: '#0CA724'
          } : {
            color: '#212121'
          }
        }, option.value(vehicle)));
      }));
    }));
  }));
};

var CompareSkeleton = function CompareSkeleton(_ref) {
  var grid = _ref.grid;
  var _useState = useState(0),
    cols = _useState[0],
    setCols = _useState[1];
  var _useState2 = useState(375),
    headerCardHeight = _useState2[0],
    setHeaderCardHeight = _useState2[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  useEffect(function () {
    if (width > 0) {
      if (width >= 768 && width < 1280) {
        setCols(3);
        setHeaderCardHeight(365);
      } else if (width >= 1280) {
        setCols(4);
        setHeaderCardHeight(375);
      } else {
        setCols(2);
        setHeaderCardHeight(365);
      }
    }
  }, [width]);
  var groups = 2;
  var fields = 10;
  if (cols === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container " + grid + " gap-4 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex items-center justify-end w-full h-full",
    style: {
      height: headerCardHeight
    }
  }), times(cols, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: "bg-gray-200 animate-pulse",
      style: {
        height: headerCardHeight
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 2
    },
    className: "bg-secondary-five w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container " + grid
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex flex-1 flex-col"
  }, times(groups, function (_, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-200 animate-pulse h-5"
    })), times(fields, function (_, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex py-2 border-b border-r border-secondary-five"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-full mr-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-2 w-1/3"
      })));
    }));
  })), times(cols, function (item) {
    var isFirstCol = item === 0;
    return /*#__PURE__*/React.createElement(Fade$1, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col"
    }, times(groups, function (_, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "py-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-5"
      }))), times(fields, function (_, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "py-2 pr-4 pl-0 lg:pr-4 lg:pl-4 border-b border-secondary-five"
        }, /*#__PURE__*/React.createElement("div", {
          className: "block lg:hidden mb-1 " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-5"
        })), /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-2 w-1/3"
        }));
      }));
    })));
  })));
};

var Compare = function Compare(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    compareFields = _ref.compareFields,
    compareGroups = _ref.compareGroups,
    hasNext = _ref.hasNext,
    hasPrev = _ref.hasPrev,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev,
    context = _ref.context,
    compareRemoveVehicle = _ref.compareRemoveVehicle;
  var _useScrollPosition = useScrollPosition(),
    scrollPosition = _useScrollPosition.scrollPosition;
  var _useState = useState(false),
    displayBar = _useState[0],
    setDisplayBar = _useState[1];
  var horizontalLineRef = useRef();
  useEffect(function () {
    var _horizontalLineRef$cu;
    setDisplayBar(scrollPosition > (horizontalLineRef === null || horizontalLineRef === void 0 ? void 0 : (_horizontalLineRef$cu = horizontalLineRef.current) === null || _horizontalLineRef$cu === void 0 ? void 0 : _horizontalLineRef$cu.offsetTop) - getStickiesOffset());
  }, [scrollPosition]);
  var gridColsClass = 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg2:grid-cols-5';
  if (loading) {
    return /*#__PURE__*/React.createElement(CompareSkeleton, {
      grid: "grid " + gridColsClass
    });
  }
  if (!loading && vehicles.length === 0) {
    return /*#__PURE__*/React.createElement(CompareNoResults, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(CompareBar, {
    vehicles: vehicles,
    displayBar: displayBar,
    gridColsClass: gridColsClass
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(CompareArrows, {
    gridColsClass: gridColsClass,
    hasNext: hasNext,
    hasPrev: hasPrev,
    onNext: onNext,
    onPrev: onPrev
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:grid gap-4 " + gridColsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), map(vehicles, function (vehicle, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "compare-card-" + index,
      className: "flex flex-col items-end"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-times cursor-pointer text-primary hover:text-secondary-three transition",
      onClick: function onClick() {
        return compareRemoveVehicle(vehicle.reference);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-full"
    }, /*#__PURE__*/React.createElement(VehicleCardDesktop, {
      dark: false,
      vehicle: vehicle,
      gridSize: 4,
      onClick: function onClick() {},
      context: context
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid md:hidden " + gridColsClass
  }, map(vehicles, function (vehicle, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "compare-card-mobile-" + index,
      className: "flex flex-col items-end"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-times text-xl cursor-pointer text-primary hover:text-secondary-three transition",
      onClick: function onClick() {
        return compareRemoveVehicle(vehicle.reference);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-full"
    }, /*#__PURE__*/React.createElement(VehicleCardStatic$1, {
      dark: false,
      vehicle: vehicle,
      context: context
    })));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    ref: horizontalLineRef,
    style: {
      height: 1
    },
    className: "bg-secondary-eight w-full"
  })), /*#__PURE__*/React.createElement(CompareSpecifications, {
    gridColsClass: gridColsClass,
    vehicles: vehicles,
    compareGroups: compareGroups,
    compareFields: compareFields,
    context: context
  }));
};
var Compare$1 = baseCompare(Compare);

var VehicleCompare = function VehicleCompare(_ref) {
  var references = _ref.references,
    onDelete = _ref.onDelete,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "container lg:min-h-content-desktop"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mb-8"
  }, t('Vehicles compare')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Compare$1, {
    references: references,
    onDelete: onDelete,
    context: context
  })));
};
VehicleCompare.defaultProps = {};
VehicleCompare.human = {
  nl: "Auto's Vergelijken",
  fr: 'Comparer des véhicules',
  en: 'Compare vehicles'
};

var VehicleCompareBanner = function VehicleCompareBanner(_ref) {
  var totalVehiclesInCompare = _ref.totalVehiclesInCompare,
    navigateCompare = _ref.navigateCompare,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    analyticsTracker = _useAnalytics.analyticsTracker,
    _useAnalytics$notific = _useAnalytics.notificationImpressionEventAnalytics,
    notificationImpressionEventAnalytics = _useAnalytics$notific === void 0 ? function () {
      return null;
    } : _useAnalytics$notific,
    _useAnalytics$notific2 = _useAnalytics.notificationClickEventAnalytics,
    notificationClickEventAnalytics = _useAnalytics$notific2 === void 0 ? function () {
      return null;
    } : _useAnalytics$notific2;
  var handleClick = function handleClick(e) {
    notificationClickEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'product',
      notificationName: 'myway-comparison',
      notificationOption: t('Compare vehicles') + " (" + totalVehiclesInCompare + ")"
    });
    navigateCompare(e);
  };
  useEffect(function () {
    notificationImpressionEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'product',
      notificationName: 'myway-comparison',
      notificationOption: ''
    });
  }, [analyticsTracker]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center fixed left-0 md:left-auto right-0 bottom-0",
    style: {
      zIndex: 99999
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:hidden w-full flex shadow-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "button button-primary p-2 w-full text-18 relative",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", null, t('Compare vehicles'), " (", totalVehiclesInCompare, ")"), /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-right",
    style: {
      marginTop: 5
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container hidden md:flex justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "button button-primary p-3 text-18 text-white rounded-tl-10 cursor-pointer relative",
    onClick: handleClick
  }, totalVehiclesInCompare > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute bg-secondary",
    style: {
      width: 30,
      height: 30,
      top: -15,
      left: -15,
      borderRadius: 30
    }
  }, totalVehiclesInCompare), /*#__PURE__*/React.createElement("div", {
    className: "p-2 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("span", null, t('Compare vehicles')), /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-right ml-2"
  })))));
};
var VehicleCompareBanner$1 = baseCompareBanner(VehicleCompareBanner);

var ThreeSixtyLightBox = function ThreeSixtyLightBox(_ref) {
  var url = _ref.url,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex  fixed inset-0 text-white bg-black bg-opacity-80",
    style: {
      zIndex: 99999999
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 w-full relative",
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute cursor-pointer text-white",
    style: {
      right: 20,
      top: 20,
      zIndex: 99999999
    },
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times",
    style: {
      fontSize: 35
    }
  })), /*#__PURE__*/React.createElement("embed", {
    src: url,
    style: {
      width: '100%',
      height: '100%'
    }
  })));
};

var ImageViewerMobile = function ImageViewerMobile(_ref) {
  var images = _ref.images,
    images360SpinnerUrl = _ref.images360SpinnerUrl,
    currentIndex = _ref.currentIndex,
    handleChangeIndex = _ref.handleChangeIndex,
    onImageClick = _ref.onImageClick,
    onContentLoad = _ref.onContentLoad;
  var _useState = useState(false),
    show360 = _useState[0],
    setShow360 = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 p-4 flex",
    style: {
      zIndex: 999999
    }
  }, images360SpinnerUrl && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-secondary-five py-2 px-4 rounded-full font-semibold cursor-pointer hover:bg-secondary-four transition",
    onClick: function onClick() {
      return setShow360(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-redo mr-2"
  }), "360\xB0")), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(ImageViewer, {
    images: images,
    currentIndex: currentIndex,
    onCurrentIndexChanged: function onCurrentIndexChanged(index) {
      return handleChangeIndex(index);
    },
    onClick: onImageClick,
    onContentLoad: onContentLoad
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex my-8 mx-5 h-2px bg-secondary-four"
  }, map(images, function (image, index) {
    if (index === currentIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "bg-secondary-two h-2px flex-1"
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "py-4 flex-1 cursor-pointer",
        onClick: function onClick() {
          return handleChangeIndex(index);
        }
      });
    }
  }))), show360 && /*#__PURE__*/React.createElement(ThreeSixtyLightBox, {
    url: images360SpinnerUrl,
    onClose: function onClose() {
      return setShow360(false);
    }
  }));
};
var ImageViewerMobile$1 = baseImageViewerAndThumbnails(ImageViewerMobile);

var ImageViewerDesktop = function ImageViewerDesktop(_ref) {
  var images = _ref.images,
    images360SpinnerUrl = _ref.images360SpinnerUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showLightbox = _useState[0],
    setShowLightbox = _useState[1];
  var _useState2 = useState(false),
    show360 = _useState2[0],
    setShow360 = _useState2[1];
  var _useState3 = useState(0),
    imageIndex = _useState3[0],
    setImageIndex = _useState3[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 p-8 flex"
  }, images360SpinnerUrl && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-secondary-five py-2 px-4 rounded-full font-semibold cursor-pointer hover:bg-secondary-four transition mr-6",
    onClick: function onClick() {
      return setShow360(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-redo mr-2"
  }), "360\xB0"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-secondary-five py-2 px-4 rounded-full font-semibold cursor-pointer hover:bg-secondary-four transition",
    onClick: function onClick() {
      return setShowLightbox(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-image mr-2"
  }), t('All images'))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2"
  }, map(images.slice(0, 8), function (image, index) {
    return /*#__PURE__*/React.createElement("img", {
      key: index,
      className: "cursor-pointer",
      onClick: function onClick() {
        setImageIndex(index);
        setShowLightbox(true);
      },
      src: image
    });
  }))), showLightbox && /*#__PURE__*/React.createElement(ImageLightBox, {
    images: images,
    currentIndex: imageIndex,
    onIndexChanged: function onIndexChanged(index) {
      return setImageIndex(index);
    },
    onClose: function onClose() {
      setShowLightbox(false);
      setImageIndex(0);
    }
  }), show360 && /*#__PURE__*/React.createElement(ThreeSixtyLightBox, {
    url: images360SpinnerUrl,
    onClose: function onClose() {
      return setShow360(false);
    }
  }));
};
var ImageViewerDesktop$1 = baseImageViewerAndThumbnails(ImageViewerDesktop);

var TotalAndMonthlyPrice = function TotalAndMonthlyPrice(_ref) {
  var price = _ref.price,
    monthlyPrice = _ref.monthlyPrice,
    priceLabel = _ref.priceLabel,
    brutoPrice = _ref.brutoPrice,
    monthlyLastPayment = _ref.monthlyLastPayment,
    scrollToFinancing = _ref.scrollToFinancing;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex font-semibold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-none " + (monthlyPrice ? 'w-1/2 pr-1' : 'w-full')
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-20"
  }, '€ ' + price), /*#__PURE__*/React.createElement("p", {
    className: "text-xs -mt-1 text-secondary-three font-normal"
  }, priceLabel), brutoPrice && /*#__PURE__*/React.createElement("p", {
    className: "font-semibold line-through text-14"
  }, brutoPrice)), monthlyPrice && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return scrollToFinancing();
    },
    className: "flex-none w-1/2 pl-1 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start text-20"
  }, /*#__PURE__*/React.createElement("div", null, "\u20AC ", monthlyPrice, " "), /*#__PURE__*/React.createElement("div", {
    className: "text-xs ml-px",
    style: {
      marginTop: 5
    }
  }, t('/ month')), /*#__PURE__*/React.createElement("i", {
    className: "far fa-info-circle ml-px",
    style: {
      fontSize: 10,
      marginTop: 8
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-xs -mt-1 text-secondary-three font-normal"
  }, priceLabel, ' ', monthlyLastPayment && /*#__PURE__*/React.createElement("span", null, t('last monthly payment'), ": \u20AC ", formatNumber(monthlyLastPayment)))));
};

var CtaButton = function CtaButton(props) {
  var onClick = props.onClick,
    context = props.context;
  var _useAnalytics = useAnalytics(context),
    analyticsEventSubmit = _useAnalytics.analyticsEventSubmit,
    buttonCtaEventInitialize = _useAnalytics.buttonCtaEventInitialize;
  var handleClick = function handleClick(e) {
    analyticsEventSubmit(buttonCtaEventInitialize(_extends({}, props, {
      buttonCategory: 'internal-link'
    }), context));
    onClick(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: props.style,
    onClick: handleClick
  }, props.children);
};

var ActionButtons = function ActionButtons(_ref) {
  var onAppointment = _ref.onAppointment,
    onClickWhatsapp = _ref.onClickWhatsapp,
    showWhatsapp = _ref.showWhatsapp,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function () {
      return null;
    } : _useAnalytics$buttonC;
  var analyticsButtonEventTrigger = function analyticsButtonEventTrigger(_buttonData) {
    var buttonData = _extends({
      analyticsButtonCategory: 'interaction',
      analyticsButtonType: 'button'
    }, _buttonData ? _buttonData : {});
    buttonClickEventAnalytics(buttonData);
  };
  var handleClickAppointment = function handleClickAppointment(e) {
    analyticsButtonEventTrigger({
      analyticsButtonName: 'to-dealersite-contact-dealer',
      analyticsButtonText: t('Make an appointment')
    });
    onAppointment(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row lg:flex-col gap-2"
  }, /*#__PURE__*/React.createElement(CtaButton, {
    name: "request-appointment",
    onClick: handleClickAppointment,
    className: "button button-tertiary whitespace-nowrap",
    context: context
  }, t('Request appointment')), showWhatsapp && /*#__PURE__*/React.createElement(CtaButton, {
    name: "request-test-drive",
    className: "button button-secondary-outline gap-1",
    onClick: onClickWhatsapp,
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-whatsapp"
  }), /*#__PURE__*/React.createElement("span", null, t('Whatsapp'))));
};

var ReservationBox = function ReservationBox(_ref) {
  var reserved = _ref.reserved,
    deliveryCost = _ref.deliveryCost,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showCostMessage = _useState[0],
    setShowCostMessage = _useState[1];
  var hasDealerInfo = false;
  var className = context.reservation || deliveryCost || hasDealerInfo ? 'my-4' : 'hidden';
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-base"
  }, !reserved && /*#__PURE__*/React.createElement(React.Fragment, null, context.reservation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-3 h-3 mr-4 rounded-full animate-ping",
    style: {
      backgroundColor: '#0CA724'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 mr-4 rounded-full",
    style: {
      backgroundColor: '#0CA724'
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "mr-4 flex-none"
  }, t('Not reserved'))), deliveryCost && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "underline text-14 cursor-default hover:text-secondary transition",
    onMouseEnter: function onMouseEnter() {
      return setShowCostMessage(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowCostMessage(false);
    }
  }, t('Excl.'), " \u20AC", deliveryCost, " ", t('delivery costs')), /*#__PURE__*/React.createElement("div", {
    className: (showCostMessage ? 'visible opacity-100' : 'invisible opacity-0') + " absolute p-3 mr-2 bg-secondary-two text-white shadow-lg rounded transition"
  }, t('First aid kit, fire extinguisher, fluorescent vest, front number plate, technical inspection, warning triangle.')))), context.reservation && reserved && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 mr-4 rounded-full",
    style: {
      backgroundColor: '#F30E04'
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: "mr-8"
  }, t('Reserved')))), hasDealerInfo );
};

var SellingPoints = function SellingPoints(_ref) {
  var labels = _ref.labels;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col font-semibold"
  }, map(labels, function (label) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between border-b border-secondary-four py-4"
    }, label.name);
  }));
};

var ActionSocials = function ActionSocials(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    buttonClickEventAnalytics = _useAnalytics.buttonClickEventAnalytics;
  var fixedEncodeURIComponent = function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  };
  var facebookUrl = function facebookUrl() {
    if (hasWindow()) {
      return "https://www.facebook.com/sharer/sharer.php?u=" + fixedEncodeURIComponent(window.location.href) + "&amp;src=sdkpreparse";
    }
    return 'https://www.facebook.com/';
  };
  var twitterUrl = function twitterUrl() {
    if (hasWindow()) {
      var text = 'Check%20out%20this%20car%20on%20A&M%20Group%20-%20';
      return "https://twitter.com/intent/tweet?text=" + text + "&url=" + fixedEncodeURIComponent(window.location.href);
    }
    return 'https://www.twitter.com';
  };
  var linkedInUrl = function linkedInUrl() {
    if (hasWindow()) {
      return "https://www.linkedin.com/sharing/share-offsite/?url=" + fixedEncodeURIComponent(window.location.href);
    }
    return 'https://www.linkedin.com';
  };
  var whatsAppUrl = function whatsAppUrl(text) {
    if (text === void 0) {
      text = t('Check out this car from A&M Group!');
    }
    if (hasWindow()) {
      return "whatsapp://send?text=" + (text + ' ' + encodeURIComponent(window.location.href));
    }
    return 'https://www.whatsapp.com';
  };
  var handleClickSocial = function handleClickSocial(socialName, socialUrl) {
    var buttonData = {
      analyticsButtonType: 'button',
      analyticsButtonName: "share-" + socialName,
      analyticsButtonCategory: 'interaction',
      url: socialUrl
    };
    buttonClickEventAnalytics(buttonData);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-4 flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-3"
  }, t('Share this vehicle') + ':'), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-4"
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: facebookUrl(),
    onClick: function onClick() {
      handleClickSocial('facebook', facebookUrl());
    },
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-facebook-f"
  })), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: twitterUrl(),
    onClick: function onClick() {
      handleClickSocial('twitter', twitterUrl());
    },
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-brands fa-x-twitter"
  })), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: linkedInUrl(),
    onClick: function onClick() {
      handleClickSocial('linkedin', linkedInUrl());
    },
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-linkedin-in"
  })), /*#__PURE__*/React.createElement("a", {
    className: "block md:hidden",
    target: "_blank",
    href: whatsAppUrl(),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-whatsapp"
  }))));
};

var Discount = function Discount(_ref) {
  var tradeInDiscount = _ref.tradeInDiscount,
    recyclingDiscount = _ref.recyclingDiscount,
    conditionsB2c = _ref.conditionsB2c;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showConditions = _useState[0],
    setShowConditions = _useState[1];
  var hasTradeInDiscount = !!tradeInDiscount && !recyclingDiscount;
  var hasRecyclingDiscount = !!recyclingDiscount && !tradeInDiscount;
  var hasDiscount = !!tradeInDiscount || !!recyclingDiscount;
  return hasDiscount && /*#__PURE__*/React.createElement("div", {
    className: "relative cursor-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center transition-colors " + (showConditions && !!conditionsB2c ? 'text-secondary' : 'text-primary'),
    onMouseEnter: function onMouseEnter() {
      return setShowConditions(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowConditions(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 mr-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check"
  })), hasTradeInDiscount && /*#__PURE__*/React.createElement("div", {
    className: "text-14 font-medium"
  }, t('Trade in discount'), " ", formatPrice(tradeInDiscount)), hasRecyclingDiscount && /*#__PURE__*/React.createElement("div", {
    className: "text-14 font-medium"
  }, t('Recycling discount'), " ", formatPrice(recyclingDiscount)), !!conditionsB2c && /*#__PURE__*/React.createElement("i", {
    className: "fal fa-info-circle ml-2 text-xs"
  })), hasDiscount && !!conditionsB2c && /*#__PURE__*/React.createElement("div", {
    className: "absolute bg-black text-white z-10 p-3 shadow-lg rounded transition " + (showConditions ? 'visible opacity-100' : 'invisible opacity-0'),
    dangerouslySetInnerHTML: {
      __html: b64DecodeUnicode(conditionsB2c)
    }
  }));
};

var _excluded = ["context", "isDetailPage"];
var CustomerTypeSwitch = function CustomerTypeSwitch(_ref) {
  var context = _ref.context,
    _ref$isDetailPage = _ref.isDetailPage,
    isDetailPage = _ref$isDetailPage === void 0 ? false : _ref$isDetailPage,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var all_filters = props.all_filters,
    filtersSet = props.filtersSet,
    filterData = props.filterData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var isProfessional = clientSettings.isProfessional;
  useEffect(function () {
    if (isObject(filterData)) {
      isProfessional ? activateProfessional() : activatePrivate();
    }
  }, [filterData]);
  var activateProfessional = function activateProfessional() {
    setClientSetting('isProfessional', true, true);
    var newFilters = [].concat(all_filters);
    var monthlyPriceFilter = find(all_filters, function (filter) {
      return filter.type === FilterTypes.monthlyPrice || filter.type === FilterTypes.monthlyPriceProfIncl || filter.type === FilterTypes.monthlyPriceProf;
    });
    if (monthlyPriceFilter) {
      newFilters = [].concat(filter(all_filters, function (f) {
        return f.type !== FilterTypes.monthlyPrice && f.type !== FilterTypes.monthlyPriceProfIncl && f.type !== FilterTypes.monthlyPriceProf;
      }), [_extends({}, monthlyPriceFilter, {
        type:  FilterTypes.monthlyPriceProfIncl 
      })]);
    }
    if (!isEqual(all_filters, newFilters)) {
      filtersSet(newFilters);
    }
  };
  var activatePrivate = function activatePrivate() {
    setClientSetting('isProfessional', false, true);
    var priceFilter = find(all_filters, function (filter) {
      return filter.type === FilterTypes.priceExcl;
    });
    var monthlyPriceFilter = find(all_filters, function (filter) {
      return filter.type === FilterTypes.monthlyPriceProf || filter.type === FilterTypes.monthlyPriceProfIncl;
    });
    var newFilters = [].concat(all_filters);
    if (priceFilter) {
      newFilters = [].concat(filter(all_filters, function (f) {
        return f.type !== FilterTypes.priceExcl;
      }), [_extends({}, priceFilter, {
        type: FilterTypes.price
      })]);
    }
    if (monthlyPriceFilter) {
      newFilters = [].concat(filter(all_filters, function (f) {
        return f.type !== FilterTypes.monthlyPriceProf && f.type !== FilterTypes.monthlyPriceProfIncl;
      }), [_extends({}, monthlyPriceFilter, {
        type: FilterTypes.monthlyPrice
      })]);
    }
    var hasVatFilter = find(newFilters, function (filter) {
      return filter.type === FilterTypes.vat;
    });
    if (hasVatFilter) {
      newFilters = [].concat(newFilters.filter(function (filter) {
        return filter.type !== FilterTypes.vat;
      }));
    }
    filtersSet(newFilters);
  };
  if (isDetailPage) {
    var defaultClassName = 'flex items-center justify-center w-1/2 px-6 cursor-pointer hover:underline h-12 text-base font-semibold text-primary';
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: defaultClassName + " rounded-tl-lg " + (!isProfessional ? 'bg-white' : 'bg-secondary-five'),
      onClick: activatePrivate
    }, t('Private')), /*#__PURE__*/React.createElement("div", {
      className: defaultClassName + " rounded-tr-lg " + (isProfessional ? 'bg-white' : 'bg-secondary-five'),
      onClick: activateProfessional
    }, t('Professional')));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-3"
  }, t('Private')), /*#__PURE__*/React.createElement(Switch, {
    onChange: function onChange(checked) {
      return checked ? activateProfessional() : activatePrivate();
    },
    checked: isProfessional,
    onColor: "#000000",
    activeBoxShadow: "",
    width: 36,
    height: 20,
    checkedIcon: false,
    uncheckedIcon: false
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-3"
  }, t('Professional')));
};
var CustomerTypeSwitch$1 = withFilters(CustomerTypeSwitch);

var _excluded$1 = ["context"];
var VatTypeFilter = function VatTypeFilter(_ref) {
  var context = _ref.context,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var all_filters = props.all_filters,
    filtersSet = props.filtersSet;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var handleVatSwitchClick = function handleVatSwitchClick(value) {
    setClientSetting('isInclVat', value, true);
    var priceInclFilter = find(all_filters, function (filter) {
      return filter.type === FilterTypes.price || filter.type === FilterTypes.priceExcl;
    });
    var monthlyPriceInclFilter = find(all_filters, function (filter) {
      return filter.type === FilterTypes.monthlyPriceProf || filter.type === FilterTypes.monthlyPriceProfIncl;
    });
    var newFilters = [].concat(all_filters);
    if (priceInclFilter) {
      newFilters = [].concat(filter(all_filters, function (f) {
        return f.type !== FilterTypes.price && f.type !== FilterTypes.priceExcl;
      }), [_extends({}, priceInclFilter, {
        type: value ? FilterTypes.price : FilterTypes.priceExcl
      })]);
    }
    if (monthlyPriceInclFilter) {
      newFilters = [].concat(filter(all_filters, function (f) {
        return f.type !== FilterTypes.monthlyPriceProf && f.type !== FilterTypes.monthlyPriceProfIncl;
      }), [_extends({}, monthlyPriceInclFilter, {
        type: value ? FilterTypes.monthlyPriceProfIncl : FilterTypes.monthlyPriceProf
      })]);
    }
    filtersSet(newFilters);
  };
  return /*#__PURE__*/React.createElement(Checkbox, {
    onClick: function onClick() {
      return handleVatSwitchClick(!isInclVat);
    },
    checked: isInclVat,
    label: t('Show prices incl. VAT')
  });
};
var VatTypeFilter$1 = withFilters(VatTypeFilter);

var DealerInfo = function DealerInfo(_ref) {
  var vehicle = _ref.vehicle,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dealer = vehicle === null || vehicle === void 0 ? void 0 : vehicle.dealer;
  if (!dealer) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  var tel = dealer.tel,
    name = dealer.name,
    address = dealer.address,
    postal = dealer.postal,
    city = dealer.city;
  var gMapDealerAddress = dealer.address.replace(new RegExp(' ', 'g'), '+');
  var gMapDealerLocationUrl = gMapDealerAddress + "+" + dealer.postal + "+" + dealer.city;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 26
    },
    className: "mr-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-car-building text-gray-darkest"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-darkest text-16 leading-23"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold mb-1"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-gray-darker mb-1"
  }, address, /*#__PURE__*/React.createElement("br", null), postal, " ", city), /*#__PURE__*/React.createElement(ExternalLink, {
    url: "https://www.google.be/maps/place/" + gMapDealerLocationUrl,
    className: "font-medium underline hover:text-green-darker",
    context: context,
    analyticsButtonType: "button",
    analyticsButtonName: "dealer-route-description-vehicleDetail",
    analyticsButtonText: t('Route description')
  }, t('Route description')), tel && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start text-16 font-medium mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-1"
  }, t('Call us at')), /*#__PURE__*/React.createElement("div", {
    className: "underline"
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:" + tel
  }, tel)))));
};

var Specifications = function Specifications(_ref) {
  var _vehicle$dealer3, _vehicle$labelsV;
  var vehicle = _ref.vehicle,
    activeRate = _ref.activeRate,
    scrollToFinancing = _ref.scrollToFinancing,
    onOpenPanelHandler = _ref.onOpenPanelHandler,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = clientSettings.isProfessional;
  var _useVehiclePrices = useVehiclePrices({
      vehicle: vehicle,
      activeRate: activeRate,
      context: context
    }),
    price = _useVehiclePrices.price,
    monthlyPrice = _useVehiclePrices.monthlyPrice,
    priceLabel = _useVehiclePrices.priceLabel,
    brutoPrice = _useVehiclePrices.brutoPrice,
    monthlyLastPayment = _useVehiclePrices.monthlyLastPayment;
  var handleClickWhatsapp = function handleClickWhatsapp() {
    var _vehicle$dealer, _vehicle$dealer2;
    if (!((_vehicle$dealer = vehicle.dealer) !== null && _vehicle$dealer !== void 0 && _vehicle$dealer.mobile)) {
      return false;
    }
    window.open("https://wa.me/" + ((_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.mobile) + "?text=" + (t("Hello, i'm interested in this car") + " " + window.location.href + ". " + t('Can you contact me as soon as possible?')));
  };
  var formatDate = function formatDate(date) {
    var today = new Date(date);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    return dd + '/' + mm + '/' + yyyy;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-0 pl-0 lg:pl-12 lg:pb-12 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-24 font-semibold capitalize truncate"
  }, (vehicle === null || vehicle === void 0 ? void 0 : vehicle.make) + ' ' + (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model)), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-secondary-three overflow-hidden"
  }, vehicle === null || vehicle === void 0 ? void 0 : vehicle.version)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap font-medium text-primary text-12 mb-4"
  }, (vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuel) !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.fuel), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.firstRegistrationYear) !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.firstRegistrationYear), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.gearbox) !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, vehicle.gearbox), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.mileage) !== undefined && vehicle.mileage > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-3 bg-secondary-five rounded-full mr-1 h-6"
  }, formatNumber(vehicle.mileage), " km")), /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg border border-gray-200"
  }, /*#__PURE__*/React.createElement(CustomerTypeSwitch$1, {
    context: context,
    isDetailPage: true
  }), /*#__PURE__*/React.createElement(Fade$1, {
    spy: isProfessional
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6"
  }, /*#__PURE__*/React.createElement(TotalAndMonthlyPrice, {
    price: price,
    monthlyPrice: monthlyPrice,
    priceLabel: priceLabel,
    brutoPrice: brutoPrice,
    monthlyLastPayment: monthlyLastPayment,
    scrollToFinancing: scrollToFinancing,
    context: context
  }), isProfessional && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-14 font-medium mt-4 text-primary",
    style: {
      maxWidth: 'fit-content'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 mr-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check"
  })), /*#__PURE__*/React.createElement("div", null, vehicle !== null && vehicle !== void 0 && vehicle.vatRegime ? t('VAT deductible') : t('VAT not deductible'))), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Discount, {
    tradeInDiscount: vehicle === null || vehicle === void 0 ? void 0 : vehicle.tradeInDiscount,
    recyclingDiscount: vehicle === null || vehicle === void 0 ? void 0 : vehicle.recyclingDiscount,
    conditionsB2c: vehicle === null || vehicle === void 0 ? void 0 : vehicle.conditionsB2c
  })), isProfessional && /*#__PURE__*/React.createElement("div", {
    className: "w-max relative mt-4 " + (vehicle.vatRegime === false ? 'px-4' : '')
  }, vehicle.vatRegime === false && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gray-100 bg-opacity-75"
  }), /*#__PURE__*/React.createElement(VatTypeFilter$1, {
    context: context
  })), monthlyPrice && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-secondary-three hover:text-primary text-14 cursor-pointer font-medium mt-4",
    onClick: scrollToFinancing
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 mr-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-calculator"
  })), /*#__PURE__*/React.createElement("div", {
    className: "underline"
  }, t('Use the financing calculator'))), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.availability) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-14 font-medium mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 mr-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check"
  })), t('Available from'), " ", /*#__PURE__*/React.createElement("span", {
    className: "font-semibold"
  }, formatDate(vehicle.availability))), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(ActionButtons, {
    vehicle: vehicle,
    onAppointment: function onAppointment() {
      return onOpenPanelHandler('appointment_form');
    },
    onOffer: function onOffer() {
      return onOpenPanelHandler('offer_form');
    },
    onTestDrive: function onTestDrive() {
      return onOpenPanelHandler('test_drive_form');
    },
    onClickWhatsapp: handleClickWhatsapp,
    showWhatsapp: !!((_vehicle$dealer3 = vehicle.dealer) !== null && _vehicle$dealer3 !== void 0 && _vehicle$dealer3.mobile),
    context: context
  }))))), /*#__PURE__*/React.createElement(ReservationBox, {
    reserved: vehicle === null || vehicle === void 0 ? void 0 : vehicle.reserved,
    deliveryCost: vehicle === null || vehicle === void 0 ? void 0 : vehicle.deliveryCost,
    dealer: vehicle === null || vehicle === void 0 ? void 0 : vehicle.dealer,
    context: context
  }), /*#__PURE__*/React.createElement(SellingPoints, {
    labels: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$labelsV = vehicle.labelsV2) === null || _vehicle$labelsV === void 0 ? void 0 : _vehicle$labelsV.warrantyData,
    context: context
  }), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.dealer) && /*#__PURE__*/React.createElement("div", {
    className: "mt-4 p-6 bg-secondary-five rounded"
  }, /*#__PURE__*/React.createElement(DealerInfo, {
    vehicle: vehicle,
    context: context
  })), /*#__PURE__*/React.createElement(ActionSocials, {
    vehicle: vehicle,
    context: context
  }));
};

var blackCarPass = "carpass_black~exaHvQRk.png";

var CtaLink = function CtaLink(props) {
  var context = props.context;
  var _useAnalytics = useAnalytics(context),
    analyticsEventSubmit = _useAnalytics.analyticsEventSubmit,
    buttonCtaEventInitialize = _useAnalytics.buttonCtaEventInitialize;
  var handleClick = function handleClick() {
    analyticsEventSubmit(buttonCtaEventInitialize(_extends({}, props, {
      buttonCategory: props.href.startsWith('http') ? 'external-link' : 'internal-link',
      url: props.href
    }), context));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: props.style,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("a", {
    href: props.href,
    target: props.target,
    className: "block cursor-pointer"
  }, props.children));
};

var Characteristics = function Characteristics(_ref) {
  var vehicle = _ref.vehicle,
    vehiclePdfUrl = _ref.vehiclePdfUrl,
    onOpenPanelHandler = _ref.onOpenPanelHandler,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var CarpassRef = useRef();
  useContentBlockImpressionWhenInViewport(CarpassRef, 'carpass', context);
  var renderCharacteristic = function renderCharacteristic(label, value) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-secondary-two"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-14 truncate"
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "font-semibold text-18 truncate"
    }, value));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five px-5 md:px-10 py-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-4"
  }, t('Characteristics')), /*#__PURE__*/React.createElement("div", {
    className: "w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-8"
  }, renderCharacteristic(t('First registration'), vehicle.firstRegistrationMonth + "/" + vehicle.firstRegistrationYear), renderCharacteristic(t('Mileage'), formatNumber(vehicle.mileage) + " km"), renderCharacteristic(t('Fuel type'), vehicle.fuel), renderCharacteristic(t('CO2 (g/km)'), vehicle.co2 + " g/km"), renderCharacteristic(t('Transmission'), vehicle.gearbox), renderCharacteristic(t('Euro Emission Class'), vehicle.euroNorm), renderCharacteristic(t('Power'), vehicle.kw + " kW / " + vehicle.hp + " PK"), renderCharacteristic(t('Engine CC'), vehicle.engineCc + " cc"), renderCharacteristic(t('Seats'), vehicle.seats), vehicle.exteriorColor[context.culture] ? renderCharacteristic(t('Body Color'), vehicle.exteriorColor[context.culture]) : renderCharacteristic(t('Body Color'), vehicle.exteriorColor), vehicle.interiorColor[context.culture] ? renderCharacteristic(t('Interior Color'), vehicle.interiorColor[context.culture]) : renderCharacteristic(t('Interior Color'), vehicle.interiorColor), renderCharacteristic(t('Internal reference'), vehicle.identification)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row item-center"
  }, vehiclePdfUrl && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button-secondary mb-6 md:mb-0",
    onClick: function onClick() {
      return onOpenPanelHandler('windscreen_form');
    }
  }, t('Download vehicle sheet')), (vehicle === null || vehicle === void 0 ? void 0 : vehicle.carpass) && /*#__PURE__*/React.createElement(CtaLink, {
    href: vehicle.carpass,
    name: "carpass",
    target: "_blank",
    context: context
  }, /*#__PURE__*/React.createElement("img", {
    ref: CarpassRef,
    className: "h-7 mt-2 ml-0 md:ml-8",
    src: useAsset(blackCarPass),
    alt: "Check Car-pass"
  }))));
};

var Equipments = function Equipments(_ref) {
  var vehicle = _ref.vehicle;
  var _useState = useState(false),
    equipmentsExpanded = _useState[0],
    setEquipmentsExpanded = _useState[1];
  var optionGroups = uniqBy(map(filter(vehicle.equipments, function (eq) {
    return eq.group_key !== 'Pros' && eq.group_key !== 'Cons';
  }), function (equipment) {
    return {
      key: equipment.group_key,
      group: equipment.group
    };
  }), 'key');
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderEquipmentsMobile = function renderEquipmentsMobile() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex md:hidden flex-col " + (equipmentsExpanded ? 'max-h-2000' : 'max-h-0')
    }, map(optionGroups, function (group) {
      var options = orderBy(filter(vehicle.equipments, function (equipment) {
        return equipment.group_key === group.key;
      }), ['priority']);
      return /*#__PURE__*/React.createElement("div", {
        key: group.key,
        className: "overflow-hidden mb-8"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "text-base font-bold mb-4"
      }, group.group), /*#__PURE__*/React.createElement("div", {
        className: "relative"
      }, /*#__PURE__*/React.createElement("div", null, map(options, function (option) {
        return /*#__PURE__*/React.createElement("p", {
          key: option.key,
          className: "truncate mb-4"
        }, option.value);
      })), !equipmentsExpanded && /*#__PURE__*/React.createElement("div", {
        className: "absolute w-full h-28 bottom-0 bg-gradient-to-t from-secondary-two transition"
      })));
    }));
  };
  var renderEquipmentsDesktop = function renderEquipmentsDesktop() {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 lg2:grid-cols-4 gap-4 overflow-hidden " + (equipmentsExpanded ? 'max-h-2000' : 'max-h-48') + " transition-max-h"
    }, map(optionGroups, function (group) {
      var options = orderBy(filter(vehicle.equipments, function (equipment) {
        return equipment.group_key === group.key;
      }), ['priority']);
      return /*#__PURE__*/React.createElement("div", {
        key: group.key,
        className: "overflow-hidden"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "text-base font-bold mb-4"
      }, group.group), map(options, function (option) {
        return /*#__PURE__*/React.createElement("p", {
          key: option.key,
          className: "truncate mb-4"
        }, option.value);
      }));
    })), !equipmentsExpanded && /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block absolute w-full h-28 bottom-0 bg-gradient-to-t from-secondary-two transition"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two text-white px-5 md:px-10 py-10 relative",
    onClick: function onClick() {
      return setEquipmentsExpanded(!equipmentsExpanded);
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "flex items-center justify-between " + (equipmentsExpanded ? 'mb-8' : 'mb-0 md:mb-8')
  }, /*#__PURE__*/React.createElement("span", {
    className: "truncate mr-5 md:mr-0"
  }, t('Options and equipment')), /*#__PURE__*/React.createElement("div", {
    className: "w-5 h-5 rounded-full bg-white flex md:hidden items-center justify-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "text-black inline-block text-xs fal " + (equipmentsExpanded ? 'fa-minus' : 'fa-plus')
  }))), renderEquipmentsMobile(), renderEquipmentsDesktop(), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:inline-block mt-4 md:mt-8 text-white hover:text-secondary-five cursor-pointer transition"
  }, !equipmentsExpanded && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: "inline-block fas fa-plus mr-3"
  }), /*#__PURE__*/React.createElement("p", {
    className: "inline-block font-semibold underline"
  }, t('Show more equipments'))), equipmentsExpanded && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: "inline-block fas fa-minus mr-3"
  }), /*#__PURE__*/React.createElement("p", {
    className: "inline-block font-semibold underline"
  }, t('Show less equipments')))));
};

var PreviousNextVehicle = function PreviousNextVehicle(_ref) {
  var hasPrevious = _ref.hasPrevious,
    hasNext = _ref.hasNext,
    navigateNext = _ref.navigateNext,
    navigatePrevious = _ref.navigatePrevious;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!hasPrevious && !hasNext) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mr-10 cursor-pointer " + (hasPrevious ? 'text-gray-500' : 'text-primary'),
    onClick: navigatePrevious
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-left text-primary mr-4"
  }), /*#__PURE__*/React.createElement("p", {
    className: (hasPrevious ? 'underline' : '') + " "
  }, t(' Previous'))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer text-primary " + (hasNext ? 'text-gray-500' : 'text-primary'),
    onClick: navigateNext
  }, /*#__PURE__*/React.createElement("p", {
    className: "mr-4 " + (hasNext ? 'underline' : '') + " "
  }, t(' Next')), /*#__PURE__*/React.createElement("i", {
    className: " far fa-chevron-right"
  })));
};
var PreviousNextVehicle$1 = basePreviousNextButtons(PreviousNextVehicle);

var BreadcrumbsBar = function BreadcrumbsBar(_ref) {
  var make = _ref.make,
    model = _ref.model,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full py-4 flex justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex truncate"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center truncate"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.home,
    context: context,
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-home-alt"
  })), /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right mx-3 text-10"
  }), /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicles,
    context: context,
    className: "cursor-pointer hover:underline"
  }, /*#__PURE__*/React.createElement("p", null, t('Stock')), ' '), /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right mx-3 text-10"
  }), /*#__PURE__*/React.createElement("p", {
    className: "uppercase truncate"
  }, make + ' ' + model))), /*#__PURE__*/React.createElement("div", {
    id: "prev-next-btn-container",
    className: "hidden md:flex"
  }, /*#__PURE__*/React.createElement(PreviousNextVehicle$1, {
    context: context
  })));
};

var WhatsAppBtn = function WhatsAppBtn(_ref) {
  var phoneNumber = _ref.phoneNumber;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var resolveDefaultMessage = function resolveDefaultMessage() {
    if (hasWindow()) {
      return t("Hello, i'm interested in this car") + " " + window.location.href + ". " + t('Can you contact me as soon as possible?');
    }
    return '';
  };
  var handleClick = function handleClick() {
    if (!phoneNumber) {
      return false;
    }
    window.open("https://wa.me/" + phoneNumber + "?text=" + resolveDefaultMessage());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "whats-app-btn",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-whatsapp"
  }));
};

var FinancingTypes = function FinancingTypes(_ref) {
  var financingTypes = _ref.financingTypes,
    activeType = _ref.activeType,
    onTypeChange = _ref.onTypeChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden pt-8"
  }, /*#__PURE__*/React.createElement(SingleSelect, {
    placeHolder: t('Financing type'),
    items: map(filter(financingTypes, function (ft) {
      var _ft$rates;
      return ((_ft$rates = ft.rates) === null || _ft$rates === void 0 ? void 0 : _ft$rates.length) > 0;
    }), function (type) {
      return {
        key: type.key,
        text: type.title
      };
    }),
    values: {
      value: activeType === null || activeType === void 0 ? void 0 : activeType.key,
      label: activeType === null || activeType === void 0 ? void 0 : activeType.title
    },
    menuPlacement: 'bottom',
    dark: false,
    handleSelectChange: function handleSelectChange(type) {
      onTypeChange({
        key: type.value,
        title: type.label
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex space-x-8"
  }, map(financingTypes, function (type) {
    var _type$rates;
    if (((_type$rates = type.rates) === null || _type$rates === void 0 ? void 0 : _type$rates.length) <= 0) return;
    return /*#__PURE__*/React.createElement("div", {
      key: type.key,
      className: "flex cursor-pointer",
      onClick: function onClick() {
        return onTypeChange(type);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-none justify-center items-center w-6 h-6 rounded-full border " + ((activeType === null || activeType === void 0 ? void 0 : activeType.key) === type.key ? 'border-secondary' : 'border-primary') + " mr-2"
    }, (activeType === null || activeType === void 0 ? void 0 : activeType.key) === type.key && /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-4 h-4 rounded-full bg-secondary"
    })), /*#__PURE__*/React.createElement("p", null, type.title));
  })));
};

var _initialFormData$2;
var FormFields$2 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy',
  requestedDealerReference: 'requestedDealerReference'
};
var initialFormData$2 = (_initialFormData$2 = {}, _initialFormData$2[FormFields$2.requestedDealerReference] = null, _initialFormData$2[FormFields$2.firstName] = '', _initialFormData$2[FormFields$2.lastName] = '', _initialFormData$2[FormFields$2.email] = '', _initialFormData$2[FormFields$2.phone] = '', _initialFormData$2[FormFields$2.message] = '', _initialFormData$2[FormFields$2.privacy] = false, _initialFormData$2);
var validator$2 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$2.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$2.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$2.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$2.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$2.phone] = t('Phone is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$2.privacy] = '';
  }
  return errors;
};
var submitDataMapper$2 = function submitDataMapper(formData, additionalData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.id,
      reference: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.reference,
      identification: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    requested_dealer_reference: formData.requestedDealerReference,
    financial: additionalData !== null && additionalData !== void 0 && additionalData.financialData ? {
      price: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.price,
      deposit: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.deposit,
      months: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.months,
      financePrice: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.financePrice
    } : {}
  };
};
var OfferForm = function OfferForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: ""
  }, t('Receive a free quote')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("p", {
    className: "mb-10"
  }, t('Send us your details and we will make you a proposal.')), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-0 md:px-5 lg:px-12 left-0 right-0 absolute",
    style: {
      top: 40
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.firstName, value);
    },
    errorText: validationErrors[FormFields$2.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.lastName, value);
    },
    errorText: validationErrors[FormFields$2.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.email, value);
    },
    errorText: validationErrors[FormFields$2.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Phone'),
    placeholder: "0486 12 34 56",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.phone, value);
    },
    errorText: validationErrors[FormFields$2.phone],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded",
    label: t('Message'),
    placeholder: t('I am interested in purchasing this car and would like to know if it is still available?'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary flex items-center  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields$2.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-primary ",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var OfferForm$1 = baseDealerContactForm(DealerContactTypes.vehicleOffer, initialFormData$2, validator$2, submitDataMapper$2, OfferForm);

var NoFinanceAvailable = function NoFinanceAvailable() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex bg-white rounded p-4"
  }, t('There is no available data to show.'));
};

var ProfessionalFinancingAmounts = function ProfessionalFinancingAmounts(_ref) {
  var vehicle = _ref.vehicle,
    financeType = _ref.financeType,
    deposit = _ref.deposit,
    months = _ref.months,
    onDepositChange = _ref.onDepositChange,
    onMonthsChange = _ref.onMonthsChange,
    activeRate = _ref.activeRate,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var rates = financeType !== null && financeType !== void 0 && financeType.rates ? financeType === null || financeType === void 0 ? void 0 : financeType.rates : [];
  var defaultRate = financeType !== null && financeType !== void 0 && financeType["default"] ? financeType === null || financeType === void 0 ? void 0 : financeType["default"] : {};
  useEffect(function () {
    onDepositChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.deposit);
    onMonthsChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.months);
  }, [defaultRate]);
  var deposits = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.deposit);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var availableMonths = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.months);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var depositMarks = mapValues(keyBy(deposits), function () {
    return '';
  });
  var monthMarks = mapValues(keyBy(availableMonths), function () {
    return '';
  });
  if (financeType.key === 'no-finance-type') {
    return /*#__PURE__*/React.createElement(NoFinanceAvailable, {
      context: context
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", null, t('Rental price (excl. VAT)'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.price ? formatPrice(activeRate === null || activeRate === void 0 ? void 0 : activeRate.price) : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", null, t('Rental price (incl. VAT)'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.priceIncl ? formatPrice(activeRate === null || activeRate === void 0 ? void 0 : activeRate.priceIncl) : '')), vehicle.vatRegime && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, t('Deposit'), " ", deposit, "%"), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(deposits)),
    max: parseInt(max(deposits)),
    step: null,
    marks: depositMarks,
    dotStyle: {
      display: 'none'
    },
    value: deposit,
    onChange: function onChange(deposit) {
      onDepositChange(deposit);
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.depositAmount ? formatNumber(activeRate === null || activeRate === void 0 ? void 0 : activeRate.depositAmount) : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, t('Contract duration')), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(availableMonths)),
    max: parseInt(max(availableMonths)),
    step: null,
    marks: monthMarks,
    dotStyle: {
      display: 'none'
    },
    value: months,
    onChange: function onChange(months) {
      onMonthsChange(months);
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.months ? (activeRate === null || activeRate === void 0 ? void 0 : activeRate.months) + ' ' + t('months') : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, t('The maximum contract duration has been exceeded.')), /*#__PURE__*/React.createElement("div", null, t('In this case a calculation is not possible.'))))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", null, t('Purchase percentage'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.purchase ? activeRate === null || activeRate === void 0 ? void 0 : activeRate.purchase : '', " %")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, t('Purchase amount'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 text-right font-bold"
  }, activeRate !== null && activeRate !== void 0 && activeRate.purchaseAmount ? formatPrice(activeRate === null || activeRate === void 0 ? void 0 : activeRate.purchaseAmount) : '')));
};

var PrivateFinancingAmounts = function PrivateFinancingAmounts(_ref) {
  var financeType = _ref.financeType,
    deposit = _ref.deposit,
    months = _ref.months,
    onDepositChange = _ref.onDepositChange,
    onMonthsChange = _ref.onMonthsChange,
    activeRate = _ref.activeRate,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var rates = financeType !== null && financeType !== void 0 && financeType.rates ? financeType === null || financeType === void 0 ? void 0 : financeType.rates : [];
  var defaultRate = financeType !== null && financeType !== void 0 && financeType["default"] ? financeType === null || financeType === void 0 ? void 0 : financeType["default"] : {};
  useEffect(function () {
    onDepositChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.deposit);
    onMonthsChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.months);
  }, [defaultRate]);
  var deposits = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.deposit);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var availableMonths = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.months);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var depositMarks = mapValues(keyBy(deposits), function () {
    return '';
  });
  var monthMarks = mapValues(keyBy(availableMonths), function () {
    return '';
  });
  if (financeType.key === 'no-finance-type') {
    return /*#__PURE__*/React.createElement(NoFinanceAvailable, {
      context: context
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", null, t('Monthly payment'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.monthlyPrice ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.monthlyPrice) : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, t('Deposit'), " ", deposit, "%"), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(deposits)),
    max: parseInt(max(deposits)),
    step: null,
    marks: depositMarks,
    dotStyle: {
      display: 'none'
    },
    value: deposit,
    onChange: function onChange(deposit) {
      onDepositChange(deposit);
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.depositAmount ? formatNumber(activeRate === null || activeRate === void 0 ? void 0 : activeRate.depositAmount) : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, t('Contract duration')), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(availableMonths)),
    max: parseInt(max(availableMonths)),
    step: null,
    marks: monthMarks,
    dotStyle: {
      display: 'none'
    },
    value: months,
    onChange: function onChange(months) {
      onMonthsChange(months);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.months ? (activeRate === null || activeRate === void 0 ? void 0 : activeRate.months) + ' ' + t('months') : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, t('The maximum contract duration has been exceeded.')), /*#__PURE__*/React.createElement("div", null, t('In this case a calculation is not possible.'))))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", null, t('Annual percentage rate (APR)'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, activeRate !== null && activeRate !== void 0 && activeRate.interest_rate ? activeRate === null || activeRate === void 0 ? void 0 : activeRate.interest_rate : '', " %")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold"
  }, t('Total amount after payment'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.investment ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.investment) : '')), (activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) && (activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center bg-white rounded py-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-auto md:w-72 lg2:w-1/3 mr-0 md:mr-8 flex-none px-2 md:px-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold"
  }, t('Last monthly payment'))), /*#__PURE__*/React.createElement("p", {
    className: "pr-2 md:pr-4 font-bold text-right"
  }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.balloon_rate ? formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) : '')));
};

var defaultDeposit = 0;
var defaultMonths = 60;
var initFinanceType = {
  key: 'no-finance-type',
  title: '',
  rates: [],
  "default": []
};
var getFinancingTypes = function getFinancingTypes(vehicle, t) {
  return [{
    key: 'balloon',
    title: t('Ballon financing'),
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.balloonRates,
    "default": vehicle === null || vehicle === void 0 ? void 0 : vehicle.defaultBalloonRate,
    customerType: 'private',
    priority: 1
  }, {
    key: 'classic',
    title: t('Classic financing'),
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.financeRates,
    "default": vehicle === null || vehicle === void 0 ? void 0 : vehicle.defaultFinanceRate,
    customerType: 'private',
    priority: 2
  }, {
    key: 'lease',
    title: t('Leasing'),
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.leaseRates,
    "default": vehicle === null || vehicle === void 0 ? void 0 : vehicle.defaultLeaseRate,
    customerType: 'professional',
    priority: 1
  }, {
    key: 'rent',
    title: t('Renting'),
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.rentingRates,
    "default": vehicle === null || vehicle === void 0 ? void 0 : vehicle.defaultRentingRate,
    customerType: 'professional',
    priority: 2
  }];
};
var getRequestTypeFromFinanceType = function getRequestTypeFromFinanceType(financeType) {
  switch (financeType) {
    case 'balloon':
      return 'autocredit';
    case 'classic':
      return 'classic-financing';
    case 'long_term_rental':
      return 'long_term_rental';
    case 'lease':
      return 'lease';
    case 'renting':
      return 'renting';
    default:
      return '';
  }
};
var FinancingBox = function FinancingBox(_ref) {
  var vehicle = _ref.vehicle,
    activeRate = _ref.activeRate,
    setActiveRate = _ref.setActiveRate,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(initFinanceType),
    financeType = _useState[0],
    setFinanceType = _useState[1];
  var _useState2 = useState(defaultDeposit),
    deposit = _useState2[0],
    setDeposit = _useState2[1];
  var _useState3 = useState(defaultMonths),
    months = _useState3[0],
    setMonths = _useState3[1];
  var _useState4 = useState(false),
    showForm = _useState4[0],
    setShowForm = _useState4[1];
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = clientSettings.isProfessional;
  var financingTypes = getFinancingTypes(vehicle, t);
  var noFinancingAvailable = every(financingTypes, function (financeType) {
    return !(financeType !== null && financeType !== void 0 && financeType.rates) || (financeType === null || financeType === void 0 ? void 0 : financeType.rates) && (financeType === null || financeType === void 0 ? void 0 : financeType.rates.length) < 1;
  });
  var currentFinanceType = financeType.key;
  var customerType = isProfessional ? 'professional' : 'private';
  var filteredFinancingTypes = filter(financingTypes, function (financingType) {
    return financingType.customerType === customerType;
  });
  useEffect(function () {
    setActiveRate(findCorrectRate(deposit, months));
  }, [deposit, months, financeType]);
  useEffect(function () {
    setShowForm(false);
    var sortedFinancingTypes = sortBy(filteredFinancingTypes, 'priority');
    var firstNonEmptyType = find(sortedFinancingTypes, function (type) {
      return type.rates && type.rates.length > 0;
    });
    setFinanceType(firstNonEmptyType ? firstNonEmptyType : initFinanceType);
  }, [clientSettings.isProfessional]);
  var findCorrectRate = function findCorrectRate(newDeposit, newMonths) {
    return find(financeType === null || financeType === void 0 ? void 0 : financeType.rates, {
      deposit: newDeposit === null || newDeposit === void 0 ? void 0 : newDeposit.toString(),
      months: newMonths === null || newMonths === void 0 ? void 0 : newMonths.toString()
    });
  };
  if (noFinancingAvailable) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five px-5 md:px-10 py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-left md:items-center justify-between"
  }, /*#__PURE__*/React.createElement("h2", null, t('Calculate your financing')), /*#__PURE__*/React.createElement(Fade$1, {
    spy: isProfessional,
    duration: 100
  }, /*#__PURE__*/React.createElement(FinancingTypes, {
    financingTypes: filteredFinancingTypes,
    activeType: financeType,
    onTypeChange: function onTypeChange(type) {
      var newFinanceType = find(financingTypes, function (fType) {
        return fType.key === type.key;
      });
      setFinanceType(newFinanceType);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "my-4 w-max"
  }, /*#__PURE__*/React.createElement(CustomerTypeSwitch$1, {
    context: context
  })), /*#__PURE__*/React.createElement(Fade$1, {
    spy: isProfessional,
    duration: 100
  }, isProfessional ? /*#__PURE__*/React.createElement(ProfessionalFinancingAmounts, {
    vehicle: vehicle,
    financeType: financeType,
    deposit: deposit,
    months: months,
    onDepositChange: function onDepositChange(deposit) {
      return setDeposit(deposit);
    },
    onMonthsChange: function onMonthsChange(months) {
      return setMonths(months);
    },
    activeRate: activeRate,
    context: context
  }) : /*#__PURE__*/React.createElement(PrivateFinancingAmounts, {
    vehicle: vehicle,
    financeType: financeType,
    deposit: deposit,
    months: months,
    onDepositChange: function onDepositChange(deposit) {
      return setDeposit(deposit);
    },
    onMonthsChange: function onMonthsChange(months) {
      return setMonths(months);
    },
    activeRate: activeRate,
    context: context
  })), !showForm && financeType.key !== 'no-finance-type' && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full items-center"
  }, /*#__PURE__*/React.createElement(CtaButton, {
    name: "request-quote",
    onClick: function onClick() {
      return setShowForm(true);
    },
    className: "button button-primary",
    context: context
  }, t('Receive a free quote')), /*#__PURE__*/React.createElement(ExternalLink, {
    url: "https://anmgroup.be/nl/diensten/financiering/",
    context: context,
    className: "text-14 text-secondary-three underline mt-4 md:mt-0 ml-0 md:ml-7"
  }, t('More information about financing or leasing'))), showForm && /*#__PURE__*/React.createElement(OfferForm$1, {
    vehicle: vehicle,
    data: {
      vehicle: vehicle
    },
    onClose: function onClose() {
      return setShowForm(false);
    },
    context: context,
    additionalData: {
      vehicle: vehicle,
      financialData: {
        price: formatPrice(vehicle.price),
        deposit: deposit,
        months: months,
        financePrice: formatPrice(activeRate.monthlyPrice),
        financeType: currentFinanceType,
        totalAmount: activeRate.investment,
        depositAmount: activeRate.depositAmount,
        annualPercentageRate: activeRate.interest_rate,
        lastMonthlyPayment: activeRate.balloon_rate,
        purchase: activeRate.purchase,
        purchaseAmount: activeRate.purchaseAmount,
        rateId: activeRate.rateId
      },
      toolType: 'simulation',
      toolName: 'dealersite-financing',
      toolStepStart: 'financing-info',
      toolStepNumber: 2,
      toolStepComplete: 'thank-you',
      toolStepError: 'financing-info',
      toolStepOption: currentFinanceType + " | " + deposit + " | " + months,
      requestType: getRequestTypeFromFinanceType(currentFinanceType)
    }
  }), financeType.key !== 'no-finance-type' && /*#__PURE__*/React.createElement("div", {
    className: "mt-8",
    dangerouslySetInnerHTML: {
      __html: b64DecodeUnicode(activeRate === null || activeRate === void 0 ? void 0 : activeRate.legal)
    }
  }));
};

var Portal = function Portal(_ref) {
  var children = _ref.children;
  if (hasWindow() && hasDocument()) {
    var _document, _document2;
    var mount = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector('.ReactModalPortal');
    if (mount) return createPortal(children, mount);
    return createPortal(children, (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.body);
  }
  return /*#__PURE__*/React.createElement(Fragment, null);
};

var Panel = function Panel(_ref) {
  var onOpenPanel = _ref.onOpenPanel,
    onClosePanel = _ref.onClosePanel,
    title = _ref.title,
    children = _ref.children,
    renderFooter = _ref.renderFooter,
    widthClassName = _ref.widthClassName;
  var _useDeviceType = useDeviceType(),
    isMobile = _useDeviceType.isMobile,
    isTablet = _useDeviceType.isTablet,
    isDesktop = _useDeviceType.isDesktop;
  useEffect(function () {
    if (hasWindow() && hasDocument() && onOpenPanel) {
      var _document;
      var body = (_document = document) === null || _document === void 0 ? void 0 : _document.body;
      body.style.setProperty('overflow', 'hidden ', 'important');
    }
    return function () {
      if (hasWindow() && hasDocument() && onOpenPanel) {
        var _document2;
        var _body = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.body;
        _body.style.setProperty('overflow', '');
      }
    };
  }, [onOpenPanel]);
  var widthClassNames = widthClassName || (isMobile || isTablet ? 'w-screen' : 'w-520px min-w-520px');
  var className = "h-screen top-0 right-0 " + (onOpenPanel ? 'opacity-100' : 'opacity-0') + " " + widthClassNames;
  if (isMobile || isTablet) {
    className += " rounded-tr-16 " + (onOpenPanel ? 'translate-y-0' : 'translate-y-full');
  } else if (isDesktop) {
    className += " rounded-bl-16 " + (onOpenPanel ? 'translate-x-0' : 'translate-x-full');
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: "Panel block w-screen sm2:h-screen fixed bottom-0 left-0 overflow-hidden bg-black transform transition-all ease-in-out duration-500 bg-opacity-50 " + (onOpenPanel ? 'z-600 opacity-100 backdrop-filter backdrop-blur-sm' : '-z-1 opacity-0'),
    style: {
      height: '100dvh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "PanelContent fixed z-600 rounded-tl-16 overflow-y-auto bg-white transform transition-all ease-in-out duration-500 " + className
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sticky top-0 left-0 px-4 py-3 flex items-center bg-white  " + (title ? 'justify-between border-b border-gray-200' : 'justify-end')
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "text-18 font-semibold flex items-center justify-center flex-1 mr-4"
  }, title), /*#__PURE__*/React.createElement("button", {
    onClick: onClosePanel,
    className: "flex justify-center items-center p-2",
    type: "button"
  }, /*#__PURE__*/React.createElement(IconWithHover, {
    iconClass: "fal fa-times text-24"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 overflow-x-hidden overflow-y-auto " + (isDesktop ? 'px-10 pt-6 mb-6' : 'px-4 pt-4 mb-4')
  }, children), renderFooter && typeof renderFooter === 'function' && /*#__PURE__*/React.createElement("div", {
    className: "sticky bottom-0 py-4 border-t border-gray-200 " + (isDesktop ? 'px-10' : 'px-4')
  }, renderFooter())))));
};

var InputCheckboxField = function InputCheckboxField(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    error = _ref.error,
    label = _ref.label,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type;
  var _useState = useState(checked),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  var id = v4();
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex cursor-pointer space-x-2",
    onClick: function onClick() {
      return onChange(!isChecked);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid place-items-center cursor-pointer"
  }, /*#__PURE__*/React.createElement("input", {
    type: type,
    id: id,
    checked: isChecked,
    className: "col-start-1 row-start-1 appearance-none cursor-pointer shrink-0 w-5 h-5 border " + (type === 'radio' ? 'rounded-full' : 'rounded') + " " + (isChecked ? 'border-black bg-black' : 'border-gray-200 bg-white')
  }), type === 'radio' && /*#__PURE__*/React.createElement("div", {
    className: "col-start-1 row-start-1 w-2 h-2 bg-white rounded-full"
  }), type !== 'radio' && isChecked && /*#__PURE__*/React.createElement("i", {
    className: "col-start-1 row-start-1 fas fa-check text-xs text-white"
  })), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    onClick: function onClick() {
      return onChange(!isChecked);
    },
    className: "text-sm font-normal cursor-pointer " + (error !== undefined ? 'text-red-400' : 'text-primary')
  }, typeof label === 'function' ? label() : label));
};

var _initialFormData$3;
var FormFields$3 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy',
  form_type: 'form_type',
  requestedDealerReference: 'requestedDealerReference'
};
var initialFormData$3 = (_initialFormData$3 = {}, _initialFormData$3[FormFields$3.requestedDealerReference] = null, _initialFormData$3[FormFields$3.firstName] = '', _initialFormData$3[FormFields$3.lastName] = '', _initialFormData$3[FormFields$3.email] = '', _initialFormData$3[FormFields$3.phone] = '', _initialFormData$3[FormFields$3.message] = '', _initialFormData$3[FormFields$3.form_type] = '', _initialFormData$3[FormFields$3.privacy] = false, _initialFormData$3);
var validator$3 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$3.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$3.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$3.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$3.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$3.phone] = t('Phone is required.');
  }
  if (!hasValue(data.form_type)) {
    errors[FormFields$3.form_type] = t('For what do we need to contact you for?');
  }
  if (data.privacy === false) {
    errors[FormFields$3.privacy] = '';
  }
  return errors;
};
var submitDataMapper$3 = function submitDataMapper(formData, additionalData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    form_type: formData.form_type,
    vehicle: {
      id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.id,
      reference: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.reference,
      identification: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    requested_dealer_reference: formData.requestedDealerReference,
    financial: additionalData !== null && additionalData !== void 0 && additionalData.financialData ? {
      price: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.price,
      deposit: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.deposit,
      months: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.months,
      financePrice: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.financePrice
    } : {}
  };
};
var initialGDDLData = {
  toolType: 'request-form',
  toolName: 'dealersite-contact-dealer'
};
var AppointmentTestDriveForm = function AppointmentTestDriveForm(_ref) {
  var data = _ref.data,
    additionalData = _ref.additionalData,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy,
    onClosePanel = _ref.onClosePanel,
    context = _ref.context;
  var _useState = useState(false),
    formSent = _useState[0],
    setFormSent = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$toolSub = _useAnalytics.toolSubmitEventAnalytics,
    toolSubmitEventAnalytics = _useAnalytics$toolSub === void 0 ? function () {
      return null;
    } : _useAnalytics$toolSub,
    _useAnalytics$toolSta = _useAnalytics.toolStartEventAnalytics,
    toolStartEventAnalytics = _useAnalytics$toolSta === void 0 ? function () {
      return null;
    } : _useAnalytics$toolSta;
  useEffect(function () {
    if (submitSuccess) {
      setFormSent(submitSuccess);
    }
  }, [submitSuccess]);
  var handleClose = function handleClose() {
    onClosePanel();
    setTimeout(function () {
      return setFormSent(false);
    }, 300);
  };
  useEffect(function () {
    toolStartEventAnalytics('dealersite-contact-dealer', _extends({}, initialGDDLData, {
      toolStep: 'personal-info',
      toolStepNumber: '1',
      vehicle: additionalData.vehicle,
      requestType: 'contact-dealer|test-drive'
    }));
  }, []);
  useEffect(function () {
    if (submitSuccess || submitError) {
      if (submitSuccess) {
        var _additionalData$vehic, _additionalData$vehic2;
        toolSubmitEventAnalytics('dealersite-contact-dealer', _extends({}, initialGDDLData, {
          toolStep: 'personal-info',
          toolStepNumber: '1',
          toolStepOption: (_additionalData$vehic = additionalData.vehicle) === null || _additionalData$vehic === void 0 ? void 0 : (_additionalData$vehic2 = _additionalData$vehic.dealer) === null || _additionalData$vehic2 === void 0 ? void 0 : _additionalData$vehic2.name,
          vehicle: additionalData.vehicle,
          requestType: data.form_type === 'vehicle_test_drive' ? 'test-drive' : 'contact-dealer'
        }));
      }
    }
  }, [submitSuccess, submitError]);
  return /*#__PURE__*/React.createElement("form", {
    className: "flex flex-col bg-white relative w-full",
    onSubmit: submit,
    action: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 overflow-y-scroll"
  }, !formSent && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-24 font-semibold"
  }, t('Schedule an appointment or book a test drive.')), /*#__PURE__*/React.createElement("p", {
    className: " text-16 font-medium"
  }, t('Let us know when you can, we will contact you soon.'))), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), formSent && /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "w-full text-24 font-semibold text-center"
  }, t('Your request has been sent!')), /*#__PURE__*/React.createElement("p", {
    className: "w-full text-16 font-medium text-center"
  }, t('We will contact you shortly to confirm the appointment.'))), !formSent && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-16 font-medium text-primary"
  }, t('Name')), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.firstName, value);
    },
    errorText: validationErrors[FormFields$3.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.lastName, value);
    },
    errorText: validationErrors[FormFields$3.lastName],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-16 font-medium text-primary"
  }, t('Contact info')), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.email, value);
    },
    errorText: validationErrors[FormFields$3.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full",
    inputClass: "rounded",
    label: t('Phone'),
    placeholder: "0486 12 34 56",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.phone, value);
    },
    errorText: validationErrors[FormFields$3.phone],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3 text-16 font-medium text-primary"
  }, t('Contact me for'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "mb-2",
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/React.createElement(InputCheckboxField, {
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.form_type, value ? DealerContactTypes.vehicleInformation : '');
    },
    error: validationErrors['form_type'],
    checked: data.form_type === DealerContactTypes.vehicleInformation,
    label: t('An appointment')
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/React.createElement(InputCheckboxField, {
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.form_type, value ? DealerContactTypes.vehicleTestDrive : '');
    },
    error: validationErrors['form_type'],
    checked: data.form_type === DealerContactTypes.vehicleTestDrive,
    label: t('Test drive')
  })), validationErrors['form_type'] !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-red-400 text-xs"
  }, validationErrors['form_type'])), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-16 font-medium text-primary"
  }, t('Message (optional)')), /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded",
    label: t('Message'),
    placeholder: t('I want to make an appointment to see this vehicle'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/React.createElement(InputCheckboxField, {
    type: "checkbox",
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.privacy, value);
    },
    error: validationErrors['privacy'],
    checked: data.privacy === true,
    label: function label() {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
        className: "underline cursor-pointer",
        onClick: navigatePrivacy
      }, t('privacy terms')));
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end pt-6 border-t border-gray-200 -mx-10 px-10 sticky bottom-0 space-x-4"
  }, formSent && /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary w-full",
    type: "button",
    onClick: function onClick() {
      return handleClose();
    }
  }, t('Close')), !formSent && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "button button-alternate",
    type: "button",
    disabled: submitting,
    onClick: function onClick() {
      return handleClose();
    }
  }, t('Cancel')), /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send')))));
};
var AppointmentTestDriveForm$1 = baseDealerContactForm(DealerContactTypes.vehicleInformation, initialFormData$3, validator$3, submitDataMapper$3, AppointmentTestDriveForm);

var _initialFormData$4;
var FormFields$4 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  message: 'message',
  requestedDealerReference: 'requestedDealerReference'
};
var initialFormData$4 = (_initialFormData$4 = {}, _initialFormData$4[FormFields$4.requestedDealerReference] = null, _initialFormData$4[FormFields$4.firstName] = '', _initialFormData$4[FormFields$4.lastName] = '', _initialFormData$4[FormFields$4.email] = '', _initialFormData$4[FormFields$4.message] = 'De voertuigfiche werd gevraagd.', _initialFormData$4[FormFields$4.privacy] = false, _initialFormData$4);
var validator$4 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$4.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$4.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$4.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$4.email] = t('Email address is not valid.');
  }
  return errors;
};
var submitDataMapper$4 = function submitDataMapper(formData, additionalData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    message: formData.message,
    vehicle: {
      id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.id,
      reference: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.reference,
      identification: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    requested_dealer_reference: formData.requestedDealerReference,
    financial: additionalData !== null && additionalData !== void 0 && additionalData.financialData ? {
      price: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.price,
      deposit: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.deposit,
      months: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.months,
      financePrice: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.financePrice
    } : {}
  };
};
var WindscreenForm = function WindscreenForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    onClosePanel = _ref.onClosePanel,
    vehiclePdfUrl = _ref.vehiclePdfUrl;
  var _useState = useState(false),
    formSent = _useState[0],
    setFormSent = _useState[1];
  var _useState2 = useState(false),
    downloadingFile = _useState2[0],
    setDownloadingFile = _useState2[1];
  var _useState3 = useState(''),
    fileDownloadError = _useState3[0],
    setFileDownloadError = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var downloadFile = function downloadFile() {
    try {
      if (!vehiclePdfUrl) return Promise.resolve();
      setFileDownloadError('');
      setDownloadingFile(true);
      try {
        var link = document.createElement('a');
        link.href = vehiclePdfUrl;
        link.download = t('windscreen') + ".pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          setDownloadingFile(false);
          setFormSent(submitSuccess);
        }, 3000);
      } catch (error) {
        setFileDownloadError(t('Failed to download the file. Please try again later.'));
        setDownloadingFile(false);
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    if (submitSuccess && vehiclePdfUrl) {
      void downloadFile();
    }
  }, [submitSuccess, vehiclePdfUrl]);
  var handleClose = function handleClose() {
    onClosePanel();
    setTimeout(function () {
      return setFormSent(false);
    }, 300);
  };
  var error = submitError || fileDownloadError;
  return /*#__PURE__*/React.createElement("form", {
    className: "flex flex-col bg-white relative w-full",
    onSubmit: submit,
    action: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 overflow-y-scroll"
  }, !formSent && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-24 font-semibold"
  }, t('Download all information about this car.')), /*#__PURE__*/React.createElement("p", {
    className: " text-16 font-medium"
  }, t('Fill the form in and download the information about this car.'))), error && error !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: error
  })), formSent && /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "w-full text-24 font-semibold text-center"
  }, t('The windscreen is downloaded')), /*#__PURE__*/React.createElement("p", {
    className: "w-full text-16 font-medium text-center"
  }, t('All information about the vehicle can be found in the downloaded windscreen.'))), !formSent && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-16 font-medium text-primary"
  }, t('Name')), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$4.firstName, value);
    },
    errorText: validationErrors[FormFields$4.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$4.lastName, value);
    },
    errorText: validationErrors[FormFields$4.lastName],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-16 font-medium text-primary"
  }, t('Contact info')), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$4.email, value);
    },
    errorText: validationErrors[FormFields$4.email],
    required: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end pt-6 border-t border-gray-200 -mx-10 px-10 sticky bottom-0 space-x-4"
  }, formSent && /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary w-full",
    type: "button",
    onClick: handleClose
  }, t('Close')), !formSent && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "button button-alternate",
    type: "button",
    disabled: submitting,
    onClick: handleClose
  }, t('Cancel')), /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    type: "submit",
    disabled: submitting
  }, submitting || downloadingFile ? t('Downloading...') : t('Download')))));
};
var WindscreenForm$1 = baseDealerContactForm(DealerContactTypes.vehicleInformation, initialFormData$4, validator$4, submitDataMapper$4, WindscreenForm);

var VEHICLE_QUERY = "query Vehicle ($reference: String!) {\n  vehicle (reference: $reference) {\n        id\n        reference       \n        vin \n        identification \n        language \n        creationDate \n        lastUpdate    \n      \n        make      \n        model        \n        modelFamily \n        version \n        firstRegistrationMonth \n        firstRegistrationYear \n        mileage \n        doors \n        seats \n        kw \n        hp\n        engineCc \n        co2 \n        euroNorm \n        interiorColor\n        exteriorColor\n    \n       \n        category        \n        body   \n        fuel        \n        gearbox \n    \n        images   \n        images360 \n        images360SpinnerUrl\n        equipments \n        comments \n       \n        financeRates\n        defaultFinanceRate\n        balloonRates\n        defaultBalloonRate\n        leaseRates\n        defaultLeaseRate\n        rentingRates\n        defaultRentingRate\n    \n        price\n        priceExcl\n        brutoPrice\n        monthlyPrice\n        monthlyPriceType\n        monthlyLastPayment\n        monthlyPriceProf\n        monthlyPriceTypeProf           \n                \n        sold \n        carpass \n        warranty\n        vatRegime\n        deliveryCost\n              \n        reserved\n        labels\n        labelsV2 {\n          key\n          name\n          logo\n          warrantyData\n        }\n        dealer {\n          name\n          address\n          postal\n          city\n          tel\n          contactUrl\n          videoCallUrl\n          appointmentUrl\n          mobile\n          externalReference\n        }\n        \n        makeKey\n        makeFamilyKey\n        modelKey        \n        modelFamilyKey\n        bodyKey\n        gearboxKey\n        categoryKey\n        fuelKey\n        exteriorColorKey\n        interiorColorKey\n        interiorUpholsteryKey\n        \n        availability\n        tradeInDiscount\n        recyclingDiscount\n        conditionsB2c\n  }\n}";
var getAdvertisementByLocation = function getAdvertisementByLocation(advertisements, location) {
  if (!advertisements || (advertisements === null || advertisements === void 0 ? void 0 : advertisements.length) === 0) {
    return undefined;
  }
  return find(advertisements, function (add) {
    return add.location === location;
  });
};
var renderLoadingSkeleton = function renderLoadingSkeleton() {
  var skeletonImages = 4;
  return /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse max-w-screen-2xl mx-auto flex flex-col w-full px-5 mt-4 mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-4 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-16 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-16 bg-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-4 mr-1 bg-gray-300"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-16 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-16 mr-1 bg-gray-300"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-4 bg-gray-300"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-2/3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:grid grid-cols-1 lg:grid-cols-2 gap-1"
  }, map(range(skeletonImages), function (img) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-300 h-52",
      key: img
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "block lg:hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-300 h-52 sm:h-96"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex bg-secondary-five mt-10 mb-10 lg:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-20 w-1/3 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center items-start h-20 w-2/3 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-3/4 bg-gray-300 mb-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-full bg-gray-300 "
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full lg:w-1/3 px-0 lg:px-12 lg:pb-12 bg-white items-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-6 w-48 bg-gray-300 mb-1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-64 bg-gray-300 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-32 bg-gray-300 mb-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-2 w-32 bg-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-none ml-4 border-l pl-4 border-secondary-four"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-32 bg-gray-300 mb-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-2 w-32 bg-gray-300"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-10 w-36 bg-gray-300 mr-2 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-10 w-48 bg-gray-300 mr-2 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-10 w-32 bg-gray-300 mb-2"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-4 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-20 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-20 bg-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-4 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-20 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-20 bg-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-14 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-4 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-4 mr-2 bg-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-4 bg-gray-300"
  })))));
};
var VehicleDetail = function VehicleDetail(_ref) {
  var _vehicle$dealer, _vehicle$dealer2, _vehicle$dealer3;
  var vehicle = _ref.vehicle,
    vehiclePdfUrl = _ref.vehiclePdfUrl,
    loading = _ref.loading,
    error = _ref.error,
    advertisements = _ref.advertisements,
    context = _ref.context;
  var _useState = useState(undefined),
    activeRate = _useState[0],
    _setActiveRate = _useState[1];
  var _useState2 = useState('standard'),
    panelType = _useState2[0],
    setPanelType = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onClosePanelHandler = function onClosePanelHandler() {
    setPanelType('standard');
  };
  var onOpenPanelHandler = function onOpenPanelHandler(newPanelType) {
    setPanelType(newPanelType);
  };
  var financeBlockRef = useRef();
  useContentBlockImpressionWhenInViewport(financeBlockRef, 'financing', context);
  var specsBlockRef = useRef();
  var MobileVehicleImageRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileVehicleImageRef, 'vehicle-image', context);
  var DesktopVehicleImageRef = useRef();
  useContentBlockImpressionWhenInViewport(DesktopVehicleImageRef, 'vehicle-image', context);
  var MobileCarDetailsRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileCarDetailsRef, 'vehicle-summary', context);
  var DesktopCarDetailsRef = useRef();
  useContentBlockImpressionWhenInViewport(DesktopCarDetailsRef, 'vehicle-summary', context);
  var MobileCarUSPRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileCarUSPRef, 'usp', context);
  var mapVehicleImagesForViewer = function mapVehicleImagesForViewer(images) {
    var isArray = images instanceof Array;
    return isArray ? images.map(function (img) {
      return img.uri;
    }) : [images.uri];
  };
  var scrollToFinancing = function scrollToFinancing() {
    financeBlockRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  };
  var scrollToSpecs = function scrollToSpecs() {
    specsBlockRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (context.builder) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 100
      }
    }, "Vehicle Detail");
  }
  if (loading) return renderLoadingSkeleton();
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 my-10"
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: error
    }));
  }
  var addForLocation1 = getAdvertisementByLocation(advertisements, 1);
  var addForLocation2 = getAdvertisementByLocation(advertisements, 2);
  var addForLocation3 = getAdvertisementByLocation(advertisements, 3);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    make: vehicle === null || vehicle === void 0 ? void 0 : vehicle.make,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "block lg:flex lg:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("div", {
    ref: DesktopCarDetailsRef,
    className: "hidden lg:block min-w-420px lg2:min-w-480px flex-none"
  }, /*#__PURE__*/React.createElement(Sticky, {
    top: 90,
    bottomBoundary: "#sticky-stop"
  }, /*#__PURE__*/React.createElement(Specifications, {
    vehicle: vehicle,
    activeRate: activeRate,
    scrollToFinancing: scrollToFinancing,
    scrollToSpecs: scrollToSpecs,
    context: context,
    onOpenPanelHandler: onOpenPanelHandler
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    ref: MobileVehicleImageRef,
    className: "block lg:hidden"
  }, /*#__PURE__*/React.createElement(ImageViewerMobile$1, {
    images: mapVehicleImagesForViewer(vehicle.images),
    images360SpinnerUrl: vehicle.images360SpinnerUrl
  })), /*#__PURE__*/React.createElement("div", {
    ref: DesktopVehicleImageRef,
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement(ImageViewerDesktop$1, {
    images: mapVehicleImagesForViewer(vehicle.images),
    images360SpinnerUrl: vehicle.images360SpinnerUrl
  })), addForLocation1 && /*#__PURE__*/React.createElement("div", {
    ref: MobileCarUSPRef,
    className: "bg-secondary-five py-5 md:py-10"
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupId: addForLocation1.groupId,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    ref: MobileCarDetailsRef,
    className: "block lg:hidden py-10"
  }, /*#__PURE__*/React.createElement(Specifications, {
    vehicle: vehicle,
    activeRate: activeRate,
    scrollToFinancing: scrollToFinancing,
    scrollToSpecs: scrollToSpecs,
    onOpenPanelHandler: onOpenPanelHandler,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    ref: specsBlockRef
  }, /*#__PURE__*/React.createElement(Characteristics, {
    vehicle: vehicle,
    vehiclePdfUrl: vehiclePdfUrl,
    onOpenPanelHandler: onOpenPanelHandler,
    context: context
  })), addForLocation2 && /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five pb-10"
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupId: addForLocation2.groupId,
    context: context
  })), /*#__PURE__*/React.createElement(Equipments, {
    vehicle: vehicle,
    context: context
  }), addForLocation3 && /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-five pt-10"
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupId: addForLocation3.groupId,
    context: context
  })), context.financing && /*#__PURE__*/React.createElement("div", {
    ref: financeBlockRef
  }, /*#__PURE__*/React.createElement(FinancingBox, {
    vehicle: vehicle,
    activeRate: activeRate,
    setActiveRate: function setActiveRate(newActiveRate) {
      return _setActiveRate(newActiveRate);
    },
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    id: "sticky-stop"
  })), vehicle && ((_vehicle$dealer = vehicle.dealer) === null || _vehicle$dealer === void 0 ? void 0 : _vehicle$dealer.mobile) && /*#__PURE__*/React.createElement(WhatsAppBtn, {
    phoneNumber: (_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.mobile
  }), panelType === 'appointment_form' && /*#__PURE__*/React.createElement(Panel, {
    onOpenPanel: panelType === 'appointment_form',
    onClosePanel: onClosePanelHandler,
    title: t('Make an appointment')
  }, /*#__PURE__*/React.createElement(AppointmentTestDriveForm$1, {
    vehicle: vehicle,
    data: {
      vehicle: vehicle
    },
    onClosePanel: onClosePanelHandler,
    context: context,
    additionalData: {
      vehicle: vehicle
    }
  })), panelType === 'windscreen_form' && /*#__PURE__*/React.createElement(Panel, {
    onOpenPanel: panelType === 'windscreen_form',
    onClosePanel: onClosePanelHandler,
    title: t('Download windscreen')
  }, /*#__PURE__*/React.createElement(WindscreenForm$1, {
    vehicle: vehicle,
    vehiclePdfUrl: vehiclePdfUrl,
    data: {
      vehicle: vehicle
    },
    onClosePanel: onClosePanelHandler,
    context: context,
    additionalData: {
      vehicle: vehicle,
      toolType: 'request-form',
      toolName: 'download-vehicle-sheet',
      toolStepStart: 'personal-info',
      toolStepComplete: 'thank-you',
      toolStepError: 'personal-info',
      toolStepOption: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer3 = vehicle.dealer) === null || _vehicle$dealer3 === void 0 ? void 0 : _vehicle$dealer3.name,
      requestType: 'vehicle-sheet'
    }
  })));
};
var VehicleDetail$1 = baseVehicleDetail(VehicleDetail, {
  query: VEHICLE_QUERY
});

var VehicleDetailWithAdds = function VehicleDetailWithAdds(_ref) {
  var reference = _ref.reference,
    advertisements = _ref.advertisements,
    context = _ref.context,
    resolveAnalyticsData = _ref.resolveAnalyticsData;
  return /*#__PURE__*/React.createElement("div", {
    className: "container with-financing"
  }, /*#__PURE__*/React.createElement(VehicleDetail$1, {
    reference: reference,
    additional_vehicle_images: [],
    advertisements: advertisements,
    context: context,
    resolveAnalyticsData: resolveAnalyticsData
  }));
};
VehicleDetailWithAdds.defaultProps = {};
VehicleDetailWithAdds.human = {
  nl: 'Detailpagina',
  fr: 'Vehicle Detail',
  en: 'Vehicle Detail'
};

var SizingSlider = function SizingSlider(_ref) {
  var gridSize = _ref.gridSize,
    handleSizingChange = _ref.handleSizingChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pr-4"
  }, t('View') + ':'), /*#__PURE__*/React.createElement("div", {
    className: "flex-none w-32 sizing-slider cursor-pointer"
  }, /*#__PURE__*/React.createElement(Slider, {
    min: 3,
    max: 5,
    step: 1,
    value: gridSize,
    onChange: function onChange(value) {
      handleSizingChange(value);
    }
  })));
};

var BreadcrumbsBar$1 = function BreadcrumbsBar(_ref) {
  var totalCountByFilters = _ref.totalCountByFilters,
    gridSize = _ref.gridSize,
    handleSizingChange = _ref.handleSizingChange,
    _ref$showGridSlider = _ref.showGridSlider,
    showGridSlider = _ref$showGridSlider === void 0 ? true : _ref$showGridSlider,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getPageName = function getPageName(key) {
    var pageData = find(context.allPagesData, function (p) {
      return p.key === key && p.language === context.culture;
    });
    return pageData === null || pageData === void 0 ? void 0 : pageData.description;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between text-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.home,
    context: context,
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-home-alt"
  })), /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right mx-3",
    style: {
      fontSize: 10
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, getPageName('stock'))), /*#__PURE__*/React.createElement("div", {
    className: "block lg2:hidden"
  }, totalCountByFilters + ' ' + t('voertuigen')), showGridSlider && /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:block"
  }, /*#__PURE__*/React.createElement(SizingSlider, {
    gridSize: gridSize,
    handleSizingChange: handleSizingChange
  }))));
};
var BreadcrumbsBar$2 = withFilters(BreadcrumbsBar$1);

var FiltersBar = function FiltersBar(_ref) {
  var filters = _ref.filters,
    totalCountByFilters = _ref.totalCountByFilters,
    open_sidebar = _ref.open_sidebar,
    categories = _ref.categories;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var quickFilters = {
    make: categories.make,
    model: categories.model,
    price: categories.price,
    fuel: categories.fuel,
    category: categories.category
  };
  var filteredOnCategory = function filteredOnCategory(category) {
    if (category === (quickFilters === null || quickFilters === void 0 ? void 0 : quickFilters.model)) {
      if (some(filters, {
        type: 'makeModel'
      })) {
        return filters.some(function (filter) {
          var _filter$value;
          return !isBoolean(filter.value) && (filter === null || filter === void 0 ? void 0 : (_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.includes('|'));
        });
      } else {
        return false;
      }
    } else if (category === quickFilters.make) {
      return some(filters, {
        type: 'makeModel'
      });
    } else if (category === quickFilters.price) {
      return some(filters, {
        type: 'monthly_price'
      }) || some(filters, {
        type: 'price'
      });
    } else {
      return some(filters, {
        type: category === null || category === void 0 ? void 0 : category.key
      });
    }
  };
  var renderText = function renderText() {
    if (!totalCountByFilters) {
      return "" + t('One of those ... vehicles can quick be yours');
    }
    return /*#__PURE__*/React.createElement("span", null, t('One of those'), " ", /*#__PURE__*/React.createElement("span", {
      className: "font-bold px-0.5"
    }, totalCountByFilters), " ", t('vehicles can quick be yours'));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-nowrap justify-between overflow-x-auto py-4 font-semibold text-base"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden flex-none rounded py-3 px-4 mr-3 cursor-pointer bg-secondary-five hover:bg-secondary-four transition",
    onClick: function onClick() {
      return open_sidebar(categories.sort);
    }
  }, t('Sort by')), map(quickFilters, function (category, index) {
    if (category !== undefined) {
      return /*#__PURE__*/React.createElement("div", {
        key: 'category-' + index,
        className: "flex-none rounded py-3 px-4 mr-3 cursor-pointer bg-secondary-five hover:bg-secondary-four transition border " + (filteredOnCategory(category) ? 'border-primary' : 'border-secondary-five'),
        onClick: function onClick() {
          open_sidebar(category);
        }
      }, ' ', category.translation(t));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-none flex items-center rounded py-3 px-4 mr-3 cursor-pointer bg-secondary-five hover:bg-secondary-four transition border border-secondary-five",
    onClick: function onClick() {
      open_sidebar(null);
    }
  }, t('All filters'), /*#__PURE__*/React.createElement("i", {
    className: "far fa-sliders-h pl-3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-none items-center justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-normal flex-initial mr-5 truncate hidden lg2:block"
  }, renderText()), /*#__PURE__*/React.createElement("div", {
    className: "flex-none rounded py-3 px-4 cursor-pointer bg-secondary-five hover:bg-secondary-four transition",
    onClick: function onClick() {
      open_sidebar(categories.sort);
    }
  }, t('Sort by'))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full px-5 2xl:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px border-b border-secondary-four"
  })));
};
var FiltersBar$1 = withFilters(FiltersBar);

var FilterBadgesBar = function FilterBadgesBar(_ref) {
  var filters = _ref.filters,
    filterDelete = _ref.filterDelete,
    filtersClear = _ref.filtersClear;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (filters.filter(function (f) {
    return (f === null || f === void 0 ? void 0 : f.label) !== undefined;
  }).length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap overflow-x-auto items-center pl-5 md:pl-0 pr-5 py-4"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-3 text-primary"
  }, t('Filters'), ":"), map(filters, function (filter, index) {
    return /*#__PURE__*/React.createElement(Fade, {
      key: "filter-badge-" + index,
      duration: 150
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-none items-center border border-secondary-three font-semibold rounded py-2 px-3 " + (index === 0 ? 'ml-0' : 'ml-3') + " cursor-pointer text-primary hover:text-secondary-three transition",
      onClick: function onClick() {
        return filterDelete(filter);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-times mr-3"
    }), filter.label ? filter.label : filter.key));
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex items-center flex-none pl-4 relative",
    style: {
      height: 42
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-4 top-0 -left-4 bg-gradient-to-l from-white",
    style: {
      height: 42
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-2 mr-2 flex items-center cursor-pointer hover:text-secondary-three transition",
    onClick: function onClick() {
      return filtersClear();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-redo mr-2"
  }), /*#__PURE__*/React.createElement("p", {
    className: "underline font-semibold"
  }, t('Clear all filters'))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full px-5 2xl:px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px border-b border-secondary-four"
  })));
};
var FilterBadgesBar$1 = withFilters(FilterBadgesBar);

var Pagination = function Pagination(_ref) {
  var goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    pages = _ref.pages,
    context = _ref.context,
    amountOfPages = _ref.amountOfPages;
  var firstShownPage = pages[0];
  var lastShownPage = pages[pages.length - 1];
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var _useDeviceType = useDeviceType(),
    isDesktop = _useDeviceType.isDesktop;
  useEffect(function () {
    var newPage = clientSettings.pageChanged <= amountOfPages ? clientSettings.pageChanged : 1;
    setChangedPage(newPage);
    if (isDesktop && clientSettings.pageChanged && clientSettings.pageChanged !== currentPage) {
      goToPage(newPage);
    }
  }, [clientSettings.pageChanged, currentPage, amountOfPages, isDesktop]);
  var setChangedPage = function setChangedPage(page) {
    setClientSetting('pageChanged', page, true);
  };
  var renderPreviousButton = function renderPreviousButton() {
    var handleClickPrevious = function handleClickPrevious() {
      setChangedPage(currentPage - 1);
      goToPreviousPage();
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-secondary-five rounded w-10 h-10 mr-2 cursor-pointer hover:bg-secondary-four transition",
      onClick: handleClickPrevious
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-left"
    }));
  };
  var renderGoToFirstPage = function renderGoToFirstPage() {
    var handleClickPageOne = function handleClickPageOne() {
      setChangedPage(1);
      goToPage(1);
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer hover:bg-secondary-five rounded-full transition",
      onClick: handleClickPageOne
    }, "1"), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."));
  };
  var renderPageNumber = function renderPageNumber(page) {
    var handleClickPageNumber = function handleClickPageNumber() {
      setChangedPage(page);
      goToPage(page);
    };
    return /*#__PURE__*/React.createElement("div", {
      key: "page-" + page,
      className: "flex items-center justify-center w-10 h-10 cursor-pointer hover:bg-secondary-five rounded-full transition " + (page === currentPage ? 'font-bold' : ''),
      onClick: handleClickPageNumber
    }, page);
  };
  var renderGoToLastPage = function renderGoToLastPage() {
    var handleClickPageLast = function handleClickPageLast() {
      setChangedPage(amountOfPages);
      goToPage(amountOfPages);
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer hover:bg-secondary-five rounded-full transition",
      onClick: handleClickPageLast
    }, amountOfPages));
  };
  var renderNextButton = function renderNextButton() {
    var handleClickNext = function handleClickNext() {
      setChangedPage(currentPage + 1);
      goToNextPage();
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-secondary-five rounded w-10 h-10 ml-2 cursor-pointer hover:bg-secondary-four transition",
      onClick: handleClickNext
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex w-full justify-center mt-12"
  }, currentPage > 1 && renderPreviousButton(), firstShownPage > 2 && renderGoToFirstPage(), pages === null || pages === void 0 ? void 0 : pages.map(function (page) {
    return renderPageNumber(page);
  }), lastShownPage < amountOfPages - 1 && renderGoToLastPage(), currentPage < amountOfPages && renderNextButton());
};
var Pagination$1 = basePagination(Pagination);

var AdvertiseCard = function AdvertiseCard(_ref) {
  var card = _ref.card,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(ActionLink, {
    action: card.action,
    context: context,
    className: "h-full",
    gatsbyClassName: "h-full"
  }, /*#__PURE__*/React.createElement(BuilderImage, {
    image: card.image,
    context: context,
    style: {
      width: '100%',
      height: '100%'
    }
  }));
};

var VehiclesList = function VehiclesList(_ref) {
  var loading = _ref.loading,
    goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    batchSize = _ref.batchSize,
    totalCount = _ref.totalCount,
    gridSize = _ref.gridSize,
    selectVehicle = _ref.selectVehicle,
    cards = _ref.cards,
    customCardsByBatch = _ref.customCardsByBatch,
    context = _ref.context;
  var gridClass = 'xl2:grid-cols-4 xl3:grid-cols-5';
  return /*#__PURE__*/React.createElement("div", {
    className: "py-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 " + gridClass + " gap-4"
  }, loading ? times(batchSize, function (index) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: index,
      dark: false
    });
  }) : map(cards, function (card, index) {
    if (card._type === 'vehicle') {
      var vehicle = card;
      return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
        key: index,
        gridSize: gridSize,
        vehicle: vehicle,
        context: context,
        onClick: function onClick() {
          return selectVehicle(vehicle);
        }
      });
    } else if (card._type === 'banner') {
      return /*#__PURE__*/React.createElement(AdvertiseCard, {
        key: index,
        card: card,
        context: context
      });
    }
  })), totalCount > batchSize && /*#__PURE__*/React.createElement(Pagination$1, {
    goToNextPage: goToNextPage,
    goToPreviousPage: goToPreviousPage,
    goToPage: goToPage,
    currentPage: currentPage,
    batchSize: batchSize,
    totalCount: totalCount,
    loading: loading,
    context: context,
    pageRange: 2,
    customCardsByBatch: customCardsByBatch
  }));
};
var VehiclesList$1 = baseVehiclesPaged(VehiclesList);

var BodyFilter = function BodyFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var BodyFilter$1 = baseTypedFilter(FilterTypes.body, BodyFilter);

var CategoryFilter = function CategoryFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var CategoryFilter$1 = baseTypedFilter(FilterTypes.category, CategoryFilter);

var initCoValue = {
  min: '',
  max: ''
};
var CO2Filter = function CO2Filter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter;
  var activeFilter = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
    } else {
      filterDeleteByType();
    }
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    handleChange();
  };
  return /*#__PURE__*/React.createElement("form", {
    className: "w-full flex",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(InputField, {
    value: value.min,
    onChange: function onChange(value) {
      return setValue(_extends({}, value, {
        min: value
      }));
    },
    label: t('From'),
    placeholder: t('From'),
    onBlur: handleChange,
    inputClass: "rounded-r-none border-r-0"
  }), /*#__PURE__*/React.createElement(InputField, {
    value: value.max,
    onChange: function onChange(value) {
      return setValue(_extends({}, value, {
        max: value
      }));
    },
    label: t('To'),
    placeholder: t('To'),
    onBlur: handleChange,
    inputClass: "rounded-l-none"
  }), /*#__PURE__*/React.createElement("button", {
    className: "hidden",
    type: "submit"
  }));
};
var CO2Filter$1 = baseTypedFilter(FilterTypes.co2Range, CO2Filter);

var DoorsFilter = function DoorsFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var doorFilters = [[2, 3], [4, 5], [6, 7]];
  var doorsRangeValue = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var isSelected = function isSelected(range) {
    return doorsRangeValue ? includes(doorsRangeValue, range[0]) && includes(doorsRangeValue, range[1]) : false;
  };
  var handleFilterChanged = function handleFilterChanged(filter) {
    if (hasFilter()) {
      filterUpdate(filter);
    } else {
      filterAdd(filter);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onClick: function onClick() {
      return filterDeleteByType();
    },
    checked: !isSelected(doorFilters[0]) && !isSelected(doorFilters[1]) && !isSelected(doorFilters[2]),
    label: t('All')
  }), map(doorFilters, function (filter, i) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: filter[0] + "/" + filter[1] + "-" + i,
      onClick: function onClick() {
        return handleFilterChanged(filter);
      },
      checked: isSelected(filter),
      label: filter[0] + "/" + filter[1]
    });
  }));
};
var DoorsFilter$1 = baseTypedFilter(FilterTypes.doorsRange, DoorsFilter);

var EquipmentsFilter = function EquipmentsFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    withSearch: true,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var EquipmentsFilter$1 = baseTypedFilter(FilterTypes.equipments, EquipmentsFilter);

var EuroNormFilter = function EuroNormFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var EuroNormFilter$1 = baseTypedFilter(FilterTypes.euroNorm, EuroNormFilter);

var ExteriorFilter = function ExteriorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var ExteriorFilter$1 = baseTypedFilter(FilterTypes.exteriorColor, ExteriorFilter);

var FuelFilter = function FuelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var FuelFilter$1 = baseTypedFilter(FilterTypes.fuel, FuelFilter);

var IdentificationFilter = function IdentificationFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter;
  var _useState = useState(filterValues ? head(filterValues) : ''),
    identification = _useState[0],
    setIdentification = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (filterValues) {
      setIdentification(head(filterValues) ? head(filterValues) : '');
    }
  }, [filterValues]);
  var handleFilterChanged = function handleFilterChanged() {
    if (identification && identification !== '') {
      if (hasFilter()) {
        filterUpdate(identification);
      } else {
        filterAdd(identification);
      }
    } else {
      filterDeleteByType();
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    if (event.keyCode === 13) {
      handleFilterChanged();
    }
  };
  return /*#__PURE__*/React.createElement(InputField, {
    value: identification,
    onChange: setIdentification,
    label: t('Reference'),
    withIcon: true,
    icon: "far fa-search",
    placeholder: t('Reference'),
    onBlur: handleFilterChanged,
    onKeyDown: handleKeyPress
  });
};
var IdentificationFilter$1 = baseTypedFilter(FilterTypes.identification, IdentificationFilter);

var InteriorColorFilter = function InteriorColorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var InteriorColorFilter$1 = baseTypedFilter(FilterTypes.interiorColor, InteriorColorFilter);

var MakesFilter = function MakesFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var MakesFilter$1 = baseMakeFilterForMakeModel(MakesFilter);

var MileageFilter = function MileageFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    key: 5000,
    text: t('Up to') + " " + formatNumber(5000) + " " + t('km')
  }, {
    key: 10000,
    text: t('Up to') + " " + formatNumber(10000) + " " + t('km')
  }, {
    key: 25000,
    text: t('Up to') + " " + formatNumber(25000) + " " + t('km')
  }, {
    key: 50000,
    text: t('Up to') + " " + formatNumber(50000) + " " + t('km')
  }, {
    key: 100000,
    text: t('Up to') + " " + formatNumber(100000) + " " + t('km')
  }];
  var getValues = function getValues() {
    return map(filterValues, function (filterValue) {
      return last(filterValue);
    });
  };
  return /*#__PURE__*/React.createElement(GenericList, {
    items: options,
    orderByField: null,
    values: getValues(),
    handleFilterChanged: function handleFilterChanged(data) {
      var range = [0, data.value];
      if (hasFilter()) {
        if (isEqual(head(filterValues), range)) {
          filterDeleteByType();
        } else {
          filterUpdate(range);
        }
      } else {
        filterAdd(range);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  });
};
var MileageFilter$1 = baseTypedFilter(FilterTypes.mileage, MileageFilter);

var ModelsFilter = function ModelsFilter(_ref) {
  var filterData = _ref.filterData,
    makeFilterValues = _ref.makeFilterValues,
    modelFilterValues = _ref.modelFilterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  var makes = filterData.makes,
    models = filterData.models;
  var availableMakesForModels = makeFilterValues.length > 0 ? filter(makes, function (m) {
    return includes(makeFilterValues, m.key);
  }) : makes;
  var modelsPerMake = map(availableMakesForModels, function (make) {
    return models ? {
      make: make,
      options: map(filter(models, function (model) {
        return model.custom === make.key;
      }), function (model) {
        return {
          key: model.key,
          value: make.key + '|' + model.key,
          label: model.text
        };
      })
    } : {};
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModelsList, {
    items: modelsPerMake,
    values: modelFilterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var ModelsFilter$1 = baseModelFilterForMakeModel(ModelsFilter);

var PkFilter = function PkFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter;
  var _useState = useState(nth(head(filterValues), 0)),
    min = _useState[0],
    setMin = _useState[1];
  var _useState2 = useState(nth(head(filterValues), 1)),
    max = _useState2[0],
    setMax = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setMin(nth(head(filterValues), 0));
    setMax(nth(head(filterValues), 1));
  }, [filterValues]);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    handleFilter();
  };
  var handleFilter = function handleFilter() {
    var maxValue = min && parseInt(max) <= parseInt(min) ? undefined : max;
    var minValue = maxValue && parseInt(min) >= parseInt(maxValue) ? undefined : min;
    if (!minValue && !maxValue) {
      filterDeleteByType();
    } else {
      var range = [minValue, maxValue];
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
    }
    if (!minValue) setMin(undefined);
    if (!maxValue) setMax(undefined);
  };
  return /*#__PURE__*/React.createElement("form", {
    className: "flex",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(InputField, {
    value: min,
    onChange: function onChange(value) {
      return setMin(value);
    },
    label: t('Min'),
    placeholder: t('Min'),
    onBlur: handleFilter,
    inputClass: "rounded-r-none border-r-0"
  }), /*#__PURE__*/React.createElement(InputField, {
    value: max,
    onChange: function onChange(value) {
      return setMax(value);
    },
    label: t('Max'),
    placeholder: t('Max'),
    onBlur: handleFilter,
    inputClass: "rounded-l-none"
  }), /*#__PURE__*/React.createElement("button", {
    className: "hidden",
    type: "submit"
  }));
};
var PkFilter$1 = baseTypedFilter(FilterTypes.pk, PkFilter);

var KwFilter = function KwFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter;
  var _useState = useState(nth(head(filterValues), 0)),
    min = _useState[0],
    setMin = _useState[1];
  var _useState2 = useState(nth(head(filterValues), 1)),
    max = _useState2[0],
    setMax = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setMin(nth(head(filterValues), 0));
    setMax(nth(head(filterValues), 1));
  }, [filterValues]);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    handleFilter();
  };
  var handleFilter = function handleFilter() {
    var maxValue = min && parseInt(max) <= parseInt(min) ? undefined : max;
    var minValue = maxValue && parseInt(min) >= parseInt(maxValue) ? undefined : min;
    if (!minValue && !maxValue) {
      filterDeleteByType();
    } else {
      var range = [minValue, maxValue];
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
    }
    if (!minValue) setMin(undefined);
    if (!maxValue) setMax(undefined);
  };
  return /*#__PURE__*/React.createElement("form", {
    className: "flex",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(InputField, {
    value: min,
    onChange: function onChange(value) {
      return setMin(value);
    },
    label: t('Min'),
    placeholder: t('Min'),
    onBlur: handleFilter,
    inputClass: "rounded-r-none border-r-0"
  }), /*#__PURE__*/React.createElement(InputField, {
    value: max,
    onChange: function onChange(value) {
      return setMax(value);
    },
    label: t('Max'),
    placeholder: t('Max'),
    onBlur: handleFilter,
    inputClass: "rounded-l-none"
  }), /*#__PURE__*/React.createElement("button", {
    className: "hidden",
    type: "submit"
  }));
};
var KwFilter$1 = baseTypedFilter(FilterTypes.kw, KwFilter);

var labels$1 = {
  PK: 'PK',
  KW: 'KW'
};
var PowerFilter = function PowerFilter(_ref) {
  var context = _ref.context;
  var _useState = useState(labels$1.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isPKActive = activeOption === labels$1.PK;
  var isKWActive = activeOption === labels$1.KW;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-8 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-2 cursor-pointer",
    onClick: function onClick() {
      return setActiveOption(labels$1.PK);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 rounded-full border " + (isPKActive ? 'border-black bg-black' : 'border-gray-200 bg-white')
  }, isPKActive && /*#__PURE__*/React.createElement("div", {
    className: "w-2 h-2 rounded-full bg-white"
  })), /*#__PURE__*/React.createElement("div", null, t('PK'))), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-2 cursor-pointer",
    onClick: function onClick() {
      return setActiveOption(labels$1.KW);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 rounded-full border " + (isKWActive ? 'border-black bg-black' : 'border-gray-200 bg-white')
  }, isKWActive && /*#__PURE__*/React.createElement("div", {
    className: "w-2 h-2 rounded-full bg-white"
  })), /*#__PURE__*/React.createElement("div", null, t('KW')))), /*#__PURE__*/React.createElement(Fade, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex"
  }, activeOption === labels$1.PK && /*#__PURE__*/React.createElement(PkFilter$1, {
    context: context
  }), activeOption === labels$1.KW && /*#__PURE__*/React.createElement(KwFilter$1, {
    context: context
  })))));
};

var getPriceType = function getPriceType(clientSettings) {
  var isProfessional = clientSettings.isProfessional;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var priceType = FilterTypes.price;
  if (isProfessional && !isInclVat) priceType = FilterTypes.priceExcl;
  return priceType;
};
var getMonthlyPriceType = function getMonthlyPriceType(clientSettings) {
  var isProfessional = clientSettings.isProfessional;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var monthlyPriceType = FilterTypes.monthlyPrice;
  if (isProfessional) {
    if (!isInclVat) monthlyPriceType = FilterTypes.monthlyPriceProf;
    if (isInclVat) monthlyPriceType = FilterTypes.monthlyPriceProfIncl;
  }
  return monthlyPriceType;
};
var PriceFilter = function PriceFilter(_ref) {
  var _find;
  var filters = _ref.filters,
    filterData = _ref.filterData,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var priceMax = filterData ? filterData.dataSettings.priceMax : 0;
  var priceStep = filterData ? filterData.dataSettings.priceStep : 0;
  var monthlyMax = filterData ? filterData.dataSettings.monthlyMax : 0;
  var monthlyStep = filterData ? filterData.dataSettings.monthlyStep : 0;
  var filterTypesPrice = getPriceType(clientSettings);
  var filterTypesMonthlyPrice = getMonthlyPriceType(clientSettings);
  var priceAmount = hasFilter(filterTypesPrice) ? (_find = find(filters, function (filter) {
    return filter.type === filterTypesPrice;
  })) === null || _find === void 0 ? void 0 : _find.value[1] : priceMax;
  var monthlyAmount = hasFilter(filterTypesMonthlyPrice) ? find(filters, function (filter) {
    return filter.type === filterTypesMonthlyPrice;
  }) : monthlyMax;
  var _useState = useState(priceAmount),
    currentPrice = _useState[0],
    setCurrentPrice = _useState[1];
  var _useState2 = useState(monthlyAmount),
    currentMonthly = _useState2[0],
    setCurrentMonthly = _useState2[1];
  var _useState3 = useState(false),
    showMonthly = _useState3[0],
    setShowMonthly = _useState3[1];
  var handlePriceFilterChanged = function handlePriceFilterChanged(value) {
    if (value[1] === priceMax) {
      filterDeleteByType(filterTypesPrice);
    } else {
      if (hasFilter(filterTypesPrice)) {
        filterUpdate(filterTypesPrice, value);
      } else {
        filterAdd(filterTypesPrice, value);
      }
    }
  };
  var handleMonthlyFilterChanged = function handleMonthlyFilterChanged(value) {
    if (value[1] === monthlyMax) {
      filterDeleteByType(filterTypesMonthlyPrice);
    } else {
      if (hasFilter(filterTypesMonthlyPrice)) {
        filterUpdate(filterTypesMonthlyPrice, value);
      } else {
        filterAdd(filterTypesMonthlyPrice, value);
      }
    }
  };
  var renderTotalPriceSlider = function renderTotalPriceSlider() {
    return /*#__PURE__*/React.createElement("div", {
      className: "pr-2"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: 0,
      max: priceMax,
      step: priceStep,
      value: currentPrice,
      onChange: function onChange(value) {
        setCurrentPrice(value);
      },
      onAfterChange: function onAfterChange(value) {
        return handlePriceFilterChanged([0, value]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold mt-2"
    }, t('Max. amount'), /*#__PURE__*/React.createElement("div", {
      className: "ml-2"
    }, formatPrice(currentPrice), /*#__PURE__*/React.createElement("span", {
      className: "ml-0.5"
    }, currentPrice === priceMax ? '+' : ''))));
  };
  var renderMonthlySlider = function renderMonthlySlider() {
    return /*#__PURE__*/React.createElement("div", {
      className: "pr-2"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: 0,
      max: monthlyMax,
      step: monthlyStep,
      value: currentMonthly,
      onChange: function onChange(value) {
        setCurrentMonthly(value);
      },
      onAfterChange: function onAfterChange(value) {
        return handleMonthlyFilterChanged([0, value]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold mt-2"
    }, t('Max. amount'), /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, formatPrice(currentMonthly))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "inline-block mb-5 bg-secondary-five rounded-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer inline-block rounded-full py-3 px-5 " + (!showMonthly ? 'bg-secondary-three text-white' : 'bg-secondary-five text-primary'),
    onClick: function onClick() {
      setShowMonthly(false);
      filterDeleteByType(filterTypesMonthlyPrice);
    }
  }, t('Total price')), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer inline-block py-3 px-5 rounded-full " + (showMonthly ? 'bg-secondary-three  text-white' : 'bg-secondary-five text-primary'),
    onClick: function onClick() {
      setShowMonthly(true);
      handleMonthlyFilterChanged([0, undefined]);
    }
  }, t('Monthly price'))), showMonthly ? renderMonthlySlider() : renderTotalPriceSlider());
};
var PriceFilter$1 = baseFilter(PriceFilter);

var SortFilter = function SortFilter(_ref) {
  var sorters = _ref.sorters,
    sorter = _ref.sorter,
    sortChange = _ref.sortChange,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function () {
      return null;
    } : _useAnalytics$buttonC;
  var isSelected = function isSelected(value, direction) {
    return (sorter === null || sorter === void 0 ? void 0 : sorter.field) === value && (sorter === null || sorter === void 0 ? void 0 : sorter.direction) === direction;
  };
  var defaultButtonData = {
    analyticsButtonType: 'list',
    analyticsButtonName: 'sort',
    analyticsButtonCategory: 'interaction'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(sorters, function (option) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between py-5 cursor-pointer text-base text-primary hover:text-secondary-three transition",
      onClick: function onClick() {
        buttonClickEventAnalytics(_extends({}, defaultButtonData, {
          analyticsButtonText: option.field
        }));
        sortChange({
          value: option.field
        }, true);
      }
    }, /*#__PURE__*/React.createElement("div", null, option.label + ' (' + t('Ascending') + ')'), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center border border-secondary-three rounded-full w-6 h-6 bg-white"
    }, isSelected(option.field, 'asc') && /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4 rounded-full bg-primary"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between py-5 cursor-pointer text-base text-primary hover:text-secondary-three transition",
      onClick: function onClick() {
        buttonClickEventAnalytics(_extends({}, defaultButtonData, {
          analyticsButtonText: option.field
        }));
        sortChange({
          value: option.field
        }, false);
      }
    }, /*#__PURE__*/React.createElement("div", null, option.label + ' (' + t('Descending') + ')'), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center border border-secondary-three rounded-full w-6 h-6 bg-white"
    }, isSelected(option.field, 'desc') && /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4 rounded-full bg-primary"
    }))));
  }));
};
var SortFilter$1 = withSort(SortFilter);

var TransmissionFilter = function TransmissionFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  });
};
var TransmissionFilter$1 = baseTypedFilter(FilterTypes.transmission, TransmissionFilter);

var UpholsteryFilter = function UpholsteryFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var UpholsteryFilter$1 = baseTypedFilter(FilterTypes.interiorUpholstery, UpholsteryFilter);

var VatFilter = function VatFilter(_ref) {
  var filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isSelected = hasFilterWithValue(true);
  var handleFilterChanged = function handleFilterChanged() {
    if (hasFilterWithValue(true)) {
      filterDelete(true);
    } else {
      filterAdd(true);
    }
  };
  return /*#__PURE__*/React.createElement(Checkbox, {
    onClick: handleFilterChanged,
    checked: isSelected,
    label: t('VAT deductible')
  });
};
var VatFilter$1 = baseTypedFilter(FilterTypes.vat, VatFilter);

var YearFilter = function YearFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: filterValues && filterValues.length > 0 ? filterValues[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
    }
  }));
};
var YearFilter$1 = baseTypedFilter(FilterTypes.year, YearFilter);

var PrivateProfessionalFilter = function PrivateProfessionalFilter(_ref) {
  var context = _ref.context;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = clientSettings.isProfessional;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement(CustomerTypeSwitch$1, {
    context: context
  }), isProfessional && /*#__PURE__*/React.createElement(VatTypeFilter$1, {
    context: context
  }), isProfessional && /*#__PURE__*/React.createElement(VatFilter$1, {
    context: context
  }));
};

var LabelsFilter = function LabelsFilter(_ref) {
  var filterAdd = _ref.filterAdd,
    filterValues = _ref.filterValues,
    filterDelete = _ref.filterDelete,
    onFilterChange = _ref.onFilterChange,
    title = _ref.title,
    labels = _ref.labels,
    renderContent = _ref.renderContent;
  var handleFilterChanged = function handleFilterChanged(isChecked) {
    forEach(labels, function (label) {
      if (isChecked) {
        filterAdd(label);
      } else {
        filterDelete(label);
      }
    });
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var isLabelSelected = some(labels, function (label) {
    return includes(filterValues.map(function (value) {
      return value.toLowerCase();
    }), label.toLowerCase());
  });
  if (renderContent && typeof renderContent === 'function') {
    return renderContent(isLabelSelected, handleFilterChanged);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between cursor-pointer text-base text-primary hover:text-secondary-three transition",
    onClick: function onClick() {
      return handleFilterChanged(!isLabelSelected);
    }
  }, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border border-secondary-three rounded w-6 h-6 " + (isLabelSelected ? 'bg-black text-white' : 'bg-white text-primary')
  }, isLabelSelected && /*#__PURE__*/React.createElement("i", {
    className: "fas fa-check text-xs"
  })));
};
LabelsFilter.defaultProps = {
  labels: [],
  renderContent: undefined,
  title: '',
  text: ''
};
var LabelsFilter$1 = baseTypedFilter(FilterTypes.label, LabelsFilter);

var CampaignFilter = function CampaignFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "py-5 "
  }, /*#__PURE__*/React.createElement(LabelsFilter$1, {
    title: t('Autosalon 2024'),
    labels: ['autobeurs_24']
  })), /*#__PURE__*/React.createElement("div", {
    className: "py-5"
  }, /*#__PURE__*/React.createElement(LabelsFilter$1, {
    title: t('Autosalon 5000'),
    labels: ['autobeurs_5000']
  })));
};
var CampaignFilter$1 = baseTypedFilter(FilterTypes.label, CampaignFilter);

var ModelsPerMake = function ModelsPerMake(_ref) {
  var allFilters = _ref.allFilters,
    filterData = _ref.filterData,
    makeFilterValues = _ref.makeFilterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    selectedMake = _ref.selectedMake;
  var makes = filterData.makes,
    models = filterData.models;
  var availableMakes = makeFilterValues.length > 0 ? filter(makes, function (m) {
    return includes(makeFilterValues, m.key);
  }) : makes;
  var modelsPerMake = filter(models, function (model) {
    return find(availableMakes, function (make) {
      return make.key === model.custom;
    });
  });
  var options = map(filter(modelsPerMake, function (model) {
    return model.custom === (selectedMake === null || selectedMake === void 0 ? void 0 : selectedMake.value);
  }), function (model) {
    return {
      value: model === null || model === void 0 ? void 0 : model.key,
      label: model === null || model === void 0 ? void 0 : model.text,
      makeKey: model.custom
    };
  });
  var handleFilterChanged = function handleFilterChanged(data) {
    var makeKey = selectedMake.value;
    var modelKey = data.value;
    var value = makeKey + "|" + modelKey;
    if (hasFilterWithValue(value)) {
      filterDelete(value);
      if (filter(makeFilterValues, function (m) {
        return (m === null || m === void 0 ? void 0 : m.toLowerCase()) === (makeKey === null || makeKey === void 0 ? void 0 : makeKey.toLowerCase());
      }).length <= 1) {
        filterAdd(makeKey);
      }
    } else {
      filterAdd(value);
    }
  };
  var checkIfSelected = function checkIfSelected(makeModel) {
    var makeModelsFilter = filter(allFilters, function (f) {
      return f.type === FilterTypes.makeModel;
    });
    var isSelected = find(makeModelsFilter, function (item) {
      return item.value === makeModel;
    });
    return !!isSelected;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, map(options, function (option) {
    var isSelected = checkIfSelected(option.makeKey + "|" + option.value);
    return /*#__PURE__*/React.createElement(Checkbox, {
      label: option.label,
      checked: isSelected,
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    });
  }));
};
ModelsPerMake.defaultProps = {
  renderSubFilters: undefined
};
var ModelsPerMake$1 = baseModelFilterForMakeModel(ModelsPerMake);

var MakeModelFilter = function MakeModelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  return /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    renderSubFilters: function renderSubFilters(option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "pl-7 pt-4"
      }, /*#__PURE__*/React.createElement(ModelsPerMake$1, {
        selectedMake: option
      }));
    },
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  });
};
var MakeModelFilter$1 = baseMakeFilterForMakeModel(MakeModelFilter);

var SeatsFilter = function SeatsFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    filterDeleteByType = _ref.filterDeleteByType,
    onToggleMore = _ref.onToggleMore,
    moreOpen = _ref.moreOpen,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var items = [{
    key: '0-2',
    text: "2 " + t('seats')
  }, {
    key: '3-4',
    text: "4 " + t('seats')
  }, {
    key: '5-6',
    text: "5 " + t('seats')
  }, {
    key: '7-8',
    text: "7 " + t('seats')
  }, {
    key: '9-',
    text: "9 " + t('seats')
  }];
  var values = map(filterValues, function (filterValue) {
    var min = head(filterValue);
    var max = last(filterValue);
    return min + "-" + max;
  });
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    containerClass: "",
    onToggleMore: onToggleMore,
    moreOpen: moreOpen,
    handleFilterChanged: function handleFilterChanged(data) {
      var min = head(data.value.split('-'));
      var max = last(data.value.split('-'));
      var range = [min, max];
      if (hasFilter()) {
        if (isEqual(head(filterValues), range)) {
          filterDeleteByType();
        } else {
          filterUpdate(range);
        }
      } else {
        filterAdd(range);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  });
};
var SeatsFilter$1 = baseTypedFilter(FilterTypes.seatsRange, SeatsFilter);

var GenericListMultipleValuesPerKey = function GenericListMultipleValuesPerKey(_ref) {
  var items = _ref.items,
    _ref$primaryItems = _ref.primaryItems,
    primaryItems = _ref$primaryItems === void 0 ? [] : _ref$primaryItems,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    _ref$withSearch = _ref.withSearch,
    withSearch = _ref$withSearch === void 0 ? false : _ref$withSearch,
    primaryItemsLabel = _ref.primaryItemsLabel,
    otherItemsLabel = _ref.otherItemsLabel,
    _ref$maxVisibleOption = _ref.maxVisibleOptions,
    maxVisibleOptions = _ref$maxVisibleOption === void 0 ? 6 : _ref$maxVisibleOption;
  var _useState = useState(''),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var transformItems = function transformItems(inputItems) {
    return map(inputItems, function (item) {
      return {
        key: item.keys,
        text: item.text,
        additional: item.additional
      };
    });
  };
  var primaryOptions = searchTerm ? filter(primaryItems, function (item) {
    return includes(toLower(item.label), toLower(searchTerm));
  }) : primaryItems;
  var secondaryOptions = searchTerm ? filter(items, function (item) {
    return includes(toLower(item.label), toLower(searchTerm));
  }) : items;
  var handleCustomFilterChanged = function handleCustomFilterChanged(option) {
    handleFilterChanged({
      values: option.value,
      label: option.label,
      additional: option.additional
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, withSearch && /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(InputField, {
    value: searchTerm,
    withIcon: true,
    icon: "far fa-search",
    placeholder: t('Enter the search term'),
    onChange: function onChange(value) {
      return setSearchTerm(value);
    }
  })), primaryOptions.length > 0 && primaryItemsLabel && /*#__PURE__*/React.createElement("div", {
    className: "text-gray text-15 font-medium leading-23 mb-4"
  }, primaryItemsLabel), primaryOptions.length > 0 && /*#__PURE__*/React.createElement(GenericList, {
    items: transformItems(primaryOptions),
    values: values,
    handleFilterChanged: handleCustomFilterChanged,
    withSearch: false,
    maxOptions: maxVisibleOptions
  }), secondaryOptions.length > 0 && otherItemsLabel && /*#__PURE__*/React.createElement("div", {
    className: "text-gray text-15 font-medium leading-23 mb-4 mt-10"
  }, otherItemsLabel), /*#__PURE__*/React.createElement(GenericList, {
    items: transformItems(secondaryOptions),
    values: values,
    handleFilterChanged: handleCustomFilterChanged,
    withSearch: false,
    maxOptions: maxVisibleOptions
  }));
};

var DealershipGroupFilter = function DealershipGroupFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var mappedFilterData = filterData.reduce(function (pre, cur) {
    var curElement = pre.find(function (el) {
      return el.text == cur.text;
    });
    if (curElement) {
      curElement.keys.push(cur.key);
    } else {
      pre.push({
        text: cur.text,
        keys: [cur.key]
      });
    }
    return pre;
  }, []);
  var handleFilterChanged = function handleFilterChanged(data) {
    data.values.forEach(function (val) {
      if (hasFilterWithValue(val)) {
        filterDelete(val);
      } else {
        filterAdd(val);
      }
    });
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  return /*#__PURE__*/React.createElement(GenericListMultipleValuesPerKey, {
    items: orderBy(mappedFilterData, ['text']),
    values: filterValues,
    containerClass: "",
    handleFilterChanged: handleFilterChanged
  });
};
var DealershipGroupFilter$1 = baseTypedFilter(FilterTypes.dealershipGroup, DealershipGroupFilter);

var STEP = 10;
var MIN_DISTANCE = 10;
var MAX_DISTANCE = 300;
var CITIES_QUERY = "query ($countryAlpha2Code: String, $search: String) {\n  cities(countryAlpha2Code: $countryAlpha2Code, search: $search) {\n    id\n    name\n    postalCode\n  }\n}";
var DistanceFilter = function DistanceFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    context = _ref.context,
    onFilterChange = _ref.onFilterChange;
  var _useState = useState(null),
    selectedPostalCode = _useState[0],
    setSelectedPostalCode = _useState[1];
  var _useState2 = useState(MIN_DISTANCE),
    distance = _useState2[0],
    setDistance = _useState2[1];
  var _useState3 = useState(MIN_DISTANCE),
    tmpDistance = _useState3[0],
    setTmpDistance = _useState3[1];
  var _useState4 = useState(''),
    searchedTerm = _useState4[0],
    setSearchedTerm = _useState4[1];
  var _useState5 = useState(false),
    showDropDown = _useState5[0],
    setShowDropDown = _useState5[1];
  var _useState6 = useState(false),
    showSlider = _useState6[0],
    setShowSlider = _useState6[1];
  var _useQuery = useQuery(context),
    data = _useQuery.data,
    fetchData = _useQuery.fetchData,
    fetchingCities = _useQuery.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setShowSlider(filterValues && (filterValues === null || filterValues === void 0 ? void 0 : filterValues.length) > 0);
    if (filterValues && (filterValues === null || filterValues === void 0 ? void 0 : filterValues.length) === 0) {
      setSelectedPostalCode(null);
      setSearchedTerm('');
    }
  }, [filterValues]);
  var distances = range(MIN_DISTANCE, MAX_DISTANCE + STEP, STEP);
  var distanceMarks = {};
  forEach(distances, function (value) {
    var _Object$assign;
    return distanceMarks = Object.assign(distanceMarks, (_Object$assign = {}, _Object$assign[value] = '', _Object$assign));
  });
  var regex = /^[0-9]+$|^$/;
  var cleanInputValue = function cleanInputValue(value) {
    if (value === '') return '';
    return value.replaceAll('.', '').replaceAll('+', '');
  };
  var handleFilterChanged = function handleFilterChanged(postalCode, selectedDistance) {
    if (postalCode && postalCode !== '') {
      var cities = data === null || data === void 0 ? void 0 : data.cities;
      var matchedCity = find(cities, function (city) {
        return city.postalCode.toLowerCase() === postalCode.toLowerCase();
      });
      if (matchedCity) {
        if (hasFilter()) {
          filterUpdate(matchedCity.id + "|" + selectedDistance + "|" + matchedCity.postalCode + "|" + matchedCity.name);
        } else {
          filterAdd(matchedCity.id + "|" + selectedDistance + "|" + matchedCity.postalCode + "|" + matchedCity.name);
        }
        setSelectedPostalCode(matchedCity.postalCode);
      }
    } else {
      filterDeleteByType();
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    setShowDropDown(false);
  };
  var handleSearchTermChange = function handleSearchTermChange(value) {
    setShowDropDown(value !== '');
    var valueSplitted = head(value.split(' '));
    fetchData(CITIES_QUERY, {
      countryAlpha2Code: 'BE',
      search: valueSplitted
    });
    setSearchedTerm(value);
  };
  var getClosestNumber = function getClosestNumber(goal) {
    return distances.reduce(function (prev, curr) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  };
  var handleDistanceInputUpdate = function handleDistanceInputUpdate(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    var closestNumber = getClosestNumber(tmpDistance);
    setDistance(closestNumber);
    handleUpdateTmpDistance(closestNumber);
    handleFilterChanged(selectedPostalCode, closestNumber);
  };
  var handleUpdateTmpDistance = function handleUpdateTmpDistance(newTmpDistance) {
    setTmpDistance(newTmpDistance);
  };
  var renderMatchedCities = function renderMatchedCities() {
    var cities = data === null || data === void 0 ? void 0 : data.cities;
    var searchedTermSplitted = head(searchedTerm.split(' '));
    var matchedCities = filter(cities, function (city) {
      var _city$postalCode, _city$name;
      return (city === null || city === void 0 ? void 0 : (_city$postalCode = city.postalCode) === null || _city$postalCode === void 0 ? void 0 : _city$postalCode.toLowerCase().includes(searchedTermSplitted.toLowerCase())) || (city === null || city === void 0 ? void 0 : (_city$name = city.name) === null || _city$name === void 0 ? void 0 : _city$name.toLowerCase().includes(searchedTermSplitted.toLowerCase()));
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, matchedCities.length < 1 && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center w-full h-full text-gray"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-empty-set text-26 mb-1"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-13 w-full text-center"
    }, t('The given postal code could not be found.'))), matchedCities.length > 0 && map(matchedCities, function (c) {
      var value = c.postalCode + ' ' + c.name;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex text-15 w-full truncate cursor-pointer font-regular",
        onClick: function onClick() {
          setSearchedTerm(value);
          handleFilterChanged(c.postalCode, distance);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-10"
      }, c.postalCode), /*#__PURE__*/React.createElement("div", null, "- ", c.name));
    }));
  };
  var renderSkeleton = function renderSkeleton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-4 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-4 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-4 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-4 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-4 bg-gray-200 animate-pulse"
    }));
  };
  var renderDropdown = function renderDropdown() {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 bg-white rounded-4 border border-gray-lightest absolute top-full inset-x-0 h-40 overflow-y-scroll mt-2 transition-all duration-100 " + (showDropDown ? 'z-20 opacity-100' : '-z-1 opacity-0')
    }, fetchingCities && renderSkeleton(), !fetchingCities && renderMatchedCities());
  };
  var calculatePaddings = function calculatePaddings() {
    var pl = distance == MIN_DISTANCE ? 'pl-3' : 'pl-0';
    var pr = distance == MAX_DISTANCE ? 'pr-3' : 'pr-0';
    if (distance == MIN_DISTANCE + STEP) {
      pl = 'pl-px';
    }
    if (distance == MAX_DISTANCE - STEP) {
      pr = 'pr-px';
    }
    return pl + " " + pr;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    id: "hidden-distance",
    className: "inline-block absolute opacity-0 -z-1"
  }, tmpDistance), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full my-5 relative bg-white items-center rounded-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(InputField, {
    value: searchedTerm,
    onChange: handleSearchTermChange,
    label: t('Postal code'),
    withIcon: true,
    icon: "far fa-search",
    placeholder: t('Enter postcode')
  })), searchedTerm !== '' && renderDropdown()), showSlider && /*#__PURE__*/React.createElement("div", {
    className: "relative pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: calculatePaddings()
  }, /*#__PURE__*/React.createElement(Slider, {
    min: MIN_DISTANCE,
    max: MAX_DISTANCE,
    defaultValue: parseInt(distance),
    value: parseInt(distance),
    step: null,
    marks: distanceMarks,
    dotStyle: {
      display: 'none'
    },
    onChange: function onChange(newDistance) {
      setTmpDistance(newDistance);
      setDistance(newDistance);
    },
    onAfterChange: function onAfterChange() {
      if (searchedTerm) {
        var postalCode = head(searchedTerm.split(' '));
        handleFilterChanged(postalCode, distance);
      }
    }
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleDistanceInputUpdate,
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(InputField, {
    value: tmpDistance,
    type: "number",
    onBlur: function onBlur() {
      return handleDistanceInputUpdate();
    },
    label: t('Max.'),
    containerClass: "w-1/2",
    onChange: function onChange(value) {
      var cleanedInputValue = cleanInputValue(value);
      if (regex.test(cleanedInputValue)) {
        handleUpdateTmpDistance(cleanedInputValue <= 300 ? cleanedInputValue : 300);
      }
    }
  }))));
};
var DistanceFilter$1 = baseTypedFilter(FilterTypes.zipRadius, DistanceFilter);

var DisplayPrices = function DisplayPrices(_ref) {
  var initialRange = _ref.initialRange,
    ranges = _ref.ranges,
    currentRange = _ref.currentRange,
    onUpdate = _ref.onUpdate;
  var _useState = useState(initialRange.min),
    minValue = _useState[0],
    setMinValue = _useState[1];
  var _useState2 = useState(initialRange.max + "+"),
    maxValue = _useState2[0],
    setMaxValue = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setMinValue(formatNumber(currentRange === null || currentRange === void 0 ? void 0 : currentRange.min));
    setMaxValue(!(currentRange !== null && currentRange !== void 0 && currentRange.max) || (currentRange === null || currentRange === void 0 ? void 0 : currentRange.max) == initialRange.max ? formatNumber(initialRange.max) + "+" : formatNumber(currentRange === null || currentRange === void 0 ? void 0 : currentRange.max));
  }, [currentRange]);
  var handleFilterUpdate = function handleFilterUpdate(e) {
    e.preventDefault();
    var cleanedMinValue = cleanInputValue(minValue) !== '' ? parseInt$1(cleanInputValue(minValue)) : 0;
    var cleanedMaxValue = cleanInputValue(maxValue) !== '' ? parseInt$1(cleanInputValue(maxValue)) : 0;
    var min = cleanedMinValue < 0 ? 0 : cleanedMinValue;
    min = min > initialRange.max ? initialRange.max : min;
    min = min > cleanedMaxValue ? cleanedMaxValue : min;
    var max = cleanedMaxValue < 0 ? 0 : cleanedMaxValue;
    max = max > initialRange.max ? initialRange.max : max;
    max = max < min ? min : max;
    var minValueCurrentRange = find(ranges, function (item) {
      return item.min < min && min < item.max;
    });
    if (minValueCurrentRange) {
      min = Math.abs(minValueCurrentRange.max - min) < Math.abs(minValueCurrentRange.min - min) ? minValueCurrentRange.max : minValueCurrentRange.min;
    }
    var maxValueCurrentRange = find(ranges, function (item) {
      return item.min < min && min < item.max;
    });
    if (maxValueCurrentRange) {
      max = Math.abs(maxValueCurrentRange.max - min) < Math.abs(maxValueCurrentRange.min - min) ? maxValueCurrentRange.max : maxValueCurrentRange.min;
    }
    onUpdate(min, max);
  };
  var regex = /^[0-9]+$|^$/;
  var cleanInputValue = function cleanInputValue(value) {
    if (value === '') return '';
    return value.replaceAll('.', '').replaceAll('+', '');
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleFilterUpdate
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement(InputField, {
    value: minValue,
    onChange: function onChange(value) {
      var cleaned = cleanInputValue(value);
      if (regex.test(cleaned)) {
        setMinValue(value);
      }
    },
    type: "number",
    withIcon: true,
    icon: "fal fa-euro-sign text-xs",
    label: t('Min'),
    placeholder: t('Min'),
    onBlur: handleFilterUpdate,
    containerClass: "w-2/5"
  }), /*#__PURE__*/React.createElement(InputField, {
    value: maxValue,
    onChange: function onChange(value) {
      var cleaned = cleanInputValue(value);
      if (regex.test(cleaned)) {
        setMaxValue(value);
      }
    },
    type: "number",
    withIcon: true,
    icon: "fal fa-euro-sign text-xs",
    label: t('Max'),
    placeholder: t('Max'),
    onBlur: handleFilterUpdate,
    containerClass: "w-2/5"
  })), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "hidden"
  }));
};

var getCurrentRangeForSlider = function getCurrentRangeForSlider(type, prices, monthlyPrices) {
  if (type === priceTypes.PRICE) {
    return prices;
  } else if (type === priceTypes.MONTHLY_PRICE) {
    return monthlyPrices;
  }
};
var getValueRangeForSlider = function getValueRangeForSlider(type, values, defaultValues) {
  if (values[type]) {
    return {
      min: head(values[type]),
      max: last(values[type])
    };
  }
  if (defaultValues[type]) {
    return {
      min: head(defaultValues[type]),
      max: last(defaultValues[type])
    };
  }
  return undefined;
};
var getRanges = function getRanges(min, max, step) {
  var data = [];
  each(range(min, max, step), function (value) {
    data.push({
      min: value,
      max: value + step
    });
  });
  return data;
};
var getPriceType$1 = function getPriceType(clientSettings, activeTypeProp) {
  if (clientSettings.priceType) return clientSettings.priceType;
  if (activeTypeProp) return activeTypeProp;
  return priceTypes.PRICE;
};
var PriceRangeSlider = function PriceRangeSlider(_ref) {
  var values = _ref.values,
    defaultValues = _ref.defaultValues,
    prices = _ref.prices,
    monthlyPrices = _ref.monthlyPrices,
    onChange = _ref.onChange,
    activeType = _ref.activeType,
    onTypeChange = _ref.onTypeChange,
    onSlideChange = _ref.onSlideChange,
    context = _ref.context;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var _useState = useState(getPriceType$1(clientSettings, activeType)),
    type = _useState[0],
    setType = _useState[1];
  var currentRange = getCurrentRangeForSlider(type, prices, monthlyPrices);
  var _useState2 = useState(undefined),
    sliderDisplayPrice = _useState2[0],
    setSliderDisplayPrice = _useState2[1];
  var _useState3 = useState((sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min) + "-" + (sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max) + "-" + type),
    key = _useState3[0],
    setKey = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var setDisplayPrice = function setDisplayPrice() {
    var valueRange = getValueRangeForSlider(type, values, defaultValues);
    var priceRange = valueRange ? valueRange : currentRange;
    setSliderDisplayPrice({
      min: priceRange !== null && priceRange !== void 0 && priceRange.min ? priceRange === null || priceRange === void 0 ? void 0 : priceRange.min : 0,
      max: priceRange !== null && priceRange !== void 0 && priceRange.max ? priceRange === null || priceRange === void 0 ? void 0 : priceRange.max : currentRange === null || currentRange === void 0 ? void 0 : currentRange.max
    });
  };
  useEffect(function () {
    setDisplayPrice();
  }, [type, activeType, values]);
  useEffect(function () {
    setKey((sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min) + "-" + (sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max) + "-" + type);
  }, [type, activeType, values]);
  var handleChange = function handleChange(type, value) {
    var min = value[0];
    var max = value[1];
    var valueRange;
    if (min === currentRange.min && max === currentRange.max) {
      valueRange = undefined;
    } else {
      max = max === currentRange.max ? undefined : max;
      valueRange = [min, max];
    }
    var newValues = type === priceTypes.PRICE ? {
      monthly: undefined,
      price: valueRange
    } : {
      price: undefined,
      monthly: valueRange
    };
    onChange(newValues);
  };
  var handleTypeChange = function handleTypeChange(type) {
    setType(type);
    onTypeChange && typeof onTypeChange === 'function' && onTypeChange(type);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative font-normal w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-2 cursor-pointer",
    onClick: function onClick() {
      handleTypeChange(priceTypes.PRICE);
      setClientSetting('priceType', priceTypes.PRICE, true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 rounded-full border " + (type === priceTypes.PRICE ? 'border-black bg-black' : 'border-gray-200 bg-white')
  }, type === priceTypes.PRICE && /*#__PURE__*/React.createElement("div", {
    className: "w-2 h-2 rounded-full bg-white"
  })), /*#__PURE__*/React.createElement("div", null, t('Total price'))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-2 cursor-pointer",
    onClick: function onClick() {
      handleTypeChange(priceTypes.MONTHLY_PRICE);
      setClientSetting('priceType', priceTypes.MONTHLY_PRICE, true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-5 h-5 rounded-full border " + (type === priceTypes.MONTHLY_PRICE ? 'border-black bg-black' : 'border-gray-200 bg-white')
  }, type === priceTypes.MONTHLY_PRICE && /*#__PURE__*/React.createElement("div", {
    className: "w-2 h-2 rounded-full bg-white"
  })), /*#__PURE__*/React.createElement("div", null, t('Monthly price')))), /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement(Range, {
    key: key + "-" + sliderDisplayPrice,
    value: [sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min, sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max],
    defaultValue: [sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min, sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max],
    min: currentRange.min,
    max: currentRange.max,
    step: currentRange.step,
    allowCross: false,
    onAfterChange: function onAfterChange(value) {
      handleChange(type, [value[0], value[1]]);
    },
    onChange: function onChange(value) {
      setSliderDisplayPrice({
        min: value[0],
        max: value[1]
      });
      if (onSlideChange && typeof onSlideChange === 'function') {
        onSlideChange();
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(DisplayPrices, {
    currentRange: sliderDisplayPrice,
    initialRange: currentRange,
    ranges: getRanges(currentRange.min, currentRange.max, currentRange.step),
    onUpdate: function onUpdate(minValue, maxValue) {
      return handleChange(type, [minValue, maxValue]);
    }
  }))));
};
PriceRangeSlider.defaultProps = {
  loading: false,
  defaultValues: {
    price: undefined,
    monthly: undefined
  },
  label: undefined,
  activeType: priceTypes.PRICE,
  onTypeChange: undefined,
  onSlideChange: undefined
};

var getPriceType$2 = function getPriceType(clientSettings) {
  var priceType = FilterTypes.price;
  return priceType;
};
var getMonthlyPriceType$1 = function getMonthlyPriceType(clientSettings) {
  var monthlyPriceType = FilterTypes.monthlyPrice;
  return monthlyPriceType;
};
var PriceRangeFilter = function PriceRangeFilter(_ref) {
  var _filterData$prices;
  var filters = _ref.filters,
    filterData = _ref.filterData,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    context = _ref.context,
    onFilterChange = _ref.onFilterChange;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isInitialRef = useRef(true);
  var priceMax = filterData ? filterData.dataSettings.priceMax : 0;
  var priceStep = filterData ? filterData.dataSettings.priceStep : 0;
  var monthlyMax = filterData ? filterData.dataSettings.monthlyMax : 0;
  var monthlyStep = filterData ? filterData.dataSettings.monthlyStep : 0;
  var prices = {
    min: 0,
    max: priceMax,
    step: priceStep
  };
  var monthlyPrices = {
    min: 0,
    max: monthlyMax,
    step: monthlyStep
  };
  var averagePrice = filterData !== null && filterData !== void 0 && filterData.prices ? filterData === null || filterData === void 0 ? void 0 : (_filterData$prices = filterData.prices) === null || _filterData$prices === void 0 ? void 0 : _filterData$prices.avg : undefined;
  var priceType = getPriceType$2();
  var monthlyPriceType = getMonthlyPriceType$1();
  var handleChange = function handleChange(type, range) {
    var typeMax = type === priceType ? prices.max : type === monthlyPriceType ? monthlyPrices.max : 0;
    var typeMin = type === priceType ? prices.min : type === monthlyPriceType ? monthlyPrices.min : 0;
    var rangeIsMax = range[0] === typeMin && range[1] === typeMax;
    if (!rangeIsMax) {
      if (hasFilter(type)) {
        filterUpdate(type, range);
      } else {
        filterAdd(type, range);
      }
    } else {
      filterDeleteByType(type);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var priceFilter = find(filters, function (f) {
    return f.type === priceType;
  });
  var monthlyFilter = find(filters, function (f) {
    return f.type === monthlyPriceType;
  });
  useEffect(function () {
    if (isInitialRef.current) {
      if (!monthlyFilter && clientSettings.priceType === priceTypes.MONTHLY_PRICE) {
        handleChange(monthlyPriceType, [0, undefined]);
      }
      isInitialRef.current = false;
    }
  }, [isInitialRef]);
  return /*#__PURE__*/React.createElement(PriceRangeSlider, {
    prices: prices,
    monthlyPrices: monthlyPrices,
    averagePrice: averagePrice,
    context: context,
    onSlideChange: function onSlideChange() {
      if (isInitialRef.current) {
        isInitialRef.current = false;
      }
    },
    onTypeChange: function onTypeChange(selectedType) {
      if (selectedType === priceTypes.MONTHLY_PRICE) {
        filterDeleteByType(priceType);
      } else {
        filterDeleteByType(monthlyPriceType);
      }
    },
    values: {
      price: priceFilter ? priceFilter.value : undefined,
      monthly: monthlyFilter ? monthlyFilter.value : undefined
    },
    onChange: function onChange(values) {
      if (values.price) {
        handleChange(priceType, values.price);
      } else {
        filterDeleteByType(priceType);
      }
      if (values.monthly) {
        handleChange(monthlyPriceType, values.monthly);
      } else {
        filterDeleteByType(monthlyPriceType);
      }
    }
  });
};
var PriceRangeFilter$1 = baseFilter(PriceRangeFilter);

var Filters = function Filters(_ref) {
  var filters = _ref.filters,
    categories = _ref.categories,
    toggle_category = _ref.toggle_category,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getActiveFilters = function getActiveFilters(key) {
    if (key === 'make') {
      return filter(filters, function (filter) {
        var _filter$value;
        return filter.type === 'makeModel' && !((_filter$value = filter.value) !== null && _filter$value !== void 0 && _filter$value.includes('|'));
      });
    } else if (key === 'model') {
      return filter(filters, function (filter) {
        var _filter$value2;
        return filter.type === 'makeModel' && ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.includes('|'));
      });
    } else if (key === 'price') {
      return filter(filters, function (filter) {
        return filter.type === 'price' || filter.type === 'monthly_price';
      });
    } else {
      return filter(filters, function (filter) {
        return filter.type === key;
      });
    }
  };
  var renderCategoryContent = function renderCategoryContent(key) {
    switch (key) {
      case 'campaign':
        return /*#__PURE__*/React.createElement(CampaignFilter$1, {
          context: context
        });
      case 'sort':
        return /*#__PURE__*/React.createElement(SortFilter$1, {
          context: context
        });
      case 'privateProfessional':
        return /*#__PURE__*/React.createElement(PrivateProfessionalFilter, {
          context: context
        });
      case 'make':
        return /*#__PURE__*/React.createElement(MakesFilter$1, {
          context: context
        });
      case 'model':
        return /*#__PURE__*/React.createElement(ModelsFilter$1, {
          context: context
        });
      case 'body':
        return /*#__PURE__*/React.createElement(BodyFilter$1, {
          context: context
        });
      case 'category':
        return /*#__PURE__*/React.createElement(CategoryFilter$1, {
          context: context
        });
      case 'co2Range':
        return /*#__PURE__*/React.createElement(CO2Filter$1, {
          context: context
        });
      case 'doorsRange':
        return /*#__PURE__*/React.createElement(DoorsFilter$1, {
          context: context
        });
      case 'equipments':
        return /*#__PURE__*/React.createElement(EquipmentsFilter$1, {
          context: context
        });
      case 'euroNorm':
        return /*#__PURE__*/React.createElement(EuroNormFilter$1, {
          context: context
        });
      case 'exteriorColor':
        return /*#__PURE__*/React.createElement(ExteriorFilter$1, {
          context: context
        });
      case 'fuel':
        return /*#__PURE__*/React.createElement(FuelFilter$1, {
          context: context
        });
      case 'identification':
        return /*#__PURE__*/React.createElement(IdentificationFilter$1, {
          context: context
        });
      case 'interiorColor':
        return /*#__PURE__*/React.createElement(InteriorColorFilter$1, {
          context: context
        });
      case 'mileage':
        return /*#__PURE__*/React.createElement(MileageFilter$1, {
          context: context
        });
      case 'price':
        return /*#__PURE__*/React.createElement(PriceFilter$1, {
          context: context
        });
      case 'priceRange':
        return /*#__PURE__*/React.createElement(PriceRangeFilter$1, {
          context: context
        });
      case 'power':
        return /*#__PURE__*/React.createElement(PowerFilter, {
          context: context
        });
      case 'transmission':
        return /*#__PURE__*/React.createElement(TransmissionFilter$1, {
          context: context
        });
      case 'interiorUpholstery':
        return /*#__PURE__*/React.createElement(UpholsteryFilter$1, {
          context: context
        });
      case 'vat':
        return /*#__PURE__*/React.createElement(VatFilter$1, {
          context: context
        });
      case 'year':
        return /*#__PURE__*/React.createElement(YearFilter$1, {
          context: context
        });
      case 'makeModel':
        return /*#__PURE__*/React.createElement(MakeModelFilter$1, {
          context: context
        });
      case 'seatsRange':
        return /*#__PURE__*/React.createElement(SeatsFilter$1, {
          context: context
        });
      case 'dealershipGroup':
        return /*#__PURE__*/React.createElement(DealershipGroupFilter$1, {
          context: context
        });
      case 'location':
        return /*#__PURE__*/React.createElement(DistanceFilter$1, {
          context: context
        });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "filters-scroll",
    className: "no-scrollbar relative w-full overflow-y-scroll px-10 lg2:px-0 pb-5"
  }, map(orderBy(categories, ['level']), function (category) {
    var _getActiveFilters;
    var hasActiveFilter = ((_getActiveFilters = getActiveFilters(category.key)) === null || _getActiveFilters === void 0 ? void 0 : _getActiveFilters.length) > 0;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-category-" + (category === null || category === void 0 ? void 0 : category.key),
      className: "" + (category.withHeader ? 'pb-4 mb-4 border-b border-gray-200' : 'lg2:pb-4 lg2:mb-4 lg2:border-b lg2:border-gray-200')
    }, category.withHeader && /*#__PURE__*/React.createElement("div", {
      id: category === null || category === void 0 ? void 0 : category.key,
      className: "flex items-center justify-between cursor-pointer " + (category.active ? 'mb-4' : 'mb-0'),
      onClick: function onClick() {
        return toggle_category(category);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-base font-bold"
    }, category.translation(t)), hasActiveFilter && /*#__PURE__*/React.createElement("div", {
      className: (category.active ? 'hidden' : 'block') + " w-full text-16 text-secondary-three truncate"
    }, map(getActiveFilters(category.key), function (filter, index) {
      if (index === getActiveFilters(category.key).length - 1) {
        return filter.label;
      } else {
        return filter.label + ', ';
      }
    }))), /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-down transform transition-transform duration-300 ease-in-out " + (category.active ? 'rotate-180' : 'rotate-0 ')
    })), (category === null || category === void 0 ? void 0 : category.active) && /*#__PURE__*/React.createElement("div", null, renderCategoryContent(category.key)));
  })));
};
var Filters$1 = withFilters(Filters);

var SlideAnimationWrapper = function SlideAnimationWrapper(props) {
  return props.children;
};
var FadeAnimationWrapper = function FadeAnimationWrapper(props) {
  if (!props.animation) return props.children;
  return /*#__PURE__*/React.createElement(Fade, {
    when: props.render_sidebar,
    duration: props.duration
  }, props.children);
};
var FiltersSidebar = function FiltersSidebar(_ref) {
  var render_sidebar = _ref.render_sidebar,
    close_sidebar = _ref.close_sidebar,
    filtersClear = _ref.filtersClear,
    totalCountByFilters = _ref.totalCountByFilters,
    categories = _ref.categories,
    toggle_category = _ref.toggle_category,
    animation = _ref.animation,
    context = _ref.context,
    renderContent = _ref.renderContent;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (!hasDocument) return;
    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];
    if (render_sidebar) {
      if (html) html.classList.add('overflow-hidden');
      if (body) body.classList.add('overflow-y-scroll');
    }
    if (!render_sidebar) {
      if (html && html.classList.contains('overflow-hidden')) {
        html.classList.remove('overflow-hidden');
      }
      if (body && body.classList.contains('overflow-y-scroll')) body.classList.remove('overflow-y-scroll');
    }
  }, [render_sidebar]);
  var renderBackground = function renderBackground() {
    return /*#__PURE__*/React.createElement(FadeAnimationWrapper, {
      render_sidebar: render_sidebar,
      animation: animation,
      duration: 300
    }, /*#__PURE__*/React.createElement("div", {
      className: (!render_sidebar && 'hidden') + " fixed h-full w-full top-0 left-0 bottom-0 right-0",
      onClick: close_sidebar,
      style: {
        backgroundColor: 'rgba(0,0,0,0.25)',
        zIndex: 7998
      }
    }));
  };
  var renderSideBar = function renderSideBar() {
    return /*#__PURE__*/React.createElement(SlideAnimationWrapper, {
      render_sidebar: render_sidebar,
      animation: animation,
      duration: 300
    }, /*#__PURE__*/React.createElement("div", {
      id: "filters-sidebar",
      className: "hidden fixed h-full w-full md:w-480px top-0 right-0 bg-white px-6",
      style: {
        zIndex: 7999
      }
    }, renderContent && typeof renderContent === 'function' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "self-end pt-5 pb-5",
      onClick: close_sidebar
    }, /*#__PURE__*/React.createElement(IconWithHover, {
      iconClass: 'far fa-times',
      hoverBackgroundClass: 'bg-secondary-five'
    }))), renderContent()) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "self-end pt-5 pb-5",
      onClick: close_sidebar
    }, /*#__PURE__*/React.createElement(IconWithHover, {
      iconClass: 'far fa-times',
      hoverBackgroundClass: 'bg-secondary-five'
    })), /*#__PURE__*/React.createElement(Filters$1, {
      categories: categories,
      toggle_category: toggle_category,
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-px pb-20"
    })), /*#__PURE__*/React.createElement("div", {
      className: "fixed w-full md:w-480px bottom-0 right-0 border-t border-secondary-four bg-white z-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex px-10 py-5"
    }, /*#__PURE__*/React.createElement("button", {
      className: "flex-1 px-5 py-2 rounded bg-white text-primary border border-secondary-four mr-4 hover:bg-secondary-five transition",
      onClick: function onClick() {
        filtersClear();
        close_sidebar();
      }
    }, t('Clear all filters')), /*#__PURE__*/React.createElement("button", {
      className: "flex-1 px-5 py-2 rounded bg-secondary-two text-white hover:bg-secondary-three transition",
      onClick: close_sidebar
    }, totalCountByFilters + ' ' + t('weergeven')))))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderBackground(), renderSideBar());
};
FiltersSidebar.defaultProps = {
  animation: true
};
var FiltersSideBar = withFilters(FiltersSidebar);

var FiltersHeaderBar = function FiltersHeaderBar(_ref) {
  var totalCountByFilters = _ref.totalCountByFilters,
    open_sidebar = _ref.open_sidebar,
    categories = _ref.categories;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderText = function renderText() {
    if (!totalCountByFilters) {
      return /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse",
        style: {
          height: 26,
          width: 300
        }
      });
    }
    return /*#__PURE__*/React.createElement("span", null, t('Ours'), " ", /*#__PURE__*/React.createElement("span", {
      className: "font-bold px-0.5"
    }, totalCountByFilters), " ", t('secondhand vehicles can be yours'));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center flex-nowrap justify-between mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium flex-initial mr-5 text-lg text-black"
  }, renderText()), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-none text-xs rounded py-2 px-3 cursor-pointer bg-white border border-secondary-four hover:bg-secondary-four transition",
    onClick: function onClick() {
      open_sidebar(categories.sort);
    }
  }, t('Sort by'), " ", /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-down ml-2"
  })));
};
var FiltersHeaderBar$1 = withFilters(FiltersHeaderBar);

var FiltersLeftSidebar = function FiltersLeftSidebar(_ref) {
  var categories = _ref.categories,
    toggle_category = _ref.toggle_category,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Filters$1, {
    categories: categories,
    toggle_category: toggle_category,
    context: context
  }));
};
var FiltersLeftSidebar$1 = withFilters(FiltersLeftSidebar);

var VehiclesOverview = function VehiclesOverview(_ref) {
  var _merge;
  var batchSize = _ref.batchSize,
    customCardsByBatch = _ref.customCardsByBatch,
    filtersUrl = _ref.filtersUrl,
    loading = _ref.loading,
    context = _ref.context;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var _useState = useState(null),
    visibleCategoryKey = _useState[0],
    setVisibleCategoryKey = _useState[1];
  var _useState2 = useState(false),
    renderFiltersSidebar = _useState2[0],
    setRenderFiltersSidebar = _useState2[1];
  var _useState3 = useState(true),
    filterSideBarAnimation = _useState3[0],
    setFilterSideBarAnimation = _useState3[1];
  var _useState4 = useState(3),
    gridSize = _useState4[0],
    setGridSize = _useState4[1];
  var _useState5 = useState('top'),
    titlePosition = _useState5[0],
    setTitlePosition = _useState5[1];
  var _useState6 = useState({
      sort: {
        key: 'sort',
        translation: function translation(t) {
          return t('Sort');
        },
        level: 1,
        active: true,
        withHeader: true
      },
      privateProfessional: {
        key: 'privateProfessional',
        translation: function translation(t) {
          return t('Private / professional');
        },
        level: 2,
        active: true,
        withHeader: false
      },
      priceRange: {
        key: 'priceRange',
        translation: function translation(t) {
          return t('Price');
        },
        level: 3,
        active: true,
        withHeader: true
      },
      fuel: {
        key: 'fuel',
        translation: function translation(t) {
          return t('Fuel type');
        },
        level: 4,
        active: true,
        withHeader: true
      },
      makeModel: {
        key: 'makeModel',
        translation: function translation(t) {
          return t('Make and model');
        },
        level: 5,
        active: true,
        withHeader: true
      },
      mileage: {
        key: 'mileage',
        translation: function translation(t) {
          return t('Mileage');
        },
        level: 6,
        active: true,
        withHeader: true
      },
      year: {
        key: 'year',
        translation: function translation(t) {
          return t('First registration');
        },
        level: 7,
        active: true,
        withHeader: true
      },
      transmission: {
        key: 'transmission',
        translation: function translation(t) {
          return t('Transmission');
        },
        level: 8,
        active: true,
        withHeader: true
      },
      body: {
        key: 'body',
        translation: function translation(t) {
          return t('Body type');
        },
        level: 9,
        active: true,
        withHeader: true
      },
      category: {
        key: 'category',
        translation: function translation(t) {
          return t('Vehicle condition');
        },
        level: 10,
        active: true,
        withHeader: true
      },
      equipments: {
        key: 'equipments',
        translation: function translation(t) {
          return t('Features');
        },
        level: 11,
        active: true,
        withHeader: true
      },
      euroNorm: {
        key: 'euroNorm',
        translation: function translation(t) {
          return t('Emission Class');
        },
        level: 12,
        active: true,
        withHeader: true
      },
      co2Range: {
        key: 'co2Range',
        translation: function translation(t) {
          return t('CO2 emissions (g/km)');
        },
        level: 13,
        active: true,
        withHeader: true
      },
      power: {
        key: 'power',
        translation: function translation(t) {
          return t('Power');
        },
        level: 14,
        active: true,
        withHeader: true
      },
      exteriorColor: {
        key: 'exteriorColor',
        translation: function translation(t) {
          return t('Exterior');
        },
        level: 15,
        active: true,
        withHeader: true
      },
      interiorColor: {
        key: 'interiorColor',
        translation: function translation(t) {
          return t('Interior color');
        },
        level: 16,
        active: true,
        withHeader: true
      },
      interiorUpholstery: {
        key: 'interiorUpholstery',
        translation: function translation(t) {
          return t('Upholstery');
        },
        level: 17,
        active: true,
        withHeader: true
      },
      seatsRange: {
        key: 'seatsRange',
        translation: function translation(t) {
          return t('Seats');
        },
        level: 18,
        active: true,
        withHeader: true
      },
      doorsRange: {
        key: 'doorsRange',
        translation: function translation(t) {
          return t('Nr. of doors');
        },
        level: 19,
        active: true,
        withHeader: true
      },
      dealershipGroup: {
        key: 'dealershipGroup',
        translation: function translation(t) {
          return t('Dealers');
        },
        level: 20,
        active: true,
        withHeader: true
      },
      location: {
        key: 'location',
        translation: function translation(t) {
          return t('Location');
        },
        level: 20,
        active: true,
        withHeader: true
      },
      identification: {
        key: 'identification',
        translation: function translation(t) {
          return t('Offer detail');
        },
        level: 21,
        active: true,
        withHeader: true
      }
    }),
    categories = _useState6[0],
    setCategories = _useState6[1];
  useEffect(function () {
    if (clientSettings.VehicleFiltersSideBarVisible) {
      setFilterSideBarAnimation(false);
      handleSidebarOpen(clientSettings.VehicleFiltersSideBarCategory);
    }
  }, []);
  useEffect(function () {
    setTitlePosition('bottom');
  }, [filtersUrl]);
  var scrollToCategory = function scrollToCategory(category) {
    if (!hasDocument) return;
    var container = document.getElementById('filters-scroll');
    var filter = document.getElementById(category === null || category === void 0 ? void 0 : category.key);
    if (container && filter) {
      container.scrollTop = filter.offsetTop;
    } else if (container) {
      container.scrollTop = 0;
    }
  };
  var setSidebarHidden = function setSidebarHidden(hidden) {
    if (!hasDocument) return;
    var sidebar = document.getElementById('filters-sidebar');
    if (sidebar && !hidden) {
      if (sidebar && sidebar.classList.contains('hidden')) sidebar.classList.remove('hidden');
    } else {
      sidebar.classList.add('hidden');
    }
  };
  var handleSidebarOpen = function handleSidebarOpen(category, onlyOneCategoryActive) {
    if (onlyOneCategoryActive === void 0) {
      onlyOneCategoryActive = true;
    }
    setSidebarHidden(false);
    if (onlyOneCategoryActive) {
      setCategories(setOnlyCategoryActive(category));
    }
    scrollToCategory(category);
    setRenderFiltersSidebar(true);
    setClientSetting('VehicleFiltersSideBarVisible', true);
    setClientSetting('VehicleFiltersSideBarCategory', category);
  };
  var handleSidebarClose = function handleSidebarClose(onlyOneCategoryActive) {
    if (onlyOneCategoryActive === void 0) {
      onlyOneCategoryActive = true;
    }
    setRenderFiltersSidebar(false);
    if (onlyOneCategoryActive) {
      setCategories(setOnlyCategoryActive(null));
    }
    scrollToCategory(null);
    setSidebarHidden(true);
    setFilterSideBarAnimation(true);
    setClientSetting('VehicleFiltersSideBarVisible', false);
    setClientSetting('VehicleFiltersSideBarCategory', null);
  };
  var handleCategoryToggle = function handleCategoryToggle(category) {
    var _extends2;
    setCategories(_extends({}, categories, (_extends2 = {}, _extends2[category.key] = _extends({}, category, {
      active: !category.active
    }), _extends2)));
    setClientSetting('VehicleFiltersSideBarCategory', category);
  };
  var setOnlyCategoryActive = function setOnlyCategoryActive(category) {
    var inactiveCategories = {};
    for (var _i = 0, _Object$entries = Object.entries(categories); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (key === (category === null || category === void 0 ? void 0 : category.key)) {
        inactiveCategories[key] = _extends({}, value, {
          active: true
        });
      } else {
        inactiveCategories[key] = _extends({}, value, {
          active: false
        });
      }
    }
    return inactiveCategories;
  };
  var renderPageText = function renderPageText() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full md:w-1/2 leading-24",
      style: {
        minHeight: 30
      }
    }, context.data && context.data.pageText && /*#__PURE__*/React.createElement(MarkupText, {
      text: JSON.parse(context.data.pageText),
      context: context
    })));
  };
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full h-screen justify-center items-center"
    }, /*#__PURE__*/React.createElement(LoadingIndicator, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block lg2:hidden"
  }, /*#__PURE__*/React.createElement(BreadcrumbsBar$2, {
    gridSize: gridSize,
    handleSizingChange: function handleSizingChange(newSize) {
      setGridSize(newSize);
    },
    context: context
  })), titlePosition === 'top' && /*#__PURE__*/React.createElement("div", {
    className: "my-7"
  }, renderPageText()), /*#__PURE__*/React.createElement("div", {
    className: "block lg2:hidden w-full " + (titlePosition === 'bottom' ? 'mt-7' : 'mt-0')
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px border-b border-secondary-four"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block lg2:hidden"
  }, /*#__PURE__*/React.createElement(FiltersBar$1, {
    open_sidebar: handleSidebarOpen,
    categories: categories,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:block bg-white border-r border-gray-200 p-6 overflow-x-hidden",
    style: {
      width: 340,
      minWidth: 340
    }
  }, /*#__PURE__*/React.createElement(FiltersLeftSidebar$1, {
    categories: omit(categories, ['sort']),
    toggle_category: handleCategoryToggle,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full p-0 lg2:p-6 bg-transparent bg-secondary-five"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:block"
  }, /*#__PURE__*/React.createElement(BreadcrumbsBar$2, {
    gridSize: gridSize,
    handleSizingChange: function handleSizingChange(newSize) {
      setGridSize(newSize);
    },
    context: context,
    showGridSlider: false
  }), /*#__PURE__*/React.createElement(FiltersHeaderBar$1, {
    open_sidebar: function open_sidebar(category) {
      setVisibleCategoryKey(category.key);
      handleSidebarOpen(category, false);
    },
    categories: categories,
    context: context
  })), /*#__PURE__*/React.createElement(FilterBadgesBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(VehiclesList$1, {
    customCardsByBatch: customCardsByBatch,
    batchSize: batchSize,
    gridSize: gridSize,
    context: context
  }), /*#__PURE__*/React.createElement(FiltersSideBar, {
    categories: visibleCategoryKey ? merge(pick(categories, [visibleCategoryKey]), (_merge = {}, _merge[visibleCategoryKey] = {
      active: true
    }, _merge)) : categories,
    toggle_category: handleCategoryToggle,
    render_sidebar: renderFiltersSidebar,
    close_sidebar: function close_sidebar() {
      return handleSidebarClose(!visibleCategoryKey);
    },
    animation: filterSideBarAnimation,
    context: context
  }))), titlePosition === 'bottom' && /*#__PURE__*/React.createElement("div", {
    className: "mt-7 mb-7"
  }, renderPageText()));
};
var VehiclesOverview$1 = baseVehiclesAndFilters(VehiclesOverview);

var VehicleListWithAdds = function VehicleListWithAdds(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    advertise_list_images = _ref.advertise_list_images,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "px-6 lg2:px-0 mt-1 lg2:mt-0 with-financing"
  }, /*#__PURE__*/React.createElement(VehiclesOverview$1, {
    advertise_top_images: advertise_top_images,
    advertise_list_images: advertise_list_images,
    context: context
  }));
};
VehicleListWithAdds.defaultProps = {
  advertise_top_images: [],
  advertise_list_images: []
};
VehicleListWithAdds.human = {
  nl: "Auto's",
  fr: 'Vehicules',
  en: 'Vehicles'
};

var ReservationStep = function ReservationStep(_ref) {
  var index = _ref.index,
    step = _ref.step,
    title = _ref.title,
    content = _ref.content,
    completedContent = _ref.completedContent;
  var STEP_IDLE = 0;
  var STEP_ACTIVE = 1;
  var STEP_COMPLETED = 2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(STEP_IDLE),
    stepState = _useState[0],
    setStepState = _useState[1];
  useEffect(function () {
    calculateStepState();
  }, [step]);
  var calculateStepState = function calculateStepState() {
    if (index === step) {
      return setStepState(STEP_ACTIVE);
    }
    if (index < step) {
      return setStepState(STEP_COMPLETED);
    }
    return setStepState(STEP_IDLE);
  };
  var styles = {
    idle: {
      container: 'bg-secondary-four',
      step: 'bg-secondary-four text-primary',
      title: 'text-primary'
    },
    active: {
      container: 'bg-secondary',
      step: 'bg-secondary',
      title: 'text-white md:text-primary'
    },
    completed: {
      container: 'bg-secondary-two',
      step: 'bg-secondary-two',
      title: 'text-white md:text-primary'
    }
  };
  var getStepStyle = function getStepStyle() {
    if (stepState === STEP_ACTIVE) {
      return styles.active;
    }
    if (stepState === STEP_COMPLETED) {
      return styles.completed;
    }
    return styles.idle;
  };
  var renderStepHeader = function renderStepHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full py-2 md:py-0 items-center md:bg-transparent rounded text-white text-base md:text-xl " + getStepStyle().container
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center ml-5 md:ml-0 mr-5 md:rounded-full md:h-10 md:w-10 md:border-primary md:mr-8 text-base font-bold md:font-normal " + getStepStyle().step
    }, stepState === STEP_COMPLETED ? /*#__PURE__*/React.createElement("i", {
      className: "fal fa-check"
    }) : index), /*#__PURE__*/React.createElement("div", {
      className: "truncate text-white font-bold " + getStepStyle().title
    }, t(title)));
  };
  var renderStepContent = function renderStepContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "md:border-l md:border-secondary-eight md:ml-5 md:pl-5 mt-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "md:ml-8"
    }, content));
  };
  var renderStepComplete = function renderStepComplete() {
    return /*#__PURE__*/React.createElement("div", {
      className: "md:ml-5 md:pl-5 mt-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "md:ml-8"
    }, completedContent));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, renderStepHeader(), stepState === STEP_ACTIVE && renderStepContent(), stepState === STEP_COMPLETED && renderStepComplete());
};

var _initialFormData$5;
var FormFields$5 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  mailings: 'mailings',
  tradeVehicle: 'tradeVehicle'
};
var initialFormData$5 = (_initialFormData$5 = {}, _initialFormData$5[FormFields$5.firstName] = '', _initialFormData$5[FormFields$5.lastName] = '', _initialFormData$5[FormFields$5.email] = '', _initialFormData$5[FormFields$5.phone] = '', _initialFormData$5[FormFields$5.mailings] = false, _initialFormData$5[FormFields$5.tradeVehicle] = false, _initialFormData$5);
var validator$5 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$5.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$5.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$5.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$5.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$5.phone] = t('Phone is required.');
  } else if (!isPhoneValid(data.phone)) {
    errors[FormFields$5.phone] = t('Phone number not valid.');
  }
  return errors;
};
var UserForm = function UserForm(_ref) {
  var data = _ref.data,
    setFormValue = _ref.setFormValue,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 relative h-full justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default mb-8"
  }, t('Tell us a little bit more about yourself. We need this information to be able to put the car aside for you.')), submitError && /*#__PURE__*/React.createElement("div", {
    className: "-mt-3 mb-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), error && /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: error
  })), /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "flex flex-col mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-6 text-16"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 mr-0 md:mr-4 mb-6 md:mb-0 font-primary",
    inputClass: "rounded-4",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$5.firstName, value);
    },
    errorText: validationErrors[FormFields$5.firstName]
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 font-primary",
    inputClass: "rounded-4",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$5.lastName, value);
    },
    errorText: validationErrors[FormFields$5.lastName]
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-6 text-16"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 mr-0 md:mr-4 mb-6 md:mb-0 font-primary",
    inputClass: "rounded-4",
    type: "email",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$5.email, value);
    },
    errorText: validationErrors[FormFields$5.email]
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 font-primary",
    inputClass: "rounded-4",
    label: t('Phone'),
    placeholder: "0486 32 12 45",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$5.phone, value);
    },
    errorText: validationErrors[FormFields$5.phone]
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2 flex items-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: data.tradeVehicle !== undefined ? data.tradeVehicle : false,
    classNames: "mr-0",
    onClick: function onClick(value) {
      return setFormValue(FormFields$5.tradeVehicle, value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-small mr-1 ml-2 "
  }, t('I have a car that I may wish to exchange.'))), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-small",
    style: {
      marginLeft: 32
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-1"
  }, t('We take over all cars.'), " ", t('The acquisition amount will be deducted'), "."))), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full px-0"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button button-secondary"
  }, submitting ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    extraSmall: true,
    color: "white"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Next')))))));
};
var UserForm$1 = baseReservationWizardUserForm(initialFormData$5, validator$5, UserForm);

var ReservationUserInformation = function ReservationUserInformation(props) {
  var reservation = props.reservation,
    step = props.step,
    reservationLoading = props.reservationLoading,
    reservationError = props.reservationError,
    onNext = props.onNext;
  if (reservationLoading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement(Fade, {
    spy: step,
    duration: 10
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col-reverse md:flex-row px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full mr-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement(UserForm$1, {
    data: reservation.data,
    onSubmit: onNext,
    submitting: reservationLoading,
    error: reservationError
  })))))));
};

var ReservationUserInformationConfirmed = function ReservationUserInformationConfirmed(props) {
  var reservation = props.reservation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-three flex mb-2 items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-user-tag text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.firstName, " ", reservation.data.lastName)), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-three flex items-center mb-2 "
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-envelope text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.email)), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-three flex items-center mb-2 "
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-phone text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.phone)));
};

var ReservationPayment = function ReservationPayment(props) {
  var settings = props.settings,
    loading = props.loading,
    onNext = props.onNext,
    reservation = props.reservation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, null);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold mb-6"
  }, t('This car is almost yours!')), /*#__PURE__*/React.createElement("div", null, t('Dont worry, we will put this car aside for you immediately after payment.'), /*#__PURE__*/React.createElement("sup", null, "1,2")), /*#__PURE__*/React.createElement("div", null, t('You can Pick up the car within'), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, ' ', settings.days, " ", t('reservation days'))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-start md:items-center justify-between bg-secondary-five rounded mt-8 p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline"
  }, t('Reservation cost'), " "), /*#__PURE__*/React.createElement("span", {
    className: "inline"
  }, "\u20AC ", settings.deposit, " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-12"
  }, "(", t('incl. 21% VAT'), ")")), settings.paymentLogos && settings.paymentLogos.length > 0 && settings.paymentLogos.some(function (pl) {
    return pl !== '';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap -ml-1"
  }, settings.paymentLogos.filter(function (pl) {
    return pl !== '';
  }).map(function (paymentLogo, i) {
    return /*#__PURE__*/React.createElement("img", {
      key: i,
      src: paymentLogo,
      alt: "Payment",
      style: {
        maxHeight: 45
      },
      className: "ml-1 mt-2"
    });
  }))), (reservation === null || reservation === void 0 ? void 0 : reservation.paymentStatus) === 'cancelled' && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: t('Payment has failed.')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start w-full mt-8"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    onClick: onNext
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    extraSmall: true,
    color: "white"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Pay')))), /*#__PURE__*/React.createElement("div", {
    className: "text-xs text-secondary-three mt-8"
  }, /*#__PURE__*/React.createElement("sup", null, "1"), " ", t('The reservation cost will be deducted from the purchase of the car or from financing.')), /*#__PURE__*/React.createElement("div", {
    className: "text-xs text-secondary-three mb-10"
  }, /*#__PURE__*/React.createElement("sup", null, "2"), " ", t('The reservation fee will'), /*#__PURE__*/React.createElement("strong", null, " ", t('not be refunded'), " "), " ", t('if you cancel the purchase and/or make the purchase after the'), " ", t('reservation days'), "."));
};

var ReservationCompleted = function ReservationCompleted(props) {
  var settings = props.settings,
    loading = props.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, null);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold mb-6"
  }, t('Reservation completed.')), /*#__PURE__*/React.createElement("div", null, t('Check your mailbox, a confirmation email has been sent.')), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, ' ', t('The car will be ready for you for the next'), " ", settings.days, " ", t('days'), "."), /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold"
  }, t('We look forward to meeting you in our showroom.')));
};

var ReservationStepper = function ReservationStepper(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var step = props.step;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 py-8"
  }, /*#__PURE__*/React.createElement(ReservationStep, {
    index: 1,
    step: step,
    title: t('Your information'),
    content: /*#__PURE__*/React.createElement(ReservationUserInformation, props),
    completedContent: /*#__PURE__*/React.createElement(ReservationUserInformationConfirmed, props)
  }), /*#__PURE__*/React.createElement(ReservationStep, {
    index: 2,
    step: step,
    title: t('Payment'),
    content: /*#__PURE__*/React.createElement(ReservationPayment, props),
    completedContent: /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-three"
    }, "We have received your payment.")
  }), /*#__PURE__*/React.createElement(ReservationStep, {
    index: 3,
    step: step,
    title: t('Confirmation'),
    content: /*#__PURE__*/React.createElement(ReservationCompleted, props)
  }));
};

var VehicleBlock = function VehicleBlock(_ref) {
  var vehicle = _ref.vehicle,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "reservation-vehicle w-full"
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full",
    src: vehicle.images[0].uri,
    alt: vehicle.make + " " + vehicle.model
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary font-bold mb-1 truncate"
  }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-secondary-three text-sm capitalize truncate"
  }, " ", vehicle.version), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center font-bold text-sm mt-5 cursor-pointer",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-arrow-right pr-2 no-underline"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hover:underline"
  }, t('View details')))));
};

var PaymentBlock = function PaymentBlock(_ref) {
  var settings = _ref.settings;
  var _useState = useState(false),
    showDescription = _useState[0],
    setShowDescription = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-5 font-bold flex justify-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "inline"
  }, t('Reservation cost'), " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two"
  }, "\u20AC ", settings.deposit, " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two text-12"
  }, "(", t('incl. 21% VAT'), ")")), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-question-circle ml-1 cursor-pointer hidden lg:block justify-self-end",
    style: {
      marginTop: 5
    },
    onClick: function onClick() {
      return setShowDescription(!showDescription);
    }
  })), /*#__PURE__*/React.createElement(Fade$1, {
    when: showDescription,
    duration: 100,
    collapse: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative text-xs px-5 pb-5"
  }, t('Deposit on your purchase.'), /*#__PURE__*/React.createElement("br", null), t('We do not sell the car to third parties during'), " ", settings.days, " ", t('days'), ".")));
};

var ReservationWizard = function ReservationWizard(props) {
  var vehicleReference = props.vehicleReference,
    vehicle = props.vehicle,
    loading = props.loading,
    loadingError = props.loadingError,
    error = props.error,
    settings = props.settings,
    context = props.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (vehicleReference === '') {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-12"
    }));
  }
  if (!loading && loadingError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: error
    }));
  }
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement(LoadingIndicator, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container mt-6 flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full flex-col flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default"
  }, t('Avoid someone getting ahead of you.'), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h2", {
    className: "font-bold"
  }, t('We reserve this car'), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary-two"
  }, ' ', settings.days, " ", t('days for you'), "."))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex-col w-full sm:w-1/2 sm:self-center border border-secondary-four rounded mt-5"
  }, /*#__PURE__*/React.createElement(VehicleBlock, {
    vehicle: vehicle,
    onClick: function onClick() {
      return navigateInternalUrl(context, vehicle.url);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-eight w-full",
    style: {
      height: 1
    }
  })), /*#__PURE__*/React.createElement(PaymentBlock, {
    settings: settings
  })), /*#__PURE__*/React.createElement(ReservationStepper, props)), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-col ml-8 w-1/3 xl:w-1/4 self-start rounded border border-secondary-four"
  }, /*#__PURE__*/React.createElement(VehicleBlock, {
    vehicle: vehicle,
    onClick: function onClick() {
      return navigateInternalUrl(context, vehicle.url);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-eight w-full",
    style: {
      height: 1
    }
  })), /*#__PURE__*/React.createElement(PaymentBlock, {
    settings: settings
  }))));
};
var ReservationWizard$1 = baseReservationWizard(ReservationWizard);

var VehicleReservation = function VehicleReservation(_ref) {
  var payment_logos = _ref.payment_logos,
    vehicle = _ref.vehicle,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReservationWizard$1, {
    paymentLogos: payment_logos,
    vehicleReference: vehicle,
    context: context
  }));
};
VehicleReservation.defaultProps = {};
VehicleReservation.human = {
  nl: 'Vehicle reservation',
  fr: 'Vehicle reservation',
  en: 'Vehicle reservation'
};

var GenericSelect = function GenericSelect(_ref) {
  var placeHolder = _ref.placeHolder,
    items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  var valuesLabels = map(filter(options, function (option) {
    return includes(values, option.value);
  }), function (item) {
    return item.label;
  });
  var valueLabel = valuesLabels.length > 0 ? {
    label: valuesLabels.join(', ')
  } : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel,
    options: options,
    placeholder: placeHolder,
    closeMenuOnSelect: false,
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = includes(values, data.value);
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 px-3 hover:bg-secondary-five cursor-pointer hover:text-primary",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border border-primary mr-2",
          style: {
            height: 16,
            width: 16
          }
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-primary",
          style: {
            fontSize: 12
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative text-primary"
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};

var MakesFilter$2 = function MakesFilter(_ref) {
  var criteriaData = _ref.criteriaData,
    criteriaValues = _ref.criteriaValues,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Make')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: criteriaData,
    values: criteriaValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var MakesFilter$3 = baseMakeSearchAgentCriteriaForMakeModel(MakesFilter$2);

var ModelsFilter$2 = function ModelsFilter(_ref) {
  var criteriaData = _ref.criteriaData,
    makeCriteriaValues = _ref.makeCriteriaValues,
    modelCriteriaValues = _ref.modelCriteriaValues,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var makes = criteriaData.makes;
  var makesInFilters = filter(makes, function (m) {
    return includes(makeCriteriaValues, m.key);
  });
  var modelOptions = map(makesInFilters, function (make) {
    return {
      value: make.key,
      label: make.text,
      options: make.models ? orderBy(map(make.models, function (model) {
        return {
          label: model.text,
          value: model.key,
          makeKey: make.key
        };
      }), ['label']) : []
    };
  });
  var modelLabel = '';
  if (!isEmpty(modelCriteriaValues) && !isEmpty(makes)) {
    modelCriteriaValues.map(function (modelItem) {
      var make = find(makes, function (make) {
        return make.key === modelItem.make;
      });
      var model = find(make.models, function (model) {
        return model.key === modelItem.model;
      });
      modelLabel = modelLabel + (make.text + " " + model.text);
    });
  }
  var handleFilterChanged = function handleFilterChanged(data) {
    var value = data.makeKey + "|" + data.value;
    if (hasCriteriaWithValue(value)) {
      criteriaDelete(value);
    } else if (hasCriteriaWithValue(data.makeKey)) {
      criteriaDelete(data.makeKey);
      criteriaAdd(value);
    } else {
      criteriaAdd(value);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Model')), /*#__PURE__*/React.createElement(SelectBox, {
    value: modelLabel ? {
      label: modelLabel
    } : '',
    options: orderBy(modelOptions, ['label']),
    closeMenuOnSelect: false,
    placeholder: t('All'),
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = filter(modelCriteriaValues, function (f) {
          return f.model === data.value;
        }).length > 0;
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 cursor-pointer hover:text-primary ml-5 text-secondary-four",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'border-primary'),
          style: {
            height: 16,
            width: 16
          }
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-white",
          style: {
            fontSize: 10,
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative " + (isSelected ? 'text-secondary-two' : 'text-secondary-three')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};
var ModelsFilter$3 = baseModelSearchAgentCriteriaForModel(ModelsFilter$2);

var BodiesFilter = function BodiesFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var onFilterChanged = function onFilterChanged(data) {
    if (hasCriteriaWithValue(data.key)) {
      criteriaDelete(data.key);
    } else {
      criteriaAdd(data.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mx-auto overflow-x-scroll py-4 px-2"
  }, map(orderBy(data, ['priority', 'text']), function (bt, i) {
    var isSelected = includes(value, bt.key);
    var isLast = data.length - 1 === i;
    return /*#__PURE__*/React.createElement("div", {
      key: "Bbody-type-" + i,
      onClick: function onClick() {
        return onFilterChanged(bt);
      },
      className: "w-32 h-32 flex-none border " + (isSelected ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer " + (isLast ? '' : 'mr-4') + " shadow-md hover:border-secondary-three transition"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center outline-none text-primary py-6"
    }, /*#__PURE__*/React.createElement("i", {
      className: bt.icon + " px-6 ",
      style: {
        fontSize: 29
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "mt-3 text-14 truncate leading-24 w-full text-center"
    }, bt.text)));
  })));
};
var BodyFilter$2 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.body, BodiesFilter);

var FuelFilter$2 = function FuelFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Fuel type')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var FuelFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.fuel, FuelFilter$2);

var GearboxFilter = function GearboxFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Gear')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var GearboxFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.transmission, GearboxFilter);

var YearFilter$2 = function YearFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('First registration')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var YearFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.year, YearFilter$2);

var MileageFilter$2 = function MileageFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mileagesFrom = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  var mileagesTo = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Mileage')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: mileagesFrom,
    optionsTo: mileagesTo,
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var MileageFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.mileage, MileageFilter$2);

var DoorsFilter$2 = function DoorsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var doorsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterExists = function filterExists(range) {
    return doorsRangeValue ? includes(doorsRangeValue, range[0]) && includes(doorsRangeValue, range[1]) : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length > 0) {
      criteriaUpdate(range);
    } else {
      criteriaAdd(range);
    }
  };
  var handleRemoveFilter = function handleRemoveFilter() {
    criteriaDelete(FilterTypes.doorsRangeValue);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Doors')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 text-14",
    style: {
      height: 42
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border border-primary rounded-l " + (!doorsRangeValue ? 'bg-secondary-two text-white' : 'text-secondary-three'),
    onClick: function onClick() {
      return handleRemoveFilter();
    }
  }, t('All')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border-t border-b border-primary " + (filterExists([2, 3]) ? 'bg-secondary-two text-white' : 'text-secondary-three'),
    onClick: function onClick() {
      return handleFilterChanged([2, 3]);
    }
  }, "2/3"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border-t border-b border-l border-primary " + (filterExists([4, 5]) ? 'bg-secondary-two text-white' : 'text-secondary-three'),
    onClick: function onClick() {
      return handleFilterChanged([4, 5]);
    }
  }, "4/5"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border border-primary rounded-r " + (filterExists([6, 7]) ? 'bg-secondary-two text-white' : 'text-secondary-three'),
    onClick: function onClick() {
      return handleFilterChanged([6, 7]);
    }
  }, "6/7")));
};
var DoorsFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.doorsRange, DoorsFilter$2);

var GenericListSecondary = function GenericListSecondary(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    containerClass = _ref.containerClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, map(options, function (option, i) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value + "-" + i,
      className: "flex flex-col text-secondary-four mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row px-2 py-2 rounded hover:bg-secondary-five cursor-pointer hover:text-primary",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded border border-primary mr-2",
      style: {
        height: 16,
        width: 16
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check text-secondary-two",
      style: {
        fontSize: 12
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative " + (isSelected ? 'font-semibold' : 'font-normal')
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-primary capitalize"
    }, option.label))));
  })));
};
GenericListSecondary.defaultProps = {
  containerClass: 'space-y-2'
};

var CategoryFilter$2 = function CategoryFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Vehicle condition')), /*#__PURE__*/React.createElement(GenericListSecondary, {
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "flex flex-row space-x-4"
  }));
};
var CategoryFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.category, CategoryFilter$2);

var VatFilter$2 = function VatFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleFilterChanged = function handleFilterChanged() {
    if (hasCriteriaWithValue(true)) {
      criteriaDelete(true);
    } else {
      criteriaAdd(true);
    }
  };
  var isSelected = includes(value, true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('VAT')), /*#__PURE__*/React.createElement("div", {
    key: "filter-vat",
    className: "flex flex-col text-gray-900 mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row py-2 px-1 rounded hover:bg-secondary-five cursor-pointer hover:text-primary",
    onClick: function onClick() {
      return handleFilterChanged();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded border border-primary mr-2",
    style: {
      height: 16,
      width: 16
    }
  }, isSelected && /*#__PURE__*/React.createElement("i", {
    className: "far fa-check text-secondary-two",
    style: {
      fontSize: 12
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between flex-1 relative text-primary " + (isSelected ? 'font-semibold' : 'font-normal')
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('VAT deductible'))))));
};
var VatFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.vat, VatFilter$2);

var SeatsFilter$2 = function SeatsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var seatsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var filterExists = function filterExists(seats) {
    return seatsRangeValue && seatsRangeValue[0] === seats ? true : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length <= 0) {
      criteriaAdd(range);
    } else {
      if (hasCriteriaWithValue(range)) {
        criteriaDelete();
      } else {
        criteriaUpdate(range);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Seats')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(2) ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary-three transition",
    onClick: function onClick() {
      return handleFilterChanged([2]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-small",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "S"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(3) ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary-three  transition",
    onClick: function onClick() {
      return handleFilterChanged([3]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-medium",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "M"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(4) ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary-three  transition",
    onClick: function onClick() {
      return handleFilterChanged([4]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-large",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "L"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(5) ? 'border-secondary-three' : 'border-secondary-five') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary-three  transition",
    onClick: function onClick() {
      return handleFilterChanged([5]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-xlarge",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "XL")))));
};
var SeatFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.seatsRange, SeatsFilter$2);

var EquipmentFilter = function EquipmentFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var handleFilterChanged = function handleFilterChanged(equipment) {
    if (hasCriteriaWithValue(equipment.key)) {
      criteriaDelete(equipment.key);
    } else {
      criteriaAdd(equipment.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-1"
  }, map(orderBy(data, ['text']), function (eq) {
    var isSelected = includes(value, eq.key);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-eq-" + eq.key,
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-primary flex flex-row p-2 hover:bg-secondary-five rounded cursor-pointer transition",
      onClick: function onClick() {
        return handleFilterChanged(eq);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded border border-primary mr-2",
      style: {
        height: 16,
        width: 16
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check font-bold",
      style: {
        fontSize: 10,
        marginTop: 2
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative " + (isSelected ? 'font-semibold' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, eq.text), /*#__PURE__*/React.createElement("div", null, eq.value))));
  }));
};
var EquipmentFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.equipments, EquipmentFilter);

var GenericColorListSecondary = function GenericColorListSecondary(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    gridClass = _ref.gridClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text,
      color: item.custom
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement("div", {
    className: gridClass
  }, map(options, function (option) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value,
      className: "flex items-center py-1 cursor-pointer",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-4 h-4 rounded mr-2 " + (option.color === '#fff' ? 'border border-secondary-three' : ''),
      style: {
        backgroundColor: option.color
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check font-bold " + (option.color === '#fff' ? 'text-primary' : 'text-white'),
      style: {
        fontSize: 10
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-primary capitalize"
    }, option.label));
  }), ";");
};
GenericColorListSecondary.defaultProps = {
  gridClass: 'grid grid-cols-2 gap-1'
};

var ExteriorColorFilter = function ExteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-2"
  }, t('Body Color')), /*#__PURE__*/React.createElement(GenericColorListSecondary, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var ExteriorColorFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.exteriorColor, ExteriorColorFilter);

var InteriorColorFilter$2 = function InteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-2"
  }, t('Interior Color')), /*#__PURE__*/React.createElement(GenericColorListSecondary, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorColorFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorColor, InteriorColorFilter$2);

var InteriorUpholstery = function InteriorUpholstery(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Upholstery')), /*#__PURE__*/React.createElement(GenericListSecondary, {
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorUpholsteryFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorUpholstery, InteriorUpholstery);

var initCoValue$1 = {
  min: '',
  max: ''
};
var CO2Filter$2 = function CO2Filter(_ref) {
  var currentValue = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var activeFilter = currentValue && currentValue.length > 0 ? currentValue[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue$1),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      if (currentValue.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    } else {
      criteriaDelete();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('CO2 (g/km)')), /*#__PURE__*/React.createElement("div", {
    className: "flex",
    style: {
      height: 44
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border border-primary text-primary rounded-l focus:outline-none",
    value: value.min,
    style: {
      maxHeight: 46
    },
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-primary rounded-r focus:outline-none",
    value: value.max,
    style: {
      maxHeight: 46
    },
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  })));
};
var CO2Filter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.co2Range, CO2Filter$2);

var EuroNormFilter$2 = function EuroNormFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Euro Emission Class')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var EuroNormFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.euroNorm, EuroNormFilter$2);

var PriceFilter$2 = function PriceFilter() {
  return /*#__PURE__*/React.createElement("div", null, "TODO");
};
PriceFilter$2.defaultProps = {
  radioButtonSize: 24
};
var PriceFilter$3 = baseSearchAgentCriteria(PriceFilter$2);

var labels$2 = {
  PK: 'PK',
  KW: 'KW'
};
var initPK$1 = {
  min: '',
  max: ''
};
var initKW$1 = {
  min: '',
  max: ''
};
var PowerFilter$1 = function PowerFilter(_ref) {
  var criteria = _ref.criteria,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteria = _ref.hasCriteria;
  var _useState = useState(labels$2.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK$1),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW$1),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pkFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.pk;
    }));
    var kwFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.kw;
    }));
    if (pkFilters) {
      setPk({
        min: pkFilters.value[0],
        max: pkFilters.value[1]
      });
    }
    if (kwFilters) {
      setKw({
        min: kwFilters.value[0],
        max: kwFilters.value[1]
      });
    }
  }, []);
  var powerOptions = [{
    value: labels$2.PK,
    label: t('hp')
  }, {
    value: labels$2.KW,
    label: t('kW')
  }];
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.pk)) {
        criteriaUpdate(SearchAgentCriteriaTypes.pk, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.pk, value);
      }
    } else {
      criteriaDelete(SearchAgentCriteriaTypes.pk);
    }
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.kw)) {
        criteriaUpdate(SearchAgentCriteriaTypes.kw, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.kw, value);
      }
    } else {
      criteriaDelete(FilterTypes.kw);
    }
  };
  var renderPK = function renderPK() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-primary text-14 text-primary rounded-l focus:outline-none",
      value: pk.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-14 text-primary rounded-r focus:outline-none",
      value: pk.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKW = function renderKW() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-primary text-14 text-primary rounded-l focus:outline-none",
      value: kw.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-primary text-14 text-primary rounded-r focus:outline-none",
      value: kw.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-primary mb-2 mt-5"
  }, t('Power')), /*#__PURE__*/React.createElement("div", {
    className: "flex text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-2/5 mr-2"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: find(powerOptions, function (i) {
      return i.value === activeOption;
    }),
    options: powerOptions,
    className: "focus:outline-none",
    isLoading: false,
    onChange: function onChange(option) {
      return setActiveOption(option.value);
    }
  })), /*#__PURE__*/React.createElement(Fade, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-3/5 w-full flex"
  }, activeOption === labels$2.PK && renderPK(), activeOption === labels$2.KW && renderKW()))));
};
var PowerFilter$2 = baseSearchAgentCriteria(PowerFilter$1);

var WishesTextArea = function WishesTextArea(_ref) {
  var value = _ref.value,
    fieldUpdate = _ref.fieldUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded-10",
    heightClass: "h-30",
    placeholder: t('Special wishes'),
    value: value.wishes,
    onChange: function onChange(value) {
      return fieldUpdate('wishes', value);
    },
    required: false
  });
};
var WishesTextArea$1 = baseSearchAgentField(WishesTextArea);

var keys$1 = {
  basic: 'basic',
  equipments: 'equipments',
  exterior: 'exterior',
  upholstery: 'upholstery',
  environment: 'environment',
  extra: 'extra'
};
var searchAgentCategories = [{
  key: keys$1.basic,
  translation: function translation(t) {
    return t('Basic specifications');
  },
  priority: 1
}, {
  key: keys$1.equipments,
  translation: function translation(t) {
    return t('Equipment');
  },
  priority: 2
}, {
  key: keys$1.exterior,
  translation: function translation(t) {
    return t('Exterior');
  },
  priority: 3
}, {
  key: keys$1.upholstery,
  translation: function translation(t) {
    return t('Interior');
  },
  priority: 4
}, {
  key: keys$1.environment,
  translation: function translation(t) {
    return t('Milieu');
  },
  priority: 5
}, {
  key: keys$1.extra,
  translation: function translation(t) {
    return t('Do you have any special wishes or comments?');
  },
  priority: 6
}];
var SearchAgentCriteria = function SearchAgentCriteria(_ref) {
  var context = _ref.context;
  var _useState = useState(keys$1.basic),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var element = document.getElementById(activeCategory);
    if (element) {
      var headerOffset = 71;
      var bodyRect = document.body.getBoundingClientRect().top;
      var elementRect = element.getBoundingClientRect().top;
      var elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'instant'
      });
    }
  }, [activeCategory]);
  var renderContent = function renderContent(key) {
    switch (key) {
      case keys$1.basic:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MakesFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModelsFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "mt-4"
        }, /*#__PURE__*/React.createElement(BodyFilter$2, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FuelFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GearboxFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "md:w-1/2 pr-6"
        }, /*#__PURE__*/React.createElement(PriceFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-0 md:mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YearFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MileageFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PowerFilter$2, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DoorsFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CategoryFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VatFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SeatFilter, {
          context: context
        })));
      case keys$1.equipments:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(EquipmentFilter$1, {
          context: context
        }));
      case keys$1.exterior:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(ExteriorColorFilter$1, {
          context: context
        }));
      case keys$1.upholstery:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(InteriorColorFilter$3, {
          context: context
        }), /*#__PURE__*/React.createElement(InteriorUpholsteryFilter, {
          context: context
        }));
      case keys$1.environment:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EuroNormFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CO2Filter$3, {
          context: context
        }))));
      case keys$1.extra:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(WishesTextArea$1, null));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "rounded border border-secondary-four relative"
  }, map(orderBy(searchAgentCategories, ['priority']), function (searchAgentCategory, i) {
    var isFirst = i === 0;
    var isLast = searchAgentCategories.length - 1 === i;
    var isActive = searchAgentCategory.key === activeCategory;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-category-" + i,
      id: searchAgentCategory.key,
      className: "border-secondary-three text-white " + (isLast ? '' : 'border-b')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between cursor-pointer p-5 bg-secondary-two text-white " + (isFirst && 'rounded-t') + " " + (isLast && !isActive && 'rounded-b'),
      onClick: function onClick() {
        return setActiveCategory(searchAgentCategory.key !== activeCategory ? searchAgentCategory.key : '');
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, searchAgentCategory.translation(t)), /*#__PURE__*/React.createElement("i", {
      className: "fal " + (searchAgentCategory.key === activeCategory ? 'fa-angle-up' : 'fa-angle-down') + " text-white",
      style: {
        marginTop: 2
      }
    })), isActive && renderContent(searchAgentCategory.key));
  })));
};

var SearchAgentTopBar = function SearchAgentTopBar(_ref) {
  var criteria = _ref.criteria,
    criteriaDelete = _ref.criteriaDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if ((criteria === null || criteria === void 0 ? void 0 : criteria.length) === 0) return /*#__PURE__*/React.createElement("div", null);
  return /*#__PURE__*/React.createElement(Sticky, {
    top: 0,
    activeClass: "w-full",
    innerZ: 50
  }, /*#__PURE__*/React.createElement(Scrollbars, {
    autoHeight: true,
    universal: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-white py-5 overflow-x-scroll"
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-max flex-none pr-3 font-semibold"
  }, t('Selected filters'), ":"), map(filter(criteria, function (c) {
    return c.type !== FilterTypes.segment;
  }), function (c, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-5 py-2 " + (index === 0 ? 'ml-0' : 'ml-3') + " rounded bg-secondary-five hover:bg-secondary-four cursor-pointer transition",
      key: "filter-type-" + index,
      onClick: function onClick() {
        return criteriaDelete(c);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-max capitalize pr-3"
    }, c.label), " ", /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }));
  }))));
};
var SearchAgentTopBar$1 = baseSearchAgentTopBar(SearchAgentTopBar);

var SearchAgentUserForm = function SearchAgentUserForm(_ref) {
  var value = _ref.value,
    userFieldUpdate = _ref.userFieldUpdate,
    fieldUpdate = _ref.fieldUpdate,
    submit = _ref.submit,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    onPrevious = _ref.onPrevious,
    context = _ref.context;
  var _useState = useState(undefined),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validate = function validate() {
    var errors = {};
    if (!hasValue(value.user.email)) {
      errors['email'] = t('Please fill in your e-mail address.');
    } else if (!isValidEmail(value.user.email)) {
      errors['email'] = t('Invalid email address');
    }
    if (!hasValue(value.user.firstName)) {
      errors['firstName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.lastName)) {
      errors['lastName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.telephone)) {
      errors['telephone'] = t('Please fill in your telephone number.');
    }
    if (!hasValue(value.user.privacy)) {
      errors['privacy'] = t('Please accept the privacy terms.');
    }
    if (value.criteria.length < 1) {
      errors['criteria'] = t('Please choose at least one criteria.');
    }
    setErrors(errors);
    return keys$2(errors).length <= 0;
  };
  var handleSubmit = function handleSubmit() {
    if (validate()) {
      submit(value);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), submitError && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: t('Your request has NOT been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "rounded border border-secondary-four p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('First name'),
    placeholder: t('First name'),
    value: value.user.firstName,
    onChange: function onChange(value) {
      return userFieldUpdate('firstName', value);
    },
    errorText: errors && errors['firstName'] ? errors['firstName'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: value.user.lastName,
    onChange: function onChange(value) {
      return userFieldUpdate('lastName', value);
    },
    errorText: errors && errors['lastName'] ? errors['lastName'] : undefined,
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('Email'),
    placeholder: t('Email'),
    value: value.user.email,
    onChange: function onChange(value) {
      return userFieldUpdate('email', value);
    },
    errorText: errors && errors['email'] ? errors['email'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Telephone'),
    placeholder: t('Telephone'),
    value: value.user.telephone,
    onChange: function onChange(value) {
      return userFieldUpdate('telephone', value);
    },
    errorText: errors && errors['telephone'] ? errors['telephone'] : undefined,
    required: true
  })), /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    heightClass: "h-30",
    label: t('Any comments'),
    placeholder: t('Comments'),
    value: value.notes,
    onChange: function onChange(value) {
      return fieldUpdate('notes', value);
    },
    required: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex my-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary  " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: value.user.privacy,
    onChange: function onChange(e) {
      return userFieldUpdate('privacy', e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.privacy);
    }
  }, t('privacy terms')), ".")), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex-1 items-center justify-center px-5 text-red-400 mt-5"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), " ", errors['criteria']), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-secondary",
    onClick: onPrevious
  }, t('Modify filters')), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-1 items-center justify-end px-5 text-red-400"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), " ", errors['criteria']), /*#__PURE__*/React.createElement("button", {
    className: "button button-primary",
    onClick: handleSubmit
  }, t('Send'))));
};
var SearchAgentUserForm$1 = baseSearchAgentForm(SearchAgentUserForm);

var viewTypes = {
  SearchCriteria: 'SearchCriteria',
  UserInfo: 'UserInfo'
};
var SearchAgent = function SearchAgent(_ref) {
  var data = _ref.data,
    loading = _ref.loading,
    context = _ref.context;
  var _useState = useState(viewTypes.SearchCriteria),
    currentView = _useState[0],
    setCurrentView = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading || !data) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentView === viewTypes.SearchCriteria && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentCriteria, {
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button-primary",
    onClick: function onClick() {
      return setCurrentView(viewTypes.UserInfo);
    }
  }, t('Next'), ' '))), currentView === viewTypes.UserInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentUserForm$1, {
    context: context,
    onPrevious: function onPrevious() {
      return setCurrentView(viewTypes.SearchCriteria);
    }
  }))));
};
var SearchAgent$1 = baseSearchAgent(SearchAgent);

var VehicleSearchAgent = function VehicleSearchAgent(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 xl:mb-12"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React.createElement(SearchAgent$1, {
    context: context
  })));
};
VehicleSearchAgent.defaultProps = {
  text: DefaultText
};
VehicleSearchAgent.human = {
  nl: '',
  fr: '',
  en: ''
};

var VehicleSliderHorizontal = function VehicleSliderHorizontal(_ref) {
  var cards = _ref.cards,
    loading = _ref.loading,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var skeletonCardsLength = 10;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex overflow-x-scroll py-4 mt-4 mb-8 slider-scrollbar scrollbar-snap-x"
    }, times(skeletonCardsLength, function (index) {
      return /*#__PURE__*/React.createElement("div", {
        className: (index !== skeletonCardsLength - 1 ? 'mr-5 lg:mr-4' : '') + " w-full sm:w-half-minus-1-rem md:w-third-minus-1-rem lg:w-quarter-minus-1-rem flex-none"
      }, /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        dark: true
      }));
    }));
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-white"
    }, t('Something went wrong') + '...');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex overflow-x-scroll py-4 mt-4 mb-8 slider-scrollbar scrollbar-snap-x"
  }, map(cards, function (card, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: (index !== cards.length - 1 ? 'mr-5 lg:mr-4' : '') + " w-full sm:w-half-minus-1-rem md:w-third-minus-1-rem lg:w-quarter-minus-1-rem flex-none",
      style: {
        scrollSnapAlign: 'start'
      }
    }, card);
  }));
};
var VehicleSliderHorizontal$1 = baseSliderWithCustomImageCard(VehicleSliderHorizontal);

var VehicleSliderWithTitleAndFilterActions = function VehicleSliderWithTitleAndFilterActions(_ref) {
  var title = _ref.title,
    filter_actions = _ref.filter_actions,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(filter_actions[0]),
    selectedAction = _useState[0],
    setSelectedAction = _useState[1];
  var _useState2 = useState(filter_actions[0]),
    selectedFilter = _useState2[0],
    setSelectedFilter = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-secondary-two text-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-16 md:py-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-start md:items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 md:mb-0 font-semibold text-xl"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "block text-white w-full md:hidden"
  }, /*#__PURE__*/React.createElement(SingleSelect, {
    placeHolder: t('Category'),
    items: map(filter_actions, function (action) {
      return {
        key: action.id,
        text: action.title
      };
    }),
    values: {
      value: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.id,
      label: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.title
    },
    menuPlacement: 'bottom',
    dark: true,
    handleSelectChange: function handleSelectChange(data) {
      setSelectedAction(filter(filter_actions, function (action) {
        return action.id === data.value;
      })[0]);
      setSelectedFilter(filter(filter_actions, function (action) {
        return action.id === data.value;
      })[0]);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex"
  }, map(filter_actions, function (action, index) {
    var isFirst = index === 0;
    var isLast = (filter_actions === null || filter_actions === void 0 ? void 0 : filter_actions.length) - 1 === index;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-action-" + index,
      className: "cursor-pointer " + (isFirst ? '' : 'ml-10') + " " + (isLast ? 'mr-5' : 'mr-10') + " " + ((action === null || action === void 0 ? void 0 : action.id) === (selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.id) ? 'border-b-2 border-secondary' : ''),
      onClick: function onClick() {
        setSelectedAction(action);
        setSelectedFilter(action);
      }
    }, action.title);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement(VehicleSliderHorizontal$1, {
    filters: selectedFilter,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
        gridSize: 5,
        dark: true,
        vehicle: vehicle,
        context: context
      });
    },
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "with-financing"
  })));
};
VehicleSliderWithTitleAndFilterActions.defaultProps = {
  title: DefaultTitle,
  custom_card_image: undefined,
  custom_card_action: undefined,
  filter_actions: DefaultActionList
};
VehicleSliderWithTitleAndFilterActions.human = {
  nl: 'Vehicle Horizontal Slider',
  fr: 'Vehicle Horizontal Slider',
  en: 'Vehicle Horizontal Slider'
};

var VehicleSliderWithTitleAndFilterActions_Light = function VehicleSliderWithTitleAndFilterActions_Light(_ref) {
  var title = _ref.title,
    filter_actions = _ref.filter_actions,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var sliderRef = useRef();
  useContentBlockImpressionWhenInViewport(sliderRef, 'deals', context);
  var _useState = useState(filter_actions[0]),
    selectedAction = _useState[0],
    setSelectedAction = _useState[1];
  var _useState2 = useState(filter_actions[0]),
    selectedFilter = _useState2[0],
    setSelectedFilter = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    className: "w-full text-black"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-start md:items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 md:mb-0 text-32 lg2:text-40 font-medium text-primary"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "block text-white w-full md:hidden"
  }, /*#__PURE__*/React.createElement(SingleSelect, {
    placeHolder: t('Category'),
    items: map(filter_actions, function (action) {
      return {
        key: action.id,
        text: action.title
      };
    }),
    values: {
      value: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.id,
      label: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.title
    },
    menuPlacement: 'bottom',
    dark: true,
    handleSelectChange: function handleSelectChange(data) {
      setSelectedAction(filter(filter_actions, function (action) {
        return action.id === data.value;
      })[0]);
      setSelectedFilter(filter(filter_actions, function (action) {
        return action.id === data.value;
      })[0]);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex"
  }, map(filter_actions, function (action, index) {
    var isFirst = index === 0;
    var isLast = (filter_actions === null || filter_actions === void 0 ? void 0 : filter_actions.length) - 1 === index;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-action-" + index,
      className: "cursor-pointer " + (isFirst ? '' : 'ml-10') + " " + (isLast ? 'mr-5' : 'mr-10') + " " + ((action === null || action === void 0 ? void 0 : action.id) === (selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.id) ? 'border-b-2 border-secondary' : ''),
      onClick: function onClick() {
        setSelectedAction(action);
        setSelectedFilter(action);
      }
    }, action.title);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement(VehicleSliderHorizontal$1, {
    filters: selectedFilter,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
        gridSize: 5,
        dark: false,
        vehicle: vehicle,
        context: context
      });
    },
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "with-financing"
  })));
};
VehicleSliderWithTitleAndFilterActions_Light.defaultProps = {
  title: DefaultTitle,
  custom_card_image: undefined,
  custom_card_action: undefined,
  filter_actions: DefaultActionList
};
VehicleSliderWithTitleAndFilterActions_Light.human = {
  nl: 'Vehicle Horizontal Slider Light',
  fr: 'Vehicle Horizontal Slider Light',
  en: 'Vehicle Horizontal Slider Light'
};

var VehicleSliderGrid = function VehicleSliderGrid(_ref) {
  var cards = _ref.cards,
    loading = _ref.loading,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return null;
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-white"
    }, t('Something went wrong') + '...');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
  }, map(cards, function (card, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: ""
    }, card);
  }));
};
var VehicleSliderGrid$1 = baseSliderWithCustomImageCard(VehicleSliderGrid);

var VehiclesBasicWithAction = function VehiclesBasicWithAction(_ref) {
  var filters = _ref.filters,
    all_action = _ref.all_action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "max-w-screen-2xl mx-auto px-10 py-12 flex flex-col items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(VehicleSliderGrid$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCardDesktop, {
        dark: false,
        vehicle: vehicle,
        context: context
      });
    },
    context: context
  })), /*#__PURE__*/React.createElement(ActionLink, {
    action: all_action,
    context: context,
    className: "rounded bg-secondary hover:bg-secondary-six transition text-white font-semibold px-4 py-2 mt-10"
  }));
};
VehiclesBasicWithAction.defaultProps = {
  filters: [],
  all_action: DefaultAction
};
VehiclesBasicWithAction.human = {
  nl: 'Vehicle Grid',
  fr: 'Vehicle Grid',
  en: 'Vehicle Grid'
};

export { Account, AdvertisementBanner, BannerBlogPosts, BannerBlogPostsWithCharTitleAndAction, BannerDraftJsMarkupFieldAndTitle, BannerDraftJsWithImageListWithCharTitle, BannerDraftJsWithImageListWithCharTitleFourCol as BannerDraftJsWithImageListWithCharTitle_FourCol, BannerGenericIconTextAndTitle, BannerGenericImageTextActionWithCharTitleAndAction, BannerGenericImageTextActionWithCharTitleAndCustomCard, BannerGenericImageTextActionWithTitle, BannerGenericImageTextActionWithTitle_Dark, BannerGenericImageTextTitle, BannerGenericImageTextTitle_InfoOverlay, BannerGenericJsonItemsWithCharTitleAndDraftJsText, BannerHtml, BannerImageAndTextWithAction, BannerImagesCarouselWithTitleAndSearch, BannerJsonImageAndTextWithAction, BannerJsonImageAndTextWithActionImageLeftDark as BannerJsonImageAndTextWithAction_ImageLeftDark, BannerJsonImageAndTextWithActionImageLeftLight as BannerJsonImageAndTextWithAction_ImageLeftLight, BannerJsonImageAndTextWithActionImageRightDark as BannerJsonImageAndTextWithAction_ImageRightDark, BannerJsonImageAndTextWithActionImageRightLight as BannerJsonImageAndTextWithAction_ImageRightLight, BannerMultiTextAction, BannerTitleDescriptionActionAndImages, BannerUspWithTextAndTwoBlocks, BlogList, Breadcrumbs, ContactFormTextAndImage, ContactFormTextAndImageV2 as ContactFormTextAndImage_V2, CookieBanner$1 as CookieBanner, Dealerships, FavoriteHeader, FavoriteVehicles, FinanceBanner$1 as FinanceBanner, FinancingTextBlock$1 as FinancingTextBlock, Footer, ForgotPassword$1 as ForgotPassword, GenericImageActionListWithCharTitle, GenericImageActionListWithTitle, Header, Header_Solid, Login, LoginPopup, MarkerMapAndCharTitle, MarkerMapAndText, PageNotFound, Paragraph, Paragraph_Left, Registration$1 as Registration, ResetPassword, SeoGenericMakeModelBlock, Separator, VehicleCompare, VehicleCompareBanner$1 as VehicleCompareBanner, VehicleDetailWithAdds, VehicleListWithAdds, VehicleReservation, VehicleSearchAgent, VehicleSliderWithTitleAndFilterActions, VehicleSliderWithTitleAndFilterActions_Light, VehiclesBasicWithAction, config };
